// // // // // // // src/pages/LandingPage.jsx
// // // // // // // All plan pricing, features, and template data read from servicesConfig
// // // // // // import { useState, useEffect, useRef } from "react";
// // // // // // import { useNavigate, Link } from "react-router-dom";
// // // // // // import { useAuth } from "../hooks/useAuth";
// // // // // // import servicesConfig from "../utils/servicesConfig";
// // // // // // //import { getEnabledPlans } from "../utils/paymentConfig";
// // // // // // import PaymentModal from "../components/PaymentModal";
// // // // // // import ChatWidget from "../components/ChatWidget";
// // // // // // import TemplateMini from "../components/TemplateMini";
// // // // // // import Icon, { IconBox } from "../components/Icons";

// // // // // // // ── Pull everything from config ──
// // // // // // const basicPlan    = servicesConfig.plans.find(p => p.id === "ats_basic");
// // // // // // const priceDisplay = basicPlan?.price        || "$1.99";
// // // // // // const analysisCount= basicPlan?.analysisCount|| 2;
// // // // // // const resumeCount  = basicPlan?.resumeGenCount|| 1;
// // // // // // const allTemplates = servicesConfig.resumeTemplates.filter(t => t.active);
// // // // // // const enabledPlans = servicesConfig.plans.filter(p => p.enabled);

// // // // // // // ── Animated counter ──
// // // // // // function Counter({ target, suffix="" }) {
// // // // // //   const [n, setN] = useState(0);
// // // // // //   const ref = useRef();
// // // // // //   useEffect(() => {
// // // // // //     const obs = new IntersectionObserver(([e]) => {
// // // // // //       if (!e.isIntersecting) return;
// // // // // //       let v = 0; const step = target / 55;
// // // // // //       const t = setInterval(() => { v += step; if (v >= target) { setN(target); clearInterval(t); } else setN(Math.floor(v)); }, 18);
// // // // // //       obs.disconnect();
// // // // // //     }, { threshold: 0.3 });
// // // // // //     if (ref.current) obs.observe(ref.current);
// // // // // //     return () => obs.disconnect();
// // // // // //   }, [target]);
// // // // // //   return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
// // // // // // }

// // // // // // // ── Realistic resume mini-preview ──
// // // // // // // eslint-disable-next-line no-unused-vars
// // // // // // function ResumeCard({ t, active, onClick }) {
// // // // // //   const a = t.accent, h = t.headerBg, id = t.id;
// // // // // //   const isMonospace = id === "technical";
// // // // // //   const bodyFont = isMonospace ? "'Courier New',monospace" : "Arial,Helvetica,sans-serif";

// // // // // //   const sLabel = (txt) => (
// // // // // //     <div style={{
// // // // // //       fontSize: 5.5, fontWeight: 700, color: a, textTransform: "uppercase", letterSpacing: "0.08em",
// // // // // //       borderBottom: (id==="classic"||id==="minimal"||id==="executive"||id==="creative") ? `0.8px solid ${a}55` : "none",
// // // // // //       borderLeft: (id==="modern"||id==="corporate"||id==="technical") ? `2px solid ${a}` : "none",
// // // // // //       paddingLeft: (id==="modern"||id==="corporate"||id==="technical") ? 4 : 0,
// // // // // //       paddingBottom: 1.5, marginBottom: 3,
// // // // // //       background: (id==="modern"||id==="corporate") ? `${a}0d` : "transparent",
// // // // // //       fontFamily: isMonospace ? "'Courier New',monospace" : "inherit",
// // // // // //     }}>{isMonospace ? `// ${txt.toUpperCase()}` : txt}</div>
// // // // // //   );

// // // // // //   const bullets = [
// // // // // //     "Led team of 12 to ship 3 features on time",
// // // // // //     "Increased user retention by 34% YoY",
// // // // // //     "Managed $2M product roadmap",
// // // // // //   ];

// // // // // //   const skills = isMonospace
// // // // // //     ? ["Python","React","AWS","Docker","SQL","Git"]
// // // // // //     : (id==="creative" ? ["Branding","Figma","Strategy","Adobe"] : ["Leadership","SQL","Agile","Figma"]);

// // // // // //   const renderHeader = () => {
// // // // // //     if (id === "minimal") return (
// // // // // //       <div style={{ padding:"11px 11px 8px", borderBottom:`2px solid ${a}`, background:"#fff" }}>
// // // // // //         <div style={{ fontSize:9, fontWeight:300, color:"#111", fontFamily:"'Helvetica Neue',Helvetica,sans-serif", marginBottom:2 }}>Jonathan Carter</div>
// // // // // //         <div style={{ width:18, height:2, background:a, borderRadius:1, margin:"2px 0 4px" }}/>
// // // // // //         <div style={{ fontSize:5.5, color:"#555", marginBottom:3 }}>Senior Product Manager</div>
// // // // // //         <div style={{ display:"flex", gap:5 }}>{["📧 john@email.com","📍 NYC"].map(c=><span key={c} style={{ fontSize:4.5, color:"#777" }}>{c}</span>)}</div>
// // // // // //       </div>
// // // // // //     );
// // // // // //     if (id === "executive") return (
// // // // // //       <div style={{ background:h, padding:"12px 11px 10px" }}>
// // // // // //         <div style={{ fontSize:9, fontWeight:700, color:"#fff", textTransform:"uppercase", letterSpacing:"0.08em", fontFamily:"Georgia,serif", marginBottom:2 }}>JONATHAN CARTER</div>
// // // // // //         <div style={{ height:0.8, background:"rgba(255,255,255,0.3)", marginBottom:2 }}/>
// // // // // //         <div style={{ height:0.3, background:"rgba(255,255,255,0.12)", marginBottom:5 }}/>
// // // // // //         <div style={{ display:"flex", gap:7 }}>{["john@email.com","New York, NY","linkedin.com"].map(c=><span key={c} style={{ fontSize:4.5, color:"rgba(255,255,255,0.55)" }}>{c}</span>)}</div>
// // // // // //       </div>
// // // // // //     );
// // // // // //     if (id === "modern") return (
// // // // // //       <div style={{ display:"flex" }}>
// // // // // //         <div style={{ width:50, background:h, padding:"11px 6px", display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
// // // // // //           <div style={{ width:24, height:24, borderRadius:"50%", background:"rgba(255,255,255,0.18)", marginBottom:3 }}/>
// // // // // //           {["john@email.com","New York, NY"].map(c=><div key={c} style={{ fontSize:4.5, color:"rgba(255,255,255,0.7)", textAlign:"center", lineHeight:1.3 }}>{c}</div>)}
// // // // // //           <div style={{ height:0.8, background:"rgba(255,255,255,0.15)", width:"80%", margin:"4px 0 3px" }}/>
// // // // // //           <div style={{ fontSize:4.8, fontWeight:700, color:"rgba(255,255,255,0.8)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:3 }}>Skills</div>
// // // // // //           {["React","Python","SQL","Agile"].map((sk,si)=>(
// // // // // //             <div key={sk} style={{ width:"88%", marginBottom:2 }}>
// // // // // //               <div style={{ fontSize:4.5, color:"rgba(255,255,255,0.7)", marginBottom:0.5 }}>{sk}</div>
// // // // // //               <div style={{ height:2, background:"rgba(255,255,255,0.15)", borderRadius:1 }}>
// // // // // //                 <div style={{ height:"100%", background:"rgba(255,255,255,0.6)", borderRadius:1, width:`${[88,78,82,72][si]}%` }}/>
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           ))}
// // // // // //         </div>
// // // // // //         <div style={{ flex:1, padding:"10px 7px 8px", background:"#fff" }}>
// // // // // //           <div style={{ fontSize:8, fontWeight:700, color:"#111", marginBottom:1 }}>Jonathan Carter</div>
// // // // // //           <div style={{ fontSize:5.5, color:a, fontWeight:600, marginBottom:4 }}>Senior Product Manager</div>
// // // // // //           <div style={{ height:1, background:`${a}20`, marginBottom:4 }}/>
// // // // // //         </div>
// // // // // //       </div>
// // // // // //     );
// // // // // //     if (id === "corporate") return (
// // // // // //       <div style={{ background:`linear-gradient(135deg,${h},${a})`, padding:"12px 11px 10px" }}>
// // // // // //         <div style={{ fontSize:9, fontWeight:700, color:"#fff", fontFamily:"Georgia,serif", marginBottom:1 }}>Jonathan Carter</div>
// // // // // //         <div style={{ fontSize:5.5, color:"rgba(200,225,255,0.7)", fontStyle:"italic", marginBottom:5 }}>Senior Business Consultant</div>
// // // // // //         <div style={{ height:0.8, background:"rgba(255,255,255,0.2)", marginBottom:5 }}/>
// // // // // //         <div style={{ display:"flex", gap:6 }}>{["📧 john@email.com","📍 NYC","🔗 LinkedIn"].map(c=><span key={c} style={{ fontSize:4.5, color:"rgba(200,225,255,0.7)" }}>{c}</span>)}</div>
// // // // // //       </div>
// // // // // //     );
// // // // // //     if (id === "creative") return (
// // // // // //       <div style={{ background:`linear-gradient(135deg,${h},${a})`, padding:"14px 11px 18px", clipPath:"polygon(0 0,100% 0,100% 78%,0 100%)" }}>
// // // // // //         <div style={{ fontSize:10, fontWeight:800, color:"#fff", fontFamily:"Georgia,serif", letterSpacing:"-0.02em", marginBottom:2 }}>Jonathan Carter</div>
// // // // // //         <div style={{ fontSize:5, color:"rgba(255,200,210,0.8)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:6 }}>Senior Marketing Director</div>
// // // // // //         <div style={{ display:"flex", gap:7 }}>{["john@email.com","New York"].map(c=><span key={c} style={{ fontSize:4.5, color:"rgba(255,200,210,0.7)" }}>{c}</span>)}</div>
// // // // // //       </div>
// // // // // //     );
// // // // // //     if (id === "technical") return (
// // // // // //       <div style={{ background:`linear-gradient(135deg,${h},#0e7490)`, padding:"12px 11px 10px", borderBottom:`2px solid ${a}` }}>
// // // // // //         <div style={{ fontSize:5, color:`${a}cc`, fontFamily:"'Courier New',monospace", marginBottom:2 }}>{"// resume.json — v2025"}</div>
// // // // // //         <div style={{ fontSize:8.5, fontWeight:700, color:"#fff", fontFamily:"'Courier New',monospace", marginBottom:1 }}>Jonathan Carter</div>
// // // // // //         <div style={{ fontSize:5, color:"rgba(180,230,240,0.8)", fontFamily:"'Courier New',monospace", marginBottom:4 }}>Senior Software Engineer</div>
// // // // // //         <div style={{ display:"flex", gap:6 }}>{["john@email.com","github.com/jcarter","NYC"].map(c=><span key={c} style={{ fontSize:4, color:"rgba(180,230,240,0.6)", fontFamily:"'Courier New',monospace" }}>{c}</span>)}</div>
// // // // // //       </div>
// // // // // //     );
// // // // // //     // classic
// // // // // //     return (
// // // // // //       <div style={{ padding:"11px 11px 8px", borderBottom:`1.5px solid ${a}`, background:"#fafafa" }}>
// // // // // //         <div style={{ fontSize:9.5, fontWeight:700, color:"#111", marginBottom:1 }}>Jonathan Carter</div>
// // // // // //         <div style={{ fontSize:6, color:"#555", marginBottom:4 }}>Senior Product Manager</div>
// // // // // //         <div style={{ display:"flex", gap:6 }}>{["john@email.com","555-1234","New York, NY"].map(c=><span key={c} style={{ fontSize:4.8, color:"#777" }}>{c}</span>)}</div>
// // // // // //       </div>
// // // // // //     );
// // // // // //   };

// // // // // //   const renderBody = () => {
// // // // // //     const topPad = id==="creative" ? "4px 10px 8px" : "8px 10px 8px";
// // // // // //     const mainContent = (
// // // // // //       <div style={{ padding: id==="modern" ? 0 : topPad }}>
// // // // // //         {/* Summary */}
// // // // // //         <div style={{ marginBottom:5 }}>
// // // // // //           {sLabel("Summary")}
// // // // // //           <div style={{ fontSize:5, color:"#444", lineHeight:1.55, fontFamily:bodyFont }}>Results-driven professional with 8+ years delivering high-impact outcomes at Fortune 500 companies.</div>
// // // // // //         </div>
// // // // // //         {/* Experience */}
// // // // // //         <div style={{ marginBottom:5 }}>
// // // // // //           {sLabel("Experience")}
// // // // // //           {[{ t:"Senior PM", c:"Google · 2020–Present", b:bullets.slice(0,2) },{ t:"Product Manager", c:"Stripe · 2017–2020", b:bullets.slice(2,3) }].map((exp,i)=>(
// // // // // //             <div key={i} style={{ marginBottom:4 }}>
// // // // // //               <div style={{ fontSize:6, fontWeight:700, color:"#111", fontFamily:bodyFont }}>{exp.t}</div>
// // // // // //               <div style={{ fontSize:4.8, color:"#666", fontStyle:"italic", marginBottom:1.5 }}>{exp.c}</div>
// // // // // //               {exp.b.map((b,j)=>(
// // // // // //                 <div key={j} style={{ display:"flex", gap:2, marginBottom:1 }}>
// // // // // //                   <span style={{ color:a, fontSize:5, flexShrink:0 }}>▪</span>
// // // // // //                   <span style={{ fontSize:4.8, color:"#333", lineHeight:1.5, fontFamily:bodyFont }}>{b}</span>
// // // // // //                 </div>
// // // // // //               ))}
// // // // // //             </div>
// // // // // //           ))}
// // // // // //         </div>
// // // // // //         {/* Skills */}
// // // // // //         <div>
// // // // // //           {sLabel("Skills")}
// // // // // //           <div style={{ display:"flex", flexWrap:"wrap", gap:2.5 }}>
// // // // // //             {skills.map(sk=>(
// // // // // //               <span key={sk} style={{ fontSize:4.5, background:`${a}12`, color:a, padding:"1.5px 5px", borderRadius:2, border:`0.5px solid ${a}25`, fontFamily:bodyFont }}>{sk}</span>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </div>
// // // // // //     );

// // // // // //     if (id === "modern") {
// // // // // //       return (
// // // // // //         <div style={{ padding:"7px 8px" }}>
// // // // // //           <div style={{ marginBottom:4 }}>
// // // // // //             {sLabel("Summary")}
// // // // // //             <div style={{ fontSize:5, color:"#444", lineHeight:1.55 }}>Results-driven PM with 8+ years delivering high-impact products at scale.</div>
// // // // // //           </div>
// // // // // //           <div style={{ marginBottom:4 }}>
// // // // // //             {sLabel("Experience")}
// // // // // //             {[{ t:"Senior PM", c:"Google · 2020–Present", b:bullets.slice(0,2) }].map((exp,i)=>(
// // // // // //               <div key={i} style={{ marginBottom:3 }}>
// // // // // //                 <div style={{ fontSize:5.5, fontWeight:700, color:"#111" }}>{exp.t}</div>
// // // // // //                 <div style={{ fontSize:4.8, color:"#666", fontStyle:"italic", marginBottom:1 }}>{exp.c}</div>
// // // // // //                 {exp.b.map((b,j)=><div key={j} style={{ display:"flex", gap:2, marginBottom:1 }}><span style={{ color:a, fontSize:4.5 }}>▪</span><span style={{ fontSize:4.5, color:"#333", lineHeight:1.5 }}>{b}</span></div>)}
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       );
// // // // // //     }
// // // // // //     return mainContent;
// // // // // //   };

// // // // // //   return (
// // // // // //     <div onClick={onClick} style={{
// // // // // //       width:162, flexShrink:0, background:"#fff", borderRadius:10, overflow:"hidden",
// // // // // //       boxShadow: active ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${a}` : "0 6px 20px rgba(0,0,0,0.09)",
// // // // // //       transform: active ? "scale(1.06) translateY(-6px)" : "scale(0.96)",
// // // // // //       transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)",
// // // // // //       cursor:"pointer", fontFamily:bodyFont,
// // // // // //     }}>
// // // // // //       {renderHeader()}
// // // // // //       {renderBody()}
// // // // // //     </div>
// // // // // //   );
// // // // // // }

// // // // // // export default function LandingPage() {
// // // // // //   const navigate = useNavigate();
// // // // // //   const { user, userData } = useAuth();
// // // // // //   const [openFaq,    setOpenFaq]    = useState(null);
// // // // // //   const [showModal,  setShowModal]  = useState(false);
// // // // // //   const [planId,     setPlanId]     = useState("ats_basic");
// // // // // //   const [menuOpen,   setMenuOpen]   = useState(false);
// // // // // //   const [scrolled,   setScrolled]   = useState(false);
// // // // // //   const [activeTmpl, setActiveTmpl] = useState(0);

// // // // // //   useEffect(() => {
// // // // // //     const fn = () => setScrolled(window.scrollY > 20);
// // // // // //     window.addEventListener("scroll", fn);
// // // // // //     return () => window.removeEventListener("scroll", fn);
// // // // // //   }, []);

// // // // // //   useEffect(() => {
// // // // // //     const t = setInterval(() => setActiveTmpl(p => (p+1) % allTemplates.length), 3600);
// // // // // //     return () => clearInterval(t);
// // // // // //   }, []);

// // // // // //   function startPayment(pid = "ats_basic") {
// // // // // //     setMenuOpen(false);
// // // // // //     if (user) { setPlanId(pid); setShowModal(true); }
// // // // // //     else navigate("/signup");
// // // // // //   }

// // // // // //   return (
// // // // // //     <div style={{ minHeight:"100vh", fontFamily:"'DM Sans','Inter',-apple-system,sans-serif", background:"#fff", color:"#111827" }}>
// // // // // //       <style>{`
// // // // // //         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,700&family=Fraunces:ital,wght@0,700;0,800;1,700;1,800&display=swap');
// // // // // //         *{box-sizing:border-box;margin:0;padding:0}
// // // // // //         @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
// // // // // //         @keyframes pulse2{0%,100%{opacity:1}50%{opacity:.4}}
// // // // // //         .fu0{animation:fadeUp .6s ease both}
// // // // // //         .fu1{animation:fadeUp .6s .1s ease both}
// // // // // //         .fu2{animation:fadeUp .6s .2s ease both}
// // // // // //         .fu3{animation:fadeUp .6s .34s ease both}
// // // // // //         .btn-d{display:inline-flex;align-items:center;gap:8px;padding:13px 30px;font-size:15px;font-weight:700;background:#111827;color:#fff;border:none;border-radius:50px;cursor:pointer;transition:all .22s;font-family:inherit;letter-spacing:-.01em;text-decoration:none}
// // // // // //         .btn-d:hover{background:#1f2937;transform:translateY(-2px);box-shadow:0 12px 28px rgba(0,0,0,.18)}
// // // // // //         .btn-l{display:inline-flex;align-items:center;gap:8px;padding:12px 24px;font-size:14px;font-weight:600;background:transparent;color:#111827;border:1.5px solid #d1d5db;border-radius:50px;cursor:pointer;transition:all .2s;font-family:inherit;text-decoration:none}
// // // // // //         .btn-l:hover{border-color:#111827;background:#f9fafb}
// // // // // //         .fc{background:#fff;border:1px solid #ebebeb;border-radius:18px;padding:26px;transition:all .28s}
// // // // // //         .fc:hover{border-color:#e0e0e0;transform:translateY(-4px);box-shadow:0 16px 40px rgba(0,0,0,.07)}
// // // // // //         .faq-item{border:1px solid #ebebeb;border-radius:14px;overflow:hidden;margin-bottom:10px}
// // // // // //         .fq{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;transition:background .15s;gap:12px;background:#fff}
// // // // // //         .fq:hover{background:#fafafa}
// // // // // //         @media(max-width:768px){
// // // // // //           .nd,.na{display:none!important}.hb{display:flex!important}
// // // // // //           .hc{justify-content:center!important}.tr{flex-direction:column!important;align-items:center!important;gap:14px!important}
// // // // // //           .pg{grid-template-columns:1fr!important}.fg{grid-template-columns:1fr!important}
// // // // // //           .sr{grid-template-columns:1fr 1fr!important}.cg{grid-template-columns:1fr!important}
// // // // // //           .fc2{grid-template-columns:1fr 1fr!important;gap:24px!important}
// // // // // //         }
// // // // // //       `}</style>

// // // // // //       {/* ══ NAV ══ */}
// // // // // //       <nav style={{ position:"sticky",top:0,zIndex:1000,background:scrolled?"rgba(255,255,255,.97)":"transparent",backdropFilter:"blur(16px)",borderBottom:scrolled?"1px solid #ebebeb":"1px solid transparent",transition:"all .3s",padding:"0 5%",height:66,display:"flex",alignItems:"center",justifyContent:"space-between" }}>
// // // // // //         <div onClick={()=>navigate("/")} style={{ display:"flex",alignItems:"center",gap:10,cursor:"pointer" }}>
// // // // // //           <div style={{ width:36,height:36,background:"#111827",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // // // //             <span style={{ color:"#fff",fontWeight:800,fontSize:17 }}>R</span>
// // // // // //           </div>
// // // // // //           <span style={{ fontWeight:800,fontSize:18,letterSpacing:"-.03em",color:"#111827",fontFamily:"'Fraunces',serif" }}>
// // // // // //             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
// // // // // //           </span>
// // // // // //         </div>
// // // // // //         <div className="nd" style={{ display:"flex",gap:28,alignItems:"center" }}>
// // // // // //           {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h])=>(
// // // // // //             <a key={l} href={h} style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none",transition:"color .15s" }}
// // // // // //               onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#4b5563"}>{l}</a>
// // // // // //           ))}
// // // // // //           <Link to="/support" style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none" }}>Support</Link>
// // // // // //         </div>
// // // // // //         <div className="na" style={{ display:"flex",gap:10,alignItems:"center" }}>
// // // // // //           {user
// // // // // //             ? <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/dashboard")}>Dashboard</button>
// // // // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>startPayment()}>New Analysis</button></>
// // // // // //             : <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/login")}>Sign In</button>
// // // // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>navigate("/signup")}>Get Started Free</button></>
// // // // // //           }
// // // // // //         </div>
// // // // // //         <button className="hb" onClick={()=>setMenuOpen(o=>!o)} style={{ display:"none",background:"none",border:"1px solid #e5e7eb",borderRadius:9,padding:"8px 11px",cursor:"pointer",flexDirection:"column",gap:4 }}>
// // // // // //           {[0,1,2].map(i=><span key={i} style={{ display:"block",width:20,height:2,background:"#374151" }}/>)}
// // // // // //         </button>
// // // // // //       </nav>

// // // // // //       {menuOpen && (
// // // // // //         <div style={{ position:"sticky",top:66,zIndex:999,background:"#fff",borderBottom:"1px solid #ebebeb",padding:"16px 5%",boxShadow:"0 8px 24px rgba(0,0,0,.07)" }}>
// // // // // //           <div style={{ display:"flex",flexDirection:"column",gap:2,marginBottom:14 }}>
// // // // // //             {["Features","Templates","Pricing","FAQ"].map(l=>(
// // // // // //               <a key={l} href={`#${l.toLowerCase()}`} onClick={()=>setMenuOpen(false)} style={{ padding:"10px 4px",fontSize:15,color:"#374151",textDecoration:"none",fontWeight:500,borderBottom:"1px solid #f5f5f5" }}>{l}</a>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //           <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
// // // // // //             <button className="btn-l" style={{ width:"100%",justifyContent:"center" }} onClick={()=>{setMenuOpen(false);navigate(user?"/dashboard":"/login");}}>
// // // // // //               {user?"Dashboard":"Sign In"}
// // // // // //             </button>
// // // // // //             <button className="btn-d" style={{ width:"100%",justifyContent:"center" }} onClick={()=>startPayment()}>
// // // // // //               {user?`New Analysis — ${priceDisplay}`:`Get Started — ${priceDisplay}`}
// // // // // //             </button>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}

// // // // // //       {/* ══ HERO ══ */}
// // // // // //       <section style={{ padding:"84px 5% 72px",background:"linear-gradient(155deg,#f8faff 0%,#fafafa 55%,#f0fdf4 100%)",position:"relative",overflow:"hidden" }}>
// // // // // //         <div style={{ position:"absolute",top:"-18%",right:"-8%",width:500,height:500,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,99,235,.06) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // // //         <div style={{ position:"absolute",bottom:"-15%",left:"-5%",width:420,height:420,borderRadius:"50%",background:"radial-gradient(circle,rgba(5,150,105,.05) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // // //           {/* Badge */}
// // // // // //           {/* <div className="fu0" style={{ display:"flex",justifyContent:"center",marginBottom:24 }}>
// // // // // //             <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"#fff",border:"1px solid #e5e7eb",borderRadius:40,padding:"7px 18px",boxShadow:"0 2px 8px rgba(0,0,0,.04)" }}>
// // // // // //               <span style={{ width:7,height:7,borderRadius:"50%",background:"#16a34a",animation:"pulse2 2s infinite" }}/>
// // // // // //               <span style={{ fontSize:12,fontWeight:600,color:"#374151" }}>AI-powered ATS resume analysis &amp; generation</span>
// // // // // //             </div>
// // // // // //           </div> */}
// // // // // //           <div className="fu0" style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
// // // // // //             <div style={{
// // // // // //               display: "inline-flex",
// // // // // //               alignItems: "center",
// // // // // //               gap: 12,
// // // // // //               background: "white",
// // // // // //               border: "1px solid #eef2ff",
// // // // // //               borderRadius: 100,
// // // // // //               padding: "8px 28px 8px 24px",
// // // // // //               boxShadow: "0 8px 20px -12px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.02)",
// // // // // //               transition: "all 0.3s ease",
// // // // // //             }}>
// // // // // //               {/* Animated pulse dot */}
// // // // // //               <div style={{
// // // // // //                 width: 8,
// // // // // //                 height: 8,
// // // // // //                 borderRadius: "50%",
// // // // // //                 background: "#3b82f6",
// // // // // //                 animation: "professionalPulse 1.8s ease-in-out infinite",
// // // // // //                 boxShadow: "0 0 0 0 rgba(59, 130, 246, 0.3)"
// // // // // //               }} />
              
// // // // // //               {/* Star icon + text */}
// // // // // //               <span style={{
// // // // // //                 fontSize: 13,
// // // // // //                 fontWeight: 500,
// // // // // //                 color: "#334155",
// // // // // //                 letterSpacing: "-0.2px"
// // // // // //               }}>
// // // // // //                 <span style={{ marginRight: 4 }}>⭐</span> 
// // // // // //                 <span style={{ fontWeight: 700, color: "#0f172a" }}>AI-powered</span> 
// // // // // //                 {" "}ATS resume analysis & generation
// // // // // //               </span>
              
// // // // // //               {/* Small "v2.0" tag */}
// // // // // // <span style={{
// // // // // //   fontSize: 10,
// // // // // //   fontWeight: 700,
// // // // // //   background: "linear-gradient(135deg, #1e293b, #0f172a)",
// // // // // //   color: "white",
// // // // // //   padding: "2px 10px",
// // // // // //   borderRadius: 100,
// // // // // //   letterSpacing: "0.3px"
// // // // // // }}>
// // // // // //   PRO
// // // // // // </span>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* Headline */}
// // // // // //           <h1 className="fu1" style={{ fontFamily:"'Fraunces',Georgia,serif",fontSize:"clamp(38px,6.5vw,72px)",fontWeight:800,lineHeight:1.06,letterSpacing:"-.03em",color:"#111827",textAlign:"center",marginBottom:22 }}>
// // // // // //             Beat the ATS.<br/>
// // // // // //             <em style={{ fontStyle:"italic",color:"#2563eb",position:"relative" }}>
// // // // // //               Land more interviews.
// // // // // //               <svg style={{ position:"absolute",bottom:-4,left:0,width:"100%",height:5 }} viewBox="0 0 400 5" preserveAspectRatio="none">
// // // // // //                 <path d="M0 3.5 Q100 0 200 3.5 Q300 7 400 3.5" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // // // // //               </svg>
// // // // // //             </em>
// // // // // //           </h1>
// // // // // //           {/* Subline */}
// // // // // //           <p className="fu2" style={{ textAlign:"center",fontSize:"clamp(15px,2vw,18px)",color:"#6b7280",lineHeight:1.75,maxWidth:560,margin:"0 auto 34px" }}>
// // // // // //             Upload your resume, paste any job description — get your ATS score, keyword gaps, AI rewrite suggestions, and a professionally improved resume for just <strong style={{ color:"#111827" }}>{priceDisplay}</strong>.
// // // // // //           </p>
// // // // // //           {/* CTAs */}
// // // // // //           <div className="hc fu3" style={{ display:"flex",gap:12,justifyContent:"center",marginBottom:44,flexWrap:"wrap" }}>
// // // // // //             <button className="btn-d" style={{ fontSize:16,padding:"15px 36px" }} onClick={()=>startPayment()}>
// // // // // //               {user?`New Analysis — ${priceDisplay}`:`Analyze My Resume — ${priceDisplay}`} →
// // // // // //             </button>
// // // // // //             <button className="btn-l" style={{ fontSize:14 }} onClick={()=>document.getElementById("templates")?.scrollIntoView({behavior:"smooth"})}>
// // // // // //               See Templates ↓
// // // // // //             </button>
// // // // // //           </div>
// // // // // //           {/* Trust badges */}
// // // // // //           <div className="fu3" style={{ display:"flex",justifyContent:"center",gap:28,flexWrap:"wrap" }}>
// // // // // //             {[["lock","Stripe Secure"],["zap","60s Analysis"],["target","ATS Optimized"],["check","No Subscription"]].map(([ic,lb])=>(
// // // // // //               <div key={lb} style={{ display:"flex",alignItems:"center",gap:6 }}>
// // // // // //                 <Icon name={ic} size={14} color="#9ca3af" strokeWidth={2} />
// // // // // //                 <span style={{ fontSize:12,color:"#9ca3af",fontWeight:500 }}>{lb}</span>
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ STATS BAR ══ */}
// // // // // //       <section style={{ background:"#111827",padding:"34px 5%" }}>
// // // // // //         <div style={{ maxWidth:1000,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24 }}>
// // // // // //           {[
// // // // // //             {v:76,s:"%",l:"of resumes rejected by ATS before a human sees them"},
// // // // // //             {v:7,s:"s",l:"average time a recruiter spends reading a resume"},
// // // // // //             {v:priceDisplay,s:"",l:"one-time price — no monthly subscription ever"},
// // // // // //             {v:analysisCount,s:"×",l:`ATS analyses included — run ${analysisCount} times per purchase`},
// // // // // //           ].map(st=>(
// // // // // //             <div key={st.l} style={{ textAlign:"center" }}>
// // // // // //               <div style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,3.5vw,38px)",color:"#fff",fontWeight:700,marginBottom:5,fontStyle:"italic" }}>
// // // // // //                 {typeof st.v==="string"?st.v:<Counter target={st.v} suffix={st.s}/>}
// // // // // //               </div>
// // // // // //               <div style={{ fontSize:11,color:"rgba(255,255,255,.38)",lineHeight:1.5,maxWidth:110,margin:"0 auto" }}>{st.l}</div>
// // // // // //             </div>
// // // // // //           ))}
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ FEATURES ══ */}
// // // // // //       {/* <section id="features" style={{ padding:"90px 5%",background:"#fff" }}>
// // // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // // //           <div style={{ textAlign:"center",marginBottom:50 }}>
// // // // // //             <div style={{ display:"inline-block",background:"#f0fdf4",color:"#16a34a",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>What You Get</div>
// // // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,4vw,42px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // // // // //               Everything to get noticed<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>by recruiters</em>
// // // // // //             </h2>
// // // // // //             <p style={{ fontSize:15,color:"#6b7280",maxWidth:480,margin:"0 auto" }}>Powered by the world’s best ATS AI — built for real results, fast</p>
// // // // // //           </div>
// // // // // //           <div className="fg" style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16 }}>
// // // // // //             {[
// // // // // //               {icon:"🎯",title:"ATS Score 0–100",desc:"Precise compatibility score with section-by-section breakdown — summary, experience, skills, education.",color:"#2563eb"},
// // // // // //               {icon:"🔍",title:"Keyword Gap Analysis",desc:"See exactly which keywords are missing vs the job description, with natural injection suggestions.",color:"#7c3aed"},
// // // // // //               {icon:"✍️",title:"AI Rewrite Suggestions",desc:"Actionable rewrites for weak bullet points tailored to your specific role and the job description.",color:"#059669"},
// // // // // //               {icon:"✨",title:"AI-Improved Resume",desc:"Your actual resume data + analysis insights = truly improved, keyword-optimized resume. Not generic.",color:"#d97706"},
// // // // // //               // {icon:"📄",title:`${allTemplates.length} ATS Templates`,desc:`${allTemplates.length} professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`,color:"#e11d48"},
// // // // // //               {icon:"📄",title:`Multiple ATS Templates`,desc:`Professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`,color:"#e11d48"},
// // // // // //               {icon:"📥",title:"PDF, Word & HTML",desc:"Download in any format the application requires — PDF for most roles, Word for older ATS systems.",color:"#0891b2"},
// // // // // //             ].map(f=>(
// // // // // //               <div key={f.title} className="fc">
// // // // // //                 <div style={{ width:46,height:46,borderRadius:13,background:`${f.color}12`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,marginBottom:18 }}>{f.icon}</div>
// // // // // //                 <h3 style={{ fontSize:16,fontWeight:700,color:"#111827",marginBottom:8 }}>{f.title}</h3>
// // // // // //                 <p style={{ fontSize:13,color:"#6b7280",lineHeight:1.72 }}>{f.desc}</p>
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section> */}

// // // // // // <section id="features" style={{ padding: "80px 5%", background: "#fafbfc", position: "relative", overflow: "hidden" }}>
// // // // // //   {/* Background decorative elements - hidden on mobile */}
// // // // // //   <div style={{ 
// // // // // //     position: "absolute", 
// // // // // //     top: "20%", 
// // // // // //     right: "-5%", 
// // // // // //     width: "400px", 
// // // // // //     height: "400px", 
// // // // // //     borderRadius: "50%", 
// // // // // //     background: "radial-gradient(circle, rgba(37,99,235,0.04) 0%, transparent 70%)", 
// // // // // //     pointerEvents: "none",
// // // // // //   }} />
// // // // // //   <div style={{ 
// // // // // //     position: "absolute", 
// // // // // //     bottom: "10%", 
// // // // // //     left: "-5%", 
// // // // // //     width: "350px", 
// // // // // //     height: "350px", 
// // // // // //     borderRadius: "50%", 
// // // // // //     background: "radial-gradient(circle, rgba(5,150,105,0.04) 0%, transparent 70%)", 
// // // // // //     pointerEvents: "none",
// // // // // //   }} />
  
// // // // // //   <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative" }}>
    
// // // // // //     {/* Section Header - Mobile responsive */}
// // // // // //     <div style={{ textAlign: "center", marginBottom: "clamp(40px, 8vw, 64px)" }}>
// // // // // //       <div style={{ 
// // // // // //         display: "inline-flex", 
// // // // // //         alignItems: "center", 
// // // // // //         gap: 8,
// // // // // //         background: "#fff", 
// // // // // //         color: "#2563eb", 
// // // // // //         fontSize: "clamp(11px, 3vw, 12px)", 
// // // // // //         fontWeight: 700, 
// // // // // //         padding: "6px 16px", 
// // // // // //         borderRadius: 30, 
// // // // // //         letterSpacing: ".06em", 
// // // // // //         textTransform: "uppercase", 
// // // // // //         marginBottom: 20,
// // // // // //         border: "1px solid #e2e8f0",
// // // // // //         boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
// // // // // //       }}>
// // // // // //         <span style={{ fontSize: "clamp(10px, 3vw, 12px)" }}>✨</span> Why Choose Us
// // // // // //       </div>
// // // // // //       <h2 style={{ 
// // // // // //         fontFamily: "'Fraunces', Georgia, serif", 
// // // // // //         fontSize: "clamp(28px, 7vw, 48px)", 
// // // // // //         fontWeight: 800, 
// // // // // //         color: "#0f172a", 
// // // // // //         lineHeight: 1.2, 
// // // // // //         letterSpacing: "-0.02em", 
// // // // // //         marginBottom: 16,
// // // // // //       }}>
// // // // // //         Everything you need to <br style={{ display: "none" }} />
// // // // // //         <span style={{ color: "#2563eb", position: "relative", display: "inline-block" }}>
// // // // // //           stand out
// // // // // //           <svg style={{ position: "absolute", bottom: 6, left: 0, width: "100%", height: 8 }} viewBox="0 0 200 8" preserveAspectRatio="none">
// // // // // //             <path d="M0 4 Q50 0 100 4 Q150 8 200 4" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.4"/>
// // // // // //           </svg>
// // // // // //         </span>
// // // // // //       </h2>
// // // // // //       <p style={{ 
// // // // // //         fontSize: "clamp(14px, 4vw, 16px)", 
// // // // // //         color: "#64748b", 
// // // // // //         maxWidth: 540, 
// // // // // //         margin: "0 auto", 
// // // // // //         lineHeight: 1.6,
// // // // // //         padding: "0 20px",
// // // // // //       }}>
// // // // // //         Powered by advanced AI technology to give you the competitive edge in your job search
// // // // // //       </p>
// // // // // //     </div>

// // // // // //     {/* Features Grid - Fully responsive */}
// // // // // //     <div style={{ 
// // // // // //       display: "grid", 
// // // // // //       gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", 
// // // // // //       gap: "clamp(20px, 4vw, 30px)",
// // // // // //       maxWidth: 1000,
// // // // // //       margin: "0 auto",
// // // // // //     }}>
// // // // // //       {[
// // // // // //         { 
// // // // // //           icon: "🎯", 
// // // // // //           title: "ATS Score 0–100", 
// // // // // //           desc: "Get a precise compatibility score with section-by-section breakdown of your resume against any job description.",
// // // // // //           color: "#2563eb",
// // // // // //           badge: "AI-Powered",
// // // // // //         },
// // // // // //         { 
// // // // // //           icon: "🔍", 
// // // // // //           title: "Keyword Gap Analysis", 
// // // // // //           desc: "Instantly identify missing keywords and get natural suggestions to inject them into your resume.",
// // // // // //           color: "#7c3aed",
// // // // // //           badge: "Real-time",
// // // // // //         },
// // // // // //         { 
// // // // // //           icon: "✍️", 
// // // // // //           title: "AI Rewrite Suggestions", 
// // // // // //           desc: "Receive actionable rewrites for weak bullet points tailored specifically to your target role.",
// // // // // //           color: "#059669",
// // // // // //           badge: "Smart",
// // // // // //         },
// // // // // //         { 
// // // // // //           icon: "✨", 
// // // // // //           title: "AI-Improved Resume", 
// // // // // //           desc: "Your actual resume data + analysis insights = a truly optimized, keyword-rich resume.",
// // // // // //           color: "#d97706",
// // // // // //           badge: "Personalized",
// // // // // //         },
// // // // // //         { 
// // // // // //           icon: "📄", 
// // // // // //           title: "Multiple ATS Templates", 
// // // // // //           desc: "Choose from professionally designed, ATS-tested layouts that work with every major system.",
// // // // // //           color: "#e11d48",
// // // // // //           badge: "7+ Options",
// // // // // //         },
// // // // // //         { 
// // // // // //           icon: "📥", 
// // // // // //           title: "PDF, Word & HTML", 
// // // // // //           desc: "Download your optimized resume in any format — PDF for most roles, Word for older ATS systems.",
// // // // // //           color: "#0891b2",
// // // // // //           badge: "Flexible",
// // // // // //         },
// // // // // //       ].map(f => (
// // // // // //         <div key={f.title} style={{ 
// // // // // //           background: "#fff", 
// // // // // //           borderRadius: "clamp(20px, 4vw, 24px)", 
// // // // // //           padding: "clamp(20px, 4vw, 28px)", 
// // // // // //           border: "1px solid #eef2ff", 
// // // // // //           transition: "all 0.3s ease",
// // // // // //           cursor: "default",
// // // // // //           position: "relative",
// // // // // //           display: "flex",
// // // // // //           flexDirection: "column",
// // // // // //           gap: "clamp(16px, 4vw, 20px)",
// // // // // //           boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
// // // // // //         }}
// // // // // //         onMouseEnter={e => {
// // // // // //           e.currentTarget.style.transform = "translateY(-4px)";
// // // // // //           e.currentTarget.style.borderColor = f.color + "30";
// // // // // //           e.currentTarget.style.boxShadow = `0 20px 32px ${f.color}10`;
// // // // // //         }}
// // // // // //         onMouseLeave={e => {
// // // // // //           e.currentTarget.style.transform = "translateY(0)";
// // // // // //           e.currentTarget.style.borderColor = "#eef2ff";
// // // // // //           e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.02)";
// // // // // //         }}>
          
// // // // // //           {/* Icon */}
// // // // // //           <div style={{ flexShrink: 0, textAlign: "center" }}>
// // // // // //             <div style={{ 
// // // // // //               width: "clamp(56px, 10vw, 64px)", 
// // // // // //               height: "clamp(56px, 10vw, 64px)", 
// // // // // //               borderRadius: "clamp(16px, 4vw, 20px)", 
// // // // // //               background: `linear-gradient(135deg, ${f.color}12, ${f.color}05)`, 
// // // // // //               display: "flex", 
// // // // // //               alignItems: "center", 
// // // // // //               justifyContent: "center", 
// // // // // //               fontSize: "clamp(28px, 6vw, 32px)",
// // // // // //               border: `1px solid ${f.color}20`,
// // // // // //               margin: "0 auto",
// // // // // //             }}>
// // // // // //               {f.icon}
// // // // // //             </div>
// // // // // //           </div>
          
// // // // // //           {/* Content */}
// // // // // //           <div style={{ flex: 1, textAlign: "center" }}>
// // // // // //             <div style={{ 
// // // // // //               display: "flex", 
// // // // // //               alignItems: "center", 
// // // // // //               justifyContent: "center",
// // // // // //               flexDirection: "column",
// // // // // //               flexWrap: "wrap",
// // // // // //               gap: 8,
// // // // // //               marginBottom: 12,
// // // // // //             }}>
// // // // // //               <h3 style={{ 
// // // // // //                 fontSize: "clamp(17px, 4vw, 18px)", 
// // // // // //                 fontWeight: 800, 
// // // // // //                 color: "#0f172a",
// // // // // //                 letterSpacing: "-0.01em",
// // // // // //               }}>
// // // // // //                 {f.title}
// // // // // //               </h3>
// // // // // //               <span style={{ 
// // // // // //                 background: `${f.color}10`, 
// // // // // //                 color: f.color, 
// // // // // //                 fontSize: "clamp(9px, 3vw, 10px)", 
// // // // // //                 fontWeight: 700, 
// // // // // //                 padding: "3px 12px", 
// // // // // //                 borderRadius: 30,
// // // // // //                 letterSpacing: "0.03em",
// // // // // //                 display: "inline-block",
// // // // // //               }}>
// // // // // //                 {f.badge}
// // // // // //               </span>
// // // // // //             </div>
// // // // // //             <p style={{ 
// // // // // //               fontSize: "clamp(13px, 3.5vw, 14px)", 
// // // // // //               color: "#64748b", 
// // // // // //               lineHeight: 1.65, 
// // // // // //               marginBottom: 0,
// // // // // //             }}>
// // // // // //               {f.desc}
// // // // // //             </p>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       ))}
// // // // // //     </div>

// // // // // //     {/* Bottom CTA Link - Responsive */}
// // // // // //     <div style={{ textAlign: "center", marginTop: "clamp(40px, 8vw, 48px)" }}>
// // // // // //       <button 
// // // // // //         onClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })}
// // // // // //         style={{
// // // // // //           background: "transparent",
// // // // // //           border: "none",
// // // // // //           color: "#2563eb",
// // // // // //           fontSize: "clamp(13px, 3.5vw, 14px)",
// // // // // //           fontWeight: 600,
// // // // // //           cursor: "pointer",
// // // // // //           display: "inline-flex",
// // // // // //           alignItems: "center",
// // // // // //           gap: 8,
// // // // // //           padding: "12px 24px",
// // // // // //           borderRadius: 40,
// // // // // //           transition: "all 0.2s ease",
// // // // // //           width: "auto",
// // // // // //           justifyContent: "center",
// // // // // //         }}
// // // // // //         onMouseEnter={e => {
// // // // // //           e.currentTarget.style.background = "#eff6ff";
// // // // // //           e.currentTarget.style.gap = "12px";
// // // // // //         }}
// // // // // //         onMouseLeave={e => {
// // // // // //           e.currentTarget.style.background = "transparent";
// // // // // //           e.currentTarget.style.gap = "8px";
// // // // // //         }}
// // // // // //       >
// // // // // //         See all features
// // // // // //         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // // //           <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // //         </svg>
// // // // // //       </button>
// // // // // //     </div>
// // // // // //   </div>

// // // // // //   {/* Media query for larger screens to show line break */}
// // // // // //   <style>{`
// // // // // //     @media (min-width: 768px) {
// // // // // //       .features-section br {
// // // // // //         display: block;
// // // // // //       }
// // // // // //     }
// // // // // //   `}</style>
// // // // // // </section>

// // // // // //       {/* ══ HOW IT WORKS ══ */}
// // // // // //       <section style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // // //         <div style={{ maxWidth:1020,margin:"0 auto" }}>
// // // // // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // // // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Simple Process</div>
// // // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em" }}>
// // // // // //               From signup to results<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>in under 60 seconds</em>
// // // // // //             </h2>
// // // // // //           </div>
// // // // // //           <div className="sr" style={{ display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12 }}>
// // // // // //             {[
// // // // // //               {n:"01",icon:"creditCard", title:`Pay ${priceDisplay}`,        desc:"One-time payment. No subscription."},
// // // // // //               {n:"02",icon:"upload",     title:"Upload Resume",               desc:"Word file or paste your text."},
// // // // // //               {n:"03",icon:"clipboard",  title:"Paste Job Description",       desc:"Copy from any job board."},
// // // // // //               {n:"04",icon:"target",     title:`Get ATS Score`,               desc:`Run up to ${analysisCount}× per purchase.`},
// // // // // //               {n:"05",icon:"fileText",   title:"Generate Resume",             desc:"Pick best analysis + template → done."},
// // // // // //             ].map((s,i)=>(
// // // // // //               <div key={s.n} style={{ textAlign:"center",position:"relative" }}>
// // // // // //                 {i<4&&<div style={{ position:"absolute",top:25,right:-8,width:16,height:1,background:"#d1d5db",zIndex:1 }}/>}
// // // // // //                 <div style={{ width:50,height:50,borderRadius:"50%",background:"#111827",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",position:"relative",zIndex:2 }}>
// // // // // //                   <Icon name={s.icon} size={22} color="#fff" strokeWidth={1.7} />
// // // // // //                 </div>
// // // // // //                 <div style={{ fontSize:10,color:"#9ca3af",fontWeight:700,letterSpacing:".1em",marginBottom:5 }}>{s.n}</div>
// // // // // //                 <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:4 }}>{s.title}</div>
// // // // // //                 <div style={{ fontSize:11,color:"#9ca3af",lineHeight:1.6 }}>{s.desc}</div>
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ TEMPLATES ══ */}
// // // // // //       <section id="templates" style={{ background:"#fff",padding:"82px 5%",overflow:"hidden" }}>
// // // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // // // // //             <div style={{ display:"inline-block",background:"#fdf4ff",color:"#7c3aed",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>{allTemplates.length} Templates Included Free</div>
// // // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // // // // //               ATS-tested resume templates<br/><em style={{ fontStyle:"italic",color:"#7c3aed" }}>that impress humans too</em>
// // // // // //             </h2>
// // // // // //             <p style={{ fontSize:15,color:"#6b7280",maxWidth:500,margin:"0 auto" }}>
// // // // // //               Every template passes ATS parsing tests. All {allTemplates.length} layouts use clean formatting, standard headings, and selectable text.
// // // // // //             </p>
// // // // // //           </div>

// // // // // //           {/* Template previews */}
// // // // // //           <div className="tr" style={{ display:"flex",gap:14,justifyContent:"center",marginBottom:32,alignItems:"flex-end",flexWrap:"wrap" }}>
// // // // // //             {allTemplates.map((t,i)=>(
// // // // // //               <div key={t.id} onClick={()=>setActiveTmpl(i)} style={{ cursor:"pointer", transform: activeTmpl===i?"scale(1.05) translateY(-6px)":"scale(0.97)", transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)", boxShadow: activeTmpl===i ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${t.accent}` : "0 6px 20px rgba(0,0,0,0.09)", borderRadius:10, overflow:"hidden" }}><TemplateMini t={t} scale={0.27} width={600} /></div>
// // // // // //             ))}
// // // // // //           </div>

// // // // // //           {/* Dots + active name */}
// // // // // //           <div style={{ textAlign:"center",marginBottom:36 }}>
// // // // // //             <div style={{ display:"flex",justifyContent:"center",gap:6,marginBottom:12 }}>
// // // // // //               {allTemplates.map((t,i)=>(
// // // // // //                 <button key={t.id} onClick={()=>setActiveTmpl(i)}
// // // // // //                   style={{ width:i===activeTmpl?24:7,height:7,borderRadius:4,background:i===activeTmpl?allTemplates[activeTmpl].accent:"#e5e7eb",border:"none",cursor:"pointer",transition:"all .3s" }}/>
// // // // // //               ))}
// // // // // //             </div>
// // // // // //             <div style={{ fontWeight:700,fontSize:17,color:"#111827",marginBottom:4,fontFamily:"'Fraunces',serif" }}>{allTemplates[activeTmpl]?.name}</div>
// // // // // //             <div style={{ fontSize:13,color:"#6b7280",marginBottom:8 }}>{allTemplates[activeTmpl]?.description}</div>
// // // // // //             <div style={{ display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap" }}>
// // // // // //               {allTemplates[activeTmpl]?.tags.map(tag=>(
// // // // // //                 <span key={tag} style={{ fontSize:11,background:"#f3f4f6",color:"#374151",padding:"3px 12px",borderRadius:20,fontWeight:500 }}>{tag}</span>
// // // // // //               ))}
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* ATS note */}
// // // // // //           <div style={{ 
// // // // // //             background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", 
// // // // // //             borderRadius: 16, 
// // // // // //             padding: "20px 24px", 
// // // // // //             border: "1px solid #cbd5e1", 
// // // // // //             display: "flex", 
// // // // // //             alignItems: "center", 
// // // // // //             gap: 16, 
// // // // // //             flexWrap: "wrap", 
// // // // // //             marginBottom: 20,
// // // // // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// // // // // //             transition: "all 0.2s ease",
// // // // // //           }}>
// // // // // //             <div style={{ 
// // // // // //               width: 44, 
// // // // // //               height: 44, 
// // // // // //               borderRadius: 12, 
// // // // // //               background: "linear-gradient(135deg, #10b981, #059669)", 
// // // // // //               display: "flex", 
// // // // // //               alignItems: "center", 
// // // // // //               justifyContent: "center",
// // // // // //               boxShadow: "0 4px 10px rgba(16, 185, 129, 0.2)",
// // // // // //               flexShrink: 0,
// // // // // //             }}>
// // // // // //               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // // //                 <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // //               </svg>
// // // // // //             </div>
// // // // // //             <div style={{ flex: 1, minWidth: 240 }}>
// // // // // //               <div style={{ 
// // // // // //                 fontWeight: 700, 
// // // // // //                 fontSize: 14, 
// // // // // //                 color: "#0f172a", 
// // // // // //                 marginBottom: 4,
// // // // // //                 display: "flex",
// // // // // //                 alignItems: "center",
// // // // // //                 gap: 8,
// // // // // //                 flexWrap: "wrap",
// // // // // //               }}>
// // // // // //                 All templates ATS-compliant by design             
// // // // // //               </div>
// // // // // //               <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // // // // //                 Standard section headings · Selectable text · No graphics in text layers · Compatible with Workday, Greenhouse, Taleo and more
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* CTA banner */}
// // // // // //           <div style={{ 
// // // // // //             background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", 
// // // // // //             borderRadius: 20, 
// // // // // //             padding: "24px 32px", 
// // // // // //             display: "flex", 
// // // // // //             alignItems: "center", 
// // // // // //             justifyContent: "space-between", 
// // // // // //             flexWrap: "wrap", 
// // // // // //             gap: 20, 
// // // // // //             border: "1px solid #a7f3d0",
// // // // // //             boxShadow: "0 8px 20px rgba(5, 150, 105, 0.12)",
// // // // // //             transition: "all 0.3s ease",
// // // // // //           }}>
// // // // // //             <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
// // // // // //               <div style={{ 
// // // // // //                 width: 52, 
// // // // // //                 height: 52, 
// // // // // //                 borderRadius: 16, 
// // // // // //                 background: "linear-gradient(135deg, #059669, #047857)", 
// // // // // //                 display: "flex", 
// // // // // //                 alignItems: "center", 
// // // // // //                 justifyContent: "center",
// // // // // //                 boxShadow: "0 6px 14px rgba(5, 150, 105, 0.25)",
// // // // // //               }}>
// // // // // //                 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // // //                   <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="white" strokeWidth="1.5" fill="none"/>
// // // // // //                   <path d="M12 6V12L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
// // // // // //                 </svg>
// // // // // //               </div>
// // // // // //               <div>
// // // // // //                 <div style={{ 
// // // // // //                   fontWeight: 800, 
// // // // // //                   fontSize: 16, 
// // // // // //                   color: "#064e3b", 
// // // // // //                   marginBottom: 6,
// // // // // //                   display: "flex",
// // // // // //                   alignItems: "center",
// // // // // //                   gap: 8,
// // // // // //                   flexWrap: "wrap",
// // // // // //                 }}>
// // // // // //                   <span style={{ fontSize: 18 }}>✨</span> 
// // // // // //                   Variety of templates included free with every analysis
// // // // // //                   <span style={{ 
// // // // // //                     background: "#059669", 
// // // // // //                     color: "#fff", 
// // // // // //                     fontSize: 10, 
// // // // // //                     fontWeight: 700, 
// // // // // //                     padding: "2px 10px", 
// // // // // //                     borderRadius: 20,
// // // // // //                     letterSpacing: "0.04em",
// // // // // //                   }}>
// // // // // //                     NO EXTRA COST
// // // // // //                   </span>
// // // // // //                 </div>
// // // // // //                 <div style={{ fontSize: 13, color: "#047857", lineHeight: 1.5 }}>
// // // // // //                   Pick your favourite after your ATS analysis.
// // // // // //                 </div>
// // // // // //               </div>
// // // // // //             </div>
// // // // // //             <button 
// // // // // //               className="btn-d" 
// // // // // //               style={{ 
// // // // // //                 background: "linear-gradient(135deg, #059669, #047857)", 
// // // // // //                 borderRadius: 40,
// // // // // //                 padding: "12px 28px",
// // // // // //                 fontSize: 14,
// // // // // //                 fontWeight: 700,
// // // // // //                 boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
// // // // // //                 transition: "all 0.2s ease",
// // // // // //                 cursor: "pointer",
// // // // // //                 border: "none",
// // // // // //                 color: "#fff",
// // // // // //                 display: "flex",
// // // // // //                 alignItems: "center",
// // // // // //                 gap: 8,
// // // // // //               }}
// // // // // //               onMouseEnter={e => {
// // // // // //                 e.currentTarget.style.transform = "translateY(-2px)";
// // // // // //                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(5, 150, 105, 0.35)";
// // // // // //               }}
// // // // // //               onMouseLeave={e => {
// // // // // //                 e.currentTarget.style.transform = "translateY(0)";
// // // // // //                 e.currentTarget.style.boxShadow = "0 4px 12px rgba(5, 150, 105, 0.3)";
// // // // // //               }}
// // // // // //               onClick={()=>startPayment()}
// // // // // //             >
// // // // // //               Start for {priceDisplay} 
// // // // // //               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // // //                 <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // //               </svg>
// // // // // //             </button>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ PRICING ══ */}
// // // // // //       <section id="pricing" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // // //         <div style={{ maxWidth:860,margin:"0 auto" }}>
// // // // // //           <div style={{ textAlign:"center",marginBottom:46 }}>
// // // // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Pricing</div>
// // // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Simple, honest pricing</h2>
// // // // // //             <p style={{ fontSize:15,color:"#6b7280" }}>No hidden fees. No subscriptions. Pay once, use fully.</p>
// // // // // //           </div>

// // // // // //           {/* Plan cards — driven entirely by servicesConfig */}
// // // // // //           <div className="pg" style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:22,maxWidth:700,margin:"0 auto" }}>
// // // // // //             {enabledPlans.filter(p=>p.active).map(plan=>{
// // // // // //               const isHighlight = plan.highlight;
// // // // // //               return (
// // // // // //                 <div key={plan.id} style={{
// // // // // //                   background: isHighlight?"#111827":"#fff",
// // // // // //                   borderRadius:22,padding:"32px 28px",
// // // // // //                   border: isHighlight?"none":"1.5px solid #ebebeb",
// // // // // //                   boxShadow: isHighlight?"0 24px 56px rgba(0,0,0,.18)":"0 4px 16px rgba(0,0,0,.04)",
// // // // // //                   position:"relative",
// // // // // //                 }}>
// // // // // //                   {isHighlight&&<div style={{ position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:"#2563eb",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20,whiteSpace:"nowrap" }}>Most Popular</div>}
// // // // // //                   <h3 style={{ fontSize:19,fontWeight:800,color:isHighlight?"#fff":"#111827",marginBottom:8,fontFamily:"'Fraunces',serif" }}>{plan.name}</h3>
// // // // // //                   <div style={{ marginBottom:8 }}>
// // // // // //                     <span style={{ fontFamily:"'Fraunces',serif",fontSize:52,color:isHighlight?"#fff":"#2563eb",fontWeight:700,fontStyle:"italic",letterSpacing:"-.03em" }}>{plan.price}</span>
// // // // // //                     <span style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.4)":"#9ca3af",marginLeft:5 }}>{plan.period}</span>
// // // // // //                   </div>
// // // // // //                   <p style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.55)":"#6b7280",marginBottom:22,lineHeight:1.65 }}>{plan.description}</p>
// // // // // //                   {/* Features from config */}
// // // // // //                   <div style={{ display:"flex",flexDirection:"column",gap:9,marginBottom:24 }}>
// // // // // //                     {plan.features.filter(f=>f.included).map(f=>(
// // // // // //                       <div key={f.text} style={{ display:"flex",alignItems:"center",gap:9,fontSize:13 }}>
// // // // // //                         <span style={{ width:16,height:16,borderRadius:"50%",background:isHighlight?"rgba(255,255,255,.12)":"#f0fdf4",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:9,color:isHighlight?"#fff":"#16a34a",fontWeight:700 }}>✓</span>
// // // // // //                         <span style={{ color:isHighlight?"rgba(255,255,255,.8)":"#374151" }}>{f.text}</span>
// // // // // //                       </div>
// // // // // //                     ))}
// // // // // //                   </div>
// // // // // //                   <button onClick={()=>startPayment(plan.id)}
// // // // // //                     style={{ width:"100%",padding:"13px",fontSize:15,fontWeight:700,borderRadius:50,background:isHighlight?"#2563eb":"#111827",color:"#fff",border:"none",cursor:"pointer",fontFamily:"inherit",transition:"all .2s" }}
// // // // // //                     onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"}
// // // // // //                     onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
// // // // // //                     {user?`Get ${plan.name} →`:"Get Started →"}
// // // // // //                   </button>
// // // // // //                   {!user&&<p style={{ fontSize:11,color:isHighlight?"rgba(255,255,255,.3)":"#9ca3af",textAlign:"center",marginTop:10 }}>
// // // // // //                     Have an account? <span style={{ color:isHighlight?"#60a5fa":"#2563eb",cursor:"pointer",fontWeight:600 }} onClick={()=>navigate("/login")}>Sign in</span>
// // // // // //                   </p>}
// // // // // //                 </div>
// // // // // //               );
// // // // // //             })}
// // // // // //           </div>

// // // // // //           {/* Comparison row */}
// // // // // //           <div style={{ marginTop:36,background:"#fff",borderRadius:16,border:"1px solid #ebebeb",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,.04)" }}>
// // // // // //             <div className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#111827" }}>
// // // // // //               <div style={{ padding:"14px 22px",fontSize:11,fontWeight:600,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:".06em" }}>Feature</div>
// // // // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // // // //                 <div style={{ fontSize:12,fontWeight:700,color:"#60a5fa" }}>ResumeScoreAI</div>
// // // // // //                 <div style={{ fontSize:20,fontWeight:800,color:"#fff",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>{priceDisplay}</div>
// // // // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.35)" }}>one-time</div>
// // // // // //               </div>
// // // // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // // // //                 <div style={{ fontSize:12,fontWeight:700,color:"rgba(255,255,255,.4)" }}>Other Tools</div>
// // // // // //                 <div style={{ fontSize:20,fontWeight:800,color:"rgba(255,255,255,.4)",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>$30</div>
// // // // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.25)" }}>per month</div>
// // // // // //               </div>
// // // // // //             </div>
// // // // // //             {[
// // // // // //               [`${analysisCount} ATS analyses per purchase`,"✅","❌ Per-resume pricing"],
// // // // // //               ["Uses YOUR real resume data","✅","❌ Generic output"],
// // // // // //               [`${allTemplates.length} ATS-tested templates free`,"✅","Limited on free tier"],
// // // // // //               ["No subscription required","✅","❌ Monthly billing"],
// // // // // //               ["AI keyword injection into your resume","✅","✅"],
// // // // // //               [`Price per resume`,`${priceDisplay} once`,"$19–$30/month"],
// // // // // //             ].map(([feat,us,them],i)=>(
// // // // // //               <div key={feat} className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",borderTop:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa" }}>
// // // // // //                 <div style={{ padding:"12px 22px",fontSize:13,color:"#374151",fontWeight:500 }}>{feat}</div>
// // // // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,fontWeight:600,color:us.startsWith("✅")?"#059669":"#111827" }}>{us}</div>
// // // // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,color:them.startsWith("❌")?"#dc2626":"#6b7280" }}>{them}</div>
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //           <p style={{ textAlign:"center",marginTop:22,fontSize:13,color:"#9ca3af" }}>
// // // // // //             We're new — and that's why we charge <strong style={{ color:"#111827" }}>{priceDisplay} once</strong> instead of $30/month.
// // // // // //           </p>
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ TRUST SIGNALS ══ */}
// // // // // //       <section style={{ background:"#fff",padding:"64px 5%" }}>
// // // // // //         <div style={{ maxWidth:900,margin:"0 auto" }}>
// // // // // //           <div style={{ textAlign:"center",marginBottom:32 }}>
// // // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(22px,3.5vw,34px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em" }}>Built to be trusted</h2>
// // // // // //           </div>
// // // // // //           <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:14 }}>
// // // // // //             {[
// // // // // //               {icon:"shield",      color:"#2563eb", title:"Stripe Payments",      desc:"Bank-level encryption. We never store your card details."},
// // // // // //               {icon:"cpu",         color:"#7c3aed", title:"AI Powered",      desc:"Powered by one of the world's most advanced language models."},
// // // // // //               {icon:"lock",        color:"#059669", title:"Firebase Secure",       desc:"Your resume data is encrypted and never sold to third parties."},
// // // // // //               {icon:"target",      color:"#d97706", title:"ATS-Tested Templates",  desc:"Verified against Workday, Greenhouse, Taleo and more."},
// // // // // //               {icon:"zap",         color:"#0891b2", title:"Instant Results",       desc:"Analysis in 15–30 seconds. Resume generation in 15–20 seconds."},
// // // // // //               {icon:"messageCircle",color:"#059669",title:"48-Hour Support",       desc:"Real human support — email and respond within 48 hours."},
// // // // // //             ].map(ts=>(
// // // // // //               <div key={ts.title} style={{ background:"#fafafa",borderRadius:14,padding:"18px",border:"1px solid #ebebeb",display:"flex",gap:12,alignItems:"flex-start" }}>
// // // // // //                 <IconBox name={ts.icon} size={36} color={ts.color} radius={9} strokeWidth={1.7} />
// // // // // //                 <div>
// // // // // //                   <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:3 }}>{ts.title}</div>
// // // // // //                   <div style={{ fontSize:12,color:"#6b7280",lineHeight:1.6 }}>{ts.desc}</div>
// // // // // //                 </div>
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ FAQ ══ */}
// // // // // //       <section id="faq" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // // //         <div style={{ maxWidth:700,margin:"0 auto" }}>
// // // // // //           <div style={{ textAlign:"center",marginBottom:44 }}>
// // // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Frequently asked questions</h2>
// // // // // //             <p style={{ fontSize:15,color:"#6b7280" }}>Still have questions? Use the chat button below 💬</p>
// // // // // //           </div>
// // // // // //           {servicesConfig.faq.map((item,i)=>(
// // // // // //             <div key={i} className="faq-item">
// // // // // //               <div className="fq" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
// // // // // //                 <span style={{ fontWeight:600,fontSize:14.5,color:"#111827",lineHeight:1.5 }}>{item.q}</span>
// // // // // //                 <span style={{ color:"#9ca3af",fontSize:10,transition:"transform .2s",display:"inline-block",transform:openFaq===i?"rotate(180deg)":"none",flexShrink:0 }}>▼</span>
// // // // // //               </div>
// // // // // //               {openFaq===i&&<div style={{ padding:"0 22px 18px",paddingTop:14,fontSize:14,color:"#6b7280",lineHeight:1.8,borderTop:"1px solid #f5f5f5" }}>{item.a}</div>}
// // // // // //             </div>
// // // // // //           ))}
// // // // // //         </div>
// // // // // //       </section>

// // // // // //       {/* ══ DISCLAIMER SECTION ══ */}
// // // // // //       <section style={{ background: "#f8fafc", padding: "40px 5%" }}>
// // // // // //         <div style={{ maxWidth: 800, margin: "0 auto", textAlign: "center" }}>
// // // // // //           <div style={{ 
// // // // // //             background: "#fff", 
// // // // // //             borderRadius: 16, 
// // // // // //             padding: "24px 32px", 
// // // // // //             border: "1px solid #e2e8f0",
// // // // // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
// // // // // //           }}>
// // // // // //             <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
// // // // // //             <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 10 }}>
// // // // // //               Important Disclaimer
// // // // // //             </h3>
// // // // // //             <p style={{ fontSize: 13, color: "#64748b", lineHeight: 1.7, marginBottom: 0 }}>
// // // // // //               The resume templates and AI-generated content provided by ResumeScoreAI are professional tools designed to 
// // // // // //               help you improve your resume and increase your chances of getting noticed by recruiters and ATS systems. 
// // // // // //               However, <strong style={{ color: "#dc2626" }}>we do not guarantee job placement, interviews, or any specific outcome</strong>. 
// // // // // //               Job search success depends on many factors including your qualifications, experience, interview performance, 
// // // // // //               and the specific requirements of each employer. Use our tools as part of a comprehensive job search strategy.
// // // // // //             </p>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </section>
      
// // // // // //       {/* ══ FINAL CTA ══ */}
// // // // // //       <section style={{ background:"#111827",padding:"90px 5%",textAlign:"center",position:"relative",overflow:"hidden" }}>
// // // // // //         <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:"70%",height:"70%",background:"radial-gradient(circle,rgba(37,99,235,.12) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // // //         <div style={{ maxWidth:600,margin:"0 auto",position:"relative" }}>
// // // // // //           <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(28px,5vw,52px)",fontWeight:800,color:"#fff",marginBottom:18,letterSpacing:"-.03em",lineHeight:1.1 }}>
// // // // // //             Ready to land<br/><em style={{ fontStyle:"italic",color:"#60a5fa" }}>more interviews?</em>
// // // // // //           </h2>
// // // // // //           <p style={{ fontSize:16,color:"rgba(255,255,255,.45)",marginBottom:32,lineHeight:1.7 }}>
// // // // // //             {analysisCount} ATS analyses + {resumeCount} AI-improved resume + {allTemplates.length} templates — all for just {priceDisplay}
// // // // // //           </p>
// // // // // //           <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap" }}>
// // // // // //             <button className="btn-d" style={{ background:"#fff",color:"#111827",fontSize:15,padding:"14px 36px" }} onClick={()=>startPayment()}>
// // // // // //               {user?`New Analysis — ${priceDisplay}`:`Analyze My Resume — ${priceDisplay}`} →
// // // // // //             </button>
// // // // // //             <Link to="/support" className="btn-l" style={{ borderColor:"rgba(255,255,255,.18)",color:"rgba(255,255,255,.7)" }}>Talk to Support</Link>
// // // // // //           </div>
// // // // // //           <p style={{ color:"rgba(255,255,255,.18)",fontSize:12,marginTop:24 }}>🔒 Stripe · No subscription · Instant results · 48h support</p>
// // // // // //         </div>
// // // // // //       </section>


// // // // // //       {/* ══ FOOTER ══ */}
// // // // // //       <footer style={{ background:"#0a0f1a",padding:"50px 5% 28px" }}>
// // // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // // //           <div className="fc2" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:40,paddingBottom:32,borderBottom:"1px solid rgba(255,255,255,.06)",marginBottom:22 }}>
// // // // // //             <div>
// // // // // //               <div style={{ display:"flex",alignItems:"center",gap:9,marginBottom:14 }}>
// // // // // //                 <div style={{ width:32,height:32,background:"#2563eb",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // // // //                   <span style={{ color:"#fff",fontWeight:800,fontSize:15 }}>R</span>
// // // // // //                 </div>
// // // // // //                 <span style={{ fontWeight:800,fontSize:16,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Fraunces',serif" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
// // // // // //               </div>
// // // // // //               <p style={{ fontSize:12,color:"rgba(255,255,255,.28)",lineHeight:1.8,maxWidth:230,marginBottom:12 }}>{servicesConfig.app.description}</p>
// // // // // //               <p style={{ fontSize:11,color:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",gap:6 }}><Icon name="mail" size={11} color="rgba(255,255,255,.2)" strokeWidth={1.8}/>{servicesConfig.app.email}</p>
// // // // // //             </div>
// // // // // //             {[
// // // // // //               {title:"Product",links:[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]]},
// // // // // //               {title:"Company",links:[["About","/about"],["Support","/support"],["Contact","/support"]]},
// // // // // //               {title:"Legal",links:[["Privacy","/privacy"],["Terms","/terms"],["Refund","/refund"]]},
// // // // // //             ].map(col=>(
// // // // // //               <div key={col.title}>
// // // // // //                 <h4 style={{ fontSize:10,fontWeight:700,color:"rgba(255,255,255,.32)",textTransform:"uppercase",letterSpacing:".1em",marginBottom:14 }}>{col.title}</h4>
// // // // // //                 {col.links.map(([label,href])=>{
// // // // // //                   const s={display:"block",fontSize:12,color:"rgba(255,255,255,.28)",textDecoration:"none",marginBottom:9,transition:"color .15s"};
// // // // // //                   return href.startsWith("#")
// // // // // //                     ? <a key={label} href={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</a>
// // // // // //                     : <Link key={label} to={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</Link>;
// // // // // //                 })}
// // // // // //               </div>
// // // // // //             ))}
// // // // // //           </div>
// // // // // //           <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10 }}>
// // // // // //             <span style={{ fontSize:11,color:"rgba(255,255,255,.16)" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// // // // // //             <div style={{ display:"flex",gap:14 }}>
// // // // // //               {[["lock","Stripe Secure"],["shield","256-bit SSL"],["check","GDPR Compliant"]].map(([ic,lb])=>(
// // // // // //                 <span key={lb} style={{ fontSize:10,color:"rgba(255,255,255,.16)",display:"inline-flex",alignItems:"center",gap:4 }}><Icon name={ic} size={10} color="rgba(255,255,255,.16)" strokeWidth={2}/>{lb}</span>
// // // // // //               ))}
// // // // // //             </div>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </footer>



// // // // // //       {/* Chat Widget */}
// // // // // //       <ChatWidget />

// // // // // //       {/* Payment Modal */}
// // // // // //       {showModal && (
// // // // // //         <PaymentModal
// // // // // //           onSuccess={()=>{ setShowModal(false); navigate("/dashboard"); }}
// // // // // //           onClose={()=>setShowModal(false)}
// // // // // //           userEmail={userData?.email||user?.email}
// // // // // //           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
// // // // // //           planId={planId}
// // // // // //           userId={user?.uid}
// // // // // //         />
// // // // // //       )}
      
// // // // // //     </div>
// // // // // //   );


// // // // // // }

// // // // // // src/pages/LandingPage.jsx
// // // // // // All plan pricing, features, and template data read from servicesConfig
// // // // // import { useState, useEffect, useRef } from "react";
// // // // // import { useNavigate, Link } from "react-router-dom";
// // // // // import { useAuth } from "../hooks/useAuth";
// // // // // import servicesConfig from "../utils/servicesConfig";
// // // // // // eslint-disable-next-line no-unused-vars
// // // // // import { getEnabledPlans } from "../utils/paymentConfig";
// // // // // import PaymentModal from "../components/PaymentModal";
// // // // // import ChatWidget from "../components/ChatWidget";
// // // // // import TemplateMini from "../components/TemplateMini";
// // // // // import Icon, { IconBox } from "../components/Icons";

// // // // // // ── Pull everything from config ──
// // // // // const basicPlan    = servicesConfig.plans.find(p => p.id === "ats_basic");
// // // // // const analysisCount= basicPlan?.analysisCount|| 2;
// // // // // const resumeCount  = basicPlan?.resumeGenCount|| 1;
// // // // // const allTemplates = servicesConfig.resumeTemplates.filter(t => t.active);
// // // // // const enabledPlans = servicesConfig.plans.filter(p => p.enabled);

// // // // // // ── Animated counter ──
// // // // // function Counter({ target, suffix="" }) {
// // // // //   const [n, setN] = useState(0);
// // // // //   const ref = useRef();
// // // // //   useEffect(() => {
// // // // //     const obs = new IntersectionObserver(([e]) => {
// // // // //       if (!e.isIntersecting) return;
// // // // //       let v = 0; const step = target / 55;
// // // // //       const t = setInterval(() => { v += step; if (v >= target) { setN(target); clearInterval(t); } else setN(Math.floor(v)); }, 18);
// // // // //       obs.disconnect();
// // // // //     }, { threshold: 0.3 });
// // // // //     if (ref.current) obs.observe(ref.current);
// // // // //     return () => obs.disconnect();
// // // // //   }, [target]);
// // // // //   return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
// // // // // }

// // // // // export default function LandingPage() {
// // // // //   const navigate = useNavigate();
// // // // //   const { user, userData } = useAuth();
// // // // //   const [openFaq,      setOpenFaq]      = useState(null);
// // // // //   const [showModal,    setShowModal]    = useState(false);
// // // // //   const [planId,       setPlanId]       = useState("ats_basic");
// // // // //   const [menuOpen,     setMenuOpen]     = useState(false);
// // // // //   const [scrolled,     setScrolled]     = useState(false);
// // // // //   const [activeTmpl,   setActiveTmpl]   = useState(0);
// // // // //   // ── Live price from server — always matches actual Stripe charge ──
// // // // //   const [priceDisplay, setPriceDisplay] = useState(basicPlan?.price || "$2.99");
// // // // //   const [serverPlans,  setServerPlans]  = useState({});
// // // // //   const [localPrice,   setLocalPrice]   = useState(null);

// // // // //   useEffect(() => {
// // // // //     const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
// // // // //     fetch(`${BACKEND}/config`)
// // // // //       .then(r => r.json())
// // // // //       .then(d => {
// // // // //         if (d.plans?.ats_basic?.priceDisplay) setPriceDisplay(d.plans.ats_basic.priceDisplay);
// // // // //         if (d.plans) setServerPlans(d.plans);
// // // // //       })
// // // // //       .catch(() => {});
// // // // //   }, []);

// // // // //   // ── Browser locale currency conversion — no API, no rate limit ──
// // // // //   useEffect(() => {
// // // // //     const usdAmount = (serverPlans?.ats_basic?.priceInCents || 299) / 100;

// // // // //     const langs    = navigator.languages?.length ? navigator.languages : [navigator.language || "en-US"];
// // // // //     const locale   = langs[0] || "en-US";
// // // // //     const parts    = locale.split("-");
// // // // //     const region   = parts[parts.length - 1]?.toUpperCase();

// // // // //     const USD_REGIONS = ["US","AS","EC","PR","SV","GU","MH","FM","MP","PW","TC","VI","ZW","BZ","PA"];
// // // // //     if (!region || USD_REGIONS.includes(region)) { setLocalPrice(null); return; }

// // // // //     const REGION_CURRENCY = {
// // // // //       IN:"INR", GB:"GBP", AU:"AUD", CA:"CAD",
// // // // //       DE:"EUR", FR:"EUR", IT:"EUR", ES:"EUR", NL:"EUR", BE:"EUR", PT:"EUR", AT:"EUR",
// // // // //       JP:"JPY", SG:"SGD", AE:"AED", ZA:"ZAR", BR:"BRL", MX:"MXN", NZ:"NZD",
// // // // //     };
// // // // //     const currency = REGION_CURRENCY[region];
// // // // //     if (!currency) { setLocalPrice(null); return; }

// // // // //     const CACHE_KEY = "fx_usd_rates_v1";
// // // // //     const CACHE_TTL = 60 * 60 * 1000; // 1 hour
// // // // //     const FALLBACK  = { INR:84, GBP:0.79, AUD:1.53, CAD:1.36, EUR:0.92, JPY:150, SGD:1.34, AED:3.67, ZAR:18.5, BRL:5.0, MXN:17.5, NZD:1.65 };

// // // // //     async function fetchAndDisplay() {
// // // // //       let rate = null;
// // // // //       try {
// // // // //         const cached = sessionStorage.getItem(CACHE_KEY);
// // // // //         if (cached) {
// // // // //           const { rates, ts } = JSON.parse(cached);
// // // // //           if (Date.now() - ts < CACHE_TTL && rates[currency]) {
// // // // //             rate = rates[currency];
// // // // //           }
// // // // //         }
// // // // //         if (!rate) {
// // // // //           const res  = await fetch("https://api.exchangerate-api.com/v4/latest/USD", { signal: AbortSignal.timeout(5000) });
// // // // //           const data = await res.json();
// // // // //           sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rates: data.rates, ts: Date.now() }));
// // // // //           rate = data.rates[currency];
// // // // //         }
// // // // //       } catch (_) {
// // // // //         rate = FALLBACK[currency] || null;
// // // // //       }
// // // // //       if (!rate) { setLocalPrice(null); return; }
// // // // //       const formatted = new Intl.NumberFormat(locale, {
// // // // //         style: "currency", currency, maximumFractionDigits: 0,
// // // // //       }).format(Math.round(usdAmount * rate));
// // // // //       setLocalPrice(formatted);
// // // // //     }

// // // // //     fetchAndDisplay();
// // // // //   }, [serverPlans]);

// // // // //   useEffect(() => {
// // // // //     const fn = () => setScrolled(window.scrollY > 20);
// // // // //     window.addEventListener("scroll", fn);
// // // // //     return () => window.removeEventListener("scroll", fn);
// // // // //   }, []);

// // // // //   useEffect(() => {
// // // // //     const t = setInterval(() => setActiveTmpl(p => (p+1) % allTemplates.length), 3600);
// // // // //     return () => clearInterval(t);
// // // // //   }, []);

// // // // //   function startPayment(pid = "ats_basic") {
// // // // //     setMenuOpen(false);
// // // // //     if (user) { setPlanId(pid); setShowModal(true); }
// // // // //     else navigate("/signup");
// // // // //   }

// // // // //   return (
// // // // //     <div style={{ minHeight:"100vh", fontFamily:"'DM Sans','Inter',-apple-system,sans-serif", background:"#fff", color:"#111827" }}>
// // // // //       <style>{`
// // // // //         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,700&family=Fraunces:ital,wght@0,700;0,800;1,700;1,800&display=swap');
// // // // //         *{box-sizing:border-box;margin:0;padding:0}
// // // // //         @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
// // // // //         @keyframes pulse2{0%,100%{opacity:1}50%{opacity:.4}}
// // // // //         .fu0{animation:fadeUp .6s ease both}
// // // // //         .fu1{animation:fadeUp .6s .1s ease both}
// // // // //         .fu2{animation:fadeUp .6s .2s ease both}
// // // // //         .fu3{animation:fadeUp .6s .34s ease both}
// // // // //         .btn-d{display:inline-flex;align-items:center;gap:8px;padding:13px 30px;font-size:15px;font-weight:700;background:#111827;color:#fff;border:none;border-radius:50px;cursor:pointer;transition:all .22s;font-family:inherit;letter-spacing:-.01em;text-decoration:none}
// // // // //         .btn-d:hover{background:#1f2937;transform:translateY(-2px);box-shadow:0 12px 28px rgba(0,0,0,.18)}
// // // // //         .btn-l{display:inline-flex;align-items:center;gap:8px;padding:12px 24px;font-size:14px;font-weight:600;background:transparent;color:#111827;border:1.5px solid #d1d5db;border-radius:50px;cursor:pointer;transition:all .2s;font-family:inherit;text-decoration:none}
// // // // //         .btn-l:hover{border-color:#111827;background:#f9fafb}
// // // // //         .fc{background:#fff;border:1px solid #ebebeb;border-radius:18px;padding:26px;transition:all .28s}
// // // // //         .fc:hover{border-color:#e0e0e0;transform:translateY(-4px);box-shadow:0 16px 40px rgba(0,0,0,.07)}
// // // // //         .faq-item{border:1px solid #ebebeb;border-radius:14px;overflow:hidden;margin-bottom:10px}
// // // // //         .fq{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;transition:background .15s;gap:12px;background:#fff}
// // // // //         .fq:hover{background:#fafafa}
// // // // //         @media(max-width:768px){
// // // // //           .nd,.na{display:none!important}.hb{display:flex!important}
// // // // //           .hc{justify-content:center!important}.tr{flex-direction:column!important;align-items:center!important;gap:14px!important}
// // // // //           .pg{grid-template-columns:1fr!important}.fg{grid-template-columns:1fr!important}
// // // // //           .sr{grid-template-columns:1fr 1fr!important}.cg{grid-template-columns:1fr!important}
// // // // //           .fc2{grid-template-columns:1fr 1fr!important;gap:24px!important}
// // // // //         }
// // // // //       `}</style>

// // // // //       {/* ══ NAV ══ */}
// // // // //       <nav style={{ position:"sticky",top:0,zIndex:1000,background:scrolled?"rgba(255,255,255,.97)":"transparent",backdropFilter:"blur(16px)",borderBottom:scrolled?"1px solid #ebebeb":"1px solid transparent",transition:"all .3s",padding:"0 5%",height:66,display:"flex",alignItems:"center",justifyContent:"space-between" }}>
// // // // //         <div onClick={()=>navigate("/")} style={{ display:"flex",alignItems:"center",gap:10,cursor:"pointer" }}>
// // // // //           <div style={{ width:36,height:36,background:"#111827",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // // //             <span style={{ color:"#fff",fontWeight:800,fontSize:17 }}>R</span>
// // // // //           </div>
// // // // //           <span style={{ fontWeight:800,fontSize:18,letterSpacing:"-.03em",color:"#111827",fontFamily:"'Fraunces',serif" }}>
// // // // //             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
// // // // //           </span>
// // // // //         </div>
// // // // //         <div className="nd" style={{ display:"flex",gap:28,alignItems:"center" }}>
// // // // //           {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h])=>(
// // // // //             <a key={l} href={h} style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none",transition:"color .15s" }}
// // // // //               onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#4b5563"}>{l}</a>
// // // // //           ))}
// // // // //           <Link to="/support" style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none" }}>Support</Link>
// // // // //         </div>
// // // // //         <div className="na" style={{ display:"flex",gap:10,alignItems:"center" }}>
// // // // //           {user
// // // // //             ? <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/dashboard")}>Dashboard</button>
// // // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>startPayment()}>{servicesConfig.app.ctaNavUser}</button></>
// // // // //             : <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/login")}>Sign In</button>
// // // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>navigate("/signup")}>{servicesConfig.app.ctaNav}</button></>
// // // // //           }
// // // // //         </div>
// // // // //         <button className="hb" onClick={()=>setMenuOpen(o=>!o)} style={{ display:"none",background:"none",border:"1px solid #e5e7eb",borderRadius:9,padding:"8px 11px",cursor:"pointer",flexDirection:"column",gap:4 }}>
// // // // //           {[0,1,2].map(i=><span key={i} style={{ display:"block",width:20,height:2,background:"#374151" }}/>)}
// // // // //         </button>
// // // // //       </nav>

// // // // //       {menuOpen && (
// // // // //         <div style={{ position:"sticky",top:66,zIndex:999,background:"#fff",borderBottom:"1px solid #ebebeb",padding:"16px 5%",boxShadow:"0 8px 24px rgba(0,0,0,.07)" }}>
// // // // //           <div style={{ display:"flex",flexDirection:"column",gap:2,marginBottom:14 }}>
// // // // //             {["Features","Templates","Pricing","FAQ"].map(l=>(
// // // // //               <a key={l} href={`#${l.toLowerCase()}`} onClick={()=>setMenuOpen(false)} style={{ padding:"10px 4px",fontSize:15,color:"#374151",textDecoration:"none",fontWeight:500,borderBottom:"1px solid #f5f5f5" }}>{l}</a>
// // // // //             ))}
// // // // //           </div>
// // // // //           <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
// // // // //             <button className="btn-l" style={{ width:"100%",justifyContent:"center" }} onClick={()=>{setMenuOpen(false);navigate(user?"/dashboard":"/login");}}>
// // // // //               {user?"Dashboard":"Sign In"}
// // // // //             </button>
// // // // //             <button className="btn-d" style={{ width:"100%",justifyContent:"center" }} onClick={()=>startPayment()}>
// // // // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""}
// // // // //             </button>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {/* ══ HERO ══ */}
// // // // //       <section style={{ padding:"84px 5% 72px",background:"linear-gradient(155deg,#f8faff 0%,#fafafa 55%,#f0fdf4 100%)",position:"relative",overflow:"hidden" }}>
// // // // //         <div style={{ position:"absolute",top:"-18%",right:"-8%",width:500,height:500,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,99,235,.06) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // //         <div style={{ position:"absolute",bottom:"-15%",left:"-5%",width:420,height:420,borderRadius:"50%",background:"radial-gradient(circle,rgba(5,150,105,.05) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //           {/* Badge - Attractive & Professional */}
// // // // //           <div className="fu0" style={{ display:"flex",justifyContent:"center",marginBottom:24 }}>
// // // // //             <div style={{
// // // // //               display:"inline-flex",
// // // // //               alignItems:"center",
// // // // //               gap:10,
// // // // //               background:"white",
// // // // //               border:"1px solid #eef2ff",
// // // // //               borderRadius:100,
// // // // //               padding:"6px 22px 6px 18px",
// // // // //               boxShadow:"0 4px 12px -6px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.02)",
// // // // //             }}>
// // // // //               <span style={{
// // // // //                 width:8,
// // // // //                 height:8,
// // // // //                 borderRadius:"50%",
// // // // //                 background:"#3b82f6",
// // // // //                 animation:"pulse2 2s infinite",
// // // // //                 boxShadow:"0 0 0 0 rgba(59,130,246,0.4)"
// // // // //               }}/>
// // // // //               <span style={{
// // // // //                 fontSize:12,
// // // // //                 fontWeight:500,
// // // // //                 color:"#334155",
// // // // //                 letterSpacing:"-0.2px"
// // // // //               }}>
// // // // //                 ⭐ <span style={{ fontWeight:700, color:"#0f172a" }}>AI-powered</span> {servicesConfig.app.shortDesc}
// // // // //               </span>
// // // // //             </div>
// // // // //           </div>
// // // // //           {/* Headline */}
// // // // //           <h1 className="fu1" style={{ fontFamily:"'Fraunces',Georgia,serif",fontSize:"clamp(38px,6.5vw,72px)",fontWeight:800,lineHeight:1.06,letterSpacing:"-.03em",color:"#111827",textAlign:"center",marginBottom:22 }}>
// // // // //             {servicesConfig.app.taglinePre}<br/>
// // // // //             <em style={{ fontStyle:"italic",color:"#2563eb",position:"relative" }}>
// // // // //               {servicesConfig.app.taglinePost}
// // // // //               <svg style={{ position:"absolute",bottom:-4,left:0,width:"100%",height:5 }} viewBox="0 0 400 5" preserveAspectRatio="none">
// // // // //                 <path d="M0 3.5 Q100 0 200 3.5 Q300 7 400 3.5" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // // // //               </svg>
// // // // //             </em>
// // // // //           </h1>
// // // // //           {/* Subline */}
// // // // //           <p className="fu2" style={{ textAlign:"center",fontSize:"clamp(15px,2vw,18px)",color:"#6b7280",lineHeight:1.75,maxWidth:560,margin:"0 auto 34px" }}>
// // // // //             Upload your resume, paste any job description — get your ATS score, keyword gaps, AI rewrite suggestions, and a professionally improved resume for just <strong style={{ color:"#111827" }}>{priceDisplay}</strong>.
// // // // //           </p>
// // // // //           {/* CTAs */}
// // // // //           <div className="hc fu3" style={{ display:"flex",gap:12,justifyContent:"center",marginBottom:44,flexWrap:"wrap" }}>
// // // // //             <button className="btn-d" style={{ fontSize:16,padding:"15px 36px" }} onClick={()=>startPayment()}>
// // // // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""} →
// // // // //             </button>
// // // // //             <button className="btn-l" style={{ fontSize:14 }} onClick={()=>document.getElementById("templates")?.scrollIntoView({behavior:"smooth"})}>
// // // // //               See Templates ↓
// // // // //             </button>
// // // // //           </div>
// // // // //           {/* Trust badges */}
// // // // //           <div className="fu3" style={{ display:"flex",justifyContent:"center",gap:28,flexWrap:"wrap" }}>
// // // // //             {[["lock","Stripe Secure"],["zap","60s Analysis"],["target","ATS Optimized"],["check","No Subscription"]].map(([ic,lb])=>(
// // // // //               <div key={lb} style={{ display:"flex",alignItems:"center",gap:6 }}>
// // // // //                 <Icon name={ic} size={14} color="#9ca3af" strokeWidth={2} />
// // // // //                 <span style={{ fontSize:12,color:"#9ca3af",fontWeight:500 }}>{lb}</span>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ STATS BAR ══ */}
// // // // //       <section style={{ background:"#111827",padding:"34px 5%" }}>
// // // // //         <div style={{ maxWidth:1000,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24 }}>
// // // // //           {[
// // // // //             {v:76,s:"%",l:"of resumes rejected by ATS before a human sees them"},
// // // // //             {v:7,s:"s",l:"average time a recruiter spends reading a resume"},
// // // // //             {v:priceDisplay,s:"",l:"one-time price — no monthly subscription ever"},
// // // // //             {v:analysisCount,s:"×",l:`ATS analyses included — run ${analysisCount} times per purchase`},
// // // // //           ].map(st=>(
// // // // //             <div key={st.l} style={{ textAlign:"center" }}>
// // // // //               <div style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,3.5vw,38px)",color:"#fff",fontWeight:700,marginBottom:5,fontStyle:"italic" }}>
// // // // //                 {typeof st.v==="string"?st.v:<Counter target={st.v} suffix={st.s}/>}
// // // // //               </div>
// // // // //               <div style={{ fontSize:11,color:"rgba(255,255,255,.38)",lineHeight:1.5,maxWidth:110,margin:"0 auto" }}>{st.l}</div>
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ FEATURES ══ */}
// // // // //       <section id="features" style={{ padding:"60px 5% 80px", background:"linear-gradient(180deg, #fff 0%, #fafcff 100%)" }}>
// // // // //   <div style={{ maxWidth:1100, margin:"0 auto" }}>
    
// // // // //     {/* Section Header - Redesigned */}
// // // // //     <div style={{ textAlign:"center", marginBottom:48 }}>
// // // // //       <div style={{
// // // // //         display:"inline-flex",
// // // // //         alignItems:"center",
// // // // //         gap:8,
// // // // //         background:"#3b82f6",
// // // // //         color:"white",
// // // // //         fontSize:"clamp(11px, 3vw, 12px)",
// // // // //         fontWeight:600,
// // // // //         padding:"6px 18px 6px 16px",
// // // // //         borderRadius:100,
// // // // //         letterSpacing:"0.03em",
// // // // //         textTransform:"uppercase",
// // // // //         marginBottom:20,
// // // // //         boxShadow:"0 4px 12px rgba(59,130,246,0.3)"
// // // // //       }}>
// // // // //         <span style={{ 
// // // // //           width:6, 
// // // // //           height:6, 
// // // // //           borderRadius:"50%", 
// // // // //           background:"white", 
// // // // //           display:"inline-block" 
// // // // //         }}/>
// // // // //         Why Choose Us
// // // // //       </div>
      
// // // // //       <h2 style={{
// // // // //         fontFamily:"'Fraunces',serif",
// // // // //         fontSize:"clamp(28px, 6vw, 48px)",
// // // // //         fontWeight:800,
// // // // //         color:"#0f172a",
// // // // //         lineHeight:1.2,
// // // // //         letterSpacing:"-0.03em",
// // // // //         marginBottom:14,
// // // // //         padding:"0 16px"
// // // // //       }}>
// // // // //         Everything you need to{" "}
// // // // //         <span style={{ position:"relative", display:"inline-block" }}>
// // // // //           stand out
// // // // //           <svg style={{ position:"absolute", bottom:-6, left:0, width:"100%", height:5 }} viewBox="0 0 200 6" preserveAspectRatio="none">
// // // // //             <path d="M0 3 Q50 0 100 3 Q150 6 200 3" stroke="#3b82f6" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // // // //           </svg>
// // // // //         </span>
// // // // //       </h2>
      
// // // // //       <p style={{
// // // // //         fontSize:"clamp(14px, 3.5vw, 16px)",
// // // // //         color:"#64748b",
// // // // //         maxWidth:520,
// // // // //         margin:"0 auto",
// // // // //         lineHeight:1.6,
// // // // //         padding:"0 16px"
// // // // //       }}>
// // // // //         Powered by advanced AI technology to give you the competitive edge in your job search
// // // // //       </p>
// // // // //     </div>

// // // // //     {/* Features Grid - Fully Responsive */}
// // // // //     <div style={{
// // // // //       display:"grid",
// // // // //       gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))",
// // // // //       gap:"clamp(16px, 4vw, 24px)",
// // // // //       position:"relative"
// // // // //     }}>
// // // // //       {[
// // // // //         {icon:"🎯", title:"ATS Score 0–100", desc:"Precise compatibility score with section-by-section breakdown — summary, experience, skills, education.", color:"#2563eb", gradient:"linear-gradient(135deg, #2563eb12, #3b82f608)"},
// // // // //         {icon:"🔍", title:"Keyword Gap Analysis", desc:"See exactly which keywords are missing vs the job description, with natural injection suggestions.", color:"#7c3aed", gradient:"linear-gradient(135deg, #7c3aed12, #8b5cf608)"},
// // // // //         {icon:"✍️", title:"AI Rewrite Suggestions", desc:"Actionable rewrites for weak bullet points tailored to your specific role and the job description.", color:"#059669", gradient:"linear-gradient(135deg, #05966912, #10b98108)"},
// // // // //         {icon:"✨", title:"AI-Improved Resume", desc:"Your actual resume data + analysis insights = truly improved, keyword-optimized resume. Not generic.", color:"#d97706", gradient:"linear-gradient(135deg, #d9770612, #f59e0b08)"},
// // // // //         {icon:"📄", title:`Variety of ATS Templates`, desc:`Multiple professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`, color:"#e11d48", gradient:"linear-gradient(135deg, #e11d4812, #f43f5e08)"},
// // // // //         {icon:"📥", title:"PDF, Word & HTML", desc:"Download in any format the application requires — PDF for most roles, Word for older ATS systems.", color:"#0891b2", gradient:"linear-gradient(135deg, #0891b212, #06b6d408)"},
// // // // //       ].map((f, idx) => (
// // // // //         <div key={f.title} style={{
// // // // //           background: f.gradient,
// // // // //           borderRadius:"clamp(20px, 5vw, 24px)",
// // // // //           padding:"clamp(20px, 5vw, 28px) clamp(16px, 4vw, 24px)",
// // // // //           transition:"all 0.35s cubic-bezier(0.2, 0.9, 0.4, 1.1)",
// // // // //           cursor:"default",
// // // // //           position:"relative",
// // // // //           overflow:"hidden",
// // // // //           border:"1px solid rgba(255,255,255,0.5)",
// // // // //           backdropFilter:"blur(4px)",
// // // // //           animation: `fadeUp 0.6s ${0.1 * idx}s ease both`
// // // // //         }}
// // // // //         onMouseEnter={e => {
// // // // //           if (window.innerWidth > 768) {
// // // // //             e.currentTarget.style.transform = "translateY(-8px)";
// // // // //             e.currentTarget.style.boxShadow = `0 24px 48px -16px ${f.color}30`;
// // // // //           }
// // // // //         }}
// // // // //         onMouseLeave={e => {
// // // // //           if (window.innerWidth > 768) {
// // // // //             e.currentTarget.style.transform = "translateY(0)";
// // // // //             e.currentTarget.style.boxShadow = "none";
// // // // //           }
// // // // //         }}>
          
// // // // //           {/* Icon with glow effect */}
// // // // //           <div style={{
// // // // //             width:"clamp(48px, 10vw, 56px)",
// // // // //             height:"clamp(48px, 10vw, 56px)",
// // // // //             borderRadius:"clamp(14px, 3vw, 18px)",
// // // // //             background: `linear-gradient(135deg, ${f.color} 0%, ${f.color}cc 100%)`,
// // // // //             display:"flex",
// // // // //             alignItems:"center",
// // // // //             justifyContent:"center",
// // // // //             fontSize:"clamp(24px, 5vw, 28px)",
// // // // //             marginBottom:"clamp(16px, 4vw, 22px)",
// // // // //             boxShadow: `0 8px 20px -6px ${f.color}80`,
// // // // //           }}>
// // // // //             {f.icon}
// // // // //           </div>
          
// // // // //           {/* Title */}
// // // // //           <h3 style={{
// // // // //             fontSize:"clamp(16px, 4vw, 18px)",
// // // // //             fontWeight:700,
// // // // //             color:"#0f172a",
// // // // //             marginBottom:8,
// // // // //             letterSpacing:"-0.3px"
// // // // //           }}>
// // // // //             {f.title}
// // // // //           </h3>
          
// // // // //           {/* Description */}
// // // // //           <p style={{
// // // // //             fontSize:"clamp(13px, 3vw, 14px)",
// // // // //             color:"#64748b",
// // // // //             lineHeight:1.65,
// // // // //             marginBottom:0
// // // // //           }}>
// // // // //             {f.desc}
// // // // //           </p>
          
// // // // //           {/* Decorative accent line */}
// // // // //           <div style={{
// // // // //             position:"absolute",
// // // // //             bottom:0,
// // // // //             left:0,
// // // // //             width:"100%",
// // // // //             height:3,
// // // // //             background: `linear-gradient(90deg, ${f.color}, transparent)`,
// // // // //             borderRadius:"0 0 24px 24px",
// // // // //             opacity:0.4
// // // // //           }}/>
// // // // //         </div>
// // // // //       ))}
// // // // //     </div>

// // // // //     {/* Bottom CTA Link - Responsive */}
// // // // //     <div style={{
// // // // //       textAlign:"center",
// // // // //       marginTop:"clamp(40px, 8vw, 56px)",
// // // // //       paddingTop:"clamp(8px, 2vw, 16px)"
// // // // //     }}>
// // // // //       <a href="#pricing" style={{
// // // // //         display:"inline-flex",
// // // // //         alignItems:"center",
// // // // //         gap:8,
// // // // //         fontSize:"clamp(13px, 3.5vw, 15px)",
// // // // //         fontWeight:600,
// // // // //         color:"#3b82f6",
// // // // //         textDecoration:"none",
// // // // //         padding:"10px 20px",
// // // // //         borderRadius:40,
// // // // //         background:"#eff6ff",
// // // // //         transition:"all 0.25s ease"
// // // // //       }}
// // // // //       onMouseEnter={e => {
// // // // //         if (window.innerWidth > 768) {
// // // // //           e.currentTarget.style.background = "#dbeafe";
// // // // //           e.currentTarget.style.gap = "12px";
// // // // //         }
// // // // //       }}
// // // // //       onMouseLeave={e => {
// // // // //         if (window.innerWidth > 768) {
// // // // //           e.currentTarget.style.background = "#eff6ff";
// // // // //           e.currentTarget.style.gap = "8px";
// // // // //         }
// // // // //       }}>
// // // // //         See full feature list → <span style={{ fontSize:"clamp(14px, 3.5vw, 16px)" }}>✨</span>
// // // // //       </a>
// // // // //     </div>
// // // // //   </div>

// // // // //   {/* Add responsive styles to head or component */}
// // // // //   <style>{`
// // // // //     @keyframes fadeUp {
// // // // //       from {
// // // // //         opacity: 0;
// // // // //         transform: translateY(30px);
// // // // //       }
// // // // //       to {
// // // // //         opacity: 1;
// // // // //         transform: translateY(0);
// // // // //       }
// // // // //     }
    
// // // // //     /* Responsive touch optimizations */
// // // // //     @media (max-width: 768px) {
// // // // //       .features-card {
// // // // //         cursor: pointer;
// // // // //         -webkit-tap-highlight-color: transparent;
// // // // //       }
// // // // //     }
    
// // // // //     /* Better grid for tablets */
// // // // //     @media (min-width: 640px) and (max-width: 1023px) {
// // // // //       .features-grid {
// // // // //         grid-template-columns: repeat(2, 1fr) !important;
// // // // //       }
// // // // //     }
    
// // // // //     /* Single column for mobile */
// // // // //     @media (max-width: 639px) {
// // // // //       .features-grid {
// // // // //         grid-template-columns: 1fr !important;
// // // // //       }
// // // // //     }
// // // // //   `}</style>
// // // // // </section>

// // // // //       {/* ══ HOW IT WORKS ══ */}
// // // // //       <section style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // //         <div style={{ maxWidth:1020,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Simple Process</div>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em" }}>
// // // // //               From signup to results<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>in under 60 seconds</em>
// // // // //             </h2>
// // // // //           </div>
// // // // //           <div className="sr" style={{ display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12 }}>
// // // // //             {[
// // // // //               {n:"01",icon:"creditCard", title:`Pay ${priceDisplay}`,        desc:"One-time payment. No subscription."},
// // // // //               {n:"02",icon:"upload",     title:"Upload Resume",               desc:"Word file or paste your text."},
// // // // //               {n:"03",icon:"clipboard",  title:"Paste Job Description",       desc:"Copy from any job board."},
// // // // //               {n:"04",icon:"target",     title:`Get ATS Score`,               desc:`Run up to ${analysisCount}× per purchase.`},
// // // // //               {n:"05",icon:"fileText",   title:"Generate Resume",             desc:"Pick best analysis + template → done."},
// // // // //             ].map((s,i)=>(
// // // // //               <div key={s.n} style={{ textAlign:"center",position:"relative" }}>
// // // // //                 {i<4&&<div style={{ position:"absolute",top:25,right:-8,width:16,height:1,background:"#d1d5db",zIndex:1 }}/>}
// // // // //                 <div style={{ width:50,height:50,borderRadius:"50%",background:"#111827",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",position:"relative",zIndex:2 }}>
// // // // //                   <Icon name={s.icon} size={22} color="#fff" strokeWidth={1.7} />
// // // // //                 </div>
// // // // //                 <div style={{ fontSize:10,color:"#9ca3af",fontWeight:700,letterSpacing:".1em",marginBottom:5 }}>{s.n}</div>
// // // // //                 <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:4 }}>{s.title}</div>
// // // // //                 <div style={{ fontSize:11,color:"#9ca3af",lineHeight:1.6 }}>{s.desc}</div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ TEMPLATES ══ */}
// // // // //       <section id="templates" style={{ background:"#fff",padding:"82px 5%",overflow:"hidden" }}>
// // // // //               <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //                 <div style={{ textAlign:"center",marginBottom:48 }}>
// // // // //                   <div style={{ display:"inline-block",background:"#fdf4ff",color:"#7c3aed",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Multiple Templates Included Free</div>
// // // // //                   <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // // // //                     ATS-tested resume templates<br/><em style={{ fontStyle:"italic",color:"#7c3aed" }}>that impress humans too</em>
// // // // //                   </h2>
// // // // //                   <p style={{ fontSize:15,color:"#6b7280",maxWidth:500,margin:"0 auto" }}>
// // // // //                     Every template passes ATS parsing tests. All our layouts use clean formatting, standard headings, and selectable text.
// // // // //                   </p>
// // // // //                 </div>
      
// // // // //                 {/* Template previews */}
// // // // //                 <div className="tr" style={{ display:"flex",gap:14,justifyContent:"center",marginBottom:32,alignItems:"flex-end",flexWrap:"wrap" }}>
// // // // //                   {allTemplates.map((t,i)=>(
// // // // //                     <div key={t.id} onClick={()=>setActiveTmpl(i)} style={{ cursor:"pointer", transform: activeTmpl===i?"scale(1.05) translateY(-6px)":"scale(0.97)", transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)", boxShadow: activeTmpl===i ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${t.accent}` : "0 6px 20px rgba(0,0,0,0.09)", borderRadius:10, overflow:"hidden" }}><TemplateMini t={t} scale={0.27} width={600} /></div>
// // // // //                   ))}
// // // // //                 </div>
      
// // // // //                 {/* Dots + active name */}
// // // // //                 <div style={{ textAlign:"center",marginBottom:36 }}>
// // // // //                   <div style={{ display:"flex",justifyContent:"center",gap:6,marginBottom:12 }}>
// // // // //                     {allTemplates.map((t,i)=>(
// // // // //                       <button key={t.id} onClick={()=>setActiveTmpl(i)}
// // // // //                         style={{ width:i===activeTmpl?24:7,height:7,borderRadius:4,background:i===activeTmpl?allTemplates[activeTmpl].accent:"#e5e7eb",border:"none",cursor:"pointer",transition:"all .3s" }}/>
// // // // //                     ))}
// // // // //                   </div>
// // // // //                   <div style={{ fontWeight:700,fontSize:17,color:"#111827",marginBottom:4,fontFamily:"'Fraunces',serif" }}>{allTemplates[activeTmpl]?.name}</div>
// // // // //                   <div style={{ fontSize:13,color:"#6b7280",marginBottom:8 }}>{allTemplates[activeTmpl]?.description}</div>
// // // // //                   <div style={{ display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap" }}>
// // // // //                     {allTemplates[activeTmpl]?.tags.map(tag=>(
// // // // //                       <span key={tag} style={{ fontSize:11,background:"#f3f4f6",color:"#374151",padding:"3px 12px",borderRadius:20,fontWeight:500 }}>{tag}</span>
// // // // //                     ))}
// // // // //                   </div>
// // // // //                 </div>
      
// // // // //                 {/* ATS note */}
// // // // //                 <div style={{ 
// // // // //                   background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", 
// // // // //                   borderRadius: 16, 
// // // // //                   padding: "20px 24px", 
// // // // //                   border: "1px solid #cbd5e1", 
// // // // //                   display: "flex", 
// // // // //                   alignItems: "center", 
// // // // //                   gap: 16, 
// // // // //                   flexWrap: "wrap", 
// // // // //                   marginBottom: 20,
// // // // //                   boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// // // // //                   transition: "all 0.2s ease",
// // // // //                 }}>
// // // // //                   <div style={{ 
// // // // //                     width: 44, 
// // // // //                     height: 44, 
// // // // //                     borderRadius: 12, 
// // // // //                     background: "linear-gradient(135deg, #10b981, #059669)", 
// // // // //                     display: "flex", 
// // // // //                     alignItems: "center", 
// // // // //                     justifyContent: "center",
// // // // //                     boxShadow: "0 4px 10px rgba(16, 185, 129, 0.2)",
// // // // //                     flexShrink: 0,
// // // // //                   }}>
// // // // //                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //                       <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
// // // // //                     </svg>
// // // // //                   </div>
// // // // //                   <div style={{ flex: 1, minWidth: 240 }}>
// // // // //                     <div style={{ 
// // // // //                       fontWeight: 700, 
// // // // //                       fontSize: 14, 
// // // // //                       color: "#0f172a", 
// // // // //                       marginBottom: 4,
// // // // //                       display: "flex",
// // // // //                       alignItems: "center",
// // // // //                       gap: 8,
// // // // //                       flexWrap: "wrap",
// // // // //                     }}>
// // // // //                       All templates ATS-compliant by design             
// // // // //                     </div>
// // // // //                     <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // // // //                       Standard section headings · Selectable text · No graphics in text layers · Compatible with Workday, Greenhouse, Taleo and more
// // // // //                     </div>
// // // // //                   </div>
// // // // //                 </div>
      
// // // // //                 {/* CTA banner */}
// // // // //                 <div style={{ 
// // // // //                   background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", 
// // // // //                   borderRadius: 20, 
// // // // //                   padding: "24px 32px", 
// // // // //                   display: "flex", 
// // // // //                   alignItems: "center", 
// // // // //                   justifyContent: "space-between", 
// // // // //                   flexWrap: "wrap", 
// // // // //                   gap: 20, 
// // // // //                   border: "1px solid #a7f3d0",
// // // // //                   boxShadow: "0 8px 20px rgba(5, 150, 105, 0.12)",
// // // // //                   transition: "all 0.3s ease",
// // // // //                 }}>
// // // // //                   <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
// // // // //                     <div style={{ 
// // // // //                       width: 52, 
// // // // //                       height: 52, 
// // // // //                       borderRadius: 16, 
// // // // //                       background: "linear-gradient(135deg, #059669, #047857)", 
// // // // //                       display: "flex", 
// // // // //                       alignItems: "center", 
// // // // //                       justifyContent: "center",
// // // // //                       boxShadow: "0 6px 14px rgba(5, 150, 105, 0.25)",
// // // // //                     }}>
// // // // //                       <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //                         <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="white" strokeWidth="1.5" fill="none"/>
// // // // //                         <path d="M12 6V12L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
// // // // //                       </svg>
// // // // //                     </div>
// // // // //                     <div>
// // // // //                       <div style={{ 
// // // // //                         fontWeight: 800, 
// // // // //                         fontSize: 16, 
// // // // //                         color: "#064e3b", 
// // // // //                         marginBottom: 6,
// // // // //                         display: "flex",
// // // // //                         alignItems: "center",
// // // // //                         gap: 8,
// // // // //                         flexWrap: "wrap",
// // // // //                       }}>
// // // // //                         <span style={{ fontSize: 18 }}>✨</span> 
// // // // //                         Variety of templates included free with every analysis
// // // // //                         <span style={{ 
// // // // //                           background: "#059669", 
// // // // //                           color: "#fff", 
// // // // //                           fontSize: 10, 
// // // // //                           fontWeight: 700, 
// // // // //                           padding: "2px 10px", 
// // // // //                           borderRadius: 20,
// // // // //                           letterSpacing: "0.04em",
// // // // //                         }}>
// // // // //                           NO EXTRA COST
// // // // //                         </span>
// // // // //                       </div>
// // // // //                       <div style={{ fontSize: 13, color: "#047857", lineHeight: 1.5 }}>
// // // // //                         Pick your favourite after your ATS analysis.
// // // // //                       </div>
// // // // //                     </div>
// // // // //                   </div>
// // // // //                   <button 
// // // // //                     className="btn-d" 
// // // // //                     style={{ 
// // // // //                       background: "linear-gradient(135deg, #059669, #047857)", 
// // // // //                       borderRadius: 40,
// // // // //                       padding: "12px 28px",
// // // // //                       fontSize: 14,
// // // // //                       fontWeight: 700,
// // // // //                       boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
// // // // //                       transition: "all 0.2s ease",
// // // // //                       cursor: "pointer",
// // // // //                       border: "none",
// // // // //                       color: "#fff",
// // // // //                       display: "flex",
// // // // //                       alignItems: "center",
// // // // //                       gap: 8,
// // // // //                     }}
// // // // //                     onMouseEnter={e => {
// // // // //                       e.currentTarget.style.transform = "translateY(-2px)";
// // // // //                       e.currentTarget.style.boxShadow = "0 8px 20px rgba(5, 150, 105, 0.35)";
// // // // //                     }}
// // // // //                     onMouseLeave={e => {
// // // // //                       e.currentTarget.style.transform = "translateY(0)";
// // // // //                       e.currentTarget.style.boxShadow = "0 4px 12px rgba(5, 150, 105, 0.3)";
// // // // //                     }}
// // // // //                     onClick={()=>startPayment()}
// // // // //                   >
// // // // //                     Start for {priceDisplay} 
// // // // //                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //                       <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // //                     </svg>
// // // // //                   </button>
// // // // //                 </div>
// // // // //               </div>
// // // // //             </section>

// // // // //       {/* ══ PRICING ══ */}
// // // // //       <section id="pricing" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // //         <div style={{ maxWidth:860,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:46 }}>
// // // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Pricing</div>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Simple, honest pricing</h2>
// // // // //             <p style={{ fontSize:15,color:"#6b7280" }}>No hidden fees. No subscriptions. Pay once, use fully.</p>
// // // // //           </div>

// // // // //           {/* Plan cards — driven entirely by servicesConfig */}
// // // // //           <div className="pg" style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:22,maxWidth:700,margin:"0 auto" }}>
// // // // //             {enabledPlans.filter(p=>p.active).map(plan=>{
// // // // //               const isHighlight = plan.highlight;
// // // // //               return (
// // // // //                 <div key={plan.id} style={{
// // // // //                   background: isHighlight?"#111827":"#fff",
// // // // //                   borderRadius:22,padding:"32px 28px",
// // // // //                   border: isHighlight?"none":"1.5px solid #ebebeb",
// // // // //                   boxShadow: isHighlight?"0 24px 56px rgba(0,0,0,.18)":"0 4px 16px rgba(0,0,0,.04)",
// // // // //                   position:"relative",
// // // // //                 }}>
// // // // //                   {isHighlight&&<div style={{ position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:"#2563eb",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20,whiteSpace:"nowrap" }}>Most Popular</div>}
// // // // //                   <h3 style={{ fontSize:19,fontWeight:800,color:isHighlight?"#fff":"#111827",marginBottom:8,fontFamily:"'Fraunces',serif" }}>{plan.name}</h3>
// // // // //                   <div style={{ marginBottom:8 }}>
// // // // //                     <span style={{ fontFamily:"'Fraunces',serif",fontSize:52,color:isHighlight?"#fff":"#2563eb",fontWeight:700,fontStyle:"italic",letterSpacing:"-.03em" }}>{plan.price}</span>
// // // // //                     <span style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.4)":"#9ca3af",marginLeft:5 }}>{plan.period}</span>
// // // // //                   </div>
// // // // //                   <p style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.55)":"#6b7280",marginBottom:22,lineHeight:1.65 }}>{plan.description}</p>
// // // // //                   {/* Features from config */}
// // // // //                   <div style={{ display:"flex",flexDirection:"column",gap:9,marginBottom:24 }}>
// // // // //                     {plan.features.filter(f=>f.included).map(f=>(
// // // // //                       <div key={f.text} style={{ display:"flex",alignItems:"center",gap:9,fontSize:13 }}>
// // // // //                         <span style={{ width:16,height:16,borderRadius:"50%",background:isHighlight?"rgba(255,255,255,.12)":"#f0fdf4",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:9,color:isHighlight?"#fff":"#16a34a",fontWeight:700 }}>✓</span>
// // // // //                         <span style={{ color:isHighlight?"rgba(255,255,255,.8)":"#374151" }}>{f.text}</span>
// // // // //                       </div>
// // // // //                     ))}
// // // // //                   </div>
// // // // //                   <button onClick={()=>startPayment(plan.id)}
// // // // //                     style={{ width:"100%",padding:"13px",fontSize:15,fontWeight:700,borderRadius:50,background:isHighlight?"#2563eb":"#111827",color:"#fff",border:"none",cursor:"pointer",fontFamily:"inherit",transition:"all .2s" }}
// // // // //                     onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"}
// // // // //                     onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
// // // // //                     {user?`Get ${plan.name} →`:"Get Started →"}
// // // // //                   </button>
// // // // //                   {!user&&<p style={{ fontSize:11,color:isHighlight?"rgba(255,255,255,.3)":"#9ca3af",textAlign:"center",marginTop:10 }}>
// // // // //                     Have an account? <span style={{ color:isHighlight?"#60a5fa":"#2563eb",cursor:"pointer",fontWeight:600 }} onClick={()=>navigate("/login")}>Sign in</span>
// // // // //                   </p>}
// // // // //                 </div>
// // // // //               );
// // // // //             })}
// // // // //           </div>

// // // // //           {/* Comparison row */}
// // // // //           <div style={{ marginTop:36,background:"#fff",borderRadius:16,border:"1px solid #ebebeb",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,.04)" }}>
// // // // //             <div className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#111827" }}>
// // // // //               <div style={{ padding:"14px 22px",fontSize:11,fontWeight:600,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:".06em" }}>Feature</div>
// // // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // // //                 <div style={{ fontSize:12,fontWeight:700,color:"#60a5fa" }}>ResumeScoreAI</div>
// // // // //                 <div style={{ fontSize:20,fontWeight:800,color:"#fff",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>{priceDisplay}</div>
// // // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.35)" }}>one-time</div>
// // // // //               </div>
// // // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // // //                 <div style={{ fontSize:12,fontWeight:700,color:"rgba(255,255,255,.4)" }}>Other Tools</div>
// // // // //                 <div style={{ fontSize:20,fontWeight:800,color:"rgba(255,255,255,.4)",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>$30</div>
// // // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.25)" }}>per month</div>
// // // // //               </div>
// // // // //             </div>
// // // // //             {[
// // // // //               [`${analysisCount} ATS analyses per purchase`,"✅","❌ Per-resume pricing"],
// // // // //               ["Uses YOUR real resume data","✅","❌ Generic output"],
// // // // //               [`${allTemplates.length} ATS-tested templates free`,"✅","Limited on free tier"],
// // // // //               ["No subscription required","✅","❌ Monthly billing"],
// // // // //               ["AI keyword injection into your resume","✅","✅"],
// // // // //               [`Price per resume`,`${priceDisplay} once`,"$19–$30/month"],
// // // // //             ].map(([feat,us,them],i)=>(
// // // // //               <div key={feat} className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",borderTop:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa" }}>
// // // // //                 <div style={{ padding:"12px 22px",fontSize:13,color:"#374151",fontWeight:500 }}>{feat}</div>
// // // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,fontWeight:600,color:us.startsWith("✅")?"#059669":"#111827" }}>{us}</div>
// // // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,color:them.startsWith("❌")?"#dc2626":"#6b7280" }}>{them}</div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //           <p style={{ textAlign:"center",marginTop:22,fontSize:13,color:"#9ca3af" }}>
// // // // //             We're new — and that's why we charge <strong style={{ color:"#111827" }}>{priceDisplay} once</strong> instead of $30/month.
// // // // //           </p>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ TRUST SIGNALS ══ */}
// // // // //       <section style={{ background:"#fff",padding:"64px 5%" }}>
// // // // //         <div style={{ maxWidth:900,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:32 }}>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(22px,3.5vw,34px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em" }}>Built to be trusted</h2>
// // // // //           </div>
// // // // //           <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:14 }}>
// // // // //             {[
// // // // //               {icon:"shield",      color:"#2563eb", title:"Stripe Payments",      desc:"Bank-level encryption. We never store your card details."},
// // // // //               {icon:"cpu",         color:"#7c3aed", title:"AI Powered",      desc:"Powered by one of the world's most advanced language models."},
// // // // //               {icon:"lock",        color:"#059669", title:"Firebase Secure",       desc:"Your resume data is encrypted and never sold to third parties."},
// // // // //               {icon:"target",      color:"#d97706", title:"ATS-Tested Templates",  desc:"Verified against Workday, Greenhouse, Taleo and more."},
// // // // //               {icon:"zap",         color:"#0891b2", title:"Instant Results",       desc:"Analysis in 15–30 seconds. Resume generation in 15–20 seconds."},
// // // // //               {icon:"messageCircle",color:"#059669", title:`${servicesConfig.app.supportHours} Support`,desc:`Real human support — email us and we respond within ${servicesConfig.app.supportHours}.`},
// // // // //             ].map(ts=>(
// // // // //               <div key={ts.title} style={{ background:"#fafafa",borderRadius:14,padding:"18px",border:"1px solid #ebebeb",display:"flex",gap:12,alignItems:"flex-start" }}>
// // // // //                 <IconBox name={ts.icon} size={36} color={ts.color} radius={9} strokeWidth={1.7} />
// // // // //                 <div>
// // // // //                   <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:3 }}>{ts.title}</div>
// // // // //                   <div style={{ fontSize:12,color:"#6b7280",lineHeight:1.6 }}>{ts.desc}</div>
// // // // //                 </div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ FAQ ══ */}
// // // // //       <section id="faq" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // //         <div style={{ maxWidth:700,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:44 }}>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Frequently asked questions</h2>
// // // // //             <p style={{ fontSize:15,color:"#6b7280" }}>Still have questions? Use the chat button below 💬</p>
// // // // //           </div>
// // // // //           {servicesConfig.faq.map((item,i)=>(
// // // // //             <div key={i} className="faq-item">
// // // // //               <div className="fq" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
// // // // //                 <span style={{ fontWeight:600,fontSize:14.5,color:"#111827",lineHeight:1.5 }}>{item.q}</span>
// // // // //                 <span style={{ color:"#9ca3af",fontSize:10,transition:"transform .2s",display:"inline-block",transform:openFaq===i?"rotate(180deg)":"none",flexShrink:0 }}>▼</span>
// // // // //               </div>
// // // // //               {openFaq===i&&<div style={{ padding:"0 22px 18px",paddingTop:14,fontSize:14,color:"#6b7280",lineHeight:1.8,borderTop:"1px solid #f5f5f5" }}>{item.a}</div>}
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ DISCLAIMER SECTION ══ */}
// // // // //       {/* <section style={{ background: "#f8fafc", padding: "40px 5%" }}>
// // // // //         <div style={{ maxWidth: 800, margin: "0 auto", textAlign: "center" }}>
// // // // //           <div style={{ 
// // // // //             background: "#fff", 
// // // // //             borderRadius: 16, 
// // // // //             padding: "24px 32px", 
// // // // //             border: "1px solid #e2e8f0",
// // // // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
// // // // //           }}>
// // // // //             <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
// // // // //             <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 10 }}>
// // // // //               Important Disclaimer
// // // // //             </h3>
// // // // //             <p style={{ fontSize: 13, color: "#64748b", lineHeight: 1.7, marginBottom: 0 }}>
// // // // //               The resume templates and AI-generated content provided by ResumeScoreAI are professional tools designed to 
// // // // //               help you improve your resume and increase your chances of getting noticed by recruiters and ATS systems. 
// // // // //               However, <strong style={{ color: "#dc2626" }}>we do not guarantee job placement, interviews, or any specific outcome</strong>. 
// // // // //               Job search success depends on many factors including your qualifications, experience, interview performance, 
// // // // //               and the specific requirements of each employer. Use our tools as part of a comprehensive job search strategy.
// // // // //             </p>
// // // // //           </div>
// // // // //         </div>
// // // // //       </section> */}

// // // // //       <section style={{ 
// // // // //         background: "#f9fafb", 
// // // // //         padding: "clamp(32px, 8vw, 56px) 5%" 
// // // // //       }}>
// // // // //         <div style={{ 
// // // // //           maxWidth: 720, 
// // // // //           margin: "0 auto" 
// // // // //         }}>
// // // // //           <div style={{ 
// // // // //             background: "#ffffff", 
// // // // //             borderRadius: 20, 
// // // // //             padding: "clamp(20px, 5vw, 36px) clamp(18px, 5vw, 32px)",
// // // // //             border: "1px solid #eef2f6",
// // // // //           }}>
// // // // //             <div style={{ 
// // // // //               display: "flex",
// // // // //               gap: 12,
// // // // //               alignItems: "flex-start",
// // // // //               flexDirection: "column",
// // // // //             }}>
// // // // //               {/* Subtle header area */}
// // // // //               <div style={{
// // // // //                 display: "flex",
// // // // //                 alignItems: "center",
// // // // //                 gap: 8,
// // // // //                 flexWrap: "wrap",
// // // // //               }}>
// // // // //                 <span style={{ 
// // // // //                   fontSize: "clamp(20px, 5vw, 24px)",
// // // // //                   opacity: 0.5,
// // // // //                 }}>📌</span>
// // // // //                 <h3 style={{ 
// // // // //                   fontSize: "clamp(15px, 4vw, 17px)", 
// // // // //                   fontWeight: 500, 
// // // // //                   color: "#4b5563", 
// // // // //                   margin: 0,
// // // // //                   letterSpacing: "-0.2px",
// // // // //                 }}>
// // // // //                   About this tool
// // // // //                 </h3>
// // // // //               </div>

// // // // //               {/* Main text - no aggressive highlighting */}
// // // // //               <p style={{ 
// // // // //                 fontSize: "clamp(13px, 4vw, 15px)", 
// // // // //                 color: "#6b7280", 
// // // // //                 lineHeight: 1.65, 
// // // // //                 margin: 0,
// // // // //                 fontWeight: 400,
// // // // //               }}>
// // // // //                 ResumeScoreAI provides professionally designed templates and AI-powered feedback to help strengthen your resume. 
// // // // //                 These tools are meant to support your job search, but they do not guarantee interviews, job offers, or specific outcomes.
// // // // //               </p>

// // // // //               {/* Secondary note - softer styling */}
// // // // //               <div style={{
// // // // //                 marginTop: 8,
// // // // //                 paddingTop: 12,
// // // // //                 borderTop: "1px solid #f0f2f5",
// // // // //               }}>
// // // // //                 <p style={{ 
// // // // //                   fontSize: "clamp(11.5px, 3.5vw, 13px)", 
// // // // //                   color: "#9ca3af", 
// // // // //                   lineHeight: 1.6, 
// // // // //                   margin: 0,
// // // // //                 }}>
// // // // //                   Success depends on your unique qualifications, experience, and interview performance. 
// // // // //                   Use this as part of a complete job search strategy.
// // // // //                 </p>
// // // // //               </div>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ FINAL CTA ══ */}
// // // // //       <section style={{ background:"#111827",padding:"90px 5%",textAlign:"center",position:"relative",overflow:"hidden" }}>
// // // // //         <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:"70%",height:"70%",background:"radial-gradient(circle,rgba(37,99,235,.12) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // //         <div style={{ maxWidth:600,margin:"0 auto",position:"relative" }}>
// // // // //           <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(28px,5vw,52px)",fontWeight:800,color:"#fff",marginBottom:18,letterSpacing:"-.03em",lineHeight:1.1 }}>
// // // // //             Ready to land<br/><em style={{ fontStyle:"italic",color:"#60a5fa" }}>more interviews?</em>
// // // // //           </h2>
// // // // //           <p style={{ fontSize:16,color:"rgba(255,255,255,.45)",marginBottom:32,lineHeight:1.7 }}>
// // // // //             {analysisCount} ATS analyses + {resumeCount} AI-improved resume + {allTemplates.length} templates — all for just {priceDisplay}
// // // // //           </p>
// // // // //           <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap" }}>
// // // // //             <button className="btn-d" style={{ background:"#fff",color:"#111827",fontSize:15,padding:"14px 36px" }} onClick={()=>startPayment()}>
// // // // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""} →
// // // // //             </button>
// // // // //             <Link to="/support" className="btn-l" style={{ borderColor:"rgba(255,255,255,.18)",color:"rgba(255,255,255,.7)" }}>Talk to Support</Link>
// // // // //           </div>
// // // // //           <p style={{ color:"rgba(255,255,255,.18)",fontSize:12,marginTop:24 }}>🔒 Stripe · No subscription · Instant results · {`${servicesConfig.app.supportHours} support`}</p>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ FOOTER ══ */}
// // // // //       <footer style={{ background:"#0a0f1a",padding:"50px 5% 28px" }}>
// // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //           <div className="fc2" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:40,paddingBottom:32,borderBottom:"1px solid rgba(255,255,255,.06)",marginBottom:22 }}>
// // // // //             <div>
// // // // //               <div style={{ display:"flex",alignItems:"center",gap:9,marginBottom:14 }}>
// // // // //                 <div style={{ width:32,height:32,background:"#2563eb",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // // //                   <span style={{ color:"#fff",fontWeight:800,fontSize:15 }}>R</span>
// // // // //                 </div>
// // // // //                 <span style={{ fontWeight:800,fontSize:16,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Fraunces',serif" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
// // // // //               </div>
// // // // //               <p style={{ fontSize:12,color:"rgba(255,255,255,.28)",lineHeight:1.8,maxWidth:230,marginBottom:12 }}>{servicesConfig.app.shortDesc}</p>
// // // // //               <p style={{ fontSize:11,color:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",gap:6 }}><Icon name="mail" size={11} color="rgba(255,255,255,.2)" strokeWidth={1.8}/>{servicesConfig.app.email}</p>
// // // // //             </div>
// // // // //             {[
// // // // //               {title:"Product",links:[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]]},
// // // // //               {title:"Company",links:[["About","/about"],["Support","/support"],["Contact","/support"]]},
// // // // //               {title:"Legal",links:[["Privacy","/privacy"],["Terms","/terms"],["Refund","/refund"]]},
// // // // //             ].map(col=>(
// // // // //               <div key={col.title}>
// // // // //                 <h4 style={{ fontSize:10,fontWeight:700,color:"rgba(255,255,255,.32)",textTransform:"uppercase",letterSpacing:".1em",marginBottom:14 }}>{col.title}</h4>
// // // // //                 {col.links.map(([label,href])=>{
// // // // //                   const s={display:"block",fontSize:12,color:"rgba(255,255,255,.28)",textDecoration:"none",marginBottom:9,transition:"color .15s"};
// // // // //                   return href.startsWith("#")
// // // // //                     ? <a key={label} href={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</a>
// // // // //                     : <Link key={label} to={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</Link>;
// // // // //                 })}
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //           <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10 }}>
// // // // //             <span style={{ fontSize:11,color:"rgba(255,255,255,.16)" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// // // // //             <div style={{ display:"flex",gap:14 }}>
// // // // //               {[["lock","Stripe Secure"],["shield","256-bit SSL"],["check","GDPR Compliant"]].map(([ic,lb])=>(
// // // // //                 <span key={lb} style={{ fontSize:10,color:"rgba(255,255,255,.16)",display:"inline-flex",alignItems:"center",gap:4 }}><Icon name={ic} size={10} color="rgba(255,255,255,.16)" strokeWidth={2}/>{lb}</span>
// // // // //               ))}
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       </footer>

// // // // //       {/* Chat Widget */}
// // // // //       <ChatWidget />

// // // // //       {/* Payment Modal */}
// // // // //       {showModal && (
// // // // //         <PaymentModal
// // // // //           onSuccess={()=>{ setShowModal(false); navigate("/dashboard"); }}
// // // // //           onClose={()=>setShowModal(false)}
// // // // //           userEmail={userData?.email||user?.email}
// // // // //           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
// // // // //           planId={planId}
// // // // //           userId={user?.uid}
// // // // //         />
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // new code 
// // // // // // src/pages/LandingPage.jsx
// // // // // // All plan pricing, features, and template data read from servicesConfig
// // // // // import { useState, useEffect, useRef } from "react";
// // // // // import { useNavigate, Link } from "react-router-dom";
// // // // // import { useAuth } from "../hooks/useAuth";
// // // // // import servicesConfig from "../utils/servicesConfig";
// // // // // //import { getEnabledPlans } from "../utils/paymentConfig";
// // // // // import PaymentModal from "../components/PaymentModal";
// // // // // import ChatWidget from "../components/ChatWidget";
// // // // // import TemplateMini from "../components/TemplateMini";
// // // // // import Icon, { IconBox } from "../components/Icons";

// // // // // // ── Pull everything from config ──
// // // // // const basicPlan    = servicesConfig.plans.find(p => p.id === "ats_basic");
// // // // // const priceDisplay = basicPlan?.price        || "$1.99";
// // // // // const analysisCount= basicPlan?.analysisCount|| 2;
// // // // // const resumeCount  = basicPlan?.resumeGenCount|| 1;
// // // // // const allTemplates = servicesConfig.resumeTemplates.filter(t => t.active);
// // // // // const enabledPlans = servicesConfig.plans.filter(p => p.enabled);

// // // // // // ── Animated counter ──
// // // // // function Counter({ target, suffix="" }) {
// // // // //   const [n, setN] = useState(0);
// // // // //   const ref = useRef();
// // // // //   useEffect(() => {
// // // // //     const obs = new IntersectionObserver(([e]) => {
// // // // //       if (!e.isIntersecting) return;
// // // // //       let v = 0; const step = target / 55;
// // // // //       const t = setInterval(() => { v += step; if (v >= target) { setN(target); clearInterval(t); } else setN(Math.floor(v)); }, 18);
// // // // //       obs.disconnect();
// // // // //     }, { threshold: 0.3 });
// // // // //     if (ref.current) obs.observe(ref.current);
// // // // //     return () => obs.disconnect();
// // // // //   }, [target]);
// // // // //   return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
// // // // // }

// // // // // // ── Realistic resume mini-preview ──
// // // // // // eslint-disable-next-line no-unused-vars
// // // // // function ResumeCard({ t, active, onClick }) {
// // // // //   const a = t.accent, h = t.headerBg, id = t.id;
// // // // //   const isMonospace = id === "technical";
// // // // //   const bodyFont = isMonospace ? "'Courier New',monospace" : "Arial,Helvetica,sans-serif";

// // // // //   const sLabel = (txt) => (
// // // // //     <div style={{
// // // // //       fontSize: 5.5, fontWeight: 700, color: a, textTransform: "uppercase", letterSpacing: "0.08em",
// // // // //       borderBottom: (id==="classic"||id==="minimal"||id==="executive"||id==="creative") ? `0.8px solid ${a}55` : "none",
// // // // //       borderLeft: (id==="modern"||id==="corporate"||id==="technical") ? `2px solid ${a}` : "none",
// // // // //       paddingLeft: (id==="modern"||id==="corporate"||id==="technical") ? 4 : 0,
// // // // //       paddingBottom: 1.5, marginBottom: 3,
// // // // //       background: (id==="modern"||id==="corporate") ? `${a}0d` : "transparent",
// // // // //       fontFamily: isMonospace ? "'Courier New',monospace" : "inherit",
// // // // //     }}>{isMonospace ? `// ${txt.toUpperCase()}` : txt}</div>
// // // // //   );

// // // // //   const bullets = [
// // // // //     "Led team of 12 to ship 3 features on time",
// // // // //     "Increased user retention by 34% YoY",
// // // // //     "Managed $2M product roadmap",
// // // // //   ];

// // // // //   const skills = isMonospace
// // // // //     ? ["Python","React","AWS","Docker","SQL","Git"]
// // // // //     : (id==="creative" ? ["Branding","Figma","Strategy","Adobe"] : ["Leadership","SQL","Agile","Figma"]);

// // // // //   const renderHeader = () => {
// // // // //     if (id === "minimal") return (
// // // // //       <div style={{ padding:"11px 11px 8px", borderBottom:`2px solid ${a}`, background:"#fff" }}>
// // // // //         <div style={{ fontSize:9, fontWeight:300, color:"#111", fontFamily:"'Helvetica Neue',Helvetica,sans-serif", marginBottom:2 }}>Jonathan Carter</div>
// // // // //         <div style={{ width:18, height:2, background:a, borderRadius:1, margin:"2px 0 4px" }}/>
// // // // //         <div style={{ fontSize:5.5, color:"#555", marginBottom:3 }}>Senior Product Manager</div>
// // // // //         <div style={{ display:"flex", gap:5 }}>{["📧 john@email.com","📍 NYC"].map(c=><span key={c} style={{ fontSize:4.5, color:"#777" }}>{c}</span>)}</div>
// // // // //       </div>
// // // // //     );
// // // // //     if (id === "executive") return (
// // // // //       <div style={{ background:h, padding:"12px 11px 10px" }}>
// // // // //         <div style={{ fontSize:9, fontWeight:700, color:"#fff", textTransform:"uppercase", letterSpacing:"0.08em", fontFamily:"Georgia,serif", marginBottom:2 }}>JONATHAN CARTER</div>
// // // // //         <div style={{ height:0.8, background:"rgba(255,255,255,0.3)", marginBottom:2 }}/>
// // // // //         <div style={{ height:0.3, background:"rgba(255,255,255,0.12)", marginBottom:5 }}/>
// // // // //         <div style={{ display:"flex", gap:7 }}>{["john@email.com","New York, NY","linkedin.com"].map(c=><span key={c} style={{ fontSize:4.5, color:"rgba(255,255,255,0.55)" }}>{c}</span>)}</div>
// // // // //       </div>
// // // // //     );
// // // // //     if (id === "modern") return (
// // // // //       <div style={{ display:"flex" }}>
// // // // //         <div style={{ width:50, background:h, padding:"11px 6px", display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
// // // // //           <div style={{ width:24, height:24, borderRadius:"50%", background:"rgba(255,255,255,0.18)", marginBottom:3 }}/>
// // // // //           {["john@email.com","New York, NY"].map(c=><div key={c} style={{ fontSize:4.5, color:"rgba(255,255,255,0.7)", textAlign:"center", lineHeight:1.3 }}>{c}</div>)}
// // // // //           <div style={{ height:0.8, background:"rgba(255,255,255,0.15)", width:"80%", margin:"4px 0 3px" }}/>
// // // // //           <div style={{ fontSize:4.8, fontWeight:700, color:"rgba(255,255,255,0.8)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:3 }}>Skills</div>
// // // // //           {["React","Python","SQL","Agile"].map((sk,si)=>(
// // // // //             <div key={sk} style={{ width:"88%", marginBottom:2 }}>
// // // // //               <div style={{ fontSize:4.5, color:"rgba(255,255,255,0.7)", marginBottom:0.5 }}>{sk}</div>
// // // // //               <div style={{ height:2, background:"rgba(255,255,255,0.15)", borderRadius:1 }}>
// // // // //                 <div style={{ height:"100%", background:"rgba(255,255,255,0.6)", borderRadius:1, width:`${[88,78,82,72][si]}%` }}/>
// // // // //               </div>
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //         <div style={{ flex:1, padding:"10px 7px 8px", background:"#fff" }}>
// // // // //           <div style={{ fontSize:8, fontWeight:700, color:"#111", marginBottom:1 }}>Jonathan Carter</div>
// // // // //           <div style={{ fontSize:5.5, color:a, fontWeight:600, marginBottom:4 }}>Senior Product Manager</div>
// // // // //           <div style={{ height:1, background:`${a}20`, marginBottom:4 }}/>
// // // // //         </div>
// // // // //       </div>
// // // // //     );
// // // // //     if (id === "corporate") return (
// // // // //       <div style={{ background:`linear-gradient(135deg,${h},${a})`, padding:"12px 11px 10px" }}>
// // // // //         <div style={{ fontSize:9, fontWeight:700, color:"#fff", fontFamily:"Georgia,serif", marginBottom:1 }}>Jonathan Carter</div>
// // // // //         <div style={{ fontSize:5.5, color:"rgba(200,225,255,0.7)", fontStyle:"italic", marginBottom:5 }}>Senior Business Consultant</div>
// // // // //         <div style={{ height:0.8, background:"rgba(255,255,255,0.2)", marginBottom:5 }}/>
// // // // //         <div style={{ display:"flex", gap:6 }}>{["📧 john@email.com","📍 NYC","🔗 LinkedIn"].map(c=><span key={c} style={{ fontSize:4.5, color:"rgba(200,225,255,0.7)" }}>{c}</span>)}</div>
// // // // //       </div>
// // // // //     );
// // // // //     if (id === "creative") return (
// // // // //       <div style={{ background:`linear-gradient(135deg,${h},${a})`, padding:"14px 11px 18px", clipPath:"polygon(0 0,100% 0,100% 78%,0 100%)" }}>
// // // // //         <div style={{ fontSize:10, fontWeight:800, color:"#fff", fontFamily:"Georgia,serif", letterSpacing:"-0.02em", marginBottom:2 }}>Jonathan Carter</div>
// // // // //         <div style={{ fontSize:5, color:"rgba(255,200,210,0.8)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:6 }}>Senior Marketing Director</div>
// // // // //         <div style={{ display:"flex", gap:7 }}>{["john@email.com","New York"].map(c=><span key={c} style={{ fontSize:4.5, color:"rgba(255,200,210,0.7)" }}>{c}</span>)}</div>
// // // // //       </div>
// // // // //     );
// // // // //     if (id === "technical") return (
// // // // //       <div style={{ background:`linear-gradient(135deg,${h},#0e7490)`, padding:"12px 11px 10px", borderBottom:`2px solid ${a}` }}>
// // // // //         <div style={{ fontSize:5, color:`${a}cc`, fontFamily:"'Courier New',monospace", marginBottom:2 }}>{"// resume.json — v2025"}</div>
// // // // //         <div style={{ fontSize:8.5, fontWeight:700, color:"#fff", fontFamily:"'Courier New',monospace", marginBottom:1 }}>Jonathan Carter</div>
// // // // //         <div style={{ fontSize:5, color:"rgba(180,230,240,0.8)", fontFamily:"'Courier New',monospace", marginBottom:4 }}>Senior Software Engineer</div>
// // // // //         <div style={{ display:"flex", gap:6 }}>{["john@email.com","github.com/jcarter","NYC"].map(c=><span key={c} style={{ fontSize:4, color:"rgba(180,230,240,0.6)", fontFamily:"'Courier New',monospace" }}>{c}</span>)}</div>
// // // // //       </div>
// // // // //     );
// // // // //     // classic
// // // // //     return (
// // // // //       <div style={{ padding:"11px 11px 8px", borderBottom:`1.5px solid ${a}`, background:"#fafafa" }}>
// // // // //         <div style={{ fontSize:9.5, fontWeight:700, color:"#111", marginBottom:1 }}>Jonathan Carter</div>
// // // // //         <div style={{ fontSize:6, color:"#555", marginBottom:4 }}>Senior Product Manager</div>
// // // // //         <div style={{ display:"flex", gap:6 }}>{["john@email.com","555-1234","New York, NY"].map(c=><span key={c} style={{ fontSize:4.8, color:"#777" }}>{c}</span>)}</div>
// // // // //       </div>
// // // // //     );
// // // // //   };

// // // // //   const renderBody = () => {
// // // // //     const topPad = id==="creative" ? "4px 10px 8px" : "8px 10px 8px";
// // // // //     const mainContent = (
// // // // //       <div style={{ padding: id==="modern" ? 0 : topPad }}>
// // // // //         {/* Summary */}
// // // // //         <div style={{ marginBottom:5 }}>
// // // // //           {sLabel("Summary")}
// // // // //           <div style={{ fontSize:5, color:"#444", lineHeight:1.55, fontFamily:bodyFont }}>Results-driven professional with 8+ years delivering high-impact outcomes at Fortune 500 companies.</div>
// // // // //         </div>
// // // // //         {/* Experience */}
// // // // //         <div style={{ marginBottom:5 }}>
// // // // //           {sLabel("Experience")}
// // // // //           {[{ t:"Senior PM", c:"Google · 2020–Present", b:bullets.slice(0,2) },{ t:"Product Manager", c:"Stripe · 2017–2020", b:bullets.slice(2,3) }].map((exp,i)=>(
// // // // //             <div key={i} style={{ marginBottom:4 }}>
// // // // //               <div style={{ fontSize:6, fontWeight:700, color:"#111", fontFamily:bodyFont }}>{exp.t}</div>
// // // // //               <div style={{ fontSize:4.8, color:"#666", fontStyle:"italic", marginBottom:1.5 }}>{exp.c}</div>
// // // // //               {exp.b.map((b,j)=>(
// // // // //                 <div key={j} style={{ display:"flex", gap:2, marginBottom:1 }}>
// // // // //                   <span style={{ color:a, fontSize:5, flexShrink:0 }}>▪</span>
// // // // //                   <span style={{ fontSize:4.8, color:"#333", lineHeight:1.5, fontFamily:bodyFont }}>{b}</span>
// // // // //                 </div>
// // // // //               ))}
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //         {/* Skills */}
// // // // //         <div>
// // // // //           {sLabel("Skills")}
// // // // //           <div style={{ display:"flex", flexWrap:"wrap", gap:2.5 }}>
// // // // //             {skills.map(sk=>(
// // // // //               <span key={sk} style={{ fontSize:4.5, background:`${a}12`, color:a, padding:"1.5px 5px", borderRadius:2, border:`0.5px solid ${a}25`, fontFamily:bodyFont }}>{sk}</span>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </div>
// // // // //     );

// // // // //     if (id === "modern") {
// // // // //       return (
// // // // //         <div style={{ padding:"7px 8px" }}>
// // // // //           <div style={{ marginBottom:4 }}>
// // // // //             {sLabel("Summary")}
// // // // //             <div style={{ fontSize:5, color:"#444", lineHeight:1.55 }}>Results-driven PM with 8+ years delivering high-impact products at scale.</div>
// // // // //           </div>
// // // // //           <div style={{ marginBottom:4 }}>
// // // // //             {sLabel("Experience")}
// // // // //             {[{ t:"Senior PM", c:"Google · 2020–Present", b:bullets.slice(0,2) }].map((exp,i)=>(
// // // // //               <div key={i} style={{ marginBottom:3 }}>
// // // // //                 <div style={{ fontSize:5.5, fontWeight:700, color:"#111" }}>{exp.t}</div>
// // // // //                 <div style={{ fontSize:4.8, color:"#666", fontStyle:"italic", marginBottom:1 }}>{exp.c}</div>
// // // // //                 {exp.b.map((b,j)=><div key={j} style={{ display:"flex", gap:2, marginBottom:1 }}><span style={{ color:a, fontSize:4.5 }}>▪</span><span style={{ fontSize:4.5, color:"#333", lineHeight:1.5 }}>{b}</span></div>)}
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       );
// // // // //     }
// // // // //     return mainContent;
// // // // //   };

// // // // //   return (
// // // // //     <div onClick={onClick} style={{
// // // // //       width:162, flexShrink:0, background:"#fff", borderRadius:10, overflow:"hidden",
// // // // //       boxShadow: active ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${a}` : "0 6px 20px rgba(0,0,0,0.09)",
// // // // //       transform: active ? "scale(1.06) translateY(-6px)" : "scale(0.96)",
// // // // //       transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)",
// // // // //       cursor:"pointer", fontFamily:bodyFont,
// // // // //     }}>
// // // // //       {renderHeader()}
// // // // //       {renderBody()}
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // export default function LandingPage() {
// // // // //   const navigate = useNavigate();
// // // // //   const { user, userData } = useAuth();
// // // // //   const [openFaq,    setOpenFaq]    = useState(null);
// // // // //   const [showModal,  setShowModal]  = useState(false);
// // // // //   const [planId,     setPlanId]     = useState("ats_basic");
// // // // //   const [menuOpen,   setMenuOpen]   = useState(false);
// // // // //   const [scrolled,   setScrolled]   = useState(false);
// // // // //   const [activeTmpl, setActiveTmpl] = useState(0);

// // // // //   useEffect(() => {
// // // // //     const fn = () => setScrolled(window.scrollY > 20);
// // // // //     window.addEventListener("scroll", fn);
// // // // //     return () => window.removeEventListener("scroll", fn);
// // // // //   }, []);

// // // // //   useEffect(() => {
// // // // //     const t = setInterval(() => setActiveTmpl(p => (p+1) % allTemplates.length), 3600);
// // // // //     return () => clearInterval(t);
// // // // //   }, []);

// // // // //   function startPayment(pid = "ats_basic") {
// // // // //     setMenuOpen(false);
// // // // //     if (user) { setPlanId(pid); setShowModal(true); }
// // // // //     else navigate("/signup");
// // // // //   }

// // // // //   return (
// // // // //     <div style={{ minHeight:"100vh", fontFamily:"'DM Sans','Inter',-apple-system,sans-serif", background:"#fff", color:"#111827" }}>
// // // // //       <style>{`
// // // // //         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,700&family=Fraunces:ital,wght@0,700;0,800;1,700;1,800&display=swap');
// // // // //         *{box-sizing:border-box;margin:0;padding:0}
// // // // //         @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
// // // // //         @keyframes pulse2{0%,100%{opacity:1}50%{opacity:.4}}
// // // // //         .fu0{animation:fadeUp .6s ease both}
// // // // //         .fu1{animation:fadeUp .6s .1s ease both}
// // // // //         .fu2{animation:fadeUp .6s .2s ease both}
// // // // //         .fu3{animation:fadeUp .6s .34s ease both}
// // // // //         .btn-d{display:inline-flex;align-items:center;gap:8px;padding:13px 30px;font-size:15px;font-weight:700;background:#111827;color:#fff;border:none;border-radius:50px;cursor:pointer;transition:all .22s;font-family:inherit;letter-spacing:-.01em;text-decoration:none}
// // // // //         .btn-d:hover{background:#1f2937;transform:translateY(-2px);box-shadow:0 12px 28px rgba(0,0,0,.18)}
// // // // //         .btn-l{display:inline-flex;align-items:center;gap:8px;padding:12px 24px;font-size:14px;font-weight:600;background:transparent;color:#111827;border:1.5px solid #d1d5db;border-radius:50px;cursor:pointer;transition:all .2s;font-family:inherit;text-decoration:none}
// // // // //         .btn-l:hover{border-color:#111827;background:#f9fafb}
// // // // //         .fc{background:#fff;border:1px solid #ebebeb;border-radius:18px;padding:26px;transition:all .28s}
// // // // //         .fc:hover{border-color:#e0e0e0;transform:translateY(-4px);box-shadow:0 16px 40px rgba(0,0,0,.07)}
// // // // //         .faq-item{border:1px solid #ebebeb;border-radius:14px;overflow:hidden;margin-bottom:10px}
// // // // //         .fq{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;transition:background .15s;gap:12px;background:#fff}
// // // // //         .fq:hover{background:#fafafa}
// // // // //         @media(max-width:768px){
// // // // //           .nd,.na{display:none!important}.hb{display:flex!important}
// // // // //           .hc{justify-content:center!important}.tr{flex-direction:column!important;align-items:center!important;gap:14px!important}
// // // // //           .pg{grid-template-columns:1fr!important}.fg{grid-template-columns:1fr!important}
// // // // //           .sr{grid-template-columns:1fr 1fr!important}.cg{grid-template-columns:1fr!important}
// // // // //           .fc2{grid-template-columns:1fr 1fr!important;gap:24px!important}
// // // // //         }
// // // // //       `}</style>

// // // // //       {/* ══ NAV ══ */}
// // // // //       <nav style={{ position:"sticky",top:0,zIndex:1000,background:scrolled?"rgba(255,255,255,.97)":"transparent",backdropFilter:"blur(16px)",borderBottom:scrolled?"1px solid #ebebeb":"1px solid transparent",transition:"all .3s",padding:"0 5%",height:66,display:"flex",alignItems:"center",justifyContent:"space-between" }}>
// // // // //         <div onClick={()=>navigate("/")} style={{ display:"flex",alignItems:"center",gap:10,cursor:"pointer" }}>
// // // // //           <div style={{ width:36,height:36,background:"#111827",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // // //             <span style={{ color:"#fff",fontWeight:800,fontSize:17 }}>R</span>
// // // // //           </div>
// // // // //           <span style={{ fontWeight:800,fontSize:18,letterSpacing:"-.03em",color:"#111827",fontFamily:"'Fraunces',serif" }}>
// // // // //             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
// // // // //           </span>
// // // // //         </div>
// // // // //         <div className="nd" style={{ display:"flex",gap:28,alignItems:"center" }}>
// // // // //           {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h])=>(
// // // // //             <a key={l} href={h} style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none",transition:"color .15s" }}
// // // // //               onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#4b5563"}>{l}</a>
// // // // //           ))}
// // // // //           <Link to="/support" style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none" }}>Support</Link>
// // // // //         </div>
// // // // //         <div className="na" style={{ display:"flex",gap:10,alignItems:"center" }}>
// // // // //           {user
// // // // //             ? <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/dashboard")}>Dashboard</button>
// // // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>startPayment()}>New Analysis</button></>
// // // // //             : <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/login")}>Sign In</button>
// // // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>navigate("/signup")}>Get Started Free</button></>
// // // // //           }
// // // // //         </div>
// // // // //         <button className="hb" onClick={()=>setMenuOpen(o=>!o)} style={{ display:"none",background:"none",border:"1px solid #e5e7eb",borderRadius:9,padding:"8px 11px",cursor:"pointer",flexDirection:"column",gap:4 }}>
// // // // //           {[0,1,2].map(i=><span key={i} style={{ display:"block",width:20,height:2,background:"#374151" }}/>)}
// // // // //         </button>
// // // // //       </nav>

// // // // //       {menuOpen && (
// // // // //         <div style={{ position:"sticky",top:66,zIndex:999,background:"#fff",borderBottom:"1px solid #ebebeb",padding:"16px 5%",boxShadow:"0 8px 24px rgba(0,0,0,.07)" }}>
// // // // //           <div style={{ display:"flex",flexDirection:"column",gap:2,marginBottom:14 }}>
// // // // //             {["Features","Templates","Pricing","FAQ"].map(l=>(
// // // // //               <a key={l} href={`#${l.toLowerCase()}`} onClick={()=>setMenuOpen(false)} style={{ padding:"10px 4px",fontSize:15,color:"#374151",textDecoration:"none",fontWeight:500,borderBottom:"1px solid #f5f5f5" }}>{l}</a>
// // // // //             ))}
// // // // //           </div>
// // // // //           <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
// // // // //             <button className="btn-l" style={{ width:"100%",justifyContent:"center" }} onClick={()=>{setMenuOpen(false);navigate(user?"/dashboard":"/login");}}>
// // // // //               {user?"Dashboard":"Sign In"}
// // // // //             </button>
// // // // //             <button className="btn-d" style={{ width:"100%",justifyContent:"center" }} onClick={()=>startPayment()}>
// // // // //               {user?`New Analysis — ${priceDisplay}`:`Get Started — ${priceDisplay}`}
// // // // //             </button>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {/* ══ HERO ══ */}
// // // // //       <section style={{ padding:"84px 5% 72px",background:"linear-gradient(155deg,#f8faff 0%,#fafafa 55%,#f0fdf4 100%)",position:"relative",overflow:"hidden" }}>
// // // // //         <div style={{ position:"absolute",top:"-18%",right:"-8%",width:500,height:500,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,99,235,.06) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // //         <div style={{ position:"absolute",bottom:"-15%",left:"-5%",width:420,height:420,borderRadius:"50%",background:"radial-gradient(circle,rgba(5,150,105,.05) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //           {/* Badge */}
// // // // //           {/* <div className="fu0" style={{ display:"flex",justifyContent:"center",marginBottom:24 }}>
// // // // //             <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"#fff",border:"1px solid #e5e7eb",borderRadius:40,padding:"7px 18px",boxShadow:"0 2px 8px rgba(0,0,0,.04)" }}>
// // // // //               <span style={{ width:7,height:7,borderRadius:"50%",background:"#16a34a",animation:"pulse2 2s infinite" }}/>
// // // // //               <span style={{ fontSize:12,fontWeight:600,color:"#374151" }}>AI-powered ATS resume analysis &amp; generation</span>
// // // // //             </div>
// // // // //           </div> */}
// // // // //           <div className="fu0" style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
// // // // //             <div style={{
// // // // //               display: "inline-flex",
// // // // //               alignItems: "center",
// // // // //               gap: 12,
// // // // //               background: "white",
// // // // //               border: "1px solid #eef2ff",
// // // // //               borderRadius: 100,
// // // // //               padding: "8px 28px 8px 24px",
// // // // //               boxShadow: "0 8px 20px -12px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.02)",
// // // // //               transition: "all 0.3s ease",
// // // // //             }}>
// // // // //               {/* Animated pulse dot */}
// // // // //               <div style={{
// // // // //                 width: 8,
// // // // //                 height: 8,
// // // // //                 borderRadius: "50%",
// // // // //                 background: "#3b82f6",
// // // // //                 animation: "professionalPulse 1.8s ease-in-out infinite",
// // // // //                 boxShadow: "0 0 0 0 rgba(59, 130, 246, 0.3)"
// // // // //               }} />
              
// // // // //               {/* Star icon + text */}
// // // // //               <span style={{
// // // // //                 fontSize: 13,
// // // // //                 fontWeight: 500,
// // // // //                 color: "#334155",
// // // // //                 letterSpacing: "-0.2px"
// // // // //               }}>
// // // // //                 <span style={{ marginRight: 4 }}>⭐</span> 
// // // // //                 <span style={{ fontWeight: 700, color: "#0f172a" }}>AI-powered</span> 
// // // // //                 {" "}ATS resume analysis & generation
// // // // //               </span>
              
// // // // //               {/* Small "v2.0" tag */}
// // // // // <span style={{
// // // // //   fontSize: 10,
// // // // //   fontWeight: 700,
// // // // //   background: "linear-gradient(135deg, #1e293b, #0f172a)",
// // // // //   color: "white",
// // // // //   padding: "2px 10px",
// // // // //   borderRadius: 100,
// // // // //   letterSpacing: "0.3px"
// // // // // }}>
// // // // //   PRO
// // // // // </span>
// // // // //             </div>
// // // // //           </div>

// // // // //           {/* Headline */}
// // // // //           <h1 className="fu1" style={{ fontFamily:"'Fraunces',Georgia,serif",fontSize:"clamp(38px,6.5vw,72px)",fontWeight:800,lineHeight:1.06,letterSpacing:"-.03em",color:"#111827",textAlign:"center",marginBottom:22 }}>
// // // // //             Beat the ATS.<br/>
// // // // //             <em style={{ fontStyle:"italic",color:"#2563eb",position:"relative" }}>
// // // // //               Land more interviews.
// // // // //               <svg style={{ position:"absolute",bottom:-4,left:0,width:"100%",height:5 }} viewBox="0 0 400 5" preserveAspectRatio="none">
// // // // //                 <path d="M0 3.5 Q100 0 200 3.5 Q300 7 400 3.5" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // // // //               </svg>
// // // // //             </em>
// // // // //           </h1>
// // // // //           {/* Subline */}
// // // // //           <p className="fu2" style={{ textAlign:"center",fontSize:"clamp(15px,2vw,18px)",color:"#6b7280",lineHeight:1.75,maxWidth:560,margin:"0 auto 34px" }}>
// // // // //             Upload your resume, paste any job description — get your ATS score, keyword gaps, AI rewrite suggestions, and a professionally improved resume for just <strong style={{ color:"#111827" }}>{priceDisplay}</strong>.
// // // // //           </p>
// // // // //           {/* CTAs */}
// // // // //           <div className="hc fu3" style={{ display:"flex",gap:12,justifyContent:"center",marginBottom:44,flexWrap:"wrap" }}>
// // // // //             <button className="btn-d" style={{ fontSize:16,padding:"15px 36px" }} onClick={()=>startPayment()}>
// // // // //               {user?`New Analysis — ${priceDisplay}`:`Analyze My Resume — ${priceDisplay}`} →
// // // // //             </button>
// // // // //             <button className="btn-l" style={{ fontSize:14 }} onClick={()=>document.getElementById("templates")?.scrollIntoView({behavior:"smooth"})}>
// // // // //               See Templates ↓
// // // // //             </button>
// // // // //           </div>
// // // // //           {/* Trust badges */}
// // // // //           <div className="fu3" style={{ display:"flex",justifyContent:"center",gap:28,flexWrap:"wrap" }}>
// // // // //             {[["lock","Stripe Secure"],["zap","60s Analysis"],["target","ATS Optimized"],["check","No Subscription"]].map(([ic,lb])=>(
// // // // //               <div key={lb} style={{ display:"flex",alignItems:"center",gap:6 }}>
// // // // //                 <Icon name={ic} size={14} color="#9ca3af" strokeWidth={2} />
// // // // //                 <span style={{ fontSize:12,color:"#9ca3af",fontWeight:500 }}>{lb}</span>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ STATS BAR ══ */}
// // // // //       <section style={{ background:"#111827",padding:"34px 5%" }}>
// // // // //         <div style={{ maxWidth:1000,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24 }}>
// // // // //           {[
// // // // //             {v:76,s:"%",l:"of resumes rejected by ATS before a human sees them"},
// // // // //             {v:7,s:"s",l:"average time a recruiter spends reading a resume"},
// // // // //             {v:priceDisplay,s:"",l:"one-time price — no monthly subscription ever"},
// // // // //             {v:analysisCount,s:"×",l:`ATS analyses included — run ${analysisCount} times per purchase`},
// // // // //           ].map(st=>(
// // // // //             <div key={st.l} style={{ textAlign:"center" }}>
// // // // //               <div style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,3.5vw,38px)",color:"#fff",fontWeight:700,marginBottom:5,fontStyle:"italic" }}>
// // // // //                 {typeof st.v==="string"?st.v:<Counter target={st.v} suffix={st.s}/>}
// // // // //               </div>
// // // // //               <div style={{ fontSize:11,color:"rgba(255,255,255,.38)",lineHeight:1.5,maxWidth:110,margin:"0 auto" }}>{st.l}</div>
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ FEATURES ══ */}
// // // // //       {/* <section id="features" style={{ padding:"90px 5%",background:"#fff" }}>
// // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:50 }}>
// // // // //             <div style={{ display:"inline-block",background:"#f0fdf4",color:"#16a34a",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>What You Get</div>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,4vw,42px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // // // //               Everything to get noticed<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>by recruiters</em>
// // // // //             </h2>
// // // // //             <p style={{ fontSize:15,color:"#6b7280",maxWidth:480,margin:"0 auto" }}>Powered by the world’s best ATS AI — built for real results, fast</p>
// // // // //           </div>
// // // // //           <div className="fg" style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16 }}>
// // // // //             {[
// // // // //               {icon:"🎯",title:"ATS Score 0–100",desc:"Precise compatibility score with section-by-section breakdown — summary, experience, skills, education.",color:"#2563eb"},
// // // // //               {icon:"🔍",title:"Keyword Gap Analysis",desc:"See exactly which keywords are missing vs the job description, with natural injection suggestions.",color:"#7c3aed"},
// // // // //               {icon:"✍️",title:"AI Rewrite Suggestions",desc:"Actionable rewrites for weak bullet points tailored to your specific role and the job description.",color:"#059669"},
// // // // //               {icon:"✨",title:"AI-Improved Resume",desc:"Your actual resume data + analysis insights = truly improved, keyword-optimized resume. Not generic.",color:"#d97706"},
// // // // //               // {icon:"📄",title:`${allTemplates.length} ATS Templates`,desc:`${allTemplates.length} professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`,color:"#e11d48"},
// // // // //               {icon:"📄",title:`Multiple ATS Templates`,desc:`Professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`,color:"#e11d48"},
// // // // //               {icon:"📥",title:"PDF, Word & HTML",desc:"Download in any format the application requires — PDF for most roles, Word for older ATS systems.",color:"#0891b2"},
// // // // //             ].map(f=>(
// // // // //               <div key={f.title} className="fc">
// // // // //                 <div style={{ width:46,height:46,borderRadius:13,background:`${f.color}12`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,marginBottom:18 }}>{f.icon}</div>
// // // // //                 <h3 style={{ fontSize:16,fontWeight:700,color:"#111827",marginBottom:8 }}>{f.title}</h3>
// // // // //                 <p style={{ fontSize:13,color:"#6b7280",lineHeight:1.72 }}>{f.desc}</p>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section> */}

// // // // // <section id="features" style={{ padding: "80px 5%", background: "#fafbfc", position: "relative", overflow: "hidden" }}>
// // // // //   {/* Background decorative elements - hidden on mobile */}
// // // // //   <div style={{ 
// // // // //     position: "absolute", 
// // // // //     top: "20%", 
// // // // //     right: "-5%", 
// // // // //     width: "400px", 
// // // // //     height: "400px", 
// // // // //     borderRadius: "50%", 
// // // // //     background: "radial-gradient(circle, rgba(37,99,235,0.04) 0%, transparent 70%)", 
// // // // //     pointerEvents: "none",
// // // // //   }} />
// // // // //   <div style={{ 
// // // // //     position: "absolute", 
// // // // //     bottom: "10%", 
// // // // //     left: "-5%", 
// // // // //     width: "350px", 
// // // // //     height: "350px", 
// // // // //     borderRadius: "50%", 
// // // // //     background: "radial-gradient(circle, rgba(5,150,105,0.04) 0%, transparent 70%)", 
// // // // //     pointerEvents: "none",
// // // // //   }} />
  
// // // // //   <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative" }}>
    
// // // // //     {/* Section Header - Mobile responsive */}
// // // // //     <div style={{ textAlign: "center", marginBottom: "clamp(40px, 8vw, 64px)" }}>
// // // // //       <div style={{ 
// // // // //         display: "inline-flex", 
// // // // //         alignItems: "center", 
// // // // //         gap: 8,
// // // // //         background: "#fff", 
// // // // //         color: "#2563eb", 
// // // // //         fontSize: "clamp(11px, 3vw, 12px)", 
// // // // //         fontWeight: 700, 
// // // // //         padding: "6px 16px", 
// // // // //         borderRadius: 30, 
// // // // //         letterSpacing: ".06em", 
// // // // //         textTransform: "uppercase", 
// // // // //         marginBottom: 20,
// // // // //         border: "1px solid #e2e8f0",
// // // // //         boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
// // // // //       }}>
// // // // //         <span style={{ fontSize: "clamp(10px, 3vw, 12px)" }}>✨</span> Why Choose Us
// // // // //       </div>
// // // // //       <h2 style={{ 
// // // // //         fontFamily: "'Fraunces', Georgia, serif", 
// // // // //         fontSize: "clamp(28px, 7vw, 48px)", 
// // // // //         fontWeight: 800, 
// // // // //         color: "#0f172a", 
// // // // //         lineHeight: 1.2, 
// // // // //         letterSpacing: "-0.02em", 
// // // // //         marginBottom: 16,
// // // // //       }}>
// // // // //         Everything you need to <br style={{ display: "none" }} />
// // // // //         <span style={{ color: "#2563eb", position: "relative", display: "inline-block" }}>
// // // // //           stand out
// // // // //           <svg style={{ position: "absolute", bottom: 6, left: 0, width: "100%", height: 8 }} viewBox="0 0 200 8" preserveAspectRatio="none">
// // // // //             <path d="M0 4 Q50 0 100 4 Q150 8 200 4" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.4"/>
// // // // //           </svg>
// // // // //         </span>
// // // // //       </h2>
// // // // //       <p style={{ 
// // // // //         fontSize: "clamp(14px, 4vw, 16px)", 
// // // // //         color: "#64748b", 
// // // // //         maxWidth: 540, 
// // // // //         margin: "0 auto", 
// // // // //         lineHeight: 1.6,
// // // // //         padding: "0 20px",
// // // // //       }}>
// // // // //         Powered by advanced AI technology to give you the competitive edge in your job search
// // // // //       </p>
// // // // //     </div>

// // // // //     {/* Features Grid - Fully responsive */}
// // // // //     <div style={{ 
// // // // //       display: "grid", 
// // // // //       gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", 
// // // // //       gap: "clamp(20px, 4vw, 30px)",
// // // // //       maxWidth: 1000,
// // // // //       margin: "0 auto",
// // // // //     }}>
// // // // //       {[
// // // // //         { 
// // // // //           icon: "🎯", 
// // // // //           title: "ATS Score 0–100", 
// // // // //           desc: "Get a precise compatibility score with section-by-section breakdown of your resume against any job description.",
// // // // //           color: "#2563eb",
// // // // //           badge: "AI-Powered",
// // // // //         },
// // // // //         { 
// // // // //           icon: "🔍", 
// // // // //           title: "Keyword Gap Analysis", 
// // // // //           desc: "Instantly identify missing keywords and get natural suggestions to inject them into your resume.",
// // // // //           color: "#7c3aed",
// // // // //           badge: "Real-time",
// // // // //         },
// // // // //         { 
// // // // //           icon: "✍️", 
// // // // //           title: "AI Rewrite Suggestions", 
// // // // //           desc: "Receive actionable rewrites for weak bullet points tailored specifically to your target role.",
// // // // //           color: "#059669",
// // // // //           badge: "Smart",
// // // // //         },
// // // // //         { 
// // // // //           icon: "✨", 
// // // // //           title: "AI-Improved Resume", 
// // // // //           desc: "Your actual resume data + analysis insights = a truly optimized, keyword-rich resume.",
// // // // //           color: "#d97706",
// // // // //           badge: "Personalized",
// // // // //         },
// // // // //         { 
// // // // //           icon: "📄", 
// // // // //           title: "Multiple ATS Templates", 
// // // // //           desc: "Choose from professionally designed, ATS-tested layouts that work with every major system.",
// // // // //           color: "#e11d48",
// // // // //           badge: "7+ Options",
// // // // //         },
// // // // //         { 
// // // // //           icon: "📥", 
// // // // //           title: "PDF, Word & HTML", 
// // // // //           desc: "Download your optimized resume in any format — PDF for most roles, Word for older ATS systems.",
// // // // //           color: "#0891b2",
// // // // //           badge: "Flexible",
// // // // //         },
// // // // //       ].map(f => (
// // // // //         <div key={f.title} style={{ 
// // // // //           background: "#fff", 
// // // // //           borderRadius: "clamp(20px, 4vw, 24px)", 
// // // // //           padding: "clamp(20px, 4vw, 28px)", 
// // // // //           border: "1px solid #eef2ff", 
// // // // //           transition: "all 0.3s ease",
// // // // //           cursor: "default",
// // // // //           position: "relative",
// // // // //           display: "flex",
// // // // //           flexDirection: "column",
// // // // //           gap: "clamp(16px, 4vw, 20px)",
// // // // //           boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
// // // // //         }}
// // // // //         onMouseEnter={e => {
// // // // //           e.currentTarget.style.transform = "translateY(-4px)";
// // // // //           e.currentTarget.style.borderColor = f.color + "30";
// // // // //           e.currentTarget.style.boxShadow = `0 20px 32px ${f.color}10`;
// // // // //         }}
// // // // //         onMouseLeave={e => {
// // // // //           e.currentTarget.style.transform = "translateY(0)";
// // // // //           e.currentTarget.style.borderColor = "#eef2ff";
// // // // //           e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.02)";
// // // // //         }}>
          
// // // // //           {/* Icon */}
// // // // //           <div style={{ flexShrink: 0, textAlign: "center" }}>
// // // // //             <div style={{ 
// // // // //               width: "clamp(56px, 10vw, 64px)", 
// // // // //               height: "clamp(56px, 10vw, 64px)", 
// // // // //               borderRadius: "clamp(16px, 4vw, 20px)", 
// // // // //               background: `linear-gradient(135deg, ${f.color}12, ${f.color}05)`, 
// // // // //               display: "flex", 
// // // // //               alignItems: "center", 
// // // // //               justifyContent: "center", 
// // // // //               fontSize: "clamp(28px, 6vw, 32px)",
// // // // //               border: `1px solid ${f.color}20`,
// // // // //               margin: "0 auto",
// // // // //             }}>
// // // // //               {f.icon}
// // // // //             </div>
// // // // //           </div>
          
// // // // //           {/* Content */}
// // // // //           <div style={{ flex: 1, textAlign: "center" }}>
// // // // //             <div style={{ 
// // // // //               display: "flex", 
// // // // //               alignItems: "center", 
// // // // //               justifyContent: "center",
// // // // //               flexDirection: "column",
// // // // //               flexWrap: "wrap",
// // // // //               gap: 8,
// // // // //               marginBottom: 12,
// // // // //             }}>
// // // // //               <h3 style={{ 
// // // // //                 fontSize: "clamp(17px, 4vw, 18px)", 
// // // // //                 fontWeight: 800, 
// // // // //                 color: "#0f172a",
// // // // //                 letterSpacing: "-0.01em",
// // // // //               }}>
// // // // //                 {f.title}
// // // // //               </h3>
// // // // //               <span style={{ 
// // // // //                 background: `${f.color}10`, 
// // // // //                 color: f.color, 
// // // // //                 fontSize: "clamp(9px, 3vw, 10px)", 
// // // // //                 fontWeight: 700, 
// // // // //                 padding: "3px 12px", 
// // // // //                 borderRadius: 30,
// // // // //                 letterSpacing: "0.03em",
// // // // //                 display: "inline-block",
// // // // //               }}>
// // // // //                 {f.badge}
// // // // //               </span>
// // // // //             </div>
// // // // //             <p style={{ 
// // // // //               fontSize: "clamp(13px, 3.5vw, 14px)", 
// // // // //               color: "#64748b", 
// // // // //               lineHeight: 1.65, 
// // // // //               marginBottom: 0,
// // // // //             }}>
// // // // //               {f.desc}
// // // // //             </p>
// // // // //           </div>
// // // // //         </div>
// // // // //       ))}
// // // // //     </div>

// // // // //     {/* Bottom CTA Link - Responsive */}
// // // // //     <div style={{ textAlign: "center", marginTop: "clamp(40px, 8vw, 48px)" }}>
// // // // //       <button 
// // // // //         onClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })}
// // // // //         style={{
// // // // //           background: "transparent",
// // // // //           border: "none",
// // // // //           color: "#2563eb",
// // // // //           fontSize: "clamp(13px, 3.5vw, 14px)",
// // // // //           fontWeight: 600,
// // // // //           cursor: "pointer",
// // // // //           display: "inline-flex",
// // // // //           alignItems: "center",
// // // // //           gap: 8,
// // // // //           padding: "12px 24px",
// // // // //           borderRadius: 40,
// // // // //           transition: "all 0.2s ease",
// // // // //           width: "auto",
// // // // //           justifyContent: "center",
// // // // //         }}
// // // // //         onMouseEnter={e => {
// // // // //           e.currentTarget.style.background = "#eff6ff";
// // // // //           e.currentTarget.style.gap = "12px";
// // // // //         }}
// // // // //         onMouseLeave={e => {
// // // // //           e.currentTarget.style.background = "transparent";
// // // // //           e.currentTarget.style.gap = "8px";
// // // // //         }}
// // // // //       >
// // // // //         See all features
// // // // //         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //           <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // //         </svg>
// // // // //       </button>
// // // // //     </div>
// // // // //   </div>

// // // // //   {/* Media query for larger screens to show line break */}
// // // // //   <style>{`
// // // // //     @media (min-width: 768px) {
// // // // //       .features-section br {
// // // // //         display: block;
// // // // //       }
// // // // //     }
// // // // //   `}</style>
// // // // // </section>

// // // // //       {/* ══ HOW IT WORKS ══ */}
// // // // //       <section style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // //         <div style={{ maxWidth:1020,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Simple Process</div>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em" }}>
// // // // //               From signup to results<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>in under 60 seconds</em>
// // // // //             </h2>
// // // // //           </div>
// // // // //           <div className="sr" style={{ display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12 }}>
// // // // //             {[
// // // // //               {n:"01",icon:"creditCard", title:`Pay ${priceDisplay}`,        desc:"One-time payment. No subscription."},
// // // // //               {n:"02",icon:"upload",     title:"Upload Resume",               desc:"Word file or paste your text."},
// // // // //               {n:"03",icon:"clipboard",  title:"Paste Job Description",       desc:"Copy from any job board."},
// // // // //               {n:"04",icon:"target",     title:`Get ATS Score`,               desc:`Run up to ${analysisCount}× per purchase.`},
// // // // //               {n:"05",icon:"fileText",   title:"Generate Resume",             desc:"Pick best analysis + template → done."},
// // // // //             ].map((s,i)=>(
// // // // //               <div key={s.n} style={{ textAlign:"center",position:"relative" }}>
// // // // //                 {i<4&&<div style={{ position:"absolute",top:25,right:-8,width:16,height:1,background:"#d1d5db",zIndex:1 }}/>}
// // // // //                 <div style={{ width:50,height:50,borderRadius:"50%",background:"#111827",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",position:"relative",zIndex:2 }}>
// // // // //                   <Icon name={s.icon} size={22} color="#fff" strokeWidth={1.7} />
// // // // //                 </div>
// // // // //                 <div style={{ fontSize:10,color:"#9ca3af",fontWeight:700,letterSpacing:".1em",marginBottom:5 }}>{s.n}</div>
// // // // //                 <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:4 }}>{s.title}</div>
// // // // //                 <div style={{ fontSize:11,color:"#9ca3af",lineHeight:1.6 }}>{s.desc}</div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ TEMPLATES ══ */}
// // // // //       <section id="templates" style={{ background:"#fff",padding:"82px 5%",overflow:"hidden" }}>
// // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // // // //             <div style={{ display:"inline-block",background:"#fdf4ff",color:"#7c3aed",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>{allTemplates.length} Templates Included Free</div>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // // // //               ATS-tested resume templates<br/><em style={{ fontStyle:"italic",color:"#7c3aed" }}>that impress humans too</em>
// // // // //             </h2>
// // // // //             <p style={{ fontSize:15,color:"#6b7280",maxWidth:500,margin:"0 auto" }}>
// // // // //               Every template passes ATS parsing tests. All {allTemplates.length} layouts use clean formatting, standard headings, and selectable text.
// // // // //             </p>
// // // // //           </div>

// // // // //           {/* Template previews */}
// // // // //           <div className="tr" style={{ display:"flex",gap:14,justifyContent:"center",marginBottom:32,alignItems:"flex-end",flexWrap:"wrap" }}>
// // // // //             {allTemplates.map((t,i)=>(
// // // // //               <div key={t.id} onClick={()=>setActiveTmpl(i)} style={{ cursor:"pointer", transform: activeTmpl===i?"scale(1.05) translateY(-6px)":"scale(0.97)", transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)", boxShadow: activeTmpl===i ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${t.accent}` : "0 6px 20px rgba(0,0,0,0.09)", borderRadius:10, overflow:"hidden" }}><TemplateMini t={t} scale={0.27} width={600} /></div>
// // // // //             ))}
// // // // //           </div>

// // // // //           {/* Dots + active name */}
// // // // //           <div style={{ textAlign:"center",marginBottom:36 }}>
// // // // //             <div style={{ display:"flex",justifyContent:"center",gap:6,marginBottom:12 }}>
// // // // //               {allTemplates.map((t,i)=>(
// // // // //                 <button key={t.id} onClick={()=>setActiveTmpl(i)}
// // // // //                   style={{ width:i===activeTmpl?24:7,height:7,borderRadius:4,background:i===activeTmpl?allTemplates[activeTmpl].accent:"#e5e7eb",border:"none",cursor:"pointer",transition:"all .3s" }}/>
// // // // //               ))}
// // // // //             </div>
// // // // //             <div style={{ fontWeight:700,fontSize:17,color:"#111827",marginBottom:4,fontFamily:"'Fraunces',serif" }}>{allTemplates[activeTmpl]?.name}</div>
// // // // //             <div style={{ fontSize:13,color:"#6b7280",marginBottom:8 }}>{allTemplates[activeTmpl]?.description}</div>
// // // // //             <div style={{ display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap" }}>
// // // // //               {allTemplates[activeTmpl]?.tags.map(tag=>(
// // // // //                 <span key={tag} style={{ fontSize:11,background:"#f3f4f6",color:"#374151",padding:"3px 12px",borderRadius:20,fontWeight:500 }}>{tag}</span>
// // // // //               ))}
// // // // //             </div>
// // // // //           </div>

// // // // //           {/* ATS note */}
// // // // //           <div style={{ 
// // // // //             background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", 
// // // // //             borderRadius: 16, 
// // // // //             padding: "20px 24px", 
// // // // //             border: "1px solid #cbd5e1", 
// // // // //             display: "flex", 
// // // // //             alignItems: "center", 
// // // // //             gap: 16, 
// // // // //             flexWrap: "wrap", 
// // // // //             marginBottom: 20,
// // // // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// // // // //             transition: "all 0.2s ease",
// // // // //           }}>
// // // // //             <div style={{ 
// // // // //               width: 44, 
// // // // //               height: 44, 
// // // // //               borderRadius: 12, 
// // // // //               background: "linear-gradient(135deg, #10b981, #059669)", 
// // // // //               display: "flex", 
// // // // //               alignItems: "center", 
// // // // //               justifyContent: "center",
// // // // //               boxShadow: "0 4px 10px rgba(16, 185, 129, 0.2)",
// // // // //               flexShrink: 0,
// // // // //             }}>
// // // // //               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //                 <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
// // // // //               </svg>
// // // // //             </div>
// // // // //             <div style={{ flex: 1, minWidth: 240 }}>
// // // // //               <div style={{ 
// // // // //                 fontWeight: 700, 
// // // // //                 fontSize: 14, 
// // // // //                 color: "#0f172a", 
// // // // //                 marginBottom: 4,
// // // // //                 display: "flex",
// // // // //                 alignItems: "center",
// // // // //                 gap: 8,
// // // // //                 flexWrap: "wrap",
// // // // //               }}>
// // // // //                 All templates ATS-compliant by design             
// // // // //               </div>
// // // // //               <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // // // //                 Standard section headings · Selectable text · No graphics in text layers · Compatible with Workday, Greenhouse, Taleo and more
// // // // //               </div>
// // // // //             </div>
// // // // //           </div>

// // // // //           {/* CTA banner */}
// // // // //           <div style={{ 
// // // // //             background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", 
// // // // //             borderRadius: 20, 
// // // // //             padding: "24px 32px", 
// // // // //             display: "flex", 
// // // // //             alignItems: "center", 
// // // // //             justifyContent: "space-between", 
// // // // //             flexWrap: "wrap", 
// // // // //             gap: 20, 
// // // // //             border: "1px solid #a7f3d0",
// // // // //             boxShadow: "0 8px 20px rgba(5, 150, 105, 0.12)",
// // // // //             transition: "all 0.3s ease",
// // // // //           }}>
// // // // //             <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
// // // // //               <div style={{ 
// // // // //                 width: 52, 
// // // // //                 height: 52, 
// // // // //                 borderRadius: 16, 
// // // // //                 background: "linear-gradient(135deg, #059669, #047857)", 
// // // // //                 display: "flex", 
// // // // //                 alignItems: "center", 
// // // // //                 justifyContent: "center",
// // // // //                 boxShadow: "0 6px 14px rgba(5, 150, 105, 0.25)",
// // // // //               }}>
// // // // //                 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //                   <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="white" strokeWidth="1.5" fill="none"/>
// // // // //                   <path d="M12 6V12L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
// // // // //                 </svg>
// // // // //               </div>
// // // // //               <div>
// // // // //                 <div style={{ 
// // // // //                   fontWeight: 800, 
// // // // //                   fontSize: 16, 
// // // // //                   color: "#064e3b", 
// // // // //                   marginBottom: 6,
// // // // //                   display: "flex",
// // // // //                   alignItems: "center",
// // // // //                   gap: 8,
// // // // //                   flexWrap: "wrap",
// // // // //                 }}>
// // // // //                   <span style={{ fontSize: 18 }}>✨</span> 
// // // // //                   Variety of templates included free with every analysis
// // // // //                   <span style={{ 
// // // // //                     background: "#059669", 
// // // // //                     color: "#fff", 
// // // // //                     fontSize: 10, 
// // // // //                     fontWeight: 700, 
// // // // //                     padding: "2px 10px", 
// // // // //                     borderRadius: 20,
// // // // //                     letterSpacing: "0.04em",
// // // // //                   }}>
// // // // //                     NO EXTRA COST
// // // // //                   </span>
// // // // //                 </div>
// // // // //                 <div style={{ fontSize: 13, color: "#047857", lineHeight: 1.5 }}>
// // // // //                   Pick your favourite after your ATS analysis.
// // // // //                 </div>
// // // // //               </div>
// // // // //             </div>
// // // // //             <button 
// // // // //               className="btn-d" 
// // // // //               style={{ 
// // // // //                 background: "linear-gradient(135deg, #059669, #047857)", 
// // // // //                 borderRadius: 40,
// // // // //                 padding: "12px 28px",
// // // // //                 fontSize: 14,
// // // // //                 fontWeight: 700,
// // // // //                 boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
// // // // //                 transition: "all 0.2s ease",
// // // // //                 cursor: "pointer",
// // // // //                 border: "none",
// // // // //                 color: "#fff",
// // // // //                 display: "flex",
// // // // //                 alignItems: "center",
// // // // //                 gap: 8,
// // // // //               }}
// // // // //               onMouseEnter={e => {
// // // // //                 e.currentTarget.style.transform = "translateY(-2px)";
// // // // //                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(5, 150, 105, 0.35)";
// // // // //               }}
// // // // //               onMouseLeave={e => {
// // // // //                 e.currentTarget.style.transform = "translateY(0)";
// // // // //                 e.currentTarget.style.boxShadow = "0 4px 12px rgba(5, 150, 105, 0.3)";
// // // // //               }}
// // // // //               onClick={()=>startPayment()}
// // // // //             >
// // // // //               Start for {priceDisplay} 
// // // // //               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // //                 <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // //               </svg>
// // // // //             </button>
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ PRICING ══ */}
// // // // //       <section id="pricing" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // //         <div style={{ maxWidth:860,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:46 }}>
// // // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Pricing</div>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Simple, honest pricing</h2>
// // // // //             <p style={{ fontSize:15,color:"#6b7280" }}>No hidden fees. No subscriptions. Pay once, use fully.</p>
// // // // //           </div>

// // // // //           {/* Plan cards — driven entirely by servicesConfig */}
// // // // //           <div className="pg" style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:22,maxWidth:700,margin:"0 auto" }}>
// // // // //             {enabledPlans.filter(p=>p.active).map(plan=>{
// // // // //               const isHighlight = plan.highlight;
// // // // //               return (
// // // // //                 <div key={plan.id} style={{
// // // // //                   background: isHighlight?"#111827":"#fff",
// // // // //                   borderRadius:22,padding:"32px 28px",
// // // // //                   border: isHighlight?"none":"1.5px solid #ebebeb",
// // // // //                   boxShadow: isHighlight?"0 24px 56px rgba(0,0,0,.18)":"0 4px 16px rgba(0,0,0,.04)",
// // // // //                   position:"relative",
// // // // //                 }}>
// // // // //                   {isHighlight&&<div style={{ position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:"#2563eb",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20,whiteSpace:"nowrap" }}>Most Popular</div>}
// // // // //                   <h3 style={{ fontSize:19,fontWeight:800,color:isHighlight?"#fff":"#111827",marginBottom:8,fontFamily:"'Fraunces',serif" }}>{plan.name}</h3>
// // // // //                   <div style={{ marginBottom:8 }}>
// // // // //                     <span style={{ fontFamily:"'Fraunces',serif",fontSize:52,color:isHighlight?"#fff":"#2563eb",fontWeight:700,fontStyle:"italic",letterSpacing:"-.03em" }}>{plan.price}</span>
// // // // //                     <span style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.4)":"#9ca3af",marginLeft:5 }}>{plan.period}</span>
// // // // //                   </div>
// // // // //                   <p style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.55)":"#6b7280",marginBottom:22,lineHeight:1.65 }}>{plan.description}</p>
// // // // //                   {/* Features from config */}
// // // // //                   <div style={{ display:"flex",flexDirection:"column",gap:9,marginBottom:24 }}>
// // // // //                     {plan.features.filter(f=>f.included).map(f=>(
// // // // //                       <div key={f.text} style={{ display:"flex",alignItems:"center",gap:9,fontSize:13 }}>
// // // // //                         <span style={{ width:16,height:16,borderRadius:"50%",background:isHighlight?"rgba(255,255,255,.12)":"#f0fdf4",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:9,color:isHighlight?"#fff":"#16a34a",fontWeight:700 }}>✓</span>
// // // // //                         <span style={{ color:isHighlight?"rgba(255,255,255,.8)":"#374151" }}>{f.text}</span>
// // // // //                       </div>
// // // // //                     ))}
// // // // //                   </div>
// // // // //                   <button onClick={()=>startPayment(plan.id)}
// // // // //                     style={{ width:"100%",padding:"13px",fontSize:15,fontWeight:700,borderRadius:50,background:isHighlight?"#2563eb":"#111827",color:"#fff",border:"none",cursor:"pointer",fontFamily:"inherit",transition:"all .2s" }}
// // // // //                     onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"}
// // // // //                     onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
// // // // //                     {user?`Get ${plan.name} →`:"Get Started →"}
// // // // //                   </button>
// // // // //                   {!user&&<p style={{ fontSize:11,color:isHighlight?"rgba(255,255,255,.3)":"#9ca3af",textAlign:"center",marginTop:10 }}>
// // // // //                     Have an account? <span style={{ color:isHighlight?"#60a5fa":"#2563eb",cursor:"pointer",fontWeight:600 }} onClick={()=>navigate("/login")}>Sign in</span>
// // // // //                   </p>}
// // // // //                 </div>
// // // // //               );
// // // // //             })}
// // // // //           </div>

// // // // //           {/* Comparison row */}
// // // // //           <div style={{ marginTop:36,background:"#fff",borderRadius:16,border:"1px solid #ebebeb",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,.04)" }}>
// // // // //             <div className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#111827" }}>
// // // // //               <div style={{ padding:"14px 22px",fontSize:11,fontWeight:600,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:".06em" }}>Feature</div>
// // // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // // //                 <div style={{ fontSize:12,fontWeight:700,color:"#60a5fa" }}>ResumeScoreAI</div>
// // // // //                 <div style={{ fontSize:20,fontWeight:800,color:"#fff",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>{priceDisplay}</div>
// // // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.35)" }}>one-time</div>
// // // // //               </div>
// // // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // // //                 <div style={{ fontSize:12,fontWeight:700,color:"rgba(255,255,255,.4)" }}>Other Tools</div>
// // // // //                 <div style={{ fontSize:20,fontWeight:800,color:"rgba(255,255,255,.4)",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>$30</div>
// // // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.25)" }}>per month</div>
// // // // //               </div>
// // // // //             </div>
// // // // //             {[
// // // // //               [`${analysisCount} ATS analyses per purchase`,"✅","❌ Per-resume pricing"],
// // // // //               ["Uses YOUR real resume data","✅","❌ Generic output"],
// // // // //               [`${allTemplates.length} ATS-tested templates free`,"✅","Limited on free tier"],
// // // // //               ["No subscription required","✅","❌ Monthly billing"],
// // // // //               ["AI keyword injection into your resume","✅","✅"],
// // // // //               [`Price per resume`,`${priceDisplay} once`,"$19–$30/month"],
// // // // //             ].map(([feat,us,them],i)=>(
// // // // //               <div key={feat} className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",borderTop:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa" }}>
// // // // //                 <div style={{ padding:"12px 22px",fontSize:13,color:"#374151",fontWeight:500 }}>{feat}</div>
// // // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,fontWeight:600,color:us.startsWith("✅")?"#059669":"#111827" }}>{us}</div>
// // // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,color:them.startsWith("❌")?"#dc2626":"#6b7280" }}>{them}</div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //           <p style={{ textAlign:"center",marginTop:22,fontSize:13,color:"#9ca3af" }}>
// // // // //             We're new — and that's why we charge <strong style={{ color:"#111827" }}>{priceDisplay} once</strong> instead of $30/month.
// // // // //           </p>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ TRUST SIGNALS ══ */}
// // // // //       <section style={{ background:"#fff",padding:"64px 5%" }}>
// // // // //         <div style={{ maxWidth:900,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:32 }}>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(22px,3.5vw,34px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em" }}>Built to be trusted</h2>
// // // // //           </div>
// // // // //           <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:14 }}>
// // // // //             {[
// // // // //               {icon:"shield",      color:"#2563eb", title:"Stripe Payments",      desc:"Bank-level encryption. We never store your card details."},
// // // // //               {icon:"cpu",         color:"#7c3aed", title:"AI Powered",      desc:"Powered by one of the world's most advanced language models."},
// // // // //               {icon:"lock",        color:"#059669", title:"Firebase Secure",       desc:"Your resume data is encrypted and never sold to third parties."},
// // // // //               {icon:"target",      color:"#d97706", title:"ATS-Tested Templates",  desc:"Verified against Workday, Greenhouse, Taleo and more."},
// // // // //               {icon:"zap",         color:"#0891b2", title:"Instant Results",       desc:"Analysis in 15–30 seconds. Resume generation in 15–20 seconds."},
// // // // //               {icon:"messageCircle",color:"#059669",title:"48-Hour Support",       desc:"Real human support — email and respond within 48 hours."},
// // // // //             ].map(ts=>(
// // // // //               <div key={ts.title} style={{ background:"#fafafa",borderRadius:14,padding:"18px",border:"1px solid #ebebeb",display:"flex",gap:12,alignItems:"flex-start" }}>
// // // // //                 <IconBox name={ts.icon} size={36} color={ts.color} radius={9} strokeWidth={1.7} />
// // // // //                 <div>
// // // // //                   <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:3 }}>{ts.title}</div>
// // // // //                   <div style={{ fontSize:12,color:"#6b7280",lineHeight:1.6 }}>{ts.desc}</div>
// // // // //                 </div>
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ FAQ ══ */}
// // // // //       <section id="faq" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // // //         <div style={{ maxWidth:700,margin:"0 auto" }}>
// // // // //           <div style={{ textAlign:"center",marginBottom:44 }}>
// // // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Frequently asked questions</h2>
// // // // //             <p style={{ fontSize:15,color:"#6b7280" }}>Still have questions? Use the chat button below 💬</p>
// // // // //           </div>
// // // // //           {servicesConfig.faq.map((item,i)=>(
// // // // //             <div key={i} className="faq-item">
// // // // //               <div className="fq" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
// // // // //                 <span style={{ fontWeight:600,fontSize:14.5,color:"#111827",lineHeight:1.5 }}>{item.q}</span>
// // // // //                 <span style={{ color:"#9ca3af",fontSize:10,transition:"transform .2s",display:"inline-block",transform:openFaq===i?"rotate(180deg)":"none",flexShrink:0 }}>▼</span>
// // // // //               </div>
// // // // //               {openFaq===i&&<div style={{ padding:"0 22px 18px",paddingTop:14,fontSize:14,color:"#6b7280",lineHeight:1.8,borderTop:"1px solid #f5f5f5" }}>{item.a}</div>}
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //       </section>

// // // // //       {/* ══ DISCLAIMER SECTION ══ */}
// // // // //       <section style={{ background: "#f8fafc", padding: "40px 5%" }}>
// // // // //         <div style={{ maxWidth: 800, margin: "0 auto", textAlign: "center" }}>
// // // // //           <div style={{ 
// // // // //             background: "#fff", 
// // // // //             borderRadius: 16, 
// // // // //             padding: "24px 32px", 
// // // // //             border: "1px solid #e2e8f0",
// // // // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
// // // // //           }}>
// // // // //             <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
// // // // //             <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 10 }}>
// // // // //               Important Disclaimer
// // // // //             </h3>
// // // // //             <p style={{ fontSize: 13, color: "#64748b", lineHeight: 1.7, marginBottom: 0 }}>
// // // // //               The resume templates and AI-generated content provided by ResumeScoreAI are professional tools designed to 
// // // // //               help you improve your resume and increase your chances of getting noticed by recruiters and ATS systems. 
// // // // //               However, <strong style={{ color: "#dc2626" }}>we do not guarantee job placement, interviews, or any specific outcome</strong>. 
// // // // //               Job search success depends on many factors including your qualifications, experience, interview performance, 
// // // // //               and the specific requirements of each employer. Use our tools as part of a comprehensive job search strategy.
// // // // //             </p>
// // // // //           </div>
// // // // //         </div>
// // // // //       </section>
      
// // // // //       {/* ══ FINAL CTA ══ */}
// // // // //       <section style={{ background:"#111827",padding:"90px 5%",textAlign:"center",position:"relative",overflow:"hidden" }}>
// // // // //         <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:"70%",height:"70%",background:"radial-gradient(circle,rgba(37,99,235,.12) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // // //         <div style={{ maxWidth:600,margin:"0 auto",position:"relative" }}>
// // // // //           <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(28px,5vw,52px)",fontWeight:800,color:"#fff",marginBottom:18,letterSpacing:"-.03em",lineHeight:1.1 }}>
// // // // //             Ready to land<br/><em style={{ fontStyle:"italic",color:"#60a5fa" }}>more interviews?</em>
// // // // //           </h2>
// // // // //           <p style={{ fontSize:16,color:"rgba(255,255,255,.45)",marginBottom:32,lineHeight:1.7 }}>
// // // // //             {analysisCount} ATS analyses + {resumeCount} AI-improved resume + {allTemplates.length} templates — all for just {priceDisplay}
// // // // //           </p>
// // // // //           <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap" }}>
// // // // //             <button className="btn-d" style={{ background:"#fff",color:"#111827",fontSize:15,padding:"14px 36px" }} onClick={()=>startPayment()}>
// // // // //               {user?`New Analysis — ${priceDisplay}`:`Analyze My Resume — ${priceDisplay}`} →
// // // // //             </button>
// // // // //             <Link to="/support" className="btn-l" style={{ borderColor:"rgba(255,255,255,.18)",color:"rgba(255,255,255,.7)" }}>Talk to Support</Link>
// // // // //           </div>
// // // // //           <p style={{ color:"rgba(255,255,255,.18)",fontSize:12,marginTop:24 }}>🔒 Stripe · No subscription · Instant results · 48h support</p>
// // // // //         </div>
// // // // //       </section>


// // // // //       {/* ══ FOOTER ══ */}
// // // // //       <footer style={{ background:"#0a0f1a",padding:"50px 5% 28px" }}>
// // // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // // //           <div className="fc2" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:40,paddingBottom:32,borderBottom:"1px solid rgba(255,255,255,.06)",marginBottom:22 }}>
// // // // //             <div>
// // // // //               <div style={{ display:"flex",alignItems:"center",gap:9,marginBottom:14 }}>
// // // // //                 <div style={{ width:32,height:32,background:"#2563eb",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // // //                   <span style={{ color:"#fff",fontWeight:800,fontSize:15 }}>R</span>
// // // // //                 </div>
// // // // //                 <span style={{ fontWeight:800,fontSize:16,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Fraunces',serif" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
// // // // //               </div>
// // // // //               <p style={{ fontSize:12,color:"rgba(255,255,255,.28)",lineHeight:1.8,maxWidth:230,marginBottom:12 }}>{servicesConfig.app.description}</p>
// // // // //               <p style={{ fontSize:11,color:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",gap:6 }}><Icon name="mail" size={11} color="rgba(255,255,255,.2)" strokeWidth={1.8}/>{servicesConfig.app.email}</p>
// // // // //             </div>
// // // // //             {[
// // // // //               {title:"Product",links:[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]]},
// // // // //               {title:"Company",links:[["About","/about"],["Support","/support"],["Contact","/support"]]},
// // // // //               {title:"Legal",links:[["Privacy","/privacy"],["Terms","/terms"],["Refund","/refund"]]},
// // // // //             ].map(col=>(
// // // // //               <div key={col.title}>
// // // // //                 <h4 style={{ fontSize:10,fontWeight:700,color:"rgba(255,255,255,.32)",textTransform:"uppercase",letterSpacing:".1em",marginBottom:14 }}>{col.title}</h4>
// // // // //                 {col.links.map(([label,href])=>{
// // // // //                   const s={display:"block",fontSize:12,color:"rgba(255,255,255,.28)",textDecoration:"none",marginBottom:9,transition:"color .15s"};
// // // // //                   return href.startsWith("#")
// // // // //                     ? <a key={label} href={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</a>
// // // // //                     : <Link key={label} to={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</Link>;
// // // // //                 })}
// // // // //               </div>
// // // // //             ))}
// // // // //           </div>
// // // // //           <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10 }}>
// // // // //             <span style={{ fontSize:11,color:"rgba(255,255,255,.16)" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// // // // //             <div style={{ display:"flex",gap:14 }}>
// // // // //               {[["lock","Stripe Secure"],["shield","256-bit SSL"],["check","GDPR Compliant"]].map(([ic,lb])=>(
// // // // //                 <span key={lb} style={{ fontSize:10,color:"rgba(255,255,255,.16)",display:"inline-flex",alignItems:"center",gap:4 }}><Icon name={ic} size={10} color="rgba(255,255,255,.16)" strokeWidth={2}/>{lb}</span>
// // // // //               ))}
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       </footer>



// // // // //       {/* Chat Widget */}
// // // // //       <ChatWidget />

// // // // //       {/* Payment Modal */}
// // // // //       {showModal && (
// // // // //         <PaymentModal
// // // // //           onSuccess={()=>{ setShowModal(false); navigate("/dashboard"); }}
// // // // //           onClose={()=>setShowModal(false)}
// // // // //           userEmail={userData?.email||user?.email}
// // // // //           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
// // // // //           planId={planId}
// // // // //           userId={user?.uid}
// // // // //         />
// // // // //       )}
      
// // // // //     </div>
// // // // //   );


// // // // // }

// // // // // src/pages/LandingPage.jsx
// // // // // All plan pricing, features, and template data read from servicesConfig
// // // // import { useState, useEffect, useRef } from "react";
// // // // import { useNavigate, Link } from "react-router-dom";
// // // // import { useAuth } from "../hooks/useAuth";
// // // // import servicesConfig from "../utils/servicesConfig";
// // // // // eslint-disable-next-line no-unused-vars
// // // // import { getEnabledPlans } from "../utils/paymentConfig";
// // // // import PaymentModal from "../components/PaymentModal";
// // // // import ChatWidget from "../components/ChatWidget";
// // // // import TemplateMini from "../components/TemplateMini";
// // // // import Icon, { IconBox } from "../components/Icons";

// // // // // ── Pull everything from config ──
// // // // // eslint-disable-next-line no-unused-vars
// // // // const basicPlan    = servicesConfig.plans.find(p => p.id === "ats_basic");
// // // // const analysisCount= basicPlan?.analysisCount|| 2;
// // // // const resumeCount  = basicPlan?.resumeGenCount|| 1;
// // // // const allTemplates = servicesConfig.resumeTemplates.filter(t => t.active);
// // // // const enabledPlans = servicesConfig.plans.filter(p => p.enabled);
// // // // const templateComparison = servicesConfig.templateComparison;

// // // // // Helper to get rating display
// // // // // eslint-disable-next-line no-unused-vars
// // // // function getRatingDisplay(score) {
// // // //   const rating = templateComparison?.ratingScale?.[score] || 
// // // //     { stars: "⭐⭐⭐", label: "Average", color: "#f59e0b" };
// // // //   return rating;
// // // // }


// // // // // ── Animated counter ──
// // // // // ── Animated counter ──
// // // // function Counter({ target, suffix="" }) {
// // // //   const [n, setN] = useState(0);
// // // //   const ref = useRef();
// // // //   useEffect(() => {
// // // //     const obs = new IntersectionObserver(([e]) => {
// // // //       if (!e.isIntersecting) return;
// // // //       let v = 0; const step = target / 55;
// // // //       const t = setInterval(() => { v += step; if (v >= target) { setN(target); clearInterval(t); } else setN(Math.floor(v)); }, 18);
// // // //       obs.disconnect();
// // // //     }, { threshold: 0.3 });
// // // //     if (ref.current) obs.observe(ref.current);
// // // //     return () => obs.disconnect();
// // // //   }, [target]);
// // // //   return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
// // // // }

// // // // export default function LandingPage() {
// // // //   const navigate = useNavigate();
// // // //   const { user, userData } = useAuth();
// // // //   const [openFaq,      setOpenFaq]      = useState(null);
// // // //   const [showModal,    setShowModal]    = useState(false);
// // // //   const [planId,       setPlanId]       = useState("ats_basic");
// // // //   const [menuOpen,     setMenuOpen]     = useState(false);
// // // //   const [scrolled,     setScrolled]     = useState(false);
// // // //   const [activeTmpl,   setActiveTmpl]   = useState(0);
// // // //   // ── Live price from server — always matches actual Stripe charge ──
// // // //   const [priceDisplay, setPriceDisplay] = useState(basicPlan?.price || "$2.99");
// // // //   const [serverPlans,  setServerPlans]  = useState({});
// // // //   const [localPrice,   setLocalPrice]   = useState(null);

// // // //   useEffect(() => {
// // // //     const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
// // // //     fetch(`${BACKEND}/config`)
// // // //       .then(r => r.json())
// // // //       .then(d => {
// // // //         if (d.plans?.ats_basic?.priceDisplay) setPriceDisplay(d.plans.ats_basic.priceDisplay);
// // // //         if (d.plans) setServerPlans(d.plans);
// // // //       })
// // // //       .catch(() => {});
// // // //   }, []);

// // // //   // ── Browser locale currency conversion — no API, no rate limit ──
// // // //   useEffect(() => {
// // // //     const usdAmount = (serverPlans?.ats_basic?.priceInCents || 299) / 100;

// // // //     const langs    = navigator.languages?.length ? navigator.languages : [navigator.language || "en-US"];
// // // //     const locale   = langs[0] || "en-US";
// // // //     const parts    = locale.split("-");
// // // //     const region   = parts[parts.length - 1]?.toUpperCase();

// // // //     const USD_REGIONS = ["US","AS","EC","PR","SV","GU","MH","FM","MP","PW","TC","VI","ZW","BZ","PA"];
// // // //     if (!region || USD_REGIONS.includes(region)) { setLocalPrice(null); return; }

// // // //     const REGION_CURRENCY = {
// // // //       IN:"INR", GB:"GBP", AU:"AUD", CA:"CAD",
// // // //       DE:"EUR", FR:"EUR", IT:"EUR", ES:"EUR", NL:"EUR", BE:"EUR", PT:"EUR", AT:"EUR",
// // // //       JP:"JPY", SG:"SGD", AE:"AED", ZA:"ZAR", BR:"BRL", MX:"MXN", NZ:"NZD",
// // // //     };
// // // //     const currency = REGION_CURRENCY[region];
// // // //     if (!currency) { setLocalPrice(null); return; }

// // // //     const CACHE_KEY = "fx_usd_rates_v1";
// // // //     const CACHE_TTL = 60 * 60 * 1000; // 1 hour
// // // //     const FALLBACK  = { INR:84, GBP:0.79, AUD:1.53, CAD:1.36, EUR:0.92, JPY:150, SGD:1.34, AED:3.67, ZAR:18.5, BRL:5.0, MXN:17.5, NZD:1.65 };

// // // //     async function fetchAndDisplay() {
// // // //       let rate = null;
// // // //       try {
// // // //         const cached = sessionStorage.getItem(CACHE_KEY);
// // // //         if (cached) {
// // // //           const { rates, ts } = JSON.parse(cached);
// // // //           if (Date.now() - ts < CACHE_TTL && rates[currency]) {
// // // //             rate = rates[currency];
// // // //           }
// // // //         }
// // // //         if (!rate) {
// // // //           const res  = await fetch("https://api.exchangerate-api.com/v4/latest/USD", { signal: AbortSignal.timeout(5000) });
// // // //           const data = await res.json();
// // // //           sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rates: data.rates, ts: Date.now() }));
// // // //           rate = data.rates[currency];
// // // //         }
// // // //       } catch (_) {
// // // //         rate = FALLBACK[currency] || null;
// // // //       }
// // // //       if (!rate) { setLocalPrice(null); return; }
// // // //       const formatted = new Intl.NumberFormat(locale, {
// // // //         style: "currency", currency, maximumFractionDigits: 0,
// // // //       }).format(Math.round(usdAmount * rate));
// // // //       setLocalPrice(formatted);
// // // //     }

// // // //     fetchAndDisplay();
// // // //   }, [serverPlans]);

// // // //   useEffect(() => {
// // // //     const fn = () => setScrolled(window.scrollY > 20);
// // // //     window.addEventListener("scroll", fn);
// // // //     return () => window.removeEventListener("scroll", fn);
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     const t = setInterval(() => setActiveTmpl(p => (p+1) % allTemplates.length), 3600);
// // // //     return () => clearInterval(t);
// // // //   }, []);

// // // //   function startPayment(pid = "ats_basic") {
// // // //     setMenuOpen(false);
// // // //     if (user) { setPlanId(pid); setShowModal(true); }
// // // //     else navigate("/signup");
// // // //   }

// // // //   return (
// // // //     <div style={{ minHeight:"100vh", fontFamily:"'DM Sans','Inter',-apple-system,sans-serif", background:"#fff", color:"#111827" }}>
// // // //       <style>{`
// // // //         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,700&family=Fraunces:ital,wght@0,700;0,800;1,700;1,800&display=swap');
// // // //         *{box-sizing:border-box;margin:0;padding:0}
// // // //         @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
// // // //         @keyframes pulse2{0%,100%{opacity:1}50%{opacity:.4}}
// // // //         .fu0{animation:fadeUp .6s ease both}
// // // //         .fu1{animation:fadeUp .6s .1s ease both}
// // // //         .fu2{animation:fadeUp .6s .2s ease both}
// // // //         .fu3{animation:fadeUp .6s .34s ease both}
// // // //         .btn-d{display:inline-flex;align-items:center;gap:8px;padding:13px 30px;font-size:15px;font-weight:700;background:#111827;color:#fff;border:none;border-radius:50px;cursor:pointer;transition:all .22s;font-family:inherit;letter-spacing:-.01em;text-decoration:none}
// // // //         .btn-d:hover{background:#1f2937;transform:translateY(-2px);box-shadow:0 12px 28px rgba(0,0,0,.18)}
// // // //         .btn-l{display:inline-flex;align-items:center;gap:8px;padding:12px 24px;font-size:14px;font-weight:600;background:transparent;color:#111827;border:1.5px solid #d1d5db;border-radius:50px;cursor:pointer;transition:all .2s;font-family:inherit;text-decoration:none}
// // // //         .btn-l:hover{border-color:#111827;background:#f9fafb}
// // // //         .fc{background:#fff;border:1px solid #ebebeb;border-radius:18px;padding:26px;transition:all .28s}
// // // //         .fc:hover{border-color:#e0e0e0;transform:translateY(-4px);box-shadow:0 16px 40px rgba(0,0,0,.07)}
// // // //         .faq-item{border:1px solid #ebebeb;border-radius:14px;overflow:hidden;margin-bottom:10px}
// // // //         .fq{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;transition:background .15s;gap:12px;background:#fff}
// // // //         .fq:hover{background:#fafafa}
// // // //         @media(max-width:768px){
// // // //           .nd,.na{display:none!important}.hb{display:flex!important}
// // // //           .hc{justify-content:center!important}.tr{flex-direction:column!important;align-items:center!important;gap:14px!important}
// // // //           .pg{grid-template-columns:1fr!important}.fg{grid-template-columns:1fr!important}
// // // //           .sr{grid-template-columns:1fr 1fr!important}.cg{grid-template-columns:1fr!important}
// // // //           .fc2{grid-template-columns:1fr 1fr!important;gap:24px!important}
// // // //         }
// // // //       `}</style>

// // // //       {/* ══ NAV ══ */}
// // // //       <nav style={{ position:"sticky",top:0,zIndex:1000,background:scrolled?"rgba(255,255,255,.97)":"transparent",backdropFilter:"blur(16px)",borderBottom:scrolled?"1px solid #ebebeb":"1px solid transparent",transition:"all .3s",padding:"0 5%",height:66,display:"flex",alignItems:"center",justifyContent:"space-between" }}>
// // // //         <div onClick={()=>navigate("/")} style={{ display:"flex",alignItems:"center",gap:10,cursor:"pointer" }}>
// // // //           <div style={{ width:36,height:36,background:"#111827",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // //             <span style={{ color:"#fff",fontWeight:800,fontSize:17 }}>R</span>
// // // //           </div>
// // // //           <span style={{ fontWeight:800,fontSize:18,letterSpacing:"-.03em",color:"#111827",fontFamily:"'Fraunces',serif" }}>
// // // //             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
// // // //           </span>
// // // //         </div>
// // // //         <div className="nd" style={{ display:"flex",gap:28,alignItems:"center" }}>
// // // //           {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h])=>(
// // // //             <a key={l} href={h} style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none",transition:"color .15s" }}
// // // //               onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#4b5563"}>{l}</a>
// // // //           ))}
// // // //           <Link to="/support" style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none" }}>Support</Link>
// // // //         </div>
// // // //         <div className="na" style={{ display:"flex",gap:10,alignItems:"center" }}>
// // // //           {user
// // // //             ? <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/dashboard")}>Dashboard</button>
// // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>startPayment()}>{servicesConfig.app.ctaNavUser}</button></>
// // // //             : <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/login")}>Sign In</button>
// // // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>navigate("/signup")}>{servicesConfig.app.ctaNav}</button></>
// // // //           }
// // // //         </div>
// // // //         <button className="hb" onClick={()=>setMenuOpen(o=>!o)} style={{ display:"none",background:"none",border:"1px solid #e5e7eb",borderRadius:9,padding:"8px 11px",cursor:"pointer",flexDirection:"column",gap:4 }}>
// // // //           {[0,1,2].map(i=><span key={i} style={{ display:"block",width:20,height:2,background:"#374151" }}/>)}
// // // //         </button>
// // // //       </nav>

// // // //       {menuOpen && (
// // // //         <div style={{ position:"sticky",top:66,zIndex:999,background:"#fff",borderBottom:"1px solid #ebebeb",padding:"16px 5%",boxShadow:"0 8px 24px rgba(0,0,0,.07)" }}>
// // // //           <div style={{ display:"flex",flexDirection:"column",gap:2,marginBottom:14 }}>
// // // //             {["Features","Templates","Pricing","FAQ"].map(l=>(
// // // //               <a key={l} href={`#${l.toLowerCase()}`} onClick={()=>setMenuOpen(false)} style={{ padding:"10px 4px",fontSize:15,color:"#374151",textDecoration:"none",fontWeight:500,borderBottom:"1px solid #f5f5f5" }}>{l}</a>
// // // //             ))}
// // // //           </div>
// // // //           <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
// // // //             <button className="btn-l" style={{ width:"100%",justifyContent:"center" }} onClick={()=>{setMenuOpen(false);navigate(user?"/dashboard":"/login");}}>
// // // //               {user?"Dashboard":"Sign In"}
// // // //             </button>
// // // //             <button className="btn-d" style={{ width:"100%",justifyContent:"center" }} onClick={()=>startPayment()}>
// // // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""}
// // // //             </button>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* ══ HERO ══ */}
// // // //       <section style={{ padding:"84px 5% 72px",background:"linear-gradient(155deg,#f8faff 0%,#fafafa 55%,#f0fdf4 100%)",position:"relative",overflow:"hidden" }}>
// // // //         <div style={{ position:"absolute",top:"-18%",right:"-8%",width:500,height:500,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,99,235,.06) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // //         <div style={{ position:"absolute",bottom:"-15%",left:"-5%",width:420,height:420,borderRadius:"50%",background:"radial-gradient(circle,rgba(5,150,105,.05) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // //           {/* Badge - Attractive & Professional */}
// // // //           <div className="fu0" style={{ display:"flex",justifyContent:"center",marginBottom:24 }}>
// // // //             <div style={{
// // // //               display:"inline-flex",
// // // //               alignItems:"center",
// // // //               gap:10,
// // // //               background:"white",
// // // //               border:"1px solid #eef2ff",
// // // //               borderRadius:100,
// // // //               padding:"6px 22px 6px 18px",
// // // //               boxShadow:"0 4px 12px -6px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.02)",
// // // //             }}>
// // // //               <span style={{
// // // //                 width:8,
// // // //                 height:8,
// // // //                 borderRadius:"50%",
// // // //                 background:"#3b82f6",
// // // //                 animation:"pulse2 2s infinite",
// // // //                 boxShadow:"0 0 0 0 rgba(59,130,246,0.4)"
// // // //               }}/>
// // // //               <span style={{
// // // //                 fontSize:12,
// // // //                 fontWeight:500,
// // // //                 color:"#334155",
// // // //                 letterSpacing:"-0.2px"
// // // //               }}>
// // // //                 ⭐ <span style={{ fontWeight:700, color:"#0f172a" }}>AI-powered</span> {servicesConfig.app.shortDesc}
// // // //               </span>
// // // //             </div>
// // // //           </div>
// // // //           {/* Headline */}
// // // //           <h1 className="fu1" style={{ fontFamily:"'Fraunces',Georgia,serif",fontSize:"clamp(38px,6.5vw,72px)",fontWeight:800,lineHeight:1.06,letterSpacing:"-.03em",color:"#111827",textAlign:"center",marginBottom:22 }}>
// // // //             {servicesConfig.app.taglinePre}<br/>
// // // //             <em style={{ fontStyle:"italic",color:"#2563eb",position:"relative" }}>
// // // //               {servicesConfig.app.taglinePost}
// // // //               <svg style={{ position:"absolute",bottom:-4,left:0,width:"100%",height:5 }} viewBox="0 0 400 5" preserveAspectRatio="none">
// // // //                 <path d="M0 3.5 Q100 0 200 3.5 Q300 7 400 3.5" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // // //               </svg>
// // // //             </em>
// // // //           </h1>
// // // //           {/* Subline */}
// // // //           <p className="fu2" style={{ textAlign:"center",fontSize:"clamp(15px,2vw,18px)",color:"#6b7280",lineHeight:1.75,maxWidth:560,margin:"0 auto 34px" }}>
// // // //             Upload your resume, paste any job description — get your ATS score, keyword gaps, AI rewrite suggestions, and a professionally improved resume for just <strong style={{ color:"#111827" }}>{priceDisplay}</strong>.
// // // //           </p>
// // // //           {/* CTAs */}
// // // //           <div className="hc fu3" style={{ display:"flex",gap:12,justifyContent:"center",marginBottom:44,flexWrap:"wrap" }}>
// // // //             <button className="btn-d" style={{ fontSize:16,padding:"15px 36px" }} onClick={()=>startPayment()}>
// // // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""} →
// // // //             </button>
// // // //             <button className="btn-l" style={{ fontSize:14 }} onClick={()=>document.getElementById("templates")?.scrollIntoView({behavior:"smooth"})}>
// // // //               See Templates ↓
// // // //             </button>
// // // //           </div>
// // // //           {/* Trust badges */}
// // // //           <div className="fu3" style={{ display:"flex",justifyContent:"center",gap:28,flexWrap:"wrap" }}>
// // // //             {[["lock","Stripe Secure"],["zap","60s Analysis"],["target","ATS Optimized"],["check","No Subscription"]].map(([ic,lb])=>(
// // // //               <div key={lb} style={{ display:"flex",alignItems:"center",gap:6 }}>
// // // //                 <Icon name={ic} size={14} color="#9ca3af" strokeWidth={2} />
// // // //                 <span style={{ fontSize:12,color:"#9ca3af",fontWeight:500 }}>{lb}</span>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </section>



// // // //       {/* ══ STATS BAR ══ */}
// // // //       <section style={{ background:"#111827",padding:"34px 5%" }}>
// // // //         <div style={{ maxWidth:1000,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24 }}>
// // // //           {[
// // // //             {v:76,s:"%",l:"of resumes rejected by ATS before a human sees them"},
// // // //             {v:7,s:"s",l:"average time a recruiter spends reading a resume"},
// // // //             {v:priceDisplay,s:"",l:"one-time price — no monthly subscription ever"},
// // // //             {v:analysisCount,s:"×",l:`ATS analyses included — run ${analysisCount} times per purchase`},
// // // //           ].map(st=>(
// // // //             <div key={st.l} style={{ textAlign:"center" }}>
// // // //               <div style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,3.5vw,38px)",color:"#fff",fontWeight:700,marginBottom:5,fontStyle:"italic" }}>
// // // //                 {typeof st.v==="string"?st.v:<Counter target={st.v} suffix={st.s}/>}
// // // //               </div>
// // // //               <div style={{ fontSize:11,color:"rgba(255,255,255,.38)",lineHeight:1.5,maxWidth:110,margin:"0 auto" }}>{st.l}</div>
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ FEATURES ══ */}
// // // //       <section id="features" style={{ padding:"60px 5% 80px", background:"linear-gradient(180deg, #fff 0%, #fafcff 100%)" }}>
// // // //       <div style={{ maxWidth:1100, margin:"0 auto" }}>
        
// // // //         {/* Section Header - Redesigned */}
// // // //         <div style={{ textAlign:"center", marginBottom:48 }}>
// // // //           <div style={{
// // // //             display:"inline-flex",
// // // //             alignItems:"center",
// // // //             gap:8,
// // // //             background:"#3b82f6",
// // // //             color:"white",
// // // //             fontSize:"clamp(11px, 3vw, 12px)",
// // // //             fontWeight:600,
// // // //             padding:"6px 18px 6px 16px",
// // // //             borderRadius:100,
// // // //             letterSpacing:"0.03em",
// // // //             textTransform:"uppercase",
// // // //             marginBottom:20,
// // // //             boxShadow:"0 4px 12px rgba(59,130,246,0.3)"
// // // //           }}>
// // // //             <span style={{ 
// // // //               width:6, 
// // // //               height:6, 
// // // //               borderRadius:"50%", 
// // // //               background:"white", 
// // // //               display:"inline-block" 
// // // //             }}/>
// // // //             Why Choose Us
// // // //           </div>
          
// // // //           <h2 style={{
// // // //             fontFamily:"'Fraunces',serif",
// // // //             fontSize:"clamp(28px, 6vw, 48px)",
// // // //             fontWeight:800,
// // // //             color:"#0f172a",
// // // //             lineHeight:1.2,
// // // //             letterSpacing:"-0.03em",
// // // //             marginBottom:14,
// // // //             padding:"0 16px"
// // // //           }}>
// // // //             Everything you need to{" "}
// // // //             <span style={{ position:"relative", display:"inline-block" }}>
// // // //               stand out
// // // //               <svg style={{ position:"absolute", bottom:-6, left:0, width:"100%", height:5 }} viewBox="0 0 200 6" preserveAspectRatio="none">
// // // //                 <path d="M0 3 Q50 0 100 3 Q150 6 200 3" stroke="#3b82f6" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // // //               </svg>
// // // //             </span>
// // // //           </h2>
          
// // // //           <p style={{
// // // //             fontSize:"clamp(14px, 3.5vw, 16px)",
// // // //             color:"#64748b",
// // // //             maxWidth:520,
// // // //             margin:"0 auto",
// // // //             lineHeight:1.6,
// // // //             padding:"0 16px"
// // // //           }}>
// // // //             Powered by advanced AI technology to give you the competitive edge in your job search
// // // //           </p>
// // // //         </div>

// // // //         {/* Features Grid - Fully Responsive */}
// // // //         <div style={{
// // // //           display:"grid",
// // // //           gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))",
// // // //           gap:"clamp(16px, 4vw, 24px)",
// // // //           position:"relative"
// // // //         }}>
// // // //           {[
// // // //             {icon:"🎯", title:"ATS Score 0–100", desc:"Precise compatibility score with section-by-section breakdown — summary, experience, skills, education.", color:"#2563eb", gradient:"linear-gradient(135deg, #2563eb12, #3b82f608)"},
// // // //             {icon:"🔍", title:"Keyword Gap Analysis", desc:"See exactly which keywords are missing vs the job description, with natural injection suggestions.", color:"#7c3aed", gradient:"linear-gradient(135deg, #7c3aed12, #8b5cf608)"},
// // // //             {icon:"✍️", title:"AI Rewrite Suggestions", desc:"Actionable rewrites for weak bullet points tailored to your specific role and the job description.", color:"#059669", gradient:"linear-gradient(135deg, #05966912, #10b98108)"},
// // // //             {icon:"✨", title:"AI-Improved Resume", desc:"Your actual resume data + analysis insights = truly improved, keyword-optimized resume. Not generic.", color:"#d97706", gradient:"linear-gradient(135deg, #d9770612, #f59e0b08)"},
// // // //             {icon:"📄", title:`Variety of ATS Templates`, desc:`Multiple professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`, color:"#e11d48", gradient:"linear-gradient(135deg, #e11d4812, #f43f5e08)"},
// // // //             {icon:"📥", title:"PDF, Word & HTML", desc:"Download in any format the application requires — PDF for most roles, Word for older ATS systems.", color:"#0891b2", gradient:"linear-gradient(135deg, #0891b212, #06b6d408)"},
// // // //           ].map((f, idx) => (
// // // //             <div key={f.title} style={{
// // // //               background: f.gradient,
// // // //               borderRadius:"clamp(20px, 5vw, 24px)",
// // // //               padding:"clamp(20px, 5vw, 28px) clamp(16px, 4vw, 24px)",
// // // //               transition:"all 0.35s cubic-bezier(0.2, 0.9, 0.4, 1.1)",
// // // //               cursor:"default",
// // // //               position:"relative",
// // // //               overflow:"hidden",
// // // //               border:"1px solid rgba(255,255,255,0.5)",
// // // //               backdropFilter:"blur(4px)",
// // // //               animation: `fadeUp 0.6s ${0.1 * idx}s ease both`
// // // //             }}
// // // //             onMouseEnter={e => {
// // // //               if (window.innerWidth > 768) {
// // // //                 e.currentTarget.style.transform = "translateY(-8px)";
// // // //                 e.currentTarget.style.boxShadow = `0 24px 48px -16px ${f.color}30`;
// // // //               }
// // // //             }}
// // // //             onMouseLeave={e => {
// // // //               if (window.innerWidth > 768) {
// // // //                 e.currentTarget.style.transform = "translateY(0)";
// // // //                 e.currentTarget.style.boxShadow = "none";
// // // //               }
// // // //             }}>
              
// // // //               {/* Icon with glow effect */}
// // // //               <div style={{
// // // //                 width:"clamp(48px, 10vw, 56px)",
// // // //                 height:"clamp(48px, 10vw, 56px)",
// // // //                 borderRadius:"clamp(14px, 3vw, 18px)",
// // // //                 background: `linear-gradient(135deg, ${f.color} 0%, ${f.color}cc 100%)`,
// // // //                 display:"flex",
// // // //                 alignItems:"center",
// // // //                 justifyContent:"center",
// // // //                 fontSize:"clamp(24px, 5vw, 28px)",
// // // //                 marginBottom:"clamp(16px, 4vw, 22px)",
// // // //                 boxShadow: `0 8px 20px -6px ${f.color}80`,
// // // //               }}>
// // // //                 {f.icon}
// // // //               </div>
              
// // // //               {/* Title */}
// // // //               <h3 style={{
// // // //                 fontSize:"clamp(16px, 4vw, 18px)",
// // // //                 fontWeight:700,
// // // //                 color:"#0f172a",
// // // //                 marginBottom:8,
// // // //                 letterSpacing:"-0.3px"
// // // //               }}>
// // // //                 {f.title}
// // // //               </h3>
              
// // // //               {/* Description */}
// // // //               <p style={{
// // // //                 fontSize:"clamp(13px, 3vw, 14px)",
// // // //                 color:"#64748b",
// // // //                 lineHeight:1.65,
// // // //                 marginBottom:0
// // // //               }}>
// // // //                 {f.desc}
// // // //               </p>
              
// // // //               {/* Decorative accent line */}
// // // //               <div style={{
// // // //                 position:"absolute",
// // // //                 bottom:0,
// // // //                 left:0,
// // // //                 width:"100%",
// // // //                 height:3,
// // // //                 background: `linear-gradient(90deg, ${f.color}, transparent)`,
// // // //                 borderRadius:"0 0 24px 24px",
// // // //                 opacity:0.4
// // // //               }}/>
// // // //             </div>
// // // //           ))}
// // // //         </div>

// // // //         {/* Bottom CTA Link - Responsive */}
// // // //         <div style={{
// // // //           textAlign:"center",
// // // //           marginTop:"clamp(40px, 8vw, 56px)",
// // // //           paddingTop:"clamp(8px, 2vw, 16px)"
// // // //         }}>
// // // //           <a href="#pricing" style={{
// // // //             display:"inline-flex",
// // // //             alignItems:"center",
// // // //             gap:8,
// // // //             fontSize:"clamp(13px, 3.5vw, 15px)",
// // // //             fontWeight:600,
// // // //             color:"#3b82f6",
// // // //             textDecoration:"none",
// // // //             padding:"10px 20px",
// // // //             borderRadius:40,
// // // //             background:"#eff6ff",
// // // //             transition:"all 0.25s ease"
// // // //           }}
// // // //           onMouseEnter={e => {
// // // //             if (window.innerWidth > 768) {
// // // //               e.currentTarget.style.background = "#dbeafe";
// // // //               e.currentTarget.style.gap = "12px";
// // // //             }
// // // //           }}
// // // //           onMouseLeave={e => {
// // // //             if (window.innerWidth > 768) {
// // // //               e.currentTarget.style.background = "#eff6ff";
// // // //               e.currentTarget.style.gap = "8px";
// // // //             }
// // // //           }}>
// // // //             See full feature list → <span style={{ fontSize:"clamp(14px, 3.5vw, 16px)" }}>✨</span>
// // // //           </a>
// // // //         </div>
// // // //       </div>

// // // //   {/* Add responsive styles to head or component */}
// // // //   <style>{`
// // // //     @keyframes fadeUp {
// // // //       from {
// // // //         opacity: 0;
// // // //         transform: translateY(30px);
// // // //       }
// // // //       to {
// // // //         opacity: 1;
// // // //         transform: translateY(0);
// // // //       }
// // // //     }
    
// // // //     /* Responsive touch optimizations */
// // // //     @media (max-width: 768px) {
// // // //       .features-card {
// // // //         cursor: pointer;
// // // //         -webkit-tap-highlight-color: transparent;
// // // //       }
// // // //     }
    
// // // //     /* Better grid for tablets */
// // // //     @media (min-width: 640px) and (max-width: 1023px) {
// // // //       .features-grid {
// // // //         grid-template-columns: repeat(2, 1fr) !important;
// // // //       }
// // // //     }
    
// // // //     /* Single column for mobile */
// // // //     @media (max-width: 639px) {
// // // //       .features-grid {
// // // //         grid-template-columns: 1fr !important;
// // // //       }
// // // //     }
// // // //   `}</style>
// // // // </section>

// // // //       {/* ══ HOW IT WORKS ══ */}
// // // //       <section style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // //         <div style={{ maxWidth:1020,margin:"0 auto" }}>
// // // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Simple Process</div>
// // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em" }}>
// // // //               From signup to results<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>in under 60 seconds</em>
// // // //             </h2>
// // // //           </div>
// // // //           <div className="sr" style={{ display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12 }}>
// // // //             {[
// // // //               {n:"01",icon:"creditCard", title:`Pay ${priceDisplay}`,        desc:"One-time payment. No subscription."},
// // // //               {n:"02",icon:"upload",     title:"Upload Resume",               desc:"Word file or paste your text."},
// // // //               {n:"03",icon:"clipboard",  title:"Paste Job Description",       desc:"Copy from any job board."},
// // // //               {n:"04",icon:"target",     title:`Get ATS Score`,               desc:`Run up to ${analysisCount}× per purchase.`},
// // // //               {n:"05",icon:"fileText",   title:"Generate Resume",             desc:"Pick best analysis + template → done."},
// // // //             ].map((s,i)=>(
// // // //               <div key={s.n} style={{ textAlign:"center",position:"relative" }}>
// // // //                 {i<4&&<div style={{ position:"absolute",top:25,right:-8,width:16,height:1,background:"#d1d5db",zIndex:1 }}/>}
// // // //                 <div style={{ width:50,height:50,borderRadius:"50%",background:"#111827",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",position:"relative",zIndex:2 }}>
// // // //                   <Icon name={s.icon} size={22} color="#fff" strokeWidth={1.7} />
// // // //                 </div>
// // // //                 <div style={{ fontSize:10,color:"#9ca3af",fontWeight:700,letterSpacing:".1em",marginBottom:5 }}>{s.n}</div>
// // // //                 <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:4 }}>{s.title}</div>
// // // //                 <div style={{ fontSize:11,color:"#9ca3af",lineHeight:1.6 }}>{s.desc}</div>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ TEMPLATES ══ */}
// // // //       <section id="templates" style={{ background:"#fff",padding:"82px 5%",overflow:"hidden" }}>
// // // //               <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // //                 <div style={{ textAlign:"center",marginBottom:48 }}>
// // // //                   <div style={{ display:"inline-block",background:"#fdf4ff",color:"#7c3aed",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Multiple Templates Included Free</div>
// // // //                   <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // // //                     ATS-tested resume templates<br/><em style={{ fontStyle:"italic",color:"#7c3aed" }}>that impress humans too</em>
// // // //                   </h2>
// // // //                   <p style={{ fontSize:15,color:"#6b7280",maxWidth:500,margin:"0 auto" }}>
// // // //                     Every template passes ATS parsing tests. All our layouts use clean formatting, standard headings, and selectable text.
// // // //                   </p>
// // // //                 </div>
      
// // // //                 {/* Template previews */}
// // // //                 <div className="tr" style={{ display:"flex",gap:14,justifyContent:"center",marginBottom:32,alignItems:"flex-end",flexWrap:"wrap" }}>
// // // //                   {allTemplates.map((t,i)=>(
// // // //                     <div key={t.id} onClick={()=>setActiveTmpl(i)} style={{ cursor:"pointer", transform: activeTmpl===i?"scale(1.05) translateY(-6px)":"scale(0.97)", transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)", boxShadow: activeTmpl===i ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${t.accent}` : "0 6px 20px rgba(0,0,0,0.09)", borderRadius:10, overflow:"hidden" }}><TemplateMini t={t} scale={0.27} width={600} /></div>
// // // //                   ))}
// // // //                 </div>
      
// // // //                 {/* Dots + active name */}
// // // //                 <div style={{ textAlign:"center",marginBottom:36 }}>
// // // //                   <div style={{ display:"flex",justifyContent:"center",gap:6,marginBottom:12 }}>
// // // //                     {allTemplates.map((t,i)=>(
// // // //                       <button key={t.id} onClick={()=>setActiveTmpl(i)}
// // // //                         style={{ width:i===activeTmpl?24:7,height:7,borderRadius:4,background:i===activeTmpl?allTemplates[activeTmpl].accent:"#e5e7eb",border:"none",cursor:"pointer",transition:"all .3s" }}/>
// // // //                     ))}
// // // //                   </div>
// // // //                   <div style={{ fontWeight:700,fontSize:17,color:"#111827",marginBottom:4,fontFamily:"'Fraunces',serif" }}>{allTemplates[activeTmpl]?.name}</div>
// // // //                   <div style={{ fontSize:13,color:"#6b7280",marginBottom:8 }}>{allTemplates[activeTmpl]?.description}</div>
// // // //                   <div style={{ display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap" }}>
// // // //                     {allTemplates[activeTmpl]?.tags.map(tag=>(
// // // //                       <span key={tag} style={{ fontSize:11,background:"#f3f4f6",color:"#374151",padding:"3px 12px",borderRadius:20,fontWeight:500 }}>{tag}</span>
// // // //                     ))}
// // // //                   </div>
// // // //                 </div>
      
// // // //                 {/* ATS note */}
// // // //                 <div style={{ 
// // // //                   background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", 
// // // //                   borderRadius: 16, 
// // // //                   padding: "20px 24px", 
// // // //                   border: "1px solid #cbd5e1", 
// // // //                   display: "flex", 
// // // //                   alignItems: "center", 
// // // //                   gap: 16, 
// // // //                   flexWrap: "wrap", 
// // // //                   marginBottom: 20,
// // // //                   boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// // // //                   transition: "all 0.2s ease",
// // // //                 }}>
// // // //                   <div style={{ 
// // // //                     width: 44, 
// // // //                     height: 44, 
// // // //                     borderRadius: 12, 
// // // //                     background: "linear-gradient(135deg, #10b981, #059669)", 
// // // //                     display: "flex", 
// // // //                     alignItems: "center", 
// // // //                     justifyContent: "center",
// // // //                     boxShadow: "0 4px 10px rgba(16, 185, 129, 0.2)",
// // // //                     flexShrink: 0,
// // // //                   }}>
// // // //                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // //                       <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
// // // //                     </svg>
// // // //                   </div>
// // // //                   <div style={{ flex: 1, minWidth: 240 }}>
// // // //                     <div style={{ 
// // // //                       fontWeight: 700, 
// // // //                       fontSize: 14, 
// // // //                       color: "#0f172a", 
// // // //                       marginBottom: 4,
// // // //                       display: "flex",
// // // //                       alignItems: "center",
// // // //                       gap: 8,
// // // //                       flexWrap: "wrap",
// // // //                     }}>
// // // //                       All templates ATS-compliant by design             
// // // //                     </div>
// // // //                     <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // // //                       Standard section headings · Selectable text · No graphics in text layers · Compatible with Workday, Greenhouse, Taleo and more
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
      
// // // //                 {/* CTA banner */}
// // // //                 <div style={{ 
// // // //                   background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", 
// // // //                   borderRadius: 20, 
// // // //                   padding: "24px 32px", 
// // // //                   display: "flex", 
// // // //                   alignItems: "center", 
// // // //                   justifyContent: "space-between", 
// // // //                   flexWrap: "wrap", 
// // // //                   gap: 20, 
// // // //                   border: "1px solid #a7f3d0",
// // // //                   boxShadow: "0 8px 20px rgba(5, 150, 105, 0.12)",
// // // //                   transition: "all 0.3s ease",
// // // //                 }}>
// // // //                   <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
// // // //                     <div style={{ 
// // // //                       width: 52, 
// // // //                       height: 52, 
// // // //                       borderRadius: 16, 
// // // //                       background: "linear-gradient(135deg, #059669, #047857)", 
// // // //                       display: "flex", 
// // // //                       alignItems: "center", 
// // // //                       justifyContent: "center",
// // // //                       boxShadow: "0 6px 14px rgba(5, 150, 105, 0.25)",
// // // //                     }}>
// // // //                       <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // //                         <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="white" strokeWidth="1.5" fill="none"/>
// // // //                         <path d="M12 6V12L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
// // // //                       </svg>
// // // //                     </div>
// // // //                     <div>
// // // //                       <div style={{ 
// // // //                         fontWeight: 800, 
// // // //                         fontSize: 16, 
// // // //                         color: "#064e3b", 
// // // //                         marginBottom: 6,
// // // //                         display: "flex",
// // // //                         alignItems: "center",
// // // //                         gap: 8,
// // // //                         flexWrap: "wrap",
// // // //                       }}>
// // // //                         <span style={{ fontSize: 18 }}>✨</span> 
// // // //                         Variety of templates included free with every analysis
// // // //                         <span style={{ 
// // // //                           background: "#059669", 
// // // //                           color: "#fff", 
// // // //                           fontSize: 10, 
// // // //                           fontWeight: 700, 
// // // //                           padding: "2px 10px", 
// // // //                           borderRadius: 20,
// // // //                           letterSpacing: "0.04em",
// // // //                         }}>
// // // //                           NO EXTRA COST
// // // //                         </span>
// // // //                       </div>
// // // //                       <div style={{ fontSize: 13, color: "#047857", lineHeight: 1.5 }}>
// // // //                         Pick your favourite after your ATS analysis.
// // // //                       </div>
// // // //                     </div>
// // // //                   </div>
// // // //                   <button 
// // // //                     className="btn-d" 
// // // //                     style={{ 
// // // //                       background: "linear-gradient(135deg, #059669, #047857)", 
// // // //                       borderRadius: 40,
// // // //                       padding: "12px 28px",
// // // //                       fontSize: 14,
// // // //                       fontWeight: 700,
// // // //                       boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
// // // //                       transition: "all 0.2s ease",
// // // //                       cursor: "pointer",
// // // //                       border: "none",
// // // //                       color: "#fff",
// // // //                       display: "flex",
// // // //                       alignItems: "center",
// // // //                       gap: 8,
// // // //                     }}
// // // //                     onMouseEnter={e => {
// // // //                       e.currentTarget.style.transform = "translateY(-2px)";
// // // //                       e.currentTarget.style.boxShadow = "0 8px 20px rgba(5, 150, 105, 0.35)";
// // // //                     }}
// // // //                     onMouseLeave={e => {
// // // //                       e.currentTarget.style.transform = "translateY(0)";
// // // //                       e.currentTarget.style.boxShadow = "0 4px 12px rgba(5, 150, 105, 0.3)";
// // // //                     }}
// // // //                     onClick={()=>startPayment()}
// // // //                   >
// // // //                     Start for {priceDisplay} 
// // // //                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // //                       <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // //                     </svg>
// // // //                   </button>
// // // //                 </div>
// // // //               </div>
// // // //             </section>   

// // // //       {/* ══ PRICING ══ */}
// // // //       <section id="pricing" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // //         <div style={{ maxWidth:860,margin:"0 auto" }}>
// // // //           <div style={{ textAlign:"center",marginBottom:46 }}>
// // // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Pricing</div>
// // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Simple, honest pricing</h2>
// // // //             <p style={{ fontSize:15,color:"#6b7280" }}>No hidden fees. No subscriptions. Pay once, use fully.</p>
// // // //           </div>

// // // //           {/* Plan cards — driven entirely by servicesConfig */}
// // // //           <div className="pg" style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:22,maxWidth:700,margin:"0 auto" }}>
// // // //             {enabledPlans.filter(p=>p.active).map(plan=>{
// // // //               const isHighlight = plan.highlight;
// // // //               return (
// // // //                 <div key={plan.id} style={{
// // // //                   background: isHighlight?"#111827":"#fff",
// // // //                   borderRadius:22,padding:"32px 28px",
// // // //                   border: isHighlight?"none":"1.5px solid #ebebeb",
// // // //                   boxShadow: isHighlight?"0 24px 56px rgba(0,0,0,.18)":"0 4px 16px rgba(0,0,0,.04)",
// // // //                   position:"relative",
// // // //                 }}>
// // // //                   {isHighlight&&<div style={{ position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:"#2563eb",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20,whiteSpace:"nowrap" }}>Most Popular</div>}
// // // //                   <h3 style={{ fontSize:19,fontWeight:800,color:isHighlight?"#fff":"#111827",marginBottom:8,fontFamily:"'Fraunces',serif" }}>{plan.name}</h3>
// // // //                   <div style={{ marginBottom:8 }}>
// // // //                     <span style={{ fontFamily:"'Fraunces',serif",fontSize:52,color:isHighlight?"#fff":"#2563eb",fontWeight:700,fontStyle:"italic",letterSpacing:"-.03em" }}>{plan.price}</span>
// // // //                     <span style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.4)":"#9ca3af",marginLeft:5 }}>{plan.period}</span>
// // // //                   </div>
// // // //                   <p style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.55)":"#6b7280",marginBottom:22,lineHeight:1.65 }}>{plan.description}</p>
// // // //                   {/* Features from config */}
// // // //                   <div style={{ display:"flex",flexDirection:"column",gap:9,marginBottom:24 }}>
// // // //                     {plan.features.filter(f=>f.included).map(f=>(
// // // //                       <div key={f.text} style={{ display:"flex",alignItems:"center",gap:9,fontSize:13 }}>
// // // //                         <span style={{ width:16,height:16,borderRadius:"50%",background:isHighlight?"rgba(255,255,255,.12)":"#f0fdf4",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:9,color:isHighlight?"#fff":"#16a34a",fontWeight:700 }}>✓</span>
// // // //                         <span style={{ color:isHighlight?"rgba(255,255,255,.8)":"#374151" }}>{f.text}</span>
// // // //                       </div>
// // // //                     ))}
// // // //                   </div>
// // // //                   <button onClick={()=>startPayment(plan.id)}
// // // //                     style={{ width:"100%",padding:"13px",fontSize:15,fontWeight:700,borderRadius:50,background:isHighlight?"#2563eb":"#111827",color:"#fff",border:"none",cursor:"pointer",fontFamily:"inherit",transition:"all .2s" }}
// // // //                     onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"}
// // // //                     onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
// // // //                     {user?`Get ${plan.name} →`:"Get Started →"}
// // // //                   </button>
// // // //                   {!user&&<p style={{ fontSize:11,color:isHighlight?"rgba(255,255,255,.3)":"#9ca3af",textAlign:"center",marginTop:10 }}>
// // // //                     Have an account? <span style={{ color:isHighlight?"#60a5fa":"#2563eb",cursor:"pointer",fontWeight:600 }} onClick={()=>navigate("/login")}>Sign in</span>
// // // //                   </p>}
// // // //                 </div>
// // // //               );
// // // //             })}
// // // //           </div>

// // // //           {/* Comparison row */}
// // // //           <div style={{ marginTop:36,background:"#fff",borderRadius:16,border:"1px solid #ebebeb",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,.04)" }}>
// // // //             <div className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#111827" }}>
// // // //               <div style={{ padding:"14px 22px",fontSize:11,fontWeight:600,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:".06em" }}>Feature</div>
// // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // //                 <div style={{ fontSize:12,fontWeight:700,color:"#60a5fa" }}>ResumeScoreAI</div>
// // // //                 <div style={{ fontSize:20,fontWeight:800,color:"#fff",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>{priceDisplay}</div>
// // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.35)" }}>one-time</div>
// // // //               </div>
// // // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // // //                 <div style={{ fontSize:12,fontWeight:700,color:"rgba(255,255,255,.4)" }}>Other Tools</div>
// // // //                 <div style={{ fontSize:20,fontWeight:800,color:"rgba(255,255,255,.4)",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>$30</div>
// // // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.25)" }}>per month</div>
// // // //               </div>
// // // //             </div>
// // // //             {[
// // // //               [`${analysisCount} ATS analyses per purchase`,"✅","❌ Per-resume pricing"],
// // // //               ["Uses YOUR real resume data","✅","❌ Generic output"],
// // // //               [`${allTemplates.length} ATS-tested templates free`,"✅","Limited on free tier"],
// // // //               ["No subscription required","✅","❌ Monthly billing"],
// // // //               ["AI keyword injection into your resume","✅","✅"],
// // // //               [`Price per resume`,`${priceDisplay} once`,"$19–$30/month"],
// // // //             ].map(([feat,us,them],i)=>(
// // // //               <div key={feat} className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",borderTop:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa" }}>
// // // //                 <div style={{ padding:"12px 22px",fontSize:13,color:"#374151",fontWeight:500 }}>{feat}</div>
// // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,fontWeight:600,color:us.startsWith("✅")?"#059669":"#111827" }}>{us}</div>
// // // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,color:them.startsWith("❌")?"#dc2626":"#6b7280" }}>{them}</div>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //           <p style={{ textAlign:"center",marginTop:22,fontSize:13,color:"#9ca3af" }}>
// // // //             We're new — and that's why we charge <strong style={{ color:"#111827" }}>{priceDisplay} once</strong> instead of $30/month.
// // // //           </p>
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ TRUST SIGNALS ══ */}
// // // //       <section style={{ background:"#fff",padding:"64px 5%" }}>
// // // //         <div style={{ maxWidth:900,margin:"0 auto" }}>
// // // //           <div style={{ textAlign:"center",marginBottom:32 }}>
// // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(22px,3.5vw,34px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em" }}>Built to be trusted</h2>
// // // //           </div>
// // // //           <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:14 }}>
// // // //             {[
// // // //               {icon:"shield",      color:"#2563eb", title:"Stripe Payments",      desc:"Bank-level encryption. We never store your card details."},
// // // //               {icon:"cpu",         color:"#7c3aed", title:"AI Powered",      desc:"Powered by one of the world's most advanced language models."},
// // // //               {icon:"lock",        color:"#059669", title:"Firebase Secure",       desc:"Your resume data is encrypted and never sold to third parties."},
// // // //               {icon:"target",      color:"#d97706", title:"ATS-Tested Templates",  desc:"Verified against Workday, Greenhouse, Taleo and more."},
// // // //               {icon:"zap",         color:"#0891b2", title:"Instant Results",       desc:"Analysis in 15–30 seconds. Resume generation in 15–20 seconds."},
// // // //               {icon:"messageCircle",color:"#059669", title:`${servicesConfig.app.supportHours} Support`,desc:`Real human support — email us and we respond within ${servicesConfig.app.supportHours}.`},
// // // //             ].map(ts=>(
// // // //               <div key={ts.title} style={{ background:"#fafafa",borderRadius:14,padding:"18px",border:"1px solid #ebebeb",display:"flex",gap:12,alignItems:"flex-start" }}>
// // // //                 <IconBox name={ts.icon} size={36} color={ts.color} radius={9} strokeWidth={1.7} />
// // // //                 <div>
// // // //                   <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:3 }}>{ts.title}</div>
// // // //                   <div style={{ fontSize:12,color:"#6b7280",lineHeight:1.6 }}>{ts.desc}</div>
// // // //                 </div>
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ FAQ ══ */}
// // // //       <section id="faq" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // // //         <div style={{ maxWidth:700,margin:"0 auto" }}>
// // // //           <div style={{ textAlign:"center",marginBottom:44 }}>
// // // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Frequently asked questions</h2>
// // // //             <p style={{ fontSize:15,color:"#6b7280" }}>Still have questions? Use the chat button below 💬</p>
// // // //           </div>
// // // //           {servicesConfig.faq.map((item,i)=>(
// // // //             <div key={i} className="faq-item">
// // // //               <div className="fq" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
// // // //                 <span style={{ fontWeight:600,fontSize:14.5,color:"#111827",lineHeight:1.5 }}>{item.q}</span>
// // // //                 <span style={{ color:"#9ca3af",fontSize:10,transition:"transform .2s",display:"inline-block",transform:openFaq===i?"rotate(180deg)":"none",flexShrink:0 }}>▼</span>
// // // //               </div>
// // // //               {openFaq===i&&<div style={{ padding:"0 22px 18px",paddingTop:14,fontSize:14,color:"#6b7280",lineHeight:1.8,borderTop:"1px solid #f5f5f5" }}>{item.a}</div>}
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ DISCLAIMER SECTION ══ */}
// // // //       {/* <section style={{ background: "#f8fafc", padding: "40px 5%" }}>
// // // //         <div style={{ maxWidth: 800, margin: "0 auto", textAlign: "center" }}>
// // // //           <div style={{ 
// // // //             background: "#fff", 
// // // //             borderRadius: 16, 
// // // //             padding: "24px 32px", 
// // // //             border: "1px solid #e2e8f0",
// // // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
// // // //           }}>
// // // //             <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
// // // //             <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", marginBottom: 10 }}>
// // // //               Important Disclaimer
// // // //             </h3>
// // // //             <p style={{ fontSize: 13, color: "#64748b", lineHeight: 1.7, marginBottom: 0 }}>
// // // //               The resume templates and AI-generated content provided by ResumeScoreAI are professional tools designed to 
// // // //               help you improve your resume and increase your chances of getting noticed by recruiters and ATS systems. 
// // // //               However, <strong style={{ color: "#dc2626" }}>we do not guarantee job placement, interviews, or any specific outcome</strong>. 
// // // //               Job search success depends on many factors including your qualifications, experience, interview performance, 
// // // //               and the specific requirements of each employer. Use our tools as part of a comprehensive job search strategy.
// // // //             </p>
// // // //           </div>
// // // //         </div>
// // // //       </section> */}

// // // //       <section style={{ 
// // // //         background: "#f9fafb", 
// // // //         padding: "clamp(32px, 8vw, 56px) 5%" 
// // // //       }}>
// // // //         <div style={{ 
// // // //           maxWidth: 720, 
// // // //           margin: "0 auto" 
// // // //         }}>
// // // //           <div style={{ 
// // // //             background: "#ffffff", 
// // // //             borderRadius: 20, 
// // // //             padding: "clamp(20px, 5vw, 36px) clamp(18px, 5vw, 32px)",
// // // //             border: "1px solid #eef2f6",
// // // //           }}>
// // // //             <div style={{ 
// // // //               display: "flex",
// // // //               gap: 12,
// // // //               alignItems: "flex-start",
// // // //               flexDirection: "column",
// // // //             }}>
// // // //               {/* Subtle header area */}
// // // //               <div style={{
// // // //                 display: "flex",
// // // //                 alignItems: "center",
// // // //                 gap: 8,
// // // //                 flexWrap: "wrap",
// // // //               }}>
// // // //                 <span style={{ 
// // // //                   fontSize: "clamp(20px, 5vw, 24px)",
// // // //                   opacity: 0.5,
// // // //                 }}>📌</span>
// // // //                 <h3 style={{ 
// // // //                   fontSize: "clamp(15px, 4vw, 17px)", 
// // // //                   fontWeight: 500, 
// // // //                   color: "#4b5563", 
// // // //                   margin: 0,
// // // //                   letterSpacing: "-0.2px",
// // // //                 }}>
// // // //                   About this tool
// // // //                 </h3>
// // // //               </div>

// // // //               {/* Main text - no aggressive highlighting */}
// // // //               <p style={{ 
// // // //                 fontSize: "clamp(13px, 4vw, 15px)", 
// // // //                 color: "#6b7280", 
// // // //                 lineHeight: 1.65, 
// // // //                 margin: 0,
// // // //                 fontWeight: 400,
// // // //               }}>
// // // //                 ResumeScoreAI provides professionally designed templates and AI-powered feedback to help strengthen your resume. 
// // // //                 These tools are meant to support your job search, but they do not guarantee interviews, job offers, or specific outcomes.
// // // //               </p>

// // // //               {/* Secondary note - softer styling */}
// // // //               <div style={{
// // // //                 marginTop: 8,
// // // //                 paddingTop: 12,
// // // //                 borderTop: "1px solid #f0f2f5",
// // // //               }}>
// // // //                 <p style={{ 
// // // //                   fontSize: "clamp(11.5px, 3.5vw, 13px)", 
// // // //                   color: "#9ca3af", 
// // // //                   lineHeight: 1.6, 
// // // //                   margin: 0,
// // // //                 }}>
// // // //                   Success depends on your unique qualifications, experience, and interview performance. 
// // // //                   Use this as part of a complete job search strategy.
// // // //                 </p>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ FINAL CTA ══ */}
// // // //       <section style={{ background:"#111827",padding:"90px 5%",textAlign:"center",position:"relative",overflow:"hidden" }}>
// // // //         <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:"70%",height:"70%",background:"radial-gradient(circle,rgba(37,99,235,.12) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // // //         <div style={{ maxWidth:600,margin:"0 auto",position:"relative" }}>
// // // //           <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(28px,5vw,52px)",fontWeight:800,color:"#fff",marginBottom:18,letterSpacing:"-.03em",lineHeight:1.1 }}>
// // // //             Ready to land<br/><em style={{ fontStyle:"italic",color:"#60a5fa" }}>more interviews?</em>
// // // //           </h2>
// // // //           <p style={{ fontSize:16,color:"rgba(255,255,255,.45)",marginBottom:32,lineHeight:1.7 }}>
// // // //             {analysisCount} ATS analyses + {resumeCount} AI-improved resume + {allTemplates.length} templates — all for just {priceDisplay}
// // // //           </p>
// // // //           <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap" }}>
// // // //             <button className="btn-d" style={{ background:"#fff",color:"#111827",fontSize:15,padding:"14px 36px" }} onClick={()=>startPayment()}>
// // // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""} →
// // // //             </button>
// // // //             <Link to="/support" className="btn-l" style={{ borderColor:"rgba(255,255,255,.18)",color:"rgba(255,255,255,.7)" }}>Talk to Support</Link>
// // // //           </div>
// // // //           <p style={{ color:"rgba(255,255,255,.18)",fontSize:12,marginTop:24 }}>🔒 Stripe · No subscription · Instant results · {`${servicesConfig.app.supportHours} support`}</p>
// // // //         </div>
// // // //       </section>

// // // //       {/* ══ FOOTER ══ */}
// // // //       <footer style={{ background:"#0a0f1a",padding:"50px 5% 28px" }}>
// // // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // // //           <div className="fc2" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:40,paddingBottom:32,borderBottom:"1px solid rgba(255,255,255,.06)",marginBottom:22 }}>
// // // //             <div>
// // // //               <div style={{ display:"flex",alignItems:"center",gap:9,marginBottom:14 }}>
// // // //                 <div style={{ width:32,height:32,background:"#2563eb",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // // //                   <span style={{ color:"#fff",fontWeight:800,fontSize:15 }}>R</span>
// // // //                 </div>
// // // //                 <span style={{ fontWeight:800,fontSize:16,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Fraunces',serif" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
// // // //               </div>
// // // //               <p style={{ fontSize:12,color:"rgba(255,255,255,.28)",lineHeight:1.8,maxWidth:230,marginBottom:12 }}>{servicesConfig.app.shortDesc}</p>
// // // //               <p style={{ fontSize:11,color:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",gap:6 }}><Icon name="mail" size={11} color="rgba(255,255,255,.2)" strokeWidth={1.8}/>{servicesConfig.app.email}</p>
// // // //             </div>
// // // //             {[
// // // //               {title:"Product",links:[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]]},
// // // //               {title:"Company",links:[["About","/about"],["Support","/support"],["Contact","/support"]]},
// // // //               {title:"Legal",links:[["Privacy","/privacy"],["Terms","/terms"],["Refund","/refund"]]},
// // // //             ].map(col=>(
// // // //               <div key={col.title}>
// // // //                 <h4 style={{ fontSize:10,fontWeight:700,color:"rgba(255,255,255,.32)",textTransform:"uppercase",letterSpacing:".1em",marginBottom:14 }}>{col.title}</h4>
// // // //                 {col.links.map(([label,href])=>{
// // // //                   const s={display:"block",fontSize:12,color:"rgba(255,255,255,.28)",textDecoration:"none",marginBottom:9,transition:"color .15s"};
// // // //                   return href.startsWith("#")
// // // //                     ? <a key={label} href={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</a>
// // // //                     : <Link key={label} to={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</Link>;
// // // //                 })}
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //           <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10 }}>
// // // //             <span style={{ fontSize:11,color:"rgba(255,255,255,.16)" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// // // //             <div style={{ display:"flex",gap:14 }}>
// // // //               {[["lock","Stripe Secure"],["shield","256-bit SSL"],["check","GDPR Compliant"]].map(([ic,lb])=>(
// // // //                 <span key={lb} style={{ fontSize:10,color:"rgba(255,255,255,.16)",display:"inline-flex",alignItems:"center",gap:4 }}><Icon name={ic} size={10} color="rgba(255,255,255,.16)" strokeWidth={2}/>{lb}</span>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </footer>

// // // //       {/* Chat Widget */}
// // // //       <ChatWidget />

// // // //       {/* Payment Modal */}
// // // //       {showModal && (
// // // //         <PaymentModal
// // // //           onSuccess={()=>{ setShowModal(false); navigate("/dashboard"); }}
// // // //           onClose={()=>setShowModal(false)}
// // // //           userEmail={userData?.email||user?.email}
// // // //           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
// // // //           planId={planId}
// // // //           userId={user?.uid}
// // // //         />
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }

// // // // new code today deep seek

// // // import { useState, useEffect, useRef } from "react";
// // // import { useNavigate, Link } from "react-router-dom";
// // // import { useAuth } from "../hooks/useAuth";
// // // import servicesConfig from "../utils/servicesConfig";
// // // // eslint-disable-next-line no-unused-vars
// // // import { getEnabledPlans } from "../utils/paymentConfig";
// // // import PaymentModal from "../components/PaymentModal";
// // // import ChatWidget from "../components/ChatWidget";
// // // import TemplateMini from "../components/TemplateMini";
// // // import Icon, { IconBox } from "../components/Icons";

// // // // ── Pull everything from config ──
// // // // eslint-disable-next-line no-unused-vars
// // // const basicPlan    = servicesConfig.plans.find(p => p.id === "ats_basic");
// // // const analysisCount= basicPlan?.analysisCount|| 2;
// // // const resumeCount  = basicPlan?.resumeGenCount|| 1;
// // // const allTemplates = servicesConfig.resumeTemplates.filter(t => t.active);
// // // const enabledPlans = servicesConfig.plans.filter(p => p.enabled);
// // // const templateComparison = servicesConfig.templateComparison;

// // // // Helper to get rating display
// // // // eslint-disable-next-line no-unused-vars
// // // function getRatingDisplay(score) {
// // //   const rating = templateComparison?.ratingScale?.[score] || 
// // //     { stars: "⭐⭐⭐", label: "Average", color: "#f59e0b" };
// // //   return rating;
// // // }

// // // // ── Animated counter ──
// // // function Counter({ target, suffix="" }) {
// // //   const [n, setN] = useState(0);
// // //   const ref = useRef();
// // //   useEffect(() => {
// // //     const obs = new IntersectionObserver(([e]) => {
// // //       if (!e.isIntersecting) return;
// // //       let v = 0; const step = target / 55;
// // //       const t = setInterval(() => { v += step; if (v >= target) { setN(target); clearInterval(t); } else setN(Math.floor(v)); }, 18);
// // //       obs.disconnect();
// // //     }, { threshold: 0.3 });
// // //     if (ref.current) obs.observe(ref.current);
// // //     return () => obs.disconnect();
// // //   }, [target]);
// // //   return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
// // // }

// // // export default function LandingPage() {
// // //   const navigate = useNavigate();
// // //   const { user, userData } = useAuth();
// // //   const [openFaq,      setOpenFaq]      = useState(null);
// // //   const [showModal,    setShowModal]    = useState(false);
// // //   const [planId,       setPlanId]       = useState("ats_basic");
// // //   const [menuOpen,     setMenuOpen]     = useState(false);
// // //   const [scrolled,     setScrolled]     = useState(false);
// // //   const [activeTmpl,   setActiveTmpl]   = useState(0);
// // //   // ── Live price from server — always matches actual Stripe charge ──
// // //   const [priceDisplay, setPriceDisplay] = useState(basicPlan?.price || "$2.99");
// // //   const [serverPlans,  setServerPlans]  = useState({});
// // //   const [localPrice,   setLocalPrice]   = useState(null);

// // //   useEffect(() => {
// // //     const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
// // //     fetch(`${BACKEND}/config`)
// // //       .then(r => r.json())
// // //       .then(d => {
// // //         if (d.plans?.ats_basic?.priceDisplay) setPriceDisplay(d.plans.ats_basic.priceDisplay);
// // //         if (d.plans) setServerPlans(d.plans);
// // //       })
// // //       .catch(() => {});
// // //   }, []);

// // //   // ── Browser locale currency conversion — no API, no rate limit ──
// // //   useEffect(() => {
// // //     const usdAmount = (serverPlans?.ats_basic?.priceInCents || 299) / 100;

// // //     const langs    = navigator.languages?.length ? navigator.languages : [navigator.language || "en-US"];
// // //     const locale   = langs[0] || "en-US";
// // //     const parts    = locale.split("-");
// // //     const region   = parts[parts.length - 1]?.toUpperCase();

// // //     const USD_REGIONS = ["US","AS","EC","PR","SV","GU","MH","FM","MP","PW","TC","VI","ZW","BZ","PA"];
// // //     if (!region || USD_REGIONS.includes(region)) { setLocalPrice(null); return; }

// // //     const REGION_CURRENCY = {
// // //       IN:"INR", GB:"GBP", AU:"AUD", CA:"CAD",
// // //       DE:"EUR", FR:"EUR", IT:"EUR", ES:"EUR", NL:"EUR", BE:"EUR", PT:"EUR", AT:"EUR",
// // //       JP:"JPY", SG:"SGD", AE:"AED", ZA:"ZAR", BR:"BRL", MX:"MXN", NZ:"NZD",
// // //     };
// // //     const currency = REGION_CURRENCY[region];
// // //     if (!currency) { setLocalPrice(null); return; }

// // //     const CACHE_KEY = "fx_usd_rates_v1";
// // //     const CACHE_TTL = 60 * 60 * 1000; // 1 hour
// // //     const FALLBACK  = { INR:84, GBP:0.79, AUD:1.53, CAD:1.36, EUR:0.92, JPY:150, SGD:1.34, AED:3.67, ZAR:18.5, BRL:5.0, MXN:17.5, NZD:1.65 };

// // //     async function fetchAndDisplay() {
// // //       let rate = null;
// // //       try {
// // //         const cached = sessionStorage.getItem(CACHE_KEY);
// // //         if (cached) {
// // //           const { rates, ts } = JSON.parse(cached);
// // //           if (Date.now() - ts < CACHE_TTL && rates[currency]) {
// // //             rate = rates[currency];
// // //           }
// // //         }
// // //         if (!rate) {
// // //           const res  = await fetch("https://api.exchangerate-api.com/v4/latest/USD", { signal: AbortSignal.timeout(5000) });
// // //           const data = await res.json();
// // //           sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rates: data.rates, ts: Date.now() }));
// // //           rate = data.rates[currency];
// // //         }
// // //       } catch (_) {
// // //         rate = FALLBACK[currency] || null;
// // //       }
// // //       if (!rate) { setLocalPrice(null); return; }
// // //       const formatted = new Intl.NumberFormat(locale, {
// // //         style: "currency", currency, maximumFractionDigits: 0,
// // //       }).format(Math.round(usdAmount * rate));
// // //       setLocalPrice(formatted);
// // //     }

// // //     fetchAndDisplay();
// // //   }, [serverPlans]);

// // //   useEffect(() => {
// // //     const fn = () => setScrolled(window.scrollY > 20);
// // //     window.addEventListener("scroll", fn);
// // //     return () => window.removeEventListener("scroll", fn);
// // //   }, []);

// // //   useEffect(() => {
// // //     const t = setInterval(() => setActiveTmpl(p => (p+1) % allTemplates.length), 3600);
// // //     return () => clearInterval(t);
// // //   }, []);

// // //   function startPayment(pid = "ats_basic") {
// // //     setMenuOpen(false);
// // //     if (user) { setPlanId(pid); setShowModal(true); }
// // //     else navigate("/signup");
// // //   }

// // //   return (
// // //     <div style={{ minHeight:"100vh", fontFamily:"'DM Sans','Inter',-apple-system,sans-serif", background:"#fff", color:"#111827" }}>
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;1,9..40,700&family=Fraunces:ital,wght@0,700;0,800;1,700;1,800&display=swap');
// // //         *{box-sizing:border-box;margin:0;padding:0}
// // //         @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
// // //         @keyframes pulse2{0%,100%{opacity:1}50%{opacity:.4}}
// // //         .fu0{animation:fadeUp .6s ease both}
// // //         .fu1{animation:fadeUp .6s .1s ease both}
// // //         .fu2{animation:fadeUp .6s .2s ease both}
// // //         .fu3{animation:fadeUp .6s .34s ease both}
// // //         .btn-d{display:inline-flex;align-items:center;gap:8px;padding:13px 30px;font-size:15px;font-weight:700;background:#111827;color:#fff;border:none;border-radius:50px;cursor:pointer;transition:all .22s;font-family:inherit;letter-spacing:-.01em;text-decoration:none}
// // //         .btn-d:hover{background:#1f2937;transform:translateY(-2px);box-shadow:0 12px 28px rgba(0,0,0,.18)}
// // //         .btn-l{display:inline-flex;align-items:center;gap:8px;padding:12px 24px;font-size:14px;font-weight:600;background:transparent;color:#111827;border:1.5px solid #d1d5db;border-radius:50px;cursor:pointer;transition:all .2s;font-family:inherit;text-decoration:none}
// // //         .btn-l:hover{border-color:#111827;background:#f9fafb}
// // //         .fc{background:#fff;border:1px solid #ebebeb;border-radius:18px;padding:26px;transition:all .28s}
// // //         .fc:hover{border-color:#e0e0e0;transform:translateY(-4px);box-shadow:0 16px 40px rgba(0,0,0,.07)}
// // //         .faq-item{border:1px solid #ebebeb;border-radius:14px;overflow:hidden;margin-bottom:10px}
// // //         .fq{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;transition:background .15s;gap:12px;background:#fff}
// // //         .fq:hover{background:#fafafa}
// // //         @media(max-width:768px){
// // //           .nd,.na{display:none!important}.hb{display:flex!important}
// // //           .hc{justify-content:center!important}.tr{flex-direction:column;align-items:center!important;gap:14px!important}
// // //           .pg{grid-template-columns:1fr!important}.fg{grid-template-columns:1fr!important}
// // //           .sr{grid-template-columns:1fr 1fr!important}.cg{grid-template-columns:1fr!important}
// // //           .fc2{grid-template-columns:1fr 1fr!important;gap:24px!important}
// // //         }
// // //       `}</style>

// // //       {/* ══ NAV ══ */}
// // //       <nav style={{ position:"sticky",top:0,zIndex:1000,background:scrolled?"rgba(255,255,255,.97)":"transparent",backdropFilter:"blur(16px)",borderBottom:scrolled?"1px solid #ebebeb":"1px solid transparent",transition:"all .3s",padding:"0 5%",height:66,display:"flex",alignItems:"center",justifyContent:"space-between" }}>
// // //         <div onClick={()=>navigate("/")} style={{ display:"flex",alignItems:"center",gap:10,cursor:"pointer" }}>
// // //           <div style={{ width:36,height:36,background:"#111827",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // //             <span style={{ color:"#fff",fontWeight:800,fontSize:17 }}>R</span>
// // //           </div>
// // //           <span style={{ fontWeight:800,fontSize:18,letterSpacing:"-.03em",color:"#111827",fontFamily:"'Fraunces',serif" }}>
// // //             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
// // //           </span>
// // //         </div>
// // //         <div className="nd" style={{ display:"flex",gap:28,alignItems:"center" }}>
// // //           {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h])=>(
// // //             <a key={l} href={h} style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none",transition:"color .15s" }}
// // //               onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#4b5563"}>{l}</a>
// // //           ))}
// // //           <Link to="/support" style={{ fontSize:14,fontWeight:500,color:"#4b5563",textDecoration:"none" }}>Support</Link>
// // //         </div>
// // //         <div className="na" style={{ display:"flex",gap:10,alignItems:"center" }}>
// // //           {user
// // //             ? <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/dashboard")}>Dashboard</button>
// // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>startPayment()}>{servicesConfig.app.ctaNavUser}</button></>
// // //             : <><button className="btn-l" style={{ padding:"8px 18px",fontSize:13 }} onClick={()=>navigate("/login")}>Sign In</button>
// // //                 <button className="btn-d" style={{ padding:"8px 20px",fontSize:13 }} onClick={()=>navigate("/signup")}>{servicesConfig.app.ctaNav}</button></>
// // //           }
// // //         </div>
// // //         <button className="hb" onClick={()=>setMenuOpen(o=>!o)} style={{ display:"none",background:"none",border:"1px solid #e5e7eb",borderRadius:9,padding:"8px 11px",cursor:"pointer",flexDirection:"column",gap:4 }}>
// // //           {[0,1,2].map(i=><span key={i} style={{ display:"block",width:20,height:2,background:"#374151" }}/>)}
// // //         </button>
// // //       </nav>

// // //       {menuOpen && (
// // //         <div style={{ position:"sticky",top:66,zIndex:999,background:"#fff",borderBottom:"1px solid #ebebeb",padding:"16px 5%",boxShadow:"0 8px 24px rgba(0,0,0,.07)" }}>
// // //           <div style={{ display:"flex",flexDirection:"column",gap:2,marginBottom:14 }}>
// // //             {["Features","Templates","Pricing","FAQ"].map(l=>(
// // //               <a key={l} href={`#${l.toLowerCase()}`} onClick={()=>setMenuOpen(false)} style={{ padding:"10px 4px",fontSize:15,color:"#374151",textDecoration:"none",fontWeight:500,borderBottom:"1px solid #f5f5f5" }}>{l}</a>
// // //             ))}
// // //           </div>
// // //           <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
// // //             <button className="btn-l" style={{ width:"100%",justifyContent:"center" }} onClick={()=>{setMenuOpen(false);navigate(user?"/dashboard":"/login");}}>
// // //               {user?"Dashboard":"Sign In"}
// // //             </button>
// // //             <button className="btn-d" style={{ width:"100%",justifyContent:"center" }} onClick={()=>startPayment()}>
// // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""}
// // //             </button>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* ══ HERO ══ */}
// // //       <section style={{ padding:"84px 5% 72px",background:"linear-gradient(155deg,#f8faff 0%,#fafafa 55%,#f0fdf4 100%)",position:"relative",overflow:"hidden" }}>
// // //         <div style={{ position:"absolute",top:"-18%",right:"-8%",width:500,height:500,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,99,235,.06) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // //         <div style={{ position:"absolute",bottom:"-15%",left:"-5%",width:420,height:420,borderRadius:"50%",background:"radial-gradient(circle,rgba(5,150,105,.05) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // //           {/* Badge - Attractive & Professional */}
// // //           <div className="fu0" style={{ display:"flex",justifyContent:"center",marginBottom:24 }}>
// // //             <div style={{
// // //               display:"inline-flex",
// // //               alignItems:"center",
// // //               gap:10,
// // //               background:"white",
// // //               border:"1px solid #eef2ff",
// // //               borderRadius:100,
// // //               padding:"6px 22px 6px 18px",
// // //               boxShadow:"0 4px 12px -6px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.02)",
// // //             }}>
// // //               <span style={{
// // //                 width:8,
// // //                 height:8,
// // //                 borderRadius:"50%",
// // //                 background:"#3b82f6",
// // //                 animation:"pulse2 2s infinite",
// // //                 boxShadow:"0 0 0 0 rgba(59,130,246,0.4)"
// // //               }}/>
// // //               <span style={{
// // //                 fontSize:12,
// // //                 fontWeight:500,
// // //                 color:"#334155",
// // //                 letterSpacing:"-0.2px"
// // //               }}>
// // //                 ⭐ <span style={{ fontWeight:700, color:"#0f172a" }}>AI-powered</span> {servicesConfig.app.shortDesc}
// // //               </span>
// // //             </div>
// // //           </div>
// // //           {/* Headline */}
// // //           <h1 className="fu1" style={{ fontFamily:"'Fraunces',Georgia,serif",fontSize:"clamp(38px,6.5vw,72px)",fontWeight:800,lineHeight:1.06,letterSpacing:"-.03em",color:"#111827",textAlign:"center",marginBottom:22 }}>
// // //             {servicesConfig.app.taglinePre}<br/>
// // //             <em style={{ fontStyle:"italic",color:"#2563eb",position:"relative" }}>
// // //               {servicesConfig.app.taglinePost}
// // //               <svg style={{ position:"absolute",bottom:-4,left:0,width:"100%",height:5 }} viewBox="0 0 400 5" preserveAspectRatio="none">
// // //                 <path d="M0 3.5 Q100 0 200 3.5 Q300 7 400 3.5" stroke="#2563eb" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // //               </svg>
// // //             </em>
// // //           </h1>
// // //           {/* Subline */}
// // //           <p className="fu2" style={{ textAlign:"center",fontSize:"clamp(15px,2vw,18px)",color:"#6b7280",lineHeight:1.75,maxWidth:560,margin:"0 auto 34px" }}>
// // //             Upload your resume, paste any job description — get your ATS score, keyword gaps, AI rewrite suggestions, and a professionally improved resume for just <strong style={{ color:"#111827" }}>{priceDisplay}</strong>.
// // //           </p>
// // //           {/* CTAs */}
// // //           <div className="hc fu3" style={{ display:"flex",gap:12,justifyContent:"center",marginBottom:44,flexWrap:"wrap" }}>
// // //             <button className="btn-d" style={{ fontSize:16,padding:"15px 36px" }} onClick={()=>startPayment()}>
// // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""} →
// // //             </button>
// // //             <button className="btn-l" style={{ fontSize:14 }} onClick={()=>document.getElementById("templates")?.scrollIntoView({behavior:"smooth"})}>
// // //               See Templates ↓
// // //             </button>
// // //           </div>
// // //           {/* Trust badges */}
// // //           <div className="fu3" style={{ display:"flex",justifyContent:"center",gap:28,flexWrap:"wrap" }}>
// // //             {[["lock","Stripe Secure"],["zap","60s Analysis"],["target","ATS Optimized"],["check","No Subscription"]].map(([ic,lb])=>(
// // //               <div key={lb} style={{ display:"flex",alignItems:"center",gap:6 }}>
// // //                 <Icon name={ic} size={14} color="#9ca3af" strokeWidth={2} />
// // //                 <span style={{ fontSize:12,color:"#9ca3af",fontWeight:500 }}>{lb}</span>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* ══ FREE BONUSES SECTION - Simple & Clean ══ */}
// // //       <section style={{ 
// // //         background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
// // //         padding: "clamp(40px, 8vw, 60px) 5%",
// // //         textAlign: "center",
// // //         borderTop: "1px solid #bbf7d0",
// // //         borderBottom: "1px solid #bbf7d0"
// // //       }}>
// // //         <div style={{ maxWidth: 900, margin: "0 auto" }}>
          
// // //           {/* Badge */}
// // //           <div style={{
// // //             display: "inline-block",
// // //             background: "#10b981",
// // //             color: "white",
// // //             fontSize: "12px",
// // //             fontWeight: 700,
// // //             padding: "4px 16px",
// // //             borderRadius: 20,
// // //             marginBottom: 20,
// // //             boxShadow: "0 2px 8px rgba(16,185,129,0.3)"
// // //           }}>
// // //             🎁 FREE BONUSES INCLUDED
// // //           </div>
          
// // //           {/* Headline */}
// // //           <h2 style={{
// // //             fontFamily: "'Fraunces', serif",
// // //             fontSize: "clamp(28px, 5vw, 42px)",
// // //             fontWeight: 800,
// // //             color: "#064e3b",
// // //             marginBottom: 16
// // //           }}>
// // //             Get These <span style={{ color: "#059669" }}>FREE</span> AI Resume
// // //           </h2>
          
// // //           <p style={{
// // //             fontSize: "16px",
// // //             color: "#065f46",
// // //             marginBottom: 32,
// // //             maxWidth: 500,
// // //             marginLeft: "auto",
// // //             marginRight: "auto"
// // //           }}>
// // //             Included automatically with every ATS analysis purchase — no extra cost!
// // //           </p>
          
// // //           {/* Simple 2-column grid for free items */}
// // //           <div style={{
// // //             display: "grid",
// // //             gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
// // //             gap: 24,
// // //             marginBottom: 36
// // //           }}>
            
// // //             {/* Free Resume from Scratch */}
// // //             <div style={{
// // //               background: "white",
// // //               borderRadius: 20,
// // //               padding: "28px 20px",
// // //               boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
// // //               border: "1px solid #bbf7d0",
// // //               transition: "all 0.3s ease"
// // //             }}
// // //             onMouseEnter={e => {
// // //               if (window.innerWidth > 768) {
// // //                 e.currentTarget.style.transform = "translateY(-5px)";
// // //                 e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.12)";
// // //               }
// // //             }}
// // //             onMouseLeave={e => {
// // //               if (window.innerWidth > 768) {
// // //                 e.currentTarget.style.transform = "translateY(0)";
// // //                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)";
// // //               }
// // //             }}>
// // //               <div style={{ fontSize: 48, marginBottom: 12 }}>✨</div>
// // //               <h3 style={{ fontSize: 20, fontWeight: 800, color: "#064e3b", marginBottom: 8 }}>
// // //                 1 AI-Powered Resume
// // //               </h3>
// // //               <p style={{ fontSize: 13, color: "#059669", fontWeight: 600, marginBottom: 8 }}>
// // //                 Built completely from scratch
// // //               </p>
// // //               <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6 }}>
// // //                 Uses YOUR real resume data • Fully customizable • ATS-optimized
// // //               </p>
// // //               <div style={{
// // //                 display: "inline-block",
// // //                 background: "#f0fdf4",
// // //                 color: "#059669",
// // //                 fontSize: 11,
// // //                 fontWeight: 700,
// // //                 padding: "4px 12px",
// // //                 borderRadius: 20,
// // //                 marginTop: 16
// // //               }}>
// // //                 ✓ INCLUDED FREE
// // //               </div>
// // //             </div>
            
// // //             {/* Free Cover Letter */}
// // //             <div style={{
// // //               background: "white",
// // //               borderRadius: 20,
// // //               padding: "28px 20px",
// // //               boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
// // //               border: "1px solid #bbf7d0",
// // //               transition: "all 0.3s ease"
// // //             }}
// // //             onMouseEnter={e => {
// // //               if (window.innerWidth > 768) {
// // //                 e.currentTarget.style.transform = "translateY(-5px)";
// // //                 e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.12)";
// // //               }
// // //             }}
// // //             onMouseLeave={e => {
// // //               if (window.innerWidth > 768) {
// // //                 e.currentTarget.style.transform = "translateY(0)";
// // //                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)";
// // //               }
// // //             }}>
// // //               <div style={{ fontSize: 48, marginBottom: 12 }}>📝</div>
// // //               <h3 style={{ fontSize: 20, fontWeight: 800, color: "#064e3b", marginBottom: 8 }}>
// // //                 1 AI-Powered Cover Letter
// // //               </h3>
// // //               <p style={{ fontSize: 13, color: "#059669", fontWeight: 600, marginBottom: 8 }}>
// // //                 Professionally written
// // //               </p>
// // //               <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6 }}>
// // //                 Tailored to your job description • Editable • Complements your resume
// // //               </p>
// // //               <div style={{
// // //                 display: "inline-block",
// // //                 background: "#f0fdf4",
// // //                 color: "#059669",
// // //                 fontSize: 11,
// // //                 fontWeight: 700,
// // //                 padding: "4px 12px",
// // //                 borderRadius: 20,
// // //                 marginTop: 16
// // //               }}>
// // //                 ✓ INCLUDED FREE
// // //               </div>
// // //             </div>
            
// // //           </div>
          
// // //           {/* Simple Value Statement */}
// // //           <div style={{
// // //             background: "#fef3c7",
// // //             borderRadius: 16,
// // //             padding: "20px",
// // //             marginBottom: 28,
// // //             border: "1px solid #fde68a"
// // //           }}>
// // //             <p style={{ fontSize: 14, color: "#78350f", marginBottom: 8 }}>
// // //               💰 <strong>Total Value:</strong> Usually $49 (Resume $39 + Cover Letter $10)
// // //             </p>
// // //             <p style={{ fontSize: 13, color: "#78350f", fontWeight: 500 }}>
// // //               Yours FREE with any ATS analysis purchase
// // //             </p>
// // //           </div>
          
// // //           {/* CTA Button */}
// // //           <button
// // //             onClick={() => startPayment()}
// // //             style={{
// // //               background: "linear-gradient(135deg, #059669, #047857)",
// // //               padding: "14px 40px",
// // //               fontSize: "16px",
// // //               fontWeight: 700,
// // //               borderRadius: 50,
// // //               border: "none",
// // //               color: "white",
// // //               cursor: "pointer",
// // //               boxShadow: "0 8px 20px rgba(5,150,105,0.3)",
// // //               transition: "all 0.3s ease"
// // //             }}
// // //             onMouseEnter={e => {
// // //               e.currentTarget.style.transform = "translateY(-2px)";
// // //               e.currentTarget.style.boxShadow = "0 12px 28px rgba(5,150,105,0.4)";
// // //             }}
// // //             onMouseLeave={e => {
// // //               e.currentTarget.style.transform = "translateY(0)";
// // //               e.currentTarget.style.boxShadow = "0 8px 20px rgba(5,150,105,0.3)";
// // //             }}
// // //           >
// // //             Get Started for {priceDisplay} → {localPrice && `(${localPrice})`}
// // //           </button>
          
// // //           <p style={{ fontSize: 12, color: "#6b7280", marginTop: 16 }}>
// // //             🔒 No subscription • One-time payment • Instant access 
// // //           </p>
// // //         </div>
// // //       </section>

// // //       {/* ══ STATS BAR ══ */}
// // //       <section style={{ background:"#111827",padding:"34px 5%" }}>
// // //         <div style={{ maxWidth:1000,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:24 }}>
// // //           {[
// // //             {v:76,s:"%",l:"of resumes rejected by ATS before a human sees them"},
// // //             {v:7,s:"s",l:"average time a recruiter spends reading a resume"},
// // //             {v:priceDisplay,s:"",l:"one-time price — no monthly subscription ever"},
// // //             {v:analysisCount,s:"×",l:`ATS analyses included — run ${analysisCount} times per purchase`},
// // //           ].map(st=>(
// // //             <div key={st.l} style={{ textAlign:"center" }}>
// // //               <div style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(26px,3.5vw,38px)",color:"#fff",fontWeight:700,marginBottom:5,fontStyle:"italic" }}>
// // //                 {typeof st.v==="string"?st.v:<Counter target={st.v} suffix={st.s}/>}
// // //               </div>
// // //               <div style={{ fontSize:11,color:"rgba(255,255,255,.38)",lineHeight:1.5,maxWidth:110,margin:"0 auto" }}>{st.l}</div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </section>

// // //       {/* ══ FEATURES ══ */}
// // //       <section id="features" style={{ padding:"60px 5% 80px", background:"linear-gradient(180deg, #fff 0%, #fafcff 100%)" }}>
// // //         <div style={{ maxWidth:1100, margin:"0 auto" }}>
          
// // //           {/* Section Header - Redesigned */}
// // //           <div style={{ textAlign:"center", marginBottom:48 }}>
// // //             <div style={{
// // //               display:"inline-flex",
// // //               alignItems:"center",
// // //               gap:8,
// // //               background:"#3b82f6",
// // //               color:"white",
// // //               fontSize:"clamp(11px, 3vw, 12px)",
// // //               fontWeight:600,
// // //               padding:"6px 18px 6px 16px",
// // //               borderRadius:100,
// // //               letterSpacing:"0.03em",
// // //               textTransform:"uppercase",
// // //               marginBottom:20,
// // //               boxShadow:"0 4px 12px rgba(59,130,246,0.3)"
// // //             }}>
// // //               <span style={{ width:6, height:6, borderRadius:"50%", background:"white", display:"inline-block" }}/>
// // //               Why Choose Us
// // //             </div>
            
// // //             <h2 style={{
// // //               fontFamily:"'Fraunces',serif",
// // //               fontSize:"clamp(28px, 6vw, 48px)",
// // //               fontWeight:800,
// // //               color:"#0f172a",
// // //               lineHeight:1.2,
// // //               letterSpacing:"-0.03em",
// // //               marginBottom:14,
// // //               padding:"0 16px"
// // //             }}>
// // //               Everything you need to{" "}
// // //               <span style={{ position:"relative", display:"inline-block" }}>
// // //                 stand out
// // //                 <svg style={{ position:"absolute", bottom:-6, left:0, width:"100%", height:5 }} viewBox="0 0 200 6" preserveAspectRatio="none">
// // //                   <path d="M0 3 Q50 0 100 3 Q150 6 200 3" stroke="#3b82f6" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
// // //                 </svg>
// // //               </span>
// // //             </h2>
            
// // //             <p style={{
// // //               fontSize:"clamp(14px, 3.5vw, 16px)",
// // //               color:"#64748b",
// // //               maxWidth:520,
// // //               margin:"0 auto",
// // //               lineHeight:1.6,
// // //               padding:"0 16px"
// // //             }}>
// // //               Powered by advanced AI technology to give you the competitive edge in your job search
// // //             </p>
// // //           </div>

// // //           {/* Features Grid - Fully Responsive */}
// // //           <div style={{
// // //             display:"grid",
// // //             gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))",
// // //             gap:"clamp(16px, 4vw, 24px)",
// // //             position:"relative"
// // //           }}>
// // //             {[
// // //               {icon:"🎯", title:"ATS Score 0–100", desc:"Precise compatibility score with section-by-section breakdown — summary, experience, skills, education.", color:"#2563eb", gradient:"linear-gradient(135deg, #2563eb12, #3b82f608)"},
// // //               {icon:"🔍", title:"Keyword Gap Analysis", desc:"See exactly which keywords are missing vs the job description, with natural injection suggestions.", color:"#7c3aed", gradient:"linear-gradient(135deg, #7c3aed12, #8b5cf608)"},
// // //               {icon:"✍️", title:"AI Rewrite Suggestions", desc:"Actionable rewrites for weak bullet points tailored to your specific role and the job description.", color:"#059669", gradient:"linear-gradient(135deg, #05966912, #10b98108)"},
// // //               {icon:"✨", title:"AI-Improved Resume", desc:"Your actual resume data + analysis insights = truly improved, keyword-optimized resume. Not generic.", color:"#d97706", gradient:"linear-gradient(135deg, #d9770612, #f59e0b08)"},
// // //               {icon:"📄", title:`Variety of ATS Templates`, desc:`Multiple professionally designed layouts — all ATS-tested. Pick the style that fits your industry.`, color:"#e11d48", gradient:"linear-gradient(135deg, #e11d4812, #f43f5e08)"},
// // //               {icon:"📥", title:"PDF, Word & HTML", desc:"Download in any format the application requires — PDF for most roles, Word for older ATS systems.", color:"#0891b2", gradient:"linear-gradient(135deg, #0891b212, #06b6d408)"},
// // //             ].map((f, idx) => (
// // //               <div key={f.title} style={{
// // //                 background: f.gradient,
// // //                 borderRadius:"clamp(20px, 5vw, 24px)",
// // //                 padding:"clamp(20px, 5vw, 28px) clamp(16px, 4vw, 24px)",
// // //                 transition:"all 0.35s cubic-bezier(0.2, 0.9, 0.4, 1.1)",
// // //                 cursor:"default",
// // //                 position:"relative",
// // //                 overflow:"hidden",
// // //                 border:"1px solid rgba(255,255,255,0.5)",
// // //                 backdropFilter:"blur(4px)",
// // //                 animation: `fadeUp 0.6s ${0.1 * idx}s ease both`
// // //               }}
// // //               onMouseEnter={e => {
// // //                 if (window.innerWidth > 768) {
// // //                   e.currentTarget.style.transform = "translateY(-8px)";
// // //                   e.currentTarget.style.boxShadow = `0 24px 48px -16px ${f.color}30`;
// // //                 }
// // //               }}
// // //               onMouseLeave={e => {
// // //                 if (window.innerWidth > 768) {
// // //                   e.currentTarget.style.transform = "translateY(0)";
// // //                   e.currentTarget.style.boxShadow = "none";
// // //                 }
// // //               }}>
                
// // //                 {/* Icon with glow effect */}
// // //                 <div style={{
// // //                   width:"clamp(48px, 10vw, 56px)",
// // //                   height:"clamp(48px, 10vw, 56px)",
// // //                   borderRadius:"clamp(14px, 3vw, 18px)",
// // //                   background: `linear-gradient(135deg, ${f.color} 0%, ${f.color}cc 100%)`,
// // //                   display:"flex",
// // //                   alignItems:"center",
// // //                   justifyContent:"center",
// // //                   fontSize:"clamp(24px, 5vw, 28px)",
// // //                   marginBottom:"clamp(16px, 4vw, 22px)",
// // //                   boxShadow: `0 8px 20px -6px ${f.color}80`,
// // //                 }}>
// // //                   {f.icon}
// // //                 </div>
                
// // //                 {/* Title */}
// // //                 <h3 style={{
// // //                   fontSize:"clamp(16px, 4vw, 18px)",
// // //                   fontWeight:700,
// // //                   color:"#0f172a",
// // //                   marginBottom:8,
// // //                   letterSpacing:"-0.3px"
// // //                 }}>
// // //                   {f.title}
// // //                 </h3>
                
// // //                 {/* Description */}
// // //                 <p style={{
// // //                   fontSize:"clamp(13px, 3vw, 14px)",
// // //                   color:"#64748b",
// // //                   lineHeight:1.65,
// // //                   marginBottom:0
// // //                 }}>
// // //                   {f.desc}
// // //                 </p>
                
// // //                 {/* Decorative accent line */}
// // //                 <div style={{
// // //                   position:"absolute",
// // //                   bottom:0,
// // //                   left:0,
// // //                   width:"100%",
// // //                   height:3,
// // //                   background: `linear-gradient(90deg, ${f.color}, transparent)`,
// // //                   borderRadius:"0 0 24px 24px",
// // //                   opacity:0.4
// // //                 }}/>
// // //               </div>
// // //             ))}
// // //           </div>

// // //           {/* Bottom CTA Link - Responsive */}
// // //           <div style={{
// // //             textAlign:"center",
// // //             marginTop:"clamp(40px, 8vw, 56px)",
// // //             paddingTop:"clamp(8px, 2vw, 16px)"
// // //           }}>
// // //             <a href="#pricing" style={{
// // //               display:"inline-flex",
// // //               alignItems:"center",
// // //               gap:8,
// // //               fontSize:"clamp(13px, 3.5vw, 15px)",
// // //               fontWeight:600,
// // //               color:"#3b82f6",
// // //               textDecoration:"none",
// // //               padding:"10px 20px",
// // //               borderRadius:40,
// // //               background:"#eff6ff",
// // //               transition:"all 0.25s ease"
// // //             }}
// // //             onMouseEnter={e => {
// // //               if (window.innerWidth > 768) {
// // //                 e.currentTarget.style.background = "#dbeafe";
// // //                 e.currentTarget.style.gap = "12px";
// // //               }
// // //             }}
// // //             onMouseLeave={e => {
// // //               if (window.innerWidth > 768) {
// // //                 e.currentTarget.style.background = "#eff6ff";
// // //                 e.currentTarget.style.gap = "8px";
// // //               }
// // //             }}>
// // //               See full feature list → <span style={{ fontSize:"clamp(14px, 3.5vw, 16px)" }}>✨</span>
// // //             </a>
// // //           </div>
// // //         </div>

// // //         {/* Add responsive styles to head or component */}
// // //         <style>{`
// // //           @keyframes fadeUp {
// // //             from {
// // //               opacity: 0;
// // //               transform: translateY(30px);
// // //             }
// // //             to {
// // //               opacity: 1;
// // //               transform: translateY(0);
// // //             }
// // //           }
          
// // //           /* Responsive touch optimizations */
// // //           @media (max-width: 768px) {
// // //             .features-card {
// // //               cursor: pointer;
// // //               -webkit-tap-highlight-color: transparent;
// // //             }
// // //           }
          
// // //           /* Better grid for tablets */
// // //           @media (min-width: 640px) and (max-width: 1023px) {
// // //             .features-grid {
// // //               grid-template-columns: repeat(2, 1fr) !important;
// // //             }
// // //           }
          
// // //           /* Single column for mobile */
// // //           @media (max-width: 639px) {
// // //             .features-grid {
// // //               grid-template-columns: 1fr !important;
// // //             }
// // //           }
// // //         `}</style>
// // //       </section>

// // //       {/* ══ HOW IT WORKS ══ */}
// // //       <section style={{ background:"#fafafa",padding:"82px 5%" }}>
// // //         <div style={{ maxWidth:1020,margin:"0 auto" }}>
// // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Simple Process</div>
// // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em" }}>
// // //               From signup to results<br/><em style={{ fontStyle:"italic",color:"#2563eb" }}>in under 60 seconds</em>
// // //             </h2>
// // //           </div>
// // //           <div className="sr" style={{ display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12 }}>
// // //             {[
// // //               {n:"01",icon:"creditCard", title:`Pay ${priceDisplay}`,        desc:"One-time payment. No subscription."},
// // //               {n:"02",icon:"upload",     title:"Upload Resume",               desc:"Word file or paste your text."},
// // //               {n:"03",icon:"clipboard",  title:"Paste Job Description",       desc:"Copy from any job board."},
// // //               {n:"04",icon:"target",     title:`Get ATS Score`,               desc:`Run up to ${analysisCount}× per purchase.`},
// // //               {n:"05",icon:"fileText",   title:"Generate Resume",             desc:"Pick best analysis + template → done."},
// // //             ].map((s,i)=>(
// // //               <div key={s.n} style={{ textAlign:"center",position:"relative" }}>
// // //                 {i<4&&<div style={{ position:"absolute",top:25,right:-8,width:16,height:1,background:"#d1d5db",zIndex:1 }}/>}
// // //                 <div style={{ width:50,height:50,borderRadius:"50%",background:"#111827",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",position:"relative",zIndex:2 }}>
// // //                   <Icon name={s.icon} size={22} color="#fff" strokeWidth={1.7} />
// // //                 </div>
// // //                 <div style={{ fontSize:10,color:"#9ca3af",fontWeight:700,letterSpacing:".1em",marginBottom:5 }}>{s.n}</div>
// // //                 <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:4 }}>{s.title}</div>
// // //                 <div style={{ fontSize:11,color:"#9ca3af",lineHeight:1.6 }}>{s.desc}</div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* ══ TEMPLATES ══ */}
// // //       <section id="templates" style={{ background:"#fff",padding:"82px 5%",overflow:"hidden" }}>
// // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // //           <div style={{ textAlign:"center",marginBottom:48 }}>
// // //             <div style={{ display:"inline-block",background:"#fdf4ff",color:"#7c3aed",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Multiple Templates Included Free</div>
// // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",lineHeight:1.1,letterSpacing:"-.02em",marginBottom:12 }}>
// // //               ATS-tested resume templates<br/><em style={{ fontStyle:"italic",color:"#7c3aed" }}>that impress humans too</em>
// // //             </h2>
// // //             <p style={{ fontSize:15,color:"#6b7280",maxWidth:500,margin:"0 auto" }}>
// // //               Every template passes ATS parsing tests. All our layouts use clean formatting, standard headings, and selectable text.
// // //             </p>
// // //           </div>

// // //           {/* Template previews */}
// // //           <div className="tr" style={{ display:"flex",gap:14,justifyContent:"center",marginBottom:32,alignItems:"flex-end",flexWrap:"wrap" }}>
// // //             {allTemplates.map((t,i)=>(
// // //               <div key={t.id} onClick={()=>setActiveTmpl(i)} style={{ cursor:"pointer", transform: activeTmpl===i?"scale(1.05) translateY(-6px)":"scale(0.97)", transition:"all 0.4s cubic-bezier(0.4,0,0.2,1)", boxShadow: activeTmpl===i ? `0 20px 48px rgba(0,0,0,0.20), 0 0 0 2px ${t.accent}` : "0 6px 20px rgba(0,0,0,0.09)", borderRadius:10, overflow:"hidden" }}><TemplateMini t={t} scale={0.27} width={600} /></div>
// // //             ))}
// // //           </div>

// // //           {/* Dots + active name */}
// // //           <div style={{ textAlign:"center",marginBottom:36 }}>
// // //             <div style={{ display:"flex",justifyContent:"center",gap:6,marginBottom:12 }}>
// // //               {allTemplates.map((t,i)=>(
// // //                 <button key={t.id} onClick={()=>setActiveTmpl(i)}
// // //                   style={{ width:i===activeTmpl?24:7,height:7,borderRadius:4,background:i===activeTmpl?allTemplates[activeTmpl].accent:"#e5e7eb",border:"none",cursor:"pointer",transition:"all .3s" }}/>
// // //               ))}
// // //             </div>
// // //             <div style={{ fontWeight:700,fontSize:17,color:"#111827",marginBottom:4,fontFamily:"'Fraunces',serif" }}>{allTemplates[activeTmpl]?.name}</div>
// // //             <div style={{ fontSize:13,color:"#6b7280",marginBottom:8 }}>{allTemplates[activeTmpl]?.description}</div>
// // //             <div style={{ display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap" }}>
// // //               {allTemplates[activeTmpl]?.tags.map(tag=>(
// // //                 <span key={tag} style={{ fontSize:11,background:"#f3f4f6",color:"#374151",padding:"3px 12px",borderRadius:20,fontWeight:500 }}>{tag}</span>
// // //               ))}
// // //             </div>
// // //           </div>

// // //           {/* ATS note */}
// // //           <div style={{ 
// // //             background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", 
// // //             borderRadius: 16, 
// // //             padding: "20px 24px", 
// // //             border: "1px solid #cbd5e1", 
// // //             display: "flex", 
// // //             alignItems: "center", 
// // //             gap: 16, 
// // //             flexWrap: "wrap", 
// // //             marginBottom: 20,
// // //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// // //             transition: "all 0.2s ease",
// // //           }}>
// // //             <div style={{ 
// // //               width: 44, 
// // //               height: 44, 
// // //               borderRadius: 12, 
// // //               background: "linear-gradient(135deg, #10b981, #059669)", 
// // //               display: "flex", 
// // //               alignItems: "center", 
// // //               justifyContent: "center",
// // //               boxShadow: "0 4px 10px rgba(16, 185, 129, 0.2)",
// // //               flexShrink: 0,
// // //             }}>
// // //               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // //                 <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
// // //               </svg>
// // //             </div>
// // //             <div style={{ flex: 1, minWidth: 240 }}>
// // //               <div style={{ 
// // //                 fontWeight: 700, 
// // //                 fontSize: 14, 
// // //                 color: "#0f172a", 
// // //                 marginBottom: 4,
// // //                 display: "flex",
// // //                 alignItems: "center",
// // //                 gap: 8,
// // //                 flexWrap: "wrap",
// // //               }}>
// // //                 All templates ATS-compliant by design             
// // //               </div>
// // //               <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>
// // //                 Standard section headings · Selectable text · No graphics in text layers · Compatible with Workday, Greenhouse, Taleo and more
// // //               </div>
// // //             </div>
// // //           </div>

// // //           {/* CTA banner */}
// // //           <div style={{ 
// // //             background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", 
// // //             borderRadius: 20, 
// // //             padding: "24px 32px", 
// // //             display: "flex", 
// // //             alignItems: "center", 
// // //             justifyContent: "space-between", 
// // //             flexWrap: "wrap", 
// // //             gap: 20, 
// // //             border: "1px solid #a7f3d0",
// // //             boxShadow: "0 8px 20px rgba(5, 150, 105, 0.12)",
// // //             transition: "all 0.3s ease",
// // //           }}>
// // //             <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
// // //               <div style={{ 
// // //                 width: 52, 
// // //                 height: 52, 
// // //                 borderRadius: 16, 
// // //                 background: "linear-gradient(135deg, #059669, #047857)", 
// // //                 display: "flex", 
// // //                 alignItems: "center", 
// // //                 justifyContent: "center",
// // //                 boxShadow: "0 6px 14px rgba(5, 150, 105, 0.25)",
// // //               }}>
// // //                 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // //                   <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="white" strokeWidth="1.5" fill="none"/>
// // //                   <path d="M12 6V12L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
// // //                 </svg>
// // //               </div>
// // //               <div>
// // //                 <div style={{ 
// // //                   fontWeight: 800, 
// // //                   fontSize: 16, 
// // //                   color: "#064e3b", 
// // //                   marginBottom: 6,
// // //                   display: "flex",
// // //                   alignItems: "center",
// // //                   gap: 8,
// // //                   flexWrap: "wrap",
// // //                 }}>
// // //                   <span style={{ fontSize: 18 }}>✨</span> 
// // //                   Variety of templates included free with every analysis
// // //                   <span style={{ 
// // //                     background: "#059669", 
// // //                     color: "#fff", 
// // //                     fontSize: 10, 
// // //                     fontWeight: 700, 
// // //                     padding: "2px 10px", 
// // //                     borderRadius: 20,
// // //                     letterSpacing: "0.04em",
// // //                   }}>
// // //                     NO EXTRA COST
// // //                   </span>
// // //                 </div>
// // //                 <div style={{ fontSize: 13, color: "#047857", lineHeight: 1.5 }}>
// // //                   Pick your favourite after your ATS analysis.
// // //                 </div>
// // //               </div>
// // //             </div>
// // //             <button 
// // //               className="btn-d" 
// // //               style={{ 
// // //                 background: "linear-gradient(135deg, #059669, #047857)", 
// // //                 borderRadius: 40,
// // //                 padding: "12px 28px",
// // //                 fontSize: 14,
// // //                 fontWeight: 700,
// // //                 boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
// // //                 transition: "all 0.2s ease",
// // //                 cursor: "pointer",
// // //                 border: "none",
// // //                 color: "#fff",
// // //                 display: "flex",
// // //                 alignItems: "center",
// // //                 gap: 8,
// // //               }}
// // //               onMouseEnter={e => {
// // //                 e.currentTarget.style.transform = "translateY(-2px)";
// // //                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(5, 150, 105, 0.35)";
// // //               }}
// // //               onMouseLeave={e => {
// // //                 e.currentTarget.style.transform = "translateY(0)";
// // //                 e.currentTarget.style.boxShadow = "0 4px 12px rgba(5, 150, 105, 0.3)";
// // //               }}
// // //               onClick={()=>startPayment()}
// // //             >
// // //               Start for {priceDisplay} 
// // //               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // //                 <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // //               </svg>
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </section>           

// // //       {/* ══ PRICING ══ */}
// // //       <section id="pricing" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // //         <div style={{ maxWidth:860,margin:"0 auto" }}>
// // //           <div style={{ textAlign:"center",marginBottom:46 }}>
// // //             <div style={{ display:"inline-block",background:"#eff6ff",color:"#2563eb",fontSize:11,fontWeight:700,padding:"5px 16px",borderRadius:20,letterSpacing:".06em",textTransform:"uppercase",marginBottom:16 }}>Pricing</div>
// // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Simple, honest pricing</h2>
// // //             <p style={{ fontSize:15,color:"#6b7280" }}>No hidden fees. No subscriptions. Pay once, use fully.</p>
// // //           </div>

// // //           {/* Plan cards — driven entirely by servicesConfig */}
// // //           <div className="pg" style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:22,maxWidth:700,margin:"0 auto" }}>
// // //             {enabledPlans.filter(p=>p.active).map(plan=>{
// // //               const isHighlight = plan.highlight;
// // //               return (
// // //                 <div key={plan.id} style={{
// // //                   background: isHighlight?"#111827":"#fff",
// // //                   borderRadius:22,padding:"32px 28px",
// // //                   border: isHighlight?"none":"1.5px solid #ebebeb",
// // //                   boxShadow: isHighlight?"0 24px 56px rgba(0,0,0,.18)":"0 4px 16px rgba(0,0,0,.04)",
// // //                   position:"relative",
// // //                 }}>
// // //                   {isHighlight&&<div style={{ position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:"#2563eb",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20,whiteSpace:"nowrap" }}>Most Popular</div>}
// // //                   <h3 style={{ fontSize:19,fontWeight:800,color:isHighlight?"#fff":"#111827",marginBottom:8,fontFamily:"'Fraunces',serif" }}>{plan.name}</h3>
// // //                   <div style={{ marginBottom:8 }}>
// // //                     <span style={{ fontFamily:"'Fraunces',serif",fontSize:52,color:isHighlight?"#fff":"#2563eb",fontWeight:700,fontStyle:"italic",letterSpacing:"-.03em" }}>{plan.price}</span>
// // //                     <span style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.4)":"#9ca3af",marginLeft:5 }}>{plan.period}</span>
// // //                   </div>
// // //                   <p style={{ fontSize:13,color:isHighlight?"rgba(255,255,255,.55)":"#6b7280",marginBottom:22,lineHeight:1.65 }}>{plan.description}</p>
// // //                   {/* Features from config */}
// // //                   <div style={{ display:"flex",flexDirection:"column",gap:9,marginBottom:24 }}>
// // //                     {plan.features.filter(f=>f.included).map(f=>(
// // //                       <div key={f.text} style={{ display:"flex",alignItems:"center",gap:9,fontSize:13 }}>
// // //                         <span style={{ width:16,height:16,borderRadius:"50%",background:isHighlight?"rgba(255,255,255,.12)":"#f0fdf4",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:9,color:isHighlight?"#fff":"#16a34a",fontWeight:700 }}>✓</span>
// // //                         <span style={{ color:isHighlight?"rgba(255,255,255,.8)":"#374151" }}>{f.text}</span>
// // //                         {(f.text.includes("Free") || f.text.includes("from scratch")) && (
// // //                           <span style={{
// // //                             background: "#10b981",
// // //                             color: "white",
// // //                             fontSize: "10px",
// // //                             fontWeight: "bold",
// // //                             padding: "2px 8px",
// // //                             borderRadius: "12px",
// // //                             marginLeft: "8px"
// // //                           }}>
// // //                             FREE
// // //                           </span>
// // //                         )}
// // //                       </div>
// // //                     ))}
// // //                   </div>
// // //                   <button onClick={()=>startPayment(plan.id)}
// // //                     style={{ width:"100%",padding:"13px",fontSize:15,fontWeight:700,borderRadius:50,background:isHighlight?"#2563eb":"#111827",color:"#fff",border:"none",cursor:"pointer",fontFamily:"inherit",transition:"all .2s" }}
// // //                     onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"}
// // //                     onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
// // //                     {user?`Get ${plan.name} →`:"Get Started →"}
// // //                   </button>
// // //                   {!user&&<p style={{ fontSize:11,color:isHighlight?"rgba(255,255,255,.3)":"#9ca3af",textAlign:"center",marginTop:10 }}>
// // //                     Have an account? <span style={{ color:isHighlight?"#60a5fa":"#2563eb",cursor:"pointer",fontWeight:600 }} onClick={()=>navigate("/login")}>Sign in</span>
// // //                   </p>}
// // //                 </div>
// // //               );
// // //             })}
// // //           </div>

// // //           {/* Comparison row */}
// // //           <div style={{ marginTop:36,background:"#fff",borderRadius:16,border:"1px solid #ebebeb",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,.04)" }}>
// // //             <div className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#111827" }}>
// // //               <div style={{ padding:"14px 22px",fontSize:11,fontWeight:600,color:"rgba(255,255,255,.4)",textTransform:"uppercase",letterSpacing:".06em" }}>Feature</div>
// // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // //                 <div style={{ fontSize:12,fontWeight:700,color:"#60a5fa" }}>ResumeScoreAI</div>
// // //                 <div style={{ fontSize:20,fontWeight:800,color:"#fff",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>{priceDisplay}</div>
// // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.35)" }}>one-time</div>
// // //               </div>
// // //               <div style={{ padding:"14px 22px",textAlign:"center" }}>
// // //                 <div style={{ fontSize:12,fontWeight:700,color:"rgba(255,255,255,.4)" }}>Other Tools</div>
// // //                 <div style={{ fontSize:20,fontWeight:800,color:"rgba(255,255,255,.4)",fontFamily:"'Fraunces',serif",fontStyle:"italic" }}>$30</div>
// // //                 <div style={{ fontSize:10,color:"rgba(255,255,255,.25)" }}>per month</div>
// // //               </div>
// // //             </div>
// // //             {[
// // //               [`${analysisCount} ATS analyses per purchase`,"✅","❌ Per-resume pricing"],
// // //               ["Uses YOUR real resume data","✅","❌ Generic output"],
// // //               [`${allTemplates.length} ATS-tested templates free`,"✅","Limited on free tier"],
// // //               ["No subscription required","✅","❌ Monthly billing"],
// // //               ["AI keyword injection into your resume","✅","✅"],
// // //               [`Price per resume`,`${priceDisplay} once`,"$19–$30/month"],
// // //             ].map(([feat,us,them],i)=>(
// // //               <div key={feat} className="cg" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",borderTop:"1px solid #f5f5f5",background:i%2===0?"#fff":"#fafafa" }}>
// // //                 <div style={{ padding:"12px 22px",fontSize:13,color:"#374151",fontWeight:500 }}>{feat}</div>
// // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,fontWeight:600,color:us.startsWith("✅")?"#059669":"#111827" }}>{us}</div>
// // //                 <div style={{ padding:"12px 22px",textAlign:"center",fontSize:13,color:them.startsWith("❌")?"#dc2626":"#6b7280" }}>{them}</div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //           <p style={{ textAlign:"center",marginTop:22,fontSize:13,color:"#9ca3af" }}>
// // //             We're new — and that's why we charge <strong style={{ color:"#111827" }}>{priceDisplay} once</strong> instead of $30/month.
// // //           </p>
// // //         </div>
// // //       </section>

// // //       {/* ══ TRUST SIGNALS ══ */}
// // //       <section style={{ background:"#fff",padding:"64px 5%" }}>
// // //         <div style={{ maxWidth:900,margin:"0 auto" }}>
// // //           <div style={{ textAlign:"center",marginBottom:32 }}>
// // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(22px,3.5vw,34px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em" }}>Built to be trusted</h2>
// // //           </div>
// // //           <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:14 }}>
// // //             {[
// // //               {icon:"shield",      color:"#2563eb", title:"Stripe Payments",      desc:"Bank-level encryption. We never store your card details."},
// // //               {icon:"cpu",         color:"#7c3aed", title:"AI Powered",      desc:"Powered by one of the world's most advanced language models."},
// // //               {icon:"lock",        color:"#059669", title:"Firebase Secure",       desc:"Your resume data is encrypted and never sold to third parties."},
// // //               {icon:"target",      color:"#d97706", title:"ATS-Tested Templates",  desc:"Verified against Workday, Greenhouse, Taleo and more."},
// // //               {icon:"zap",         color:"#0891b2", title:"Instant Results",       desc:"Analysis in 15–30 seconds. Resume generation in 15–20 seconds."},
// // //               {icon:"messageCircle",color:"#059669", title:`${servicesConfig.app.supportHours} Support`,desc:`Real human support — email us and we respond within ${servicesConfig.app.supportHours}.`},
// // //             ].map(ts=>(
// // //               <div key={ts.title} style={{ background:"#fafafa",borderRadius:14,padding:"18px",border:"1px solid #ebebeb",display:"flex",gap:12,alignItems:"flex-start" }}>
// // //                 <IconBox name={ts.icon} size={36} color={ts.color} radius={9} strokeWidth={1.7} />
// // //                 <div>
// // //                   <div style={{ fontWeight:700,fontSize:13,color:"#111827",marginBottom:3 }}>{ts.title}</div>
// // //                   <div style={{ fontSize:12,color:"#6b7280",lineHeight:1.6 }}>{ts.desc}</div>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* ══ FAQ ══ */}
// // //       <section id="faq" style={{ background:"#fafafa",padding:"82px 5%" }}>
// // //         <div style={{ maxWidth:700,margin:"0 auto" }}>
// // //           <div style={{ textAlign:"center",marginBottom:44 }}>
// // //             <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:800,color:"#111827",letterSpacing:"-.02em",marginBottom:10 }}>Frequently asked questions</h2>
// // //             <p style={{ fontSize:15,color:"#6b7280" }}>Still have questions? Use the chat button below 💬</p>
// // //           </div>
// // //           {servicesConfig.faq.map((item,i)=>(
// // //             <div key={i} className="faq-item">
// // //               <div className="fq" onClick={()=>setOpenFaq(openFaq===i?null:i)}>
// // //                 <span style={{ fontWeight:600,fontSize:14.5,color:"#111827",lineHeight:1.5 }}>{item.q}</span>
// // //                 <span style={{ color:"#9ca3af",fontSize:10,transition:"transform .2s",display:"inline-block",transform:openFaq===i?"rotate(180deg)":"none",flexShrink:0 }}>▼</span>
// // //               </div>
// // //               {openFaq===i&&<div style={{ padding:"0 22px 18px",paddingTop:14,fontSize:14,color:"#6b7280",lineHeight:1.8,borderTop:"1px solid #f5f5f5" }}>{item.a}</div>}
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </section>

// // //       {/* ══ DISCLAIMER SECTION ══ */}
// // //       <section style={{ 
// // //         background: "#f9fafb", 
// // //         padding: "clamp(32px, 8vw, 56px) 5%" 
// // //       }}>
// // //         <div style={{ 
// // //           maxWidth: 720, 
// // //           margin: "0 auto" 
// // //         }}>
// // //           <div style={{ 
// // //             background: "#ffffff", 
// // //             borderRadius: 20, 
// // //             padding: "clamp(20px, 5vw, 36px) clamp(18px, 5vw, 32px)",
// // //             border: "1px solid #eef2f6",
// // //           }}>
// // //             <div style={{ 
// // //               display: "flex",
// // //               gap: 12,
// // //               alignItems: "flex-start",
// // //               flexDirection: "column",
// // //             }}>
// // //               <div style={{
// // //                 display: "flex",
// // //                 alignItems: "center",
// // //                 gap: 8,
// // //                 flexWrap: "wrap",
// // //               }}>
// // //                 <span style={{ fontSize: "clamp(20px, 5vw, 24px)", opacity: 0.5 }}>📌</span>
// // //                 <h3 style={{ fontSize: "clamp(15px, 4vw, 17px)", fontWeight: 500, color: "#4b5563", margin: 0, letterSpacing: "-0.2px" }}>
// // //                   About this tool
// // //                 </h3>
// // //               </div>
// // //               <p style={{ fontSize: "clamp(13px, 4vw, 15px)", color: "#6b7280", lineHeight: 1.65, margin: 0, fontWeight: 400 }}>
// // //                 ResumeScoreAI provides professionally designed templates and AI-powered feedback to help strengthen your resume. 
// // //                 These tools are meant to support your job search, but they do not guarantee interviews, job offers, or specific outcomes.
// // //               </p>
// // //               <div style={{ marginTop: 8, paddingTop: 12, borderTop: "1px solid #f0f2f5" }}>
// // //                 <p style={{ fontSize: "clamp(11.5px, 3.5vw, 13px)", color: "#9ca3af", lineHeight: 1.6, margin: 0 }}>
// // //                   Success depends on your unique qualifications, experience, and interview performance. Use this as part of a complete job search strategy.
// // //                 </p>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* ══ FINAL CTA ══ */}
// // //       <section style={{ background:"#111827",padding:"90px 5%",textAlign:"center",position:"relative",overflow:"hidden" }}>
// // //         <div style={{ position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:"70%",height:"70%",background:"radial-gradient(circle,rgba(37,99,235,.12) 0%,transparent 70%)",pointerEvents:"none" }}/>
// // //         <div style={{ maxWidth:600,margin:"0 auto",position:"relative" }}>
// // //           <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"clamp(28px,5vw,52px)",fontWeight:800,color:"#fff",marginBottom:18,letterSpacing:"-.03em",lineHeight:1.1 }}>
// // //             Ready to land<br/><em style={{ fontStyle:"italic",color:"#60a5fa" }}>more interviews?</em>
// // //           </h2>
// // //           <p style={{ fontSize:16,color:"rgba(255,255,255,.45)",marginBottom:32,lineHeight:1.7 }}>
// // //             {analysisCount} ATS analyses + {resumeCount} AI-improved resume + {allTemplates.length} templates — all for just {priceDisplay}
// // //           </p>
// // //           <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap" }}>
// // //             <button className="btn-d" style={{ background:"#fff",color:"#111827",fontSize:15,padding:"14px 36px" }} onClick={()=>startPayment()}>
// // //               {user ? servicesConfig.app.ctaNavUser : servicesConfig.app.ctaHero} — {priceDisplay}{localPrice ? ` (≈${localPrice})` : ""} →
// // //             </button>
// // //             <Link to="/support" className="btn-l" style={{ borderColor:"rgba(255,255,255,.18)",color:"rgba(255,255,255,.7)" }}>Talk to Support</Link>
// // //           </div>
// // //           <p style={{ color:"rgba(255,255,255,.18)",fontSize:12,marginTop:24 }}>🔒 Stripe · No subscription · Instant results · {`${servicesConfig.app.supportHours} support`}</p>
// // //         </div>
// // //       </section>

// // //       {/* ══ FOOTER ══ */}
// // //       <footer style={{ background:"#0a0f1a",padding:"50px 5% 28px" }}>
// // //         <div style={{ maxWidth:1100,margin:"0 auto" }}>
// // //           <div className="fc2" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:40,paddingBottom:32,borderBottom:"1px solid rgba(255,255,255,.06)",marginBottom:22 }}>
// // //             <div>
// // //               <div style={{ display:"flex",alignItems:"center",gap:9,marginBottom:14 }}>
// // //                 <div style={{ width:32,height:32,background:"#2563eb",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
// // //                   <span style={{ color:"#fff",fontWeight:800,fontSize:15 }}>R</span>
// // //                 </div>
// // //                 <span style={{ fontWeight:800,fontSize:16,color:"#fff",letterSpacing:"-.02em",fontFamily:"'Fraunces',serif" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
// // //               </div>
// // //               <p style={{ fontSize:12,color:"rgba(255,255,255,.28)",lineHeight:1.8,maxWidth:230,marginBottom:12 }}>{servicesConfig.app.shortDesc}</p>
// // //               <p style={{ fontSize:11,color:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",gap:6 }}><Icon name="mail" size={11} color="rgba(255,255,255,.2)" strokeWidth={1.8}/>{servicesConfig.app.email}</p>
// // //             </div>
// // //             {[
// // //               {title:"Product",links:[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]]},
// // //               {title:"Company",links:[["About","/about"],["Support","/support"],["Contact","/support"]]},
// // //               {title:"Legal",links:[["Privacy","/privacy"],["Terms","/terms"],["Refund","/refund"]]},
// // //             ].map(col=>(
// // //               <div key={col.title}>
// // //                 <h4 style={{ fontSize:10,fontWeight:700,color:"rgba(255,255,255,.32)",textTransform:"uppercase",letterSpacing:".1em",marginBottom:14 }}>{col.title}</h4>
// // //                 {col.links.map(([label,href])=>{
// // //                   const s={display:"block",fontSize:12,color:"rgba(255,255,255,.28)",textDecoration:"none",marginBottom:9,transition:"color .15s"};
// // //                   return href.startsWith("#")
// // //                     ? <a key={label} href={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</a>
// // //                     : <Link key={label} to={href} style={s} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.28)"}>{label}</Link>;
// // //                 })}
// // //               </div>
// // //             ))}
// // //           </div>
// // //           <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10 }}>
// // //             <span style={{ fontSize:11,color:"rgba(255,255,255,.16)" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// // //             <div style={{ display:"flex",gap:14 }}>
// // //               {[["lock","Stripe Secure"],["shield","256-bit SSL"],["check","GDPR Compliant"]].map(([ic,lb])=>(
// // //                 <span key={lb} style={{ fontSize:10,color:"rgba(255,255,255,.16)",display:"inline-flex",alignItems:"center",gap:4 }}><Icon name={ic} size={10} color="rgba(255,255,255,.16)" strokeWidth={2}/>{lb}</span>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </footer>

// // //       {/* Chat Widget */}
// // //       <ChatWidget />

// // //       {/* Payment Modal */}
// // //       {showModal && (
// // //         <PaymentModal
// // //           onSuccess={()=>{ setShowModal(false); navigate("/dashboard"); }}
// // //           onClose={()=>setShowModal(false)}
// // //           userEmail={userData?.email||user?.email}
// // //           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
// // //           planId={planId}
// // //           userId={user?.uid}
// // //         />
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // new code 
// // // eslint-disable-next-line no-unused-vars
// // import { useState, useEffect, useRef } from "react";
// // import { useNavigate, Link } from "react-router-dom";
// // import { useAuth } from "../hooks/useAuth";
// // import servicesConfig from "../utils/servicesConfig";
// // import PaymentModal from "../components/PaymentModal";
// // import ChatWidget from "../components/ChatWidget";
// // import TemplateMini from "../components/TemplateMini";

// // // ── SVG Icon set — clean, consistent, no emojis ──
// // const Icon = {
// //   // Includes banner
// //   BarChart: () => (
// //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
// //     </svg>
// //   ),
// //   Sparkle: () => (
// //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
// //     </svg>
// //   ),
// //   Gift: () => (
// //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/>
// //       <line x1="12" y1="22" x2="12" y2="7"/>
// //       <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
// //       <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
// //     </svg>
// //   ),
// //   FileText: () => (
// //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
// //       <polyline points="14 2 14 8 20 8"/>
// //       <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
// //     </svg>
// //   ),
// //   Download: () => (
// //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
// //       <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
// //     </svg>
// //   ),
// //   // How it works
// //   CreditCard: () => (
// //     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
// //       <line x1="1" y1="10" x2="23" y2="10"/>
// //     </svg>
// //   ),
// //   Upload: () => (
// //     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
// //       <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
// //     </svg>
// //   ),
// //   Zap: () => (
// //     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
// //     </svg>
// //   ),
// //   // Features
// //   TrendingUp: () => (
// //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
// //       <polyline points="17 6 23 6 23 12"/>
// //     </svg>
// //   ),
// //   Search: () => (
// //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
// //     </svg>
// //   ),
// //   Edit: () => (
// //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
// //       <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
// //     </svg>
// //   ),
// //   RefreshCw: () => (
// //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <polyline points="23 4 23 10 17 10"/>
// //       <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/>
// //     </svg>
// //   ),
// //   Layout: () => (
// //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
// //       <line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
// //     </svg>
// //   ),
// //   Mail: () => (
// //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //       <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
// //       <polyline points="22 6 12 13 2 6"/>
// //     </svg>
// //   ),
// //   // Misc
// //   Lock: () => (
// //     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
// //       <path d="M7 11V7a5 5 0 0110 0v4"/>
// //     </svg>
// //   ),
// //   Clock: () => (
// //     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //       <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
// //     </svg>
// //   ),
// //   Check: ({ size = 10, color = "#fff" }) => (
// //     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
// //       <polyline points="20 6 9 17 4 12"/>
// //     </svg>
// //   ),
// // };



// // const basicPlan     = servicesConfig.plans.find(p => p.id === "ats_basic");
// // const analysisCount = basicPlan?.analysisCount || 3;
// // const allTemplates  = servicesConfig.resumeTemplates.filter(t => t.active);
// // const enabledPlans  = servicesConfig.plans.filter(p => p.enabled);

// // export default function LandingPage() {
// //   const navigate = useNavigate();
// //   const { user, userData } = useAuth();

// //   const [showModal,    setShowModal]    = useState(false);
// //   const [planId,       setPlanId]       = useState("ats_basic");
// //   const [menuOpen,     setMenuOpen]     = useState(false);
// //   const [scrolled,     setScrolled]     = useState(false);
// //   const [openFaq,      setOpenFaq]      = useState(null);
// //   const [activeTmpl,   setActiveTmpl]   = useState(0);
// //   const [priceDisplay, setPriceDisplay] = useState(basicPlan?.price || "$4.99");
// //   // eslint-disable-next-line no-unused-vars
// //   const [localPrice,   setLocalPrice]   = useState(null);

// //   // Fetch live price from server
// //   useEffect(() => {
// //     const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
// //     fetch(`${BACKEND}/config`)
// //       .then(r => r.json())
// //       .then(d => { if (d.plans?.ats_basic?.priceDisplay) setPriceDisplay(d.plans.ats_basic.priceDisplay); })
// //       .catch(() => {});
// //   }, []);

// //   // Scroll listener for nav
// //   useEffect(() => {
// //     const fn = () => setScrolled(window.scrollY > 20);
// //     window.addEventListener("scroll", fn);
// //     return () => window.removeEventListener("scroll", fn);
// //   }, []);

// //   // Template carousel
// //   useEffect(() => {
// //     const t = setInterval(() => setActiveTmpl(p => (p + 1) % allTemplates.length), 4500);
// //     return () => clearInterval(t);
// //   }, []);

// //   function startPayment(pid = "ats_basic") {
// //     setMenuOpen(false);
// //     if (user) { setPlanId(pid); setShowModal(true); }
// //     else navigate("/signup");
// //   }

// //   function ScoreRing({ target = 70, duration = 2000 }) {
// //   const [score, setScore] = useState(0);
// //   const CIRCUMFERENCE = 2 * Math.PI * 50;

// //   const color = score < 45 ? "#e24b4a" : score < 65 ? "#ef9f27" : score < 80 ? "#2563eb" : "#1d9e75";
// //   const offset = CIRCUMFERENCE - (score / 100) * CIRCUMFERENCE;

// //   useEffect(() => {
// //     let start = null;
// //     const step = (ts) => {
// //       if (!start) start = ts;
// //       const t = Math.min((ts - start) / duration, 1);
// //       const ease = t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
// //       setScore(Math.round(target * ease));
// //       if (t < 1) requestAnimationFrame(step);
// //     };
// //     const raf = requestAnimationFrame(step);
// //     return () => cancelAnimationFrame(raf);
// //   }, [target, duration]);

// //   return (
// //     <div style={{ position:"relative", width:120, height:120, margin:"0 auto 16px" }}>
// //       <svg width="120" height="120" viewBox="0 0 120 120" style={{ transform:"rotate(-90deg)" }}>
// //         <circle cx="60" cy="60" r="50" fill="none" stroke="#f1f5f9" strokeWidth="10" />
// //         <circle cx="60" cy="60" r="50" fill="none" stroke={color} strokeWidth="10"
// //           strokeLinecap="round"
// //           strokeDasharray={CIRCUMFERENCE}
// //           strokeDashoffset={offset}
// //           style={{ transition:"stroke 0.3s" }} />
// //       </svg>
// //       <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
// //         <span style={{ fontSize:32, fontWeight:800, color, lineHeight:1 }}>{score}</span>
// //         <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>/100</span>
// //       </div>
// //     </div>
// //   );
// // }

// //   return (
// //     <div style={{ minHeight:"100vh", fontFamily:"'Inter',-apple-system,BlinkMacSystemFont,sans-serif", background:"#fff", color:"#111827" }}>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
// //         *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }

// //         .lp-btn-dark {
// //           background:#111827; color:#fff; border:none; border-radius:10px;
// //           font-weight:600; cursor:pointer; transition:all 0.2s ease;
// //         }
// //         .lp-btn-dark:hover { background:#1f2937; transform:translateY(-1px); box-shadow:0 6px 20px rgba(0,0,0,0.15); }
// //         .lp-btn-outline {
// //           background:transparent; color:#374151; border:1.5px solid #d1d5db; border-radius:10px;
// //           font-weight:500; cursor:pointer; transition:all 0.2s ease;
// //         }
// //         .lp-btn-outline:hover { border-color:#374151; background:#f9fafb; }
// //         .lp-btn-blue {
// //           background:linear-gradient(135deg,#2563eb,#1d4ed8); color:#fff; border:none; border-radius:10px;
// //           font-weight:700; cursor:pointer; transition:all 0.2s ease;
// //         }
// //         .lp-btn-blue:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(37,99,235,0.3); }

// //         .lp-card {
// //           background:#fff; border:1px solid #e5e7eb; border-radius:16px;
// //           transition:box-shadow 0.2s, transform 0.2s;
// //         }
// //         .lp-card:hover { box-shadow:0 12px 32px rgba(0,0,0,0.08); transform:translateY(-3px); }

// //         .lp-tag {
// //           display:inline-block; font-size:12px; font-weight:600;
// //           padding:4px 14px; border-radius:20px;
// //         }
// //         .lp-divider { width:1px; height:20px; background:#e5e7eb; }

// //         @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
// //         .fade-up { animation:fadeUp 0.55s ease forwards; }

// //         /* Mobile */
// //         @media(max-width:768px) {
// //           .lp-desktop       { display:none !important; }
// //           .lp-mobile-show   { display:flex !important; }
// //           .lp-grid-3        { grid-template-columns:1fr !important; }
// //           /* Hero: stack columns on tablet/mobile */
// //           .lp-hero-grid     { grid-template-columns:1fr !important; }
// //           /* Hide score card mock on mobile — focus on copy */
// //           .lp-hero-mock     { display:none !important; }
// //           /* Includes banner: 2 cols on tablet */
// //           .lp-includes-row  { gap:clamp(12px,4vw,24px) !important; justify-content:flex-start !important; }
// //           .lp-includes-item { min-width:calc(50% - 12px); }
// //           /* Pricing features: single col */
// //           .lp-pricing-feats { grid-template-columns:1fr !important; }
// //         }
// //         @media(max-width:480px) {
// //           .lp-hero-btns     { flex-direction:column !important; }
// //           .lp-hero-btns button { width:100% !important; }
// //           .lp-includes-row  { flex-direction:column !important; align-items:flex-start !important; }
// //           .lp-includes-divs { display:none !important; }
// //           /* FAQ full padding */
// //           .lp-faq-item      { padding:14px 16px !important; }
// //           /* Footer bottom bar stack */
// //           .lp-footer-bottom { flex-direction:column !important; text-align:center !important; gap:6px !important; }
// //           /* CTA button full width */
// //           .lp-cta-btn       { width:100% !important; }
// //         }
// //       `}</style>

// //       {/* ── NAV ── */}
// //       <nav style={{
// //         position:"sticky", top:0, zIndex:1000,
// //         background: scrolled ? "rgba(255,255,255,0.97)" : "transparent",
// //         backdropFilter:"blur(16px)",
// //         borderBottom: scrolled ? "1px solid #f3f4f6" : "1px solid transparent",
// //         padding:"0 5%", height:64,
// //         display:"flex", alignItems:"center", justifyContent:"space-between",
// //         transition:"all 0.3s ease",
// //       }}>
// //         <div onClick={() => navigate("/")} style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}>
// //           <div style={{ width:34, height:34, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center" }}>
// //             <span style={{ color:"#fff", fontWeight:800, fontSize:17 }}>R</span>
// //           </div>
// //           <span style={{ fontWeight:700, fontSize:18, letterSpacing:"-0.3px" }}>
// //             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
// //           </span>
// //         </div>

// //         <div className="lp-desktop" style={{ display:"flex", gap:32, alignItems:"center" }}>
// //           {[["How it works","#how"],["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h]) => (
// //             <a key={l} href={h} style={{ fontSize:14, fontWeight:500, color:"#6b7280", textDecoration:"none", transition:"color 0.2s" }}
// //                onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#6b7280"}>{l}</a>
// //           ))}
// //           <Link to="/support" style={{ fontSize:14, fontWeight:500, color:"#6b7280", textDecoration:"none" }}>Support</Link>
// //         </div>

// //         <div className="lp-desktop" style={{ display:"flex", gap:10 }}>
// //           {user ? (
// //             <>
// //               <button className="lp-btn-outline" style={{ padding:"8px 18px", fontSize:13 }} onClick={() => navigate("/dashboard")}>Dashboard</button>
// //               <button className="lp-btn-blue"    style={{ padding:"8px 20px", fontSize:13 }} onClick={() => startPayment()}>Get Access</button>
// //             </>
// //           ) : (
// //             <>
// //               <button className="lp-btn-outline" style={{ padding:"8px 18px", fontSize:13 }} onClick={() => navigate("/login")}>Sign in</button>
// //               <button className="lp-btn-blue"    style={{ padding:"8px 20px", fontSize:13 }} onClick={() => navigate("/signup")}>Get started</button>
// //             </>
// //           )}
// //         </div>

// //         {/* Hamburger */}
// //         <button onClick={() => setMenuOpen(!menuOpen)} className="lp-mobile-show"
// //           style={{ display:"none", background:"none", border:"1px solid #e5e7eb", borderRadius:8, padding:"7px 9px", cursor:"pointer", flexDirection:"column", gap:4 }}>
// //           {[0,1,2].map(i => <span key={i} style={{ display:"block", width:18, height:2, background:"#374151", borderRadius:1 }} />)}
// //         </button>
// //       </nav>

// //       {menuOpen && (
// //         <div style={{ background:"#fff", borderBottom:"1px solid #e5e7eb", padding:"16px 5%", zIndex:999, boxShadow:"0 8px 24px rgba(0,0,0,0.06)" }}>
// //           {["How it works","Features","Templates","Pricing","FAQ"].map(l => (
// //             <a key={l} href={`#${l.toLowerCase().replace(" ","")}`} onClick={() => setMenuOpen(false)}
// //                style={{ display:"block", padding:"10px 0", fontSize:15, color:"#374151", textDecoration:"none", borderBottom:"1px solid #f5f5f5", fontWeight:500 }}>{l}</a>
// //           ))}
// //           <Link to="/support" onClick={() => setMenuOpen(false)}
// //             style={{ display:"block", padding:"10px 0", fontSize:15, color:"#374151", textDecoration:"none", borderBottom:"1px solid #f5f5f5", fontWeight:500 }}>Support</Link>
// //           <div style={{ display:"flex", gap:10, marginTop:14 }}>
// //             <button className="lp-btn-outline" style={{ flex:1, padding:"11px", fontSize:14 }} onClick={() => { setMenuOpen(false); navigate("/login"); }}>Sign in</button>
// //             <button className="lp-btn-blue"    style={{ flex:1, padding:"11px", fontSize:14 }} onClick={() => startPayment()}>Get started</button>
// //           </div>
// //         </div>
// //       )}

// //       {/* ════════════════════════════════════
// //           HERO
// //       ════════════════════════════════════ */}
// //       <section style={{ padding:"clamp(56px,10vw,96px) 5% clamp(48px,8vw,80px)", background:"#f9fafb", borderBottom:"1px solid #e5e7eb" }}>
// //         <div className="lp-hero-grid" style={{ maxWidth:1100, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"clamp(40px,6vw,64px)", alignItems:"center" }}>

// //           {/* Left */}
// //           <div className="fade-up">
// //             {/* Launch badge — honest */}
// //             <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:20, padding:"5px 14px 5px 10px", marginBottom:24 }}>
// //               <span style={{ width:7, height:7, borderRadius:"50%", background:"#3b82f6", display:"inline-block" }} />
// //               <span style={{ fontSize:12, fontWeight:600, color:"#1d4ed8" }}>Founding price · Won't last forever</span>
// //             </div>

// //             <h1 style={{ fontSize:"clamp(34px,5vw,54px)", fontWeight:800, lineHeight:1.1, letterSpacing:"-0.03em", color:"#0f172a", marginBottom:20 }}>
// //               Know exactly why your resume{" "}
// //               <span style={{ color:"#2563eb" }}>isn't getting interviews</span>
// //             </h1>

// //             <p style={{ fontSize:"clamp(15px,2.5vw,18px)", color:"#4b5563", lineHeight:1.7, marginBottom:32, maxWidth:520 }}>
// //               Paste your resume and a job description. We analyse keyword gaps, score your ATS match, and show you exactly what to fix — with specific rewrite suggestions.
// //             </p>

// //             <div className="lp-hero-btns" style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:28 }}>
// //               <button className="lp-btn-blue" style={{ padding:"13px 28px", fontSize:15 }} onClick={() => startPayment()}>
// //                 Analyse my resume — {priceDisplay}
// //               </button>
// //               <button className="lp-btn-outline" style={{ padding:"13px 22px", fontSize:15 }} onClick={() => document.getElementById("how")?.scrollIntoView({ behavior:"smooth" })}>
// //                 See how it works
// //               </button>
// //             </div>

// //             {/* Honest social proof */}
// //             <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap", justifyContent:"flex-start" }}>
// //               <div style={{ display:"flex", alignItems:"center", gap:6 }}>
// //                 <div style={{ color:"#94a3b8" }}><Icon.Lock /></div>
// //                 <span style={{ fontSize:12, color:"#6b7280", fontWeight:500 }}>One-time payment, no subscription</span>
// //               </div>
// //               <div className="lp-divider" />
// //               <div style={{ display:"flex", alignItems:"center", gap:6 }}>
// //                 <div style={{ color:"#94a3b8" }}><Icon.Clock /></div>
// //                 <span style={{ fontSize:12, color:"#6b7280", fontWeight:500 }}>Results in under 30 seconds</span>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Right — score card mock */}
// //           <div className="lp-hero-mock" style={{ display:"flex", justifyContent:"center" }}>
// //             <div style={{ width:"100%", maxWidth:380, background:"#fff", borderRadius:20, border:"1px solid #e5e7eb", overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.08)" }}>

// //               {/* Header bar */}
// //               <div style={{ padding:"16px 20px", borderBottom:"1px solid #f3f4f6", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
// //                 <div style={{ display:"flex", alignItems:"center", gap:8 }}>
// //                   <div style={{ width:28, height:28, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:7, display:"flex", alignItems:"center", justifyContent:"center" }}>
// //                     <span style={{ color:"#fff", fontSize:12, fontWeight:800 }}>R</span>
// //                   </div>
// //                   <span style={{ fontWeight:700, fontSize:13, color:"#1e293b" }}>ATS Analysis</span>
// //                 </div>
// //                 <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>Just now</span>
// //               </div>

// //               {/* Score ring area */}
// //               {/* Animated ATS score ring */}
// //               <ScoreRing target={90} duration={2000} />

// //               {/* Keyword pills */}
// //               <div style={{ padding:"0 20px 16px" }}>
// //                 <div style={{ fontSize:11, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>Missing keywords</div>
// //                 <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
// //                   {["Kubernetes","CI/CD","Terraform","GraphQL","TypeScript"].map(k => (
// //                     <span key={k} style={{ fontSize:11, padding:"4px 8px", borderRadius:20, background:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca", fontWeight:500, whiteSpace:"nowrap" }}>{k}</span>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* Recommendation */}
// //               <div style={{ margin:"0 20px 20px", background:"#f0fdf4", borderRadius:12, padding:"12px 14px", border:"1px solid #bbf7d0" }}>
// //                 <div style={{ fontSize:11, fontWeight:700, color:"#059669", marginBottom:4 }}>Top recommendation</div>
// //                 <div style={{ fontSize:12, color:"#166534", lineHeight:1.5 }}>
// //                   Add "Kubernetes" to 2 experience bullets — moves it from Skills section to full credit.
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           WHAT'S INCLUDED BANNER
// //       ════════════════════════════════════ */}
// //       <section style={{ background:"#fff", padding:"20px 5%", borderBottom:"1px solid #e5e7eb" }}>
// //         <div className="lp-includes-row" style={{ maxWidth:1100, margin:"0 auto", display:"flex", alignItems:"center", justifyContent:"center", gap:"clamp(20px,5vw,56px)", flexWrap:"wrap" }}>
// //           {[
// //             { Icon: Icon.BarChart, label:`${analysisCount} ATS analyses`, sub:"per purchase", color:"#2563eb" },
// //             { Icon: Icon.RefreshCw, label:"AI-improved resume", sub:"based on your real one", color:"#7c3aed" },
// //             { Icon: Icon.Layout, label:"Resume from scratch", sub:"free with plan", color:"#059669" },
// //             { Icon: Icon.Mail, label:"Cover letter", sub:"free with plan", color:"#0891b2" },
// //             { Icon: Icon.Download, label:"PDF + Word download", sub:"all templates", color:"#dc2626" },
// //           ].map(item => (
// //             <div key={item.label} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 0" }}>
// //               <div style={{ width:32, height:32, background:`${item.color}15`, borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", color:item.color, flexShrink:0 }}>
// //                 <item.Icon />
// //               </div>
// //               <div>
// //                 <div style={{ fontSize:13, fontWeight:700, color:"#0f172a" }}>{item.label}</div>
// //                 <div style={{ fontSize:11, color:"#94a3b8" }}>{item.sub}</div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           HOW IT WORKS
// //       ════════════════════════════════════ */}
// //       <section id="how" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
// //         <div style={{ maxWidth:1000, margin:"0 auto" }}>
// //           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
// //             <span className="lp-tag" style={{ background:"#fef3c7", color:"#92400e", marginBottom:16 }}>Simple process</span>
// //             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", lineHeight:1.2, marginBottom:14 }}>
// //               From upload to results in under a minute
// //             </h2>
// //             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:480, margin:"0 auto" }}>
// //               No account tour, no setup. Just paste and go.
// //             </p>
// //           </div>

// //           <div className="lp-grid-3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"clamp(24px,4vw,36px)" }}>
// //             {[
// //               { n:"1", Icon: Icon.CreditCard, title:"Pay once", body:`${priceDisplay} one-time. No subscription. Includes ${analysisCount} full analyses, an improved resume, cover letter, and resume builder.` },
// //               { n:"2", Icon: Icon.Upload, title:"Upload resume + job description", body:"Paste or upload your resume. Paste the job description. That's all the input we need." },
// //               { n:"3", Icon: Icon.Zap, title:"Get your score and fixes", body:"See your ATS score, which keywords are missing, exactly where they should go, and a rewritten resume ready to download." },
// //             ].map(s => (
// //               <div key={s.n} className="lp-card" style={{ padding:"clamp(24px,4vw,32px)" }}>
// //                 <div style={{ width:44, height:44, background:"#eff6ff", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", color:"#2563eb", marginBottom:20 }}>
// //                   <s.Icon />
// //                 </div>
// //                 <div style={{ fontSize:11, fontWeight:700, color:"#2563eb", marginBottom:8, letterSpacing:"0.06em", textTransform:"uppercase" }}>Step {s.n}</div>
// //                 <div style={{ fontSize:"clamp(15px,2.5vw,18px)", fontWeight:700, color:"#0f172a", marginBottom:10, lineHeight:1.3 }}>{s.title}</div>
// //                 <p style={{ fontSize:"clamp(13px,2vw,14px)", color:"#64748b", lineHeight:1.65 }}>{s.body}</p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           FEATURES
// //       ════════════════════════════════════ */}
// //       <section id="features" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#fff" }}>
// //         <div style={{ maxWidth:1100, margin:"0 auto" }}>
// //           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
// //             <span className="lp-tag" style={{ background:"#eff6ff", color:"#1d4ed8", marginBottom:16 }}>What you get</span>
// //             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
// //               Honest, specific feedback — not vague advice
// //             </h2>
// //             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:500, margin:"0 auto" }}>
// //               We tell you exactly which keywords are missing, where to add them, and show you before/after rewrites.
// //             </p>
// //           </div>

// //           <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(min(100%,300px),1fr))", gap:"clamp(16px,3vw,24px)" }}>
// //             {[
// //               {
// //                 Icon: Icon.TrendingUp, color:"#2563eb", title:"Position-weighted ATS score",
// //                 body:"We don't just count keywords. A keyword buried in your skills section scores less than one demonstrated in a bullet with a result. We show you exactly where each skill sits and how to move it up.",
// //                 tag:null,
// //               },
// //               {
// //                 Icon: Icon.Search,     color:"#7c3aed", title:"Hard skill gap analysis",
// //                 body:"We extract the specific tools, technologies, and certifications from the job description and check your resume against them — with synonym matching (AWS = Amazon Web Services, etc.).",
// //                 tag:null,
// //               },
// //               {
// //                 Icon: Icon.Edit,   color:"#059669", title:"Before/after rewrite suggestions",
// //                 body:"Not just \"add more keywords\" — we show you the exact weak bullet, and an improved version that adds a metric and the missing keyword naturally.",
// //                 tag:null,
// //               },
// //               {
// //                 Icon: Icon.RefreshCw, color:"#d97706", title:"AI-improved resume",
// //                 body:"We take your real resume, promote skills-only keywords into experience bullets where they fit, add estimated metrics to weak bullets, and verify the score improved before delivering.",
// //                 tag:null,
// //               },
// //               {
// //                 Icon: Icon.Layout,    color:"#dc2626", title:"Resume from scratch",
// //                 body:"No existing resume? We build a realistic sample based on your field, experience level, and job description. You'll need to personalise it with your real details.",
// //                 tag:"Included free",
// //               },
// //               {
// //                 Icon: Icon.Mail,      color:"#0891b2", title:"Cover letter",
// //                 body:"A tailored cover letter that matches specific JD requirements to your real background. Three tone options: professional, confident, or enthusiastic.",
// //                 tag:"Included free",
// //               },
// //             ].map(f => (
// //               <div key={f.title} className="lp-card" style={{ padding:"clamp(22px,3.5vw,28px)", position:"relative", overflow:"hidden" }}>
// //                 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg,#2563eb,#7c3aed)", opacity:0.6 }} />
// //                 {f.tag && (
// //                   <span className="lp-tag" style={{ background:"#f0fdf4", color:"#059669", border:"1px solid #bbf7d0", fontSize:11, marginBottom:12, display:"inline-block" }}>{f.tag}</span>
// //                 )}
// //                 <div style={{ width:48, height:48, background:`${f.color}12`, borderRadius:14, display:"flex", alignItems:"center", justifyContent:"center", color:f.color, marginBottom:16 }}>
// //                   <f.Icon />
// //                 </div>
// //                 <div style={{ fontSize:"clamp(14px,2.5vw,16px)", fontWeight:700, color:"#0f172a", marginBottom:10, lineHeight:1.3 }}>{f.title}</div>
// //                 <p style={{ fontSize:"clamp(12px,2vw,13px)", color:"#64748b", lineHeight:1.65 }}>{f.body}</p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           TEMPLATES
// //       ════════════════════════════════════ */}
// //       <section id="templates" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
// //         <div style={{ maxWidth:1100, margin:"0 auto" }}>
// //           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
// //             <span className="lp-tag" style={{ background:"#f3e8ff", color:"#6b21a8", marginBottom:16 }}>Resume templates</span>
// //             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
// //               {allTemplates.length} templates, all ATS-compatible
// //             </h2>
// //             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:480, margin:"0 auto" }}>
// //               Clean layouts that parse correctly in modern ATS systems. Download as PDF, Word, or HTML.
// //             </p>
// //           </div>

// //           <div style={{ display:"flex", gap:"clamp(12px,2vw,20px)", overflowX:"auto", paddingBottom:16, scrollSnapType:"x mandatory", WebkitOverflowScrolling:"touch" }}>
// //             {allTemplates.map((t, i) => (
// //               <div key={t.id} onClick={() => setActiveTmpl(i)}
// //                 style={{
// //                   flex:"0 0 min(260px,80vw)", scrollSnapAlign:"start", cursor:"pointer",
// //                   borderRadius:16, overflow:"hidden", transition:"all 0.2s",
// //                   border: activeTmpl===i ? `2px solid ${t.accent||"#2563eb"}` : "1.5px solid #e5e7eb",
// //                   background:"#fff", boxShadow: activeTmpl===i ? `0 12px 36px ${t.accent||"#2563eb"}20` : "0 2px 8px rgba(0,0,0,0.04)",
// //                 }}>
// //                 <div style={{ padding:"12px 14px", borderBottom:"1px solid #f3f4f6", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
// //                   <div>
// //                     <div style={{ fontWeight:700, fontSize:13, color:"#0f172a" }}>{t.name}</div>
// //                     <div style={{ fontSize:10, color:"#94a3b8", marginTop:2 }}>{t.tags?.slice(0,2).join(" · ")}</div>
// //                   </div>
// //                   {activeTmpl===i && (
// //                     <div style={{ width:20, height:20, borderRadius:"50%", background:t.accent||"#2563eb", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
// //                       <Icon.Check size={10} color="#fff" />
// //                     </div>
// //                   )}
// //                 </div>
// //                 <div style={{ padding:"16px", background:"#fafafa", display:"flex", alignItems:"center", justifyContent:"center", minHeight:220 }}>
// //                   <TemplateMini t={t} scale={0.22} width={500} />
// //                 </div>
// //               </div>
// //             ))}
// //           </div>

// //           {/* Dots */}
// //           <div style={{ display:"flex", justifyContent:"center", gap:8, marginTop:20, marginBottom:32 }}>
// //             {allTemplates.map((t,i) => (
// //               <button key={i} onClick={() => setActiveTmpl(i)}
// //                 style={{ width:i===activeTmpl?28:8, height:8, borderRadius:i===activeTmpl?12:4, background:i===activeTmpl?(allTemplates[activeTmpl]?.accent||"#2563eb"):"#d1d5db", border:"none", cursor:"pointer", transition:"all 0.2s" }} />
// //             ))}
// //           </div>

// //           <div style={{ textAlign:"center" }}>
// //             <p style={{ fontSize:13, color:"#94a3b8", marginBottom:20 }}>All templates included with every purchase — no upsells.</p>
// //             <button className="lp-btn-blue" style={{ padding:"12px 28px", fontSize:14 }} onClick={() => startPayment()}>
// //               Get started — {priceDisplay}
// //             </button>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           PRICING
// //       ════════════════════════════════════ */}
// //       <section id="pricing" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#fff" }}>
// //         <div style={{ maxWidth:640, margin:"0 auto" }}>
// //           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
// //             <span className="lp-tag" style={{ background:"#eff6ff", color:"#1d4ed8", marginBottom:16 }}>Pricing</span>
// //             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
// //               One price, no surprises
// //             </h2>
// //             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b" }}>
// //               Pay once. Use it. No recurring charges, no hidden fees.
// //             </p>
// //           </div>

// //           {enabledPlans.filter(p => p.active).map(plan => (
// //             <div key={plan.id} style={{
// //               background:"#0f172a", borderRadius:24, padding:"clamp(32px,5vw,48px) clamp(28px,4vw,40px)",
// //               boxShadow:"0 24px 64px rgba(0,0,0,0.15)", position:"relative", overflow:"hidden",
// //             }}>
// //               <div style={{ position:"absolute", top:-40, right:-40, width:200, height:200, borderRadius:"50%", background:"radial-gradient(circle,rgba(37,99,235,0.15),transparent)", pointerEvents:"none" }} />

// //               <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:16, marginBottom:28, position:"relative", zIndex:2 }}>
// //                 <div>
// //                   <div style={{ fontSize:20, fontWeight:800, color:"#fff", marginBottom:4 }}>{plan.name}</div>
// //                   <div style={{ fontSize:13, color:"#94a3b8" }}>Everything you need for a successful job application</div>
// //                 </div>
// //                 <div style={{ textAlign:"right" }}>
// //                   <div style={{ fontSize:"clamp(40px,6vw,52px)", fontWeight:800, color:"#fff", lineHeight:1 }}>{priceDisplay}</div>
// //                   <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>one-time payment</div>
// //                 </div>
// //               </div>

// //               <div className="lp-pricing-feats" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:10, marginBottom:32, position:"relative", zIndex:2 }}>
// //                 {plan.features.filter(f => f.included).map(f => (
// //                   <div key={f.text} style={{ display:"flex", alignItems:"center", gap:10 }}>
// //                     <div style={{ width:20, height:20, borderRadius:"50%", background:"rgba(37,99,235,0.25)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
// //                       <Icon.Check size={10} color="#60a5fa" />
// //                     </div>
// //                     <span style={{ fontSize:"clamp(12px,2.5vw,13px)", color:"#e2e8f0" }}>{f.text}</span>
// //                   </div>
// //                 ))}
// //               </div>

// //               <button onClick={() => startPayment(plan.id)} className="lp-btn-blue"
// //                 style={{ width:"100%", padding:"15px", fontSize:"clamp(14px,3vw,16px)", borderRadius:12, fontWeight:700, position:"relative", zIndex:2 }}>
// //                 Get started — {priceDisplay}
// //               </button>

// //               {!user && (
// //                 <p style={{ fontSize:12, color:"#64748b", textAlign:"center", marginTop:16, position:"relative", zIndex:2 }}>
// //                   Already have an account?{" "}
// //                   <Link to="/login" style={{ color:"#60a5fa", textDecoration:"none", fontWeight:600 }}>Sign in</Link>
// //                 </p>
// //               )}
// //             </div>
// //           ))}

// //           {/* Honest notes */}
// //           <div style={{ marginTop:28, display:"flex", flexDirection:"column", gap:10 }}>
// //             {[
// //               { icon: <Icon.Lock />,  text: "Secure payment via Stripe — we never see your card details." },
// //               { icon: <Icon.Zap />,   text: "New product — we're actively improving based on your feedback." },
// //               { icon: <Icon.Mail />,  text: "Any issues? Email support and we'll respond personally." },
// //             ].map((note, i) => (
// //               <div key={i} style={{ display:"flex", alignItems:"center", gap:10, fontSize:13, color:"#6b7280", lineHeight:1.5 }}>
// //                 <div style={{ color:"#94a3b8", flexShrink:0 }}>{note.icon}</div>
// //                 <span>{note.text}</span>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           FAQ
// //       ════════════════════════════════════ */}
// //       <section id="faq" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
// //         <div style={{ maxWidth:720, margin:"0 auto" }}>
// //           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
// //             <span className="lp-tag" style={{ background:"#fef3c7", color:"#92400e", marginBottom:16 }}>FAQ</span>
// //             <h2 style={{ fontSize:"clamp(28px,5vw,38px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em" }}>
// //               Common questions
// //             </h2>
// //           </div>

// //           <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
// //             {/* Use servicesConfig FAQ if available, otherwise fallback */}
// //             {(servicesConfig.faq?.length > 0 ? servicesConfig.faq : [
// //               { q:"How does the ATS score work?",          a:`We extract hard skills (tools, technologies, certifications) from the job description and check where each one appears in your resume. A keyword in a bullet point with a result scores more than one buried in a skills list. Your final score is based on this position-weighted matching, plus bonuses for having metrics in every role and penalties for keyword stuffing.` },
// //               { q:"Is this an actual ATS or a simulation?", a:"It's a simulation — we replicate the keyword matching logic that most ATS software uses, but we're not the actual system your employer's using. Different employers use different ATS platforms and each one is slightly different. Our score gives you a strong indication of how your resume will perform, but it can't be 100% identical to any specific employer's system." },
// //               { q:"What does the AI-improved resume do?",   a:"We take your real resume, identify keywords that are only in your skills section and promote them into relevant experience bullets (where they score higher), add estimated metrics to weak bullets, and run the scorer on the output to verify the score improved before delivering it. We never invent skills you don't have." },
// //               { q:"What is the resume from scratch?",      a:"It generates a realistic sample resume based on your field, experience level, and the job description. It will have fictional company names and dates — you'll need to replace those with your real information before sending it to employers. Think of it as a well-structured starting point, not a finished product." },
// //               { q:"What do I get for the one-time payment?", a:`You get ${analysisCount} full ATS analyses, one AI-improved resume, one resume from scratch, one AI cover letter, and access to all ${allTemplates.length} resume templates with PDF, Word, and HTML download. No subscription, no expiry on what you've generated.` },
// //               { q:"I have a problem — how do I get support?", a:"Email us from the Support page. Since we're a new product, we read every message and respond personally. If something isn't working right, tell us and we'll fix it." },
// //             ]).map((item, i) => (
// //               <div key={i} style={{ background:"#fff", border:"1px solid #e5e7eb", borderRadius:14, overflow:"hidden" }}>
// //                 <button onClick={() => setOpenFaq(openFaq===i ? null : i)}
// //                   style={{ width:"100%", textAlign:"left", padding:"clamp(14px,3vw,18px) clamp(18px,3vw,22px)", background:"#fff", border:"none", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", gap:16 }}>
// //                   <span style={{ fontSize:"clamp(13px,2.5vw,15px)", fontWeight:600, color:"#0f172a", flex:1, lineHeight:1.4 }}>{item.q}</span>
// //                   <span style={{ fontSize:18, color:"#94a3b8", flexShrink:0, fontWeight:300 }}>{openFaq===i ? "−" : "+"}</span>
// //                 </button>
// //                 {openFaq===i && (
// //                   <div style={{ padding:"0 clamp(18px,3vw,22px) clamp(16px,3vw,20px)", fontSize:"clamp(13px,2vw,14px)", color:"#4b5563", lineHeight:1.7, borderTop:"1px solid #f3f4f6", background:"#fafafa" }}>
// //                     {item.a}
// //                   </div>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           FINAL CTA
// //       ════════════════════════════════════ */}
// //       <section style={{ padding:"clamp(56px,8vw,80px) 5%", background:"#0f172a", textAlign:"center", position:"relative", overflow:"hidden" }}>
// //         <div style={{ position:"absolute", top:-60, left:"50%", transform:"translateX(-50%)", width:400, height:400, borderRadius:"50%", background:"radial-gradient(circle,rgba(37,99,235,0.12),transparent)", pointerEvents:"none" }} />
// //         <div style={{ maxWidth:600, margin:"0 auto", position:"relative", zIndex:2 }}>
// //           <h2 style={{ fontSize:"clamp(28px,5vw,44px)", fontWeight:800, color:"#fff", letterSpacing:"-0.02em", marginBottom:16, lineHeight:1.2 }}>
// //             Stop guessing why you're not getting callbacks
// //           </h2>
// //           <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#94a3b8", marginBottom:32, lineHeight:1.65 }}>
// //             Find out exactly what your resume is missing for any job description — in under a minute.
// //           </p>
// //           <button className="lp-btn-blue lp-cta-btn" style={{ padding:"14px 36px", fontSize:"clamp(14px,3vw,16px)", fontWeight:700, borderRadius:12 }} onClick={() => startPayment()}>
// //             Analyse my resume — {priceDisplay}
// //           </button>
// //           <p style={{ fontSize:12, color:"#475569", marginTop:18 }}>
// //             One-time payment · No subscription · Results in seconds
// //           </p>
// //         </div>
// //       </section>

// //       {/* ════════════════════════════════════
// //           FOOTER
// //       ════════════════════════════════════ */}
// //       <footer style={{ background:"#070d1a", padding:"clamp(40px,6vw,56px) 5% clamp(24px,4vw,32px)" }}>
// //         <div style={{ maxWidth:1100, margin:"0 auto" }}>
// //           <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:"clamp(28px,4vw,40px)", marginBottom:"clamp(28px,4vw,40px)" }}>
// //             <div>
// //               <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14 }}>
// //                 <div style={{ width:32, height:32, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center" }}>
// //                   <span style={{ color:"#fff", fontWeight:800, fontSize:15 }}>R</span>
// //                 </div>
// //                 <span style={{ fontWeight:700, fontSize:16, color:"#fff" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
// //               </div>
// //               <p style={{ fontSize:12, color:"#64748b", lineHeight:1.6, maxWidth:220 }}>
// //                 ATS analysis and resume optimisation tools for job seekers. New product — actively improving.
// //               </p>
// //             </div>

// //             <div>
// //               <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>PRODUCT</h4>
// //               {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"]].map(([l,h]) => (
// //                 <a key={l} href={h} style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10, transition:"color 0.2s" }}
// //                    onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</a>
// //               ))}
// //             </div>

// //             <div>
// //               <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>SUPPORT</h4>
// //               <Link to="/support" style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>Contact us</Link>
// //               <a href="#faq"      style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>FAQ</a>
// //             </div>

// //             <div>
// //               <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>LEGAL</h4>
// //               {[["Privacy Policy","/privacy"],["Terms of Service","/terms"],["Refund Policy","/refund"]].map(([l,h]) => (
// //                 <Link key={l} to={h} style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }}
// //                       onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</Link>
// //               ))}
// //             </div>
// //           </div>

// //           <div className="lp-footer-bottom" style={{ borderTop:"1px solid #1e293b", paddingTop:"clamp(20px,3vw,28px)", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
// //             <span style={{ fontSize:12, color:"#475569" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// //             <span style={{ fontSize:12, color:"#334155" }}>Built with care for job seekers</span>
// //           </div>
// //         </div>
// //       </footer>

// //       <ChatWidget />
// //       {showModal && (
// //         <PaymentModal
// //           onSuccess={() => { setShowModal(false); navigate("/dashboard"); }}
// //           onClose={() => setShowModal(false)}
// //           userEmail={userData?.email || user?.email}
// //           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
// //           planId={planId}
// //           userId={user?.uid}
// //         />
// //       )}
// //     </div>
// //   );
// // }

// // eslint-disable-next-line no-unused-vars
// import { useState, useEffect, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
// import servicesConfig from "../utils/servicesConfig";
// import PaymentModal from "../components/PaymentModal";
// import ChatWidget from "../components/ChatWidget";
// import TemplateMini from "../components/TemplateMini";

// // ── SVG Icon set — clean, consistent, no emojis ──
// const Icon = {
//   // Includes banner
//   BarChart: () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
//     </svg>
//   ),
//   Sparkle: () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
//     </svg>
//   ),
//   Gift: () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/>
//       <line x1="12" y1="22" x2="12" y2="7"/>
//       <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
//       <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
//     </svg>
//   ),
//   FileText: () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
//       <polyline points="14 2 14 8 20 8"/>
//       <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
//     </svg>
//   ),
//   Download: () => (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
//       <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
//     </svg>
//   ),
//   // How it works
//   CreditCard: () => (
//     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
//       <line x1="1" y1="10" x2="23" y2="10"/>
//     </svg>
//   ),
//   Upload: () => (
//     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
//       <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
//     </svg>
//   ),
//   Zap: () => (
//     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
//     </svg>
//   ),
//   // Features
//   TrendingUp: () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
//       <polyline points="17 6 23 6 23 12"/>
//     </svg>
//   ),
//   Search: () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
//     </svg>
//   ),
//   Edit: () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
//       <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
//     </svg>
//   ),
//   RefreshCw: () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="23 4 23 10 17 10"/>
//       <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/>
//     </svg>
//   ),
//   Layout: () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
//       <line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
//     </svg>
//   ),
//   Mail: () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//       <polyline points="22 6 12 13 2 6"/>
//     </svg>
//   ),
//   // Misc
//   Lock: () => (
//     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//       <path d="M7 11V7a5 5 0 0110 0v4"/>
//     </svg>
//   ),
//   Clock: () => (
//     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
//     </svg>
//   ),
//   Check: ({ size = 10, color = "#fff" }) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="20 6 9 17 4 12"/>
//     </svg>
//   ),
// };

// const basicPlan     = servicesConfig.plans.find(p => p.id === "ats_basic");
// const analysisCount = basicPlan?.analysisCount || 3;
// const allTemplates  = servicesConfig.resumeTemplates.filter(t => t.active);
// const enabledPlans  = servicesConfig.plans.filter(p => p.enabled);

// export default function LandingPage() {
//   const navigate = useNavigate();
//   const { user, userData } = useAuth();

//   const [showModal,    setShowModal]    = useState(false);
//   const [planId,       setPlanId]       = useState("ats_basic");
//   const [menuOpen,     setMenuOpen]     = useState(false);
//   const [scrolled,     setScrolled]     = useState(false);
//   const [openFaq,      setOpenFaq]      = useState(null);
//   const [activeTmpl,   setActiveTmpl]   = useState(0);
//   const [priceDisplay, setPriceDisplay] = useState(basicPlan?.price || "$4.99");
//   const [serverPlans,  setServerPlans]  = useState({});
//   const [localPrice,   setLocalPrice]   = useState(null);

//   // Fetch live price from server
//   useEffect(() => {
//     const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";
//     fetch(`${BACKEND}/config`)
//       .then(r => r.json())
//       .then(d => { 
//         if (d.plans?.ats_basic?.priceDisplay) setPriceDisplay(d.plans.ats_basic.priceDisplay);
//         if (d.plans) setServerPlans(d.plans);
//       })
//       .catch(() => {});
//   }, []);

//   // ── Browser locale currency conversion — no API, no rate limit ──
//   useEffect(() => {
//     const usdAmount = (serverPlans?.ats_basic?.priceInCents || 499) / 100;

//     const langs    = navigator.languages?.length ? navigator.languages : [navigator.language || "en-US"];
//     const locale   = langs[0] || "en-US";
//     const parts    = locale.split("-");
//     const region   = parts[parts.length - 1]?.toUpperCase();

//     const USD_REGIONS = ["US","AS","EC","PR","SV","GU","MH","FM","MP","PW","TC","VI","ZW","BZ","PA"];
//     if (!region || USD_REGIONS.includes(region)) { setLocalPrice(null); return; }

//     const REGION_CURRENCY = {
//       IN:"INR", GB:"GBP", AU:"AUD", CA:"CAD",
//       DE:"EUR", FR:"EUR", IT:"EUR", ES:"EUR", NL:"EUR", BE:"EUR", PT:"EUR", AT:"EUR",
//       JP:"JPY", SG:"SGD", AE:"AED", ZA:"ZAR", BR:"BRL", MX:"MXN", NZ:"NZD",
//     };
//     const currency = REGION_CURRENCY[region];
//     if (!currency) { setLocalPrice(null); return; }

//     const CACHE_KEY = "fx_usd_rates_v1";
//     const CACHE_TTL = 60 * 60 * 1000; // 1 hour
//     const FALLBACK  = { INR:84, GBP:0.79, AUD:1.53, CAD:1.36, EUR:0.92, JPY:150, SGD:1.34, AED:3.67, ZAR:18.5, BRL:5.0, MXN:17.5, NZD:1.65 };

//     async function fetchAndDisplay() {
//       let rate = null;
//       try {
//         const cached = sessionStorage.getItem(CACHE_KEY);
//         if (cached) {
//           const { rates, ts } = JSON.parse(cached);
//           if (Date.now() - ts < CACHE_TTL && rates[currency]) {
//             rate = rates[currency];
//           }
//         }
//         if (!rate) {
//           const res  = await fetch("https://api.exchangerate-api.com/v4/latest/USD", { signal: AbortSignal.timeout(5000) });
//           const data = await res.json();
//           sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rates: data.rates, ts: Date.now() }));
//           rate = data.rates[currency];
//         }
//       } catch (_) {
//         rate = FALLBACK[currency] || null;
//       }
//       if (!rate) { setLocalPrice(null); return; }
//       const formatted = new Intl.NumberFormat(locale, {
//         style: "currency", currency, maximumFractionDigits: 0,
//       }).format(Math.round(usdAmount * rate));
//       setLocalPrice(formatted);
//     }

//     fetchAndDisplay();
//   }, [serverPlans]);

//   // Scroll listener for nav
//   useEffect(() => {
//     const fn = () => setScrolled(window.scrollY > 20);
//     window.addEventListener("scroll", fn);
//     return () => window.removeEventListener("scroll", fn);
//   }, []);

//   // Template carousel
//   useEffect(() => {
//     const t = setInterval(() => setActiveTmpl(p => (p + 1) % allTemplates.length), 4500);
//     return () => clearInterval(t);
//   }, []);

//   function startPayment(pid = "ats_basic") {
//     setMenuOpen(false);
//     if (user) { setPlanId(pid); setShowModal(true); }
//     else navigate("/signup");
//   }

//   function ScoreRing({ target = 70, duration = 2000 }) {
//   const [score, setScore] = useState(0);
//   const CIRCUMFERENCE = 2 * Math.PI * 50;

//   const color = score < 45 ? "#e24b4a" : score < 65 ? "#ef9f27" : score < 80 ? "#2563eb" : "#1d9e75";
//   const offset = CIRCUMFERENCE - (score / 100) * CIRCUMFERENCE;

//   useEffect(() => {
//     let start = null;
//     const step = (ts) => {
//       if (!start) start = ts;
//       const t = Math.min((ts - start) / duration, 1);
//       const ease = t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
//       setScore(Math.round(target * ease));
//       if (t < 1) requestAnimationFrame(step);
//     };
//     const raf = requestAnimationFrame(step);
//     return () => cancelAnimationFrame(raf);
//   }, [target, duration]);

//   return (
//     <div style={{ position:"relative", width:120, height:120, margin:"0 auto 16px" }}>
//       <svg width="120" height="120" viewBox="0 0 120 120" style={{ transform:"rotate(-90deg)" }}>
//         <circle cx="60" cy="60" r="50" fill="none" stroke="#f1f5f9" strokeWidth="10" />
//         <circle cx="60" cy="60" r="50" fill="none" stroke={color} strokeWidth="10"
//           strokeLinecap="round"
//           strokeDasharray={CIRCUMFERENCE}
//           strokeDashoffset={offset}
//           style={{ transition:"stroke 0.3s" }} />
//       </svg>
//       <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
//         <span style={{ fontSize:32, fontWeight:800, color, lineHeight:1 }}>{score}</span>
//         <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>/100</span>
//       </div>
//     </div>
//   );
// }

//   // Helper to format price with local currency if available
//   const getDisplayPrice = () => {
//     if (localPrice) {
//       return `${priceDisplay} (≈${localPrice})`;
//     }
//     return priceDisplay;
//   };

//   return (
//     <div style={{ minHeight:"100vh", fontFamily:"'Inter',-apple-system,BlinkMacSystemFont,sans-serif", background:"#fff", color:"#111827" }}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
//         *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }

//         .lp-btn-dark {
//           background:#111827; color:#fff; border:none; border-radius:10px;
//           font-weight:600; cursor:pointer; transition:all 0.2s ease;
//         }
//         .lp-btn-dark:hover { background:#1f2937; transform:translateY(-1px); box-shadow:0 6px 20px rgba(0,0,0,0.15); }
//         .lp-btn-outline {
//           background:transparent; color:#374151; border:1.5px solid #d1d5db; border-radius:10px;
//           font-weight:500; cursor:pointer; transition:all 0.2s ease;
//         }
//         .lp-btn-outline:hover { border-color:#374151; background:#f9fafb; }
//         .lp-btn-blue {
//           background:linear-gradient(135deg,#2563eb,#1d4ed8); color:#fff; border:none; border-radius:10px;
//           font-weight:700; cursor:pointer; transition:all 0.2s ease;
//         }
//         .lp-btn-blue:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(37,99,235,0.3); }

//         .lp-card {
//           background:#fff; border:1px solid #e5e7eb; border-radius:16px;
//           transition:box-shadow 0.2s, transform 0.2s;
//         }
//         .lp-card:hover { box-shadow:0 12px 32px rgba(0,0,0,0.08); transform:translateY(-3px); }

//         .lp-tag {
//           display:inline-block; font-size:12px; font-weight:600;
//           padding:4px 14px; border-radius:20px;
//         }
//         .lp-divider { width:1px; height:20px; background:#e5e7eb; }

//         @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
//         .fade-up { animation:fadeUp 0.55s ease forwards; }

//         /* Mobile */
//         @media(max-width:768px) {
//           .lp-desktop       { display:none !important; }
//           .lp-mobile-show   { display:flex !important; }
//           .lp-grid-3        { grid-template-columns:1fr !important; }
//           /* Hero: stack columns on tablet/mobile */
//           .lp-hero-grid     { grid-template-columns:1fr !important; }
//           /* Hide score card mock on mobile — focus on copy */
//           .lp-hero-mock     { display:none !important; }
//           /* Includes banner: 2 cols on tablet */
//           .lp-includes-row  { gap:clamp(12px,4vw,24px) !important; justify-content:flex-start !important; }
//           .lp-includes-item { min-width:calc(50% - 12px); }
//           /* Pricing features: single col */
//           .lp-pricing-feats { grid-template-columns:1fr !important; }
//         }
//         @media(max-width:480px) {
//           .lp-hero-btns     { flex-direction:column !important; }
//           .lp-hero-btns button { width:100% !important; }
//           .lp-includes-row  { flex-direction:column !important; align-items:flex-start !important; }
//           .lp-includes-divs { display:none !important; }
//           /* FAQ full padding */
//           .lp-faq-item      { padding:14px 16px !important; }
//           /* Footer bottom bar stack */
//           .lp-footer-bottom { flex-direction:column !important; text-align:center !important; gap:6px !important; }
//           /* CTA button full width */
//           .lp-cta-btn       { width:100% !important; }
//         }
//       `}</style>

//       {/* ── NAV ── */}
//       <nav style={{
//         position:"sticky", top:0, zIndex:1000,
//         background: scrolled ? "rgba(255,255,255,0.97)" : "transparent",
//         backdropFilter:"blur(16px)",
//         borderBottom: scrolled ? "1px solid #f3f4f6" : "1px solid transparent",
//         padding:"0 5%", height:64,
//         display:"flex", alignItems:"center", justifyContent:"space-between",
//         transition:"all 0.3s ease",
//       }}>
//         <div onClick={() => navigate("/")} style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}>
//           <div style={{ width:34, height:34, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center" }}>
//             <span style={{ color:"#fff", fontWeight:800, fontSize:17 }}>R</span>
//           </div>
//           <span style={{ fontWeight:700, fontSize:18, letterSpacing:"-0.3px" }}>
//             ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
//           </span>
//         </div>

//         <div className="lp-desktop" style={{ display:"flex", gap:32, alignItems:"center" }}>
//           {[["How it works","#how"],["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h]) => (
//             <a key={l} href={h} style={{ fontSize:14, fontWeight:500, color:"#6b7280", textDecoration:"none", transition:"color 0.2s" }}
//                onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#6b7280"}>{l}</a>
//           ))}
//           <Link to="/support" style={{ fontSize:14, fontWeight:500, color:"#6b7280", textDecoration:"none" }}>Support</Link>
//         </div>

//         <div className="lp-desktop" style={{ display:"flex", gap:10 }}>
//           {user ? (
//             <>
//               <button className="lp-btn-outline" style={{ padding:"8px 18px", fontSize:13 }} onClick={() => navigate("/dashboard")}>Dashboard</button>
//               <button className="lp-btn-blue"    style={{ padding:"8px 20px", fontSize:13 }} onClick={() => startPayment()}>Get Access</button>
//             </>
//           ) : (
//             <>
//               <button className="lp-btn-outline" style={{ padding:"8px 18px", fontSize:13 }} onClick={() => navigate("/login")}>Sign in</button>
//               <button className="lp-btn-blue"    style={{ padding:"8px 20px", fontSize:13 }} onClick={() => navigate("/signup")}>Get started</button>
//             </>
//           )}
//         </div>

//         {/* Hamburger */}
//         <button onClick={() => setMenuOpen(!menuOpen)} className="lp-mobile-show"
//           style={{ display:"none", background:"none", border:"1px solid #e5e7eb", borderRadius:8, padding:"7px 9px", cursor:"pointer", flexDirection:"column", gap:4 }}>
//           {[0,1,2].map(i => <span key={i} style={{ display:"block", width:18, height:2, background:"#374151", borderRadius:1 }} />)}
//         </button>
//       </nav>

//       {menuOpen && (
//         <div style={{ background:"#fff", borderBottom:"1px solid #e5e7eb", padding:"16px 5%", zIndex:999, boxShadow:"0 8px 24px rgba(0,0,0,0.06)" }}>
//           {["How it works","Features","Templates","Pricing","FAQ"].map(l => (
//             <a key={l} href={`#${l.toLowerCase().replace(" ","")}`} onClick={() => setMenuOpen(false)}
//                style={{ display:"block", padding:"10px 0", fontSize:15, color:"#374151", textDecoration:"none", borderBottom:"1px solid #f5f5f5", fontWeight:500 }}>{l}</a>
//           ))}
//           <Link to="/support" onClick={() => setMenuOpen(false)}
//             style={{ display:"block", padding:"10px 0", fontSize:15, color:"#374151", textDecoration:"none", borderBottom:"1px solid #f5f5f5", fontWeight:500 }}>Support</Link>
//           <div style={{ display:"flex", gap:10, marginTop:14 }}>
//             <button className="lp-btn-outline" style={{ flex:1, padding:"11px", fontSize:14 }} onClick={() => { setMenuOpen(false); navigate("/login"); }}>Sign in</button>
//             <button className="lp-btn-blue"    style={{ flex:1, padding:"11px", fontSize:14 }} onClick={() => startPayment()}>Get started</button>
//           </div>
//         </div>
//       )}

//       {/* ════════════════════════════════════
//           HERO
//       ════════════════════════════════════ */}
//       <section style={{ padding:"clamp(56px,10vw,96px) 5% clamp(48px,8vw,80px)", background:"#f9fafb", borderBottom:"1px solid #e5e7eb" }}>
//         <div className="lp-hero-grid" style={{ maxWidth:1100, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"clamp(40px,6vw,64px)", alignItems:"center" }}>

//           {/* Left */}
//           <div className="fade-up">
//             {/* Launch badge — honest */}
//             <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:20, padding:"5px 14px 5px 10px", marginBottom:24 }}>
//               <span style={{ width:7, height:7, borderRadius:"50%", background:"#3b82f6", display:"inline-block" }} />
//               <span style={{ fontSize:12, fontWeight:600, color:"#1d4ed8" }}>Founding price · Won't last forever</span>
//             </div>

//             <h1 style={{ fontSize:"clamp(34px,5vw,54px)", fontWeight:800, lineHeight:1.1, letterSpacing:"-0.03em", color:"#0f172a", marginBottom:20 }}>
//               Know exactly why your resume{" "}
//               <span style={{ color:"#2563eb" }}>isn't getting interviews</span>
//             </h1>

//             <p style={{ fontSize:"clamp(15px,2.5vw,18px)", color:"#4b5563", lineHeight:1.7, marginBottom:32, maxWidth:520 }}>
//               Paste your resume and a job description. We analyse keyword gaps, score your ATS match, and show you exactly what to fix — with specific rewrite suggestions.
//             </p>

//             <div className="lp-hero-btns" style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:28 }}>
//               <button className="lp-btn-blue" style={{ padding:"13px 28px", fontSize:15 }} onClick={() => startPayment()}>
//                 Analyse my resume — {getDisplayPrice()}
//               </button>
//               <button className="lp-btn-outline" style={{ padding:"13px 22px", fontSize:15 }} onClick={() => document.getElementById("how")?.scrollIntoView({ behavior:"smooth" })}>
//                 See how it works
//               </button>
//             </div>

//             {/* Honest social proof */}
//             <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap", justifyContent:"flex-start" }}>
//               <div style={{ display:"flex", alignItems:"center", gap:6 }}>
//                 <div style={{ color:"#94a3b8" }}><Icon.Lock /></div>
//                 <span style={{ fontSize:12, color:"#6b7280", fontWeight:500 }}>One-time payment, no subscription</span>
//               </div>
//               <div className="lp-divider" />
//               <div style={{ display:"flex", alignItems:"center", gap:6 }}>
//                 <div style={{ color:"#94a3b8" }}><Icon.Clock /></div>
//                 <span style={{ fontSize:12, color:"#6b7280", fontWeight:500 }}>Results in under 30 seconds</span>
//               </div>
//             </div>
//           </div>

//           {/* Right — score card mock */}
//           <div className="lp-hero-mock" style={{ display:"flex", justifyContent:"center" }}>
//             <div style={{ width:"100%", maxWidth:380, background:"#fff", borderRadius:20, border:"1px solid #e5e7eb", overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.08)" }}>

//               {/* Header bar */}
//               <div style={{ padding:"16px 20px", borderBottom:"1px solid #f3f4f6", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
//                 <div style={{ display:"flex", alignItems:"center", gap:8 }}>
//                   <div style={{ width:28, height:28, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:7, display:"flex", alignItems:"center", justifyContent:"center" }}>
//                     <span style={{ color:"#fff", fontSize:12, fontWeight:800 }}>R</span>
//                   </div>
//                   <span style={{ fontWeight:700, fontSize:13, color:"#1e293b" }}>ATS Analysis</span>
//                 </div>
//                 <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>Just now</span>
//               </div>

//               {/* Score ring area */}
//               {/* Animated ATS score ring */}
//               <ScoreRing target={90} duration={2000} />

//               {/* Keyword pills */}
//               <div style={{ padding:"0 20px 16px" }}>
//                 <div style={{ fontSize:11, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>Missing keywords</div>
//                 <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
//                   {["Kubernetes","CI/CD","Terraform","GraphQL","TypeScript"].map(k => (
//                     <span key={k} style={{ fontSize:11, padding:"4px 8px", borderRadius:20, background:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca", fontWeight:500, whiteSpace:"nowrap" }}>{k}</span>
//                   ))}
//                 </div>
//               </div>

//               {/* Recommendation */}
//               <div style={{ margin:"0 20px 20px", background:"#f0fdf4", borderRadius:12, padding:"12px 14px", border:"1px solid #bbf7d0" }}>
//                 <div style={{ fontSize:11, fontWeight:700, color:"#059669", marginBottom:4 }}>Top recommendation</div>
//                 <div style={{ fontSize:12, color:"#166534", lineHeight:1.5 }}>
//                   Add "Kubernetes" to 2 experience bullets — moves it from Skills section to full credit.
//                 </div>
//               </div>
//             </div>
//           </div>

//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           WHAT'S INCLUDED BANNER
//       ════════════════════════════════════ */}
//       <section style={{ background:"#fff", padding:"20px 5%", borderBottom:"1px solid #e5e7eb" }}>
//         <div className="lp-includes-row" style={{ maxWidth:1100, margin:"0 auto", display:"flex", alignItems:"center", justifyContent:"center", gap:"clamp(20px,5vw,56px)", flexWrap:"wrap" }}>
//           {[
//             { Icon: Icon.BarChart, label:`${analysisCount} ATS analyses`, sub:"per purchase", color:"#2563eb" },
//             { Icon: Icon.RefreshCw, label:"AI-improved resume", sub:"based on your real one", color:"#7c3aed" },
//             { Icon: Icon.Layout, label:"Resume from scratch", sub:"free with plan", color:"#059669" },
//             { Icon: Icon.Mail, label:"Cover letter", sub:"free with plan", color:"#0891b2" },
//             { Icon: Icon.Download, label:"PDF + Word download", sub:"all templates", color:"#dc2626" },
//           ].map(item => (
//             <div key={item.label} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 0" }}>
//               <div style={{ width:32, height:32, background:`${item.color}15`, borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", color:item.color, flexShrink:0 }}>
//                 <item.Icon />
//               </div>
//               <div>
//                 <div style={{ fontSize:13, fontWeight:700, color:"#0f172a" }}>{item.label}</div>
//                 <div style={{ fontSize:11, color:"#94a3b8" }}>{item.sub}</div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           HOW IT WORKS
//       ════════════════════════════════════ */}
//       <section id="how" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
//         <div style={{ maxWidth:1000, margin:"0 auto" }}>
//           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
//             <span className="lp-tag" style={{ background:"#fef3c7", color:"#92400e", marginBottom:16 }}>Simple process</span>
//             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", lineHeight:1.2, marginBottom:14 }}>
//               From upload to results in under a minute
//             </h2>
//             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:480, margin:"0 auto" }}>
//               No account tour, no setup. Just paste and go.
//             </p>
//           </div>

//           <div className="lp-grid-3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"clamp(24px,4vw,36px)" }}>
//             {[
//               { n:"1", Icon: Icon.CreditCard, title:"Pay once", body:`${getDisplayPrice()} one-time. No subscription. Includes ${analysisCount} full analyses, an improved resume, cover letter, and resume builder.` },
//               { n:"2", Icon: Icon.Upload, title:"Upload resume + job description", body:"Paste or upload your resume. Paste the job description. That's all the input we need." },
//               { n:"3", Icon: Icon.Zap, title:"Get your score and fixes", body:"See your ATS score, which keywords are missing, exactly where they should go, and a rewritten resume ready to download." },
//             ].map(s => (
//               <div key={s.n} className="lp-card" style={{ padding:"clamp(24px,4vw,32px)" }}>
//                 <div style={{ width:44, height:44, background:"#eff6ff", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", color:"#2563eb", marginBottom:20 }}>
//                   <s.Icon />
//                 </div>
//                 <div style={{ fontSize:11, fontWeight:700, color:"#2563eb", marginBottom:8, letterSpacing:"0.06em", textTransform:"uppercase" }}>Step {s.n}</div>
//                 <div style={{ fontSize:"clamp(15px,2.5vw,18px)", fontWeight:700, color:"#0f172a", marginBottom:10, lineHeight:1.3 }}>{s.title}</div>
//                 <p style={{ fontSize:"clamp(13px,2vw,14px)", color:"#64748b", lineHeight:1.65 }}>{s.body}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           FEATURES
//       ════════════════════════════════════ */}
//       <section id="features" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#fff" }}>
//         <div style={{ maxWidth:1100, margin:"0 auto" }}>
//           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
//             <span className="lp-tag" style={{ background:"#eff6ff", color:"#1d4ed8", marginBottom:16 }}>What you get</span>
//             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
//               Honest, specific feedback — not vague advice
//             </h2>
//             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:500, margin:"0 auto" }}>
//               We tell you exactly which keywords are missing, where to add them, and show you before/after rewrites.
//             </p>
//           </div>

//           <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(min(100%,300px),1fr))", gap:"clamp(16px,3vw,24px)" }}>
//             {[
//               {
//                 Icon: Icon.TrendingUp, color:"#2563eb", title:"Position-weighted ATS score",
//                 body:"We don't just count keywords. A keyword buried in your skills section scores less than one demonstrated in a bullet with a result. We show you exactly where each skill sits and how to move it up.",
//                 tag:null,
//               },
//               {
//                 Icon: Icon.Search,     color:"#7c3aed", title:"Hard skill gap analysis",
//                 body:"We extract the specific tools, technologies, and certifications from the job description and check your resume against them — with synonym matching (AWS = Amazon Web Services, etc.).",
//                 tag:null,
//               },
//               {
//                 Icon: Icon.Edit,   color:"#059669", title:"Before/after rewrite suggestions",
//                 body:"Not just \"add more keywords\" — we show you the exact weak bullet, and an improved version that adds a metric and the missing keyword naturally.",
//                 tag:null,
//               },
//               {
//                 Icon: Icon.RefreshCw, color:"#d97706", title:"AI-improved resume",
//                 body:"We take your real resume, promote skills-only keywords into experience bullets where they fit, add estimated metrics to weak bullets, and verify the score improved before delivering.",
//                 tag:null,
//               },
//               {
//                 Icon: Icon.Layout,    color:"#dc2626", title:"Resume from scratch",
//                 body:"No existing resume? We build a realistic sample based on your field, experience level, and job description. You'll need to personalise it with your real details.",
//                 tag:"Included free",
//               },
//               {
//                 Icon: Icon.Mail,      color:"#0891b2", title:"Cover letter",
//                 body:"A tailored cover letter that matches specific JD requirements to your real background. Three tone options: professional, confident, or enthusiastic.",
//                 tag:"Included free",
//               },
//             ].map(f => (
//               <div key={f.title} className="lp-card" style={{ padding:"clamp(22px,3.5vw,28px)", position:"relative", overflow:"hidden" }}>
//                 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg,#2563eb,#7c3aed)", opacity:0.6 }} />
//                 {f.tag && (
//                   <span className="lp-tag" style={{ background:"#f0fdf4", color:"#059669", border:"1px solid #bbf7d0", fontSize:11, marginBottom:12, display:"inline-block" }}>{f.tag}</span>
//                 )}
//                 <div style={{ width:48, height:48, background:`${f.color}12`, borderRadius:14, display:"flex", alignItems:"center", justifyContent:"center", color:f.color, marginBottom:16 }}>
//                   <f.Icon />
//                 </div>
//                 <div style={{ fontSize:"clamp(14px,2.5vw,16px)", fontWeight:700, color:"#0f172a", marginBottom:10, lineHeight:1.3 }}>{f.title}</div>
//                 <p style={{ fontSize:"clamp(12px,2vw,13px)", color:"#64748b", lineHeight:1.65 }}>{f.body}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           TEMPLATES
//       ════════════════════════════════════ */}
//       <section id="templates" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
//         <div style={{ maxWidth:1100, margin:"0 auto" }}>
//           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
//             <span className="lp-tag" style={{ background:"#f3e8ff", color:"#6b21a8", marginBottom:16 }}>Resume templates</span>
//             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
//               {allTemplates.length} templates, all ATS-compatible
//             </h2>
//             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:480, margin:"0 auto" }}>
//               Clean layouts that parse correctly in modern ATS systems. Download as PDF, Word, or HTML.
//             </p>
//           </div>

//           <div style={{ display:"flex", gap:"clamp(12px,2vw,20px)", overflowX:"auto", paddingBottom:16, scrollSnapType:"x mandatory", WebkitOverflowScrolling:"touch" }}>
//             {allTemplates.map((t, i) => (
//               <div key={t.id} onClick={() => setActiveTmpl(i)}
//                 style={{
//                   flex:"0 0 min(260px,80vw)", scrollSnapAlign:"start", cursor:"pointer",
//                   borderRadius:16, overflow:"hidden", transition:"all 0.2s",
//                   border: activeTmpl===i ? `2px solid ${t.accent||"#2563eb"}` : "1.5px solid #e5e7eb",
//                   background:"#fff", boxShadow: activeTmpl===i ? `0 12px 36px ${t.accent||"#2563eb"}20` : "0 2px 8px rgba(0,0,0,0.04)",
//                 }}>
//                 <div style={{ padding:"12px 14px", borderBottom:"1px solid #f3f4f6", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
//                   <div>
//                     <div style={{ fontWeight:700, fontSize:13, color:"#0f172a" }}>{t.name}</div>
//                     <div style={{ fontSize:10, color:"#94a3b8", marginTop:2 }}>{t.tags?.slice(0,2).join(" · ")}</div>
//                   </div>
//                   {activeTmpl===i && (
//                     <div style={{ width:20, height:20, borderRadius:"50%", background:t.accent||"#2563eb", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
//                       <Icon.Check size={10} color="#fff" />
//                     </div>
//                   )}
//                 </div>
//                 <div style={{ padding:"16px", background:"#fafafa", display:"flex", alignItems:"center", justifyContent:"center", minHeight:220 }}>
//                   <TemplateMini t={t} scale={0.22} width={500} />
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Dots */}
//           <div style={{ display:"flex", justifyContent:"center", gap:8, marginTop:20, marginBottom:32 }}>
//             {allTemplates.map((t,i) => (
//               <button key={i} onClick={() => setActiveTmpl(i)}
//                 style={{ width:i===activeTmpl?28:8, height:8, borderRadius:i===activeTmpl?12:4, background:i===activeTmpl?(allTemplates[activeTmpl]?.accent||"#2563eb"):"#d1d5db", border:"none", cursor:"pointer", transition:"all 0.2s" }} />
//             ))}
//           </div>

//           <div style={{ textAlign:"center" }}>
//             <p style={{ fontSize:13, color:"#94a3b8", marginBottom:20 }}>All templates included with every purchase — no upsells.</p>
//             <button className="lp-btn-blue" style={{ padding:"12px 28px", fontSize:14 }} onClick={() => startPayment()}>
//               Get started — {getDisplayPrice()}
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           PRICING
//       ════════════════════════════════════ */}
//       <section id="pricing" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#fff" }}>
//         <div style={{ maxWidth:640, margin:"0 auto" }}>
//           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
//             <span className="lp-tag" style={{ background:"#eff6ff", color:"#1d4ed8", marginBottom:16 }}>Pricing</span>
//             <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
//               One price, no surprises
//             </h2>
//             <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b" }}>
//               Pay once. Use it. No recurring charges, no hidden fees.
//             </p>
//           </div>

//           {enabledPlans.filter(p => p.active).map(plan => (
//             <div key={plan.id} style={{
//               background:"#0f172a", borderRadius:24, padding:"clamp(32px,5vw,48px) clamp(28px,4vw,40px)",
//               boxShadow:"0 24px 64px rgba(0,0,0,0.15)", position:"relative", overflow:"hidden",
//             }}>
//               <div style={{ position:"absolute", top:-40, right:-40, width:200, height:200, borderRadius:"50%", background:"radial-gradient(circle,rgba(37,99,235,0.15),transparent)", pointerEvents:"none" }} />

//               <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:16, marginBottom:28, position:"relative", zIndex:2 }}>
//                 <div>
//                   <div style={{ fontSize:20, fontWeight:800, color:"#fff", marginBottom:4 }}>{plan.name}</div>
//                   <div style={{ fontSize:13, color:"#94a3b8" }}>Everything you need for a successful job application</div>
//                 </div>
//                 <div style={{ textAlign:"right" }}>
//                   <div style={{ fontSize:"clamp(40px,6vw,52px)", fontWeight:800, color:"#fff", lineHeight:1 }}>{getDisplayPrice()}</div>
//                   <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>one-time payment</div>
//                 </div>
//               </div>

//               <div className="lp-pricing-feats" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:10, marginBottom:32, position:"relative", zIndex:2 }}>
//                 {plan.features.filter(f => f.included).map(f => (
//                   <div key={f.text} style={{ display:"flex", alignItems:"center", gap:10 }}>
//                     <div style={{ width:20, height:20, borderRadius:"50%", background:"rgba(37,99,235,0.25)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
//                       <Icon.Check size={10} color="#60a5fa" />
//                     </div>
//                     <span style={{ fontSize:"clamp(12px,2.5vw,13px)", color:"#e2e8f0" }}>{f.text}</span>
//                   </div>
//                 ))}
//               </div>

//               <button onClick={() => startPayment(plan.id)} className="lp-btn-blue"
//                 style={{ width:"100%", padding:"15px", fontSize:"clamp(14px,3vw,16px)", borderRadius:12, fontWeight:700, position:"relative", zIndex:2 }}>
//                 Get started — {getDisplayPrice()}
//               </button>

//               {!user && (
//                 <p style={{ fontSize:12, color:"#64748b", textAlign:"center", marginTop:16, position:"relative", zIndex:2 }}>
//                   Already have an account?{" "}
//                   <Link to="/login" style={{ color:"#60a5fa", textDecoration:"none", fontWeight:600 }}>Sign in</Link>
//                 </p>
//               )}
//             </div>
//           ))}

//           {/* Honest notes */}
//           <div style={{ marginTop:28, display:"flex", flexDirection:"column", gap:10 }}>
//             {[
//               { icon: <Icon.Lock />,  text: "Secure payment via Stripe — we never see your card details." },
//               { icon: <Icon.Zap />,   text: "New product — we're actively improving based on your feedback." },
//               { icon: <Icon.Mail />,  text: "Any issues? Email support and we'll respond personally." },
//             ].map((note, i) => (
//               <div key={i} style={{ display:"flex", alignItems:"center", gap:10, fontSize:13, color:"#6b7280", lineHeight:1.5 }}>
//                 <div style={{ color:"#94a3b8", flexShrink:0 }}>{note.icon}</div>
//                 <span>{note.text}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           FAQ
//       ════════════════════════════════════ */}
//       <section id="faq" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
//         <div style={{ maxWidth:720, margin:"0 auto" }}>
//           <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
//             <span className="lp-tag" style={{ background:"#fef3c7", color:"#92400e", marginBottom:16 }}>FAQ</span>
//             <h2 style={{ fontSize:"clamp(28px,5vw,38px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em" }}>
//               Common questions
//             </h2>
//           </div>

//           <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
//             {/* Use servicesConfig FAQ if available, otherwise fallback */}
//             {(servicesConfig.faq?.length > 0 ? servicesConfig.faq : [
//               { q:"How does the ATS score work?",          a:`We extract hard skills (tools, technologies, certifications) from the job description and check where each one appears in your resume. A keyword in a bullet point with a result scores more than one buried in a skills list. Your final score is based on this position-weighted matching, plus bonuses for having metrics in every role and penalties for keyword stuffing.` },
//               { q:"Is this an actual ATS or a simulation?", a:"It's a simulation — we replicate the keyword matching logic that most ATS software uses, but we're not the actual system your employer's using. Different employers use different ATS platforms and each one is slightly different. Our score gives you a strong indication of how your resume will perform, but it can't be 100% identical to any specific employer's system." },
//               { q:"What does the AI-improved resume do?",   a:"We take your real resume, identify keywords that are only in your skills section and promote them into relevant experience bullets (where they score higher), add estimated metrics to weak bullets, and run the scorer on the output to verify the score improved before delivering it. We never invent skills you don't have." },
//               { q:"What is the resume from scratch?",      a:"It generates a realistic sample resume based on your field, experience level, and the job description. It will have fictional company names and dates — you'll need to replace those with your real information before sending it to employers. Think of it as a well-structured starting point, not a finished product." },
//               { q:"What do I get for the one-time payment?", a:`You get ${analysisCount} full ATS analyses, one AI-improved resume, one resume from scratch, one AI cover letter, and access to all ${allTemplates.length} resume templates with PDF, Word, and HTML download. No subscription, no expiry on what you've generated.` },
//               { q:"I have a problem — how do I get support?", a:"Email us from the Support page. Since we're a new product, we read every message and respond personally. If something isn't working right, tell us and we'll fix it." },
//             ]).map((item, i) => (
//               <div key={i} style={{ background:"#fff", border:"1px solid #e5e7eb", borderRadius:14, overflow:"hidden" }}>
//                 <button onClick={() => setOpenFaq(openFaq===i ? null : i)}
//                   style={{ width:"100%", textAlign:"left", padding:"clamp(14px,3vw,18px) clamp(18px,3vw,22px)", background:"#fff", border:"none", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", gap:16 }}>
//                   <span style={{ fontSize:"clamp(13px,2.5vw,15px)", fontWeight:600, color:"#0f172a", flex:1, lineHeight:1.4 }}>{item.q}</span>
//                   <span style={{ fontSize:18, color:"#94a3b8", flexShrink:0, fontWeight:300 }}>{openFaq===i ? "−" : "+"}</span>
//                 </button>
//                 {openFaq===i && (
//                   <div style={{ padding:"0 clamp(18px,3vw,22px) clamp(16px,3vw,20px)", fontSize:"clamp(13px,2vw,14px)", color:"#4b5563", lineHeight:1.7, borderTop:"1px solid #f3f4f6", background:"#fafafa" }}>
//                     {item.a}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           FINAL CTA
//       ════════════════════════════════════ */}
//       <section style={{ padding:"clamp(56px,8vw,80px) 5%", background:"#0f172a", textAlign:"center", position:"relative", overflow:"hidden" }}>
//         <div style={{ position:"absolute", top:-60, left:"50%", transform:"translateX(-50%)", width:400, height:400, borderRadius:"50%", background:"radial-gradient(circle,rgba(37,99,235,0.12),transparent)", pointerEvents:"none" }} />
//         <div style={{ maxWidth:600, margin:"0 auto", position:"relative", zIndex:2 }}>
//           <h2 style={{ fontSize:"clamp(28px,5vw,44px)", fontWeight:800, color:"#fff", letterSpacing:"-0.02em", marginBottom:16, lineHeight:1.2 }}>
//             Stop guessing why you're not getting callbacks
//           </h2>
//           <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#94a3b8", marginBottom:32, lineHeight:1.65 }}>
//             Find out exactly what your resume is missing for any job description — in under a minute.
//           </p>
//           <button className="lp-btn-blue lp-cta-btn" style={{ padding:"14px 36px", fontSize:"clamp(14px,3vw,16px)", fontWeight:700, borderRadius:12 }} onClick={() => startPayment()}>
//             Analyse my resume — {getDisplayPrice()}
//           </button>
//           <p style={{ fontSize:12, color:"#475569", marginTop:18 }}>
//             One-time payment · No subscription · Results in seconds
//           </p>
//         </div>
//       </section>

//       {/* ════════════════════════════════════
//           FOOTER
//       ════════════════════════════════════ */}
//       <footer style={{ background:"#070d1a", padding:"clamp(40px,6vw,56px) 5% clamp(24px,4vw,32px)" }}>
//         <div style={{ maxWidth:1100, margin:"0 auto" }}>
//           <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:"clamp(28px,4vw,40px)", marginBottom:"clamp(28px,4vw,40px)" }}>
//             <div>
//               <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14 }}>
//                 <div style={{ width:32, height:32, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center" }}>
//                   <span style={{ color:"#fff", fontWeight:800, fontSize:15 }}>R</span>
//                 </div>
//                 <span style={{ fontWeight:700, fontSize:16, color:"#fff" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
//               </div>
//               <p style={{ fontSize:12, color:"#64748b", lineHeight:1.6, maxWidth:220 }}>
//                 ATS analysis and resume optimisation tools for job seekers. New product — actively improving.
//               </p>
//             </div>

//             <div>
//               <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>PRODUCT</h4>
//               {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"]].map(([l,h]) => (
//                 <a key={l} href={h} style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10, transition:"color 0.2s" }}
//                    onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</a>
//               ))}
//             </div>

//             <div>
//               <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>SUPPORT</h4>
//               <Link to="/support" style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>Contact us</Link>
//               <a href="#faq"      style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>FAQ</a>
//             </div>

//             <div>
//               <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>LEGAL</h4>
//               {[["Privacy Policy","/privacy"],["Terms of Service","/terms"],["Refund Policy","/refund"]].map(([l,h]) => (
//                 <Link key={l} to={h} style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }}
//                       onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</Link>
//               ))}
//             </div>
//           </div>

//           <div className="lp-footer-bottom" style={{ borderTop:"1px solid #1e293b", paddingTop:"clamp(20px,3vw,28px)", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
//             <span style={{ fontSize:12, color:"#475569" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
//             <span style={{ fontSize:12, color:"#334155" }}>Built with care for job seekers</span>
//           </div>
//         </div>
//       </footer>

//       <ChatWidget />
//       {showModal && (
//         <PaymentModal
//           onSuccess={() => { setShowModal(false); navigate("/dashboard"); }}
//           onClose={() => setShowModal(false)}
//           userEmail={userData?.email || user?.email}
//           userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
//           planId={planId}
//           userId={user?.uid}
//         />
//       )}
//     </div>
//   );
// }

// new code for pricing change
// eslint-disable-next-line no-unused-vars
import { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import servicesConfig from "../utils/servicesConfig";
import PaymentModal from "../components/PaymentModal";
import ChatWidget from "../components/ChatWidget";
import TemplateMini from "../components/TemplateMini";
// eslint-disable-next-line no-unused-vars
import { usePricing, PriceTag } from "../hooks/usePricing";

// ── SVG Icon set — clean, consistent, no emojis ──
const Icon = {
  // Includes banner
  BarChart: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  Sparkle: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
    </svg>
  ),
  Gift: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/>
      <line x1="12" y1="22" x2="12" y2="7"/>
      <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
      <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
    </svg>
  ),
  FileText: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
  Download: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  ),
  // How it works
  CreditCard: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
      <line x1="1" y1="10" x2="23" y2="10"/>
    </svg>
  ),
  Upload: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  ),
  Zap: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  // Features
  TrendingUp: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
      <polyline points="17 6 23 6 23 12"/>
    </svg>
  ),
  Search: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  Edit: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  RefreshCw: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10"/>
      <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/>
    </svg>
  ),
  Layout: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
      <line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
    </svg>
  ),
  Mail: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22 6 12 13 2 6"/>
    </svg>
  ),
  // Misc
  Lock: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
      <path d="M7 11V7a5 5 0 0110 0v4"/>
    </svg>
  ),
  Clock: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Check: ({ size = 10, color = "#fff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
};



const basicPlan     = servicesConfig.plans.find(p => p.id === "ats_basic");
const analysisCount = basicPlan?.analysisCount || 3;
const allTemplates  = servicesConfig.resumeTemplates.filter(t => t.active);
const enabledPlans  = servicesConfig.plans.filter(p => p.enabled);

export default function LandingPage() {
  const navigate = useNavigate();
  const { user, userData } = useAuth();

  const [showModal,    setShowModal]    = useState(false);
  const [planId,       setPlanId]       = useState("ats_basic");
  const [menuOpen,     setMenuOpen]     = useState(false);
  const [scrolled,     setScrolled]     = useState(false);
  const [openFaq,      setOpenFaq]      = useState(null);
  const [activeTmpl,   setActiveTmpl]   = useState(0);
  // All pricing handled by usePricing hook
  const { usdDisplay: priceDisplay, localDisplay: localPrice, fullDisplay: fullPriceDisplay } = usePricing("ats_basic");

  // Scroll listener for nav
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Template carousel
  useEffect(() => {
    const t = setInterval(() => setActiveTmpl(p => (p + 1) % allTemplates.length), 4500);
    return () => clearInterval(t);
  }, []);

  function startPayment(pid = "ats_basic") {
    setMenuOpen(false);
    if (user) { setPlanId(pid); setShowModal(true); }
    else navigate("/signup");
  }

  function ScoreRing({ target = 70, duration = 2000 }) {
  const [score, setScore] = useState(0);
  const CIRCUMFERENCE = 2 * Math.PI * 50;

  const color = score < 45 ? "#e24b4a" : score < 65 ? "#ef9f27" : score < 80 ? "#2563eb" : "#1d9e75";
  const offset = CIRCUMFERENCE - (score / 100) * CIRCUMFERENCE;

  useEffect(() => {
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const t = Math.min((ts - start) / duration, 1);
      const ease = t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
      setScore(Math.round(target * ease));
      if (t < 1) requestAnimationFrame(step);
    };
    const raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return (
    <div style={{ position:"relative", width:120, height:120, margin:"0 auto 16px" }}>
      <svg width="120" height="120" viewBox="0 0 120 120" style={{ transform:"rotate(-90deg)" }}>
        <circle cx="60" cy="60" r="50" fill="none" stroke="#f1f5f9" strokeWidth="10" />
        <circle cx="60" cy="60" r="50" fill="none" stroke={color} strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          style={{ transition:"stroke 0.3s" }} />
      </svg>
      <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
        <span style={{ fontSize:32, fontWeight:800, color, lineHeight:1 }}>{score}</span>
        <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>/100</span>
      </div>
    </div>
  );
}

  return (
    <div style={{ minHeight:"100vh", fontFamily:"'Inter',-apple-system,BlinkMacSystemFont,sans-serif", background:"#fff", color:"#111827" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }

        .lp-btn-dark {
          background:#111827; color:#fff; border:none; border-radius:10px;
          font-weight:600; cursor:pointer; transition:all 0.2s ease;
        }
        .lp-btn-dark:hover { background:#1f2937; transform:translateY(-1px); box-shadow:0 6px 20px rgba(0,0,0,0.15); }
        .lp-btn-outline {
          background:transparent; color:#374151; border:1.5px solid #d1d5db; border-radius:10px;
          font-weight:500; cursor:pointer; transition:all 0.2s ease;
        }
        .lp-btn-outline:hover { border-color:#374151; background:#f9fafb; }
        .lp-btn-blue {
          background:linear-gradient(135deg,#2563eb,#1d4ed8); color:#fff; border:none; border-radius:10px;
          font-weight:700; cursor:pointer; transition:all 0.2s ease;
        }
        .lp-btn-blue:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(37,99,235,0.3); }

        .lp-card {
          background:#fff; border:1px solid #e5e7eb; border-radius:16px;
          transition:box-shadow 0.2s, transform 0.2s;
        }
        .lp-card:hover { box-shadow:0 12px 32px rgba(0,0,0,0.08); transform:translateY(-3px); }

        .lp-tag {
          display:inline-block; font-size:12px; font-weight:600;
          padding:4px 14px; border-radius:20px;
        }
        .lp-divider { width:1px; height:20px; background:#e5e7eb; }

        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        .fade-up { animation:fadeUp 0.55s ease forwards; }

        /* Mobile */
        @media(max-width:768px) {
          .lp-desktop       { display:none !important; }
          .lp-mobile-show   { display:flex !important; }
          .lp-grid-3        { grid-template-columns:1fr !important; }
          /* Hero: stack columns on tablet/mobile */
          .lp-hero-grid     { grid-template-columns:1fr !important; }
          /* Hide score card mock on mobile — focus on copy */
          .lp-hero-mock     { display:none !important; }
          /* Includes banner: 2 cols on tablet */
          .lp-includes-row  { gap:clamp(12px,4vw,24px) !important; justify-content:flex-start !important; }
          .lp-includes-item { min-width:calc(50% - 12px); }
          /* Pricing features: single col */
          .lp-pricing-feats { grid-template-columns:1fr !important; }
        }
        @media(max-width:480px) {
          .lp-hero-btns     { flex-direction:column !important; }
          .lp-hero-btns button { width:100% !important; }
          .lp-includes-row  { flex-direction:column !important; align-items:flex-start !important; }
          .lp-includes-divs { display:none !important; }
          /* FAQ full padding */
          .lp-faq-item      { padding:14px 16px !important; }
          /* Footer bottom bar stack */
          .lp-footer-bottom { flex-direction:column !important; text-align:center !important; gap:6px !important; }
          /* CTA button full width */
          .lp-cta-btn       { width:100% !important; }
        }
      `}</style>

      {/* ── NAV ── */}
      <nav style={{
        position:"sticky", top:0, zIndex:1000,
        background: scrolled ? "rgba(255,255,255,0.97)" : "transparent",
        backdropFilter:"blur(16px)",
        borderBottom: scrolled ? "1px solid #f3f4f6" : "1px solid transparent",
        padding:"0 5%", height:64,
        display:"flex", alignItems:"center", justifyContent:"space-between",
        transition:"all 0.3s ease",
      }}>
        <div onClick={() => navigate("/")} style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}>
          <div style={{ width:34, height:34, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:9, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <span style={{ color:"#fff", fontWeight:800, fontSize:17 }}>R</span>
          </div>
          <span style={{ fontWeight:700, fontSize:18, letterSpacing:"-0.3px" }}>
            ResumeScore<span style={{ color:"#2563eb" }}>AI</span>
          </span>
        </div>

        <div className="lp-desktop" style={{ display:"flex", gap:32, alignItems:"center" }}>
          {[["How it works","#how"],["Features","#features"],["Templates","#templates"],["Pricing","#pricing"],["FAQ","#faq"]].map(([l,h]) => (
            <a key={l} href={h} style={{ fontSize:14, fontWeight:500, color:"#6b7280", textDecoration:"none", transition:"color 0.2s" }}
               onMouseEnter={e=>e.target.style.color="#111827"} onMouseLeave={e=>e.target.style.color="#6b7280"}>{l}</a>
          ))}
          <Link to="/support" style={{ fontSize:14, fontWeight:500, color:"#6b7280", textDecoration:"none" }}>Support</Link>
        </div>

        <div className="lp-desktop" style={{ display:"flex", gap:10 }}>
          {user ? (
            <>
              <button className="lp-btn-outline" style={{ padding:"8px 18px", fontSize:13 }} onClick={() => navigate("/dashboard")}>Dashboard</button>
              <button className="lp-btn-blue"    style={{ padding:"8px 20px", fontSize:13 }} onClick={() => startPayment()}>Get Access</button>
            </>
          ) : (
            <>
              <button className="lp-btn-outline" style={{ padding:"8px 18px", fontSize:13 }} onClick={() => navigate("/login")}>Sign in</button>
              <button className="lp-btn-blue"    style={{ padding:"8px 20px", fontSize:13 }} onClick={() => navigate("/signup")}>Get started</button>
            </>
          )}
        </div>

        {/* Hamburger */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="lp-mobile-show"
          style={{ display:"none", background:"none", border:"1px solid #e5e7eb", borderRadius:8, padding:"7px 9px", cursor:"pointer", flexDirection:"column", gap:4 }}>
          {[0,1,2].map(i => <span key={i} style={{ display:"block", width:18, height:2, background:"#374151", borderRadius:1 }} />)}
        </button>
      </nav>

      {menuOpen && (
        <div style={{ background:"#fff", borderBottom:"1px solid #e5e7eb", padding:"16px 5%", zIndex:999, boxShadow:"0 8px 24px rgba(0,0,0,0.06)" }}>
          {["How it works","Features","Templates","Pricing","FAQ"].map(l => (
            <a key={l} href={`#${l.toLowerCase().replace(" ","")}`} onClick={() => setMenuOpen(false)}
               style={{ display:"block", padding:"10px 0", fontSize:15, color:"#374151", textDecoration:"none", borderBottom:"1px solid #f5f5f5", fontWeight:500 }}>{l}</a>
          ))}
          <Link to="/support" onClick={() => setMenuOpen(false)}
            style={{ display:"block", padding:"10px 0", fontSize:15, color:"#374151", textDecoration:"none", borderBottom:"1px solid #f5f5f5", fontWeight:500 }}>Support</Link>
          <div style={{ display:"flex", gap:10, marginTop:14 }}>
            <button className="lp-btn-outline" style={{ flex:1, padding:"11px", fontSize:14 }} onClick={() => { setMenuOpen(false); navigate("/login"); }}>Sign in</button>
            <button className="lp-btn-blue"    style={{ flex:1, padding:"11px", fontSize:14 }} onClick={() => startPayment()}>Get started</button>
          </div>
        </div>
      )}

      {/* ════════════════════════════════════
          HERO
      ════════════════════════════════════ */}
      <section style={{ padding:"clamp(56px,10vw,96px) 5% clamp(48px,8vw,80px)", background:"#f9fafb", borderBottom:"1px solid #e5e7eb" }}>
        <div className="lp-hero-grid" style={{ maxWidth:1100, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"clamp(40px,6vw,64px)", alignItems:"center" }}>

          {/* Left */}
          <div className="fade-up">
            {/* Launch badge — honest */}
            <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:20, padding:"5px 14px 5px 10px", marginBottom:24 }}>
              <span style={{ width:7, height:7, borderRadius:"50%", background:"#3b82f6", display:"inline-block" }} />
              <span style={{ fontSize:12, fontWeight:600, color:"#1d4ed8" }}>Founding price · Won't last forever</span>
            </div>

            <h1 style={{ fontSize:"clamp(34px,5vw,54px)", fontWeight:800, lineHeight:1.1, letterSpacing:"-0.03em", color:"#0f172a", marginBottom:20 }}>
              Know exactly why your resume{" "}
              <span style={{ color:"#2563eb" }}>isn't getting interviews</span>
            </h1>

            <p style={{ fontSize:"clamp(15px,2.5vw,18px)", color:"#4b5563", lineHeight:1.7, marginBottom:32, maxWidth:520 }}>
              Paste your resume and a job description. We analyse keyword gaps, score your ATS match, and show you exactly what to fix — with specific rewrite suggestions.
            </p>

            <div className="lp-hero-btns" style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:28 }}>
              <button className="lp-btn-blue" style={{ padding:"13px 28px", fontSize:15 }} onClick={() => startPayment()}>
                Analyse my resume — {fullPriceDisplay}
              </button>
              <button className="lp-btn-outline" style={{ padding:"13px 22px", fontSize:15 }} onClick={() => document.getElementById("how")?.scrollIntoView({ behavior:"smooth" })}>
                See how it works
              </button>
            </div>

            {/* Honest social proof */}
            <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap", justifyContent:"flex-start" }}>
              <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                <div style={{ color:"#94a3b8" }}><Icon.Lock /></div>
                <span style={{ fontSize:12, color:"#6b7280", fontWeight:500 }}>One-time payment, no subscription</span>
              </div>
              <div className="lp-divider" />
              <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                <div style={{ color:"#94a3b8" }}><Icon.Clock /></div>
                <span style={{ fontSize:12, color:"#6b7280", fontWeight:500 }}>Results in under 30 seconds</span>
              </div>
            </div>
          </div>

          {/* Right — score card mock */}
          <div className="lp-hero-mock" style={{ display:"flex", justifyContent:"center" }}>
            <div style={{ width:"100%", maxWidth:380, background:"#fff", borderRadius:20, border:"1px solid #e5e7eb", overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.08)" }}>

              {/* Header bar */}
              <div style={{ padding:"16px 20px", borderBottom:"1px solid #f3f4f6", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <div style={{ width:28, height:28, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:7, display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <span style={{ color:"#fff", fontSize:12, fontWeight:800 }}>R</span>
                  </div>
                  <span style={{ fontWeight:700, fontSize:13, color:"#1e293b" }}>ATS Analysis</span>
                </div>
                <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>Just now</span>
              </div>

              {/* Score ring area */}
              {/* <div style={{ padding:"24px 20px 16px", textAlign:"center" }}>
                <div style={{ position:"relative", width:120, height:120, margin:"0 auto 16px" }}>
                  <svg viewBox="0 0 120 120" style={{ width:120, height:120, transform:"rotate(-90deg)" }}>
                    <circle cx="60" cy="60" r="50" fill="none" stroke="#f1f5f9" strokeWidth="10" />
                    <circle cx="60" cy="60" r="50" fill="none" stroke="#2563eb" strokeWidth="10"
                      strokeDasharray="314" strokeDashoffset="94" strokeLinecap="round" />
                  </svg>
                  <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
                    <span style={{ fontSize:32, fontWeight:800, color:"#0f172a", lineHeight:1 }}>70</span>
                    <span style={{ fontSize:11, color:"#94a3b8", fontWeight:500 }}>/100</span>
                  </div>
                </div>
                <div style={{ fontWeight:700, fontSize:14, color:"#0f172a", marginBottom:4 }}>ATS Score</div>
                <div style={{ fontSize:12, color:"#64748b" }}>14 of 20 keywords matched</div>
              </div> */}

              {/* Score ring area */}
              <ScoreRing target={90} duration={2000} />

              {/* Keyword pills */}
              <div style={{ padding:"0 20px 16px" }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>Missing keywords</div>
                <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                  {["Kubernetes","CI/CD","Terraform","GraphQL","TypeScript"].map(k => (
                    <span key={k} style={{ fontSize:11, padding:"4px 8px", borderRadius:20, background:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca", fontWeight:500, whiteSpace:"nowrap" }}>{k}</span>
                  ))}
                </div>
              </div>

              {/* Recommendation */}
              <div style={{ margin:"0 20px 20px", background:"#f0fdf4", borderRadius:12, padding:"12px 14px", border:"1px solid #bbf7d0" }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#059669", marginBottom:4 }}>Top recommendation</div>
                <div style={{ fontSize:12, color:"#166534", lineHeight:1.5 }}>
                  Add "Kubernetes" to 2 experience bullets — moves it from Skills section to full credit.
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ════════════════════════════════════
          WHAT'S INCLUDED BANNER
      ════════════════════════════════════ */}
      <section style={{ background:"#fff", padding:"20px 5%", borderBottom:"1px solid #e5e7eb" }}>
        <div className="lp-includes-row" style={{ maxWidth:1100, margin:"0 auto", display:"flex", alignItems:"center", justifyContent:"center", gap:"clamp(20px,5vw,56px)", flexWrap:"wrap" }}>
          {[
            { Icon: Icon.BarChart, label:`${analysisCount} ATS analyses`, sub:"per purchase", color:"#2563eb" },
            { Icon: Icon.RefreshCw, label:"AI-improved resume", sub:"based on your real one", color:"#7c3aed" },
            { Icon: Icon.Layout, label:"Resume from scratch", sub:"free with plan", color:"#059669" },
            { Icon: Icon.Mail, label:"Cover letter", sub:"free with plan", color:"#0891b2" },
            { Icon: Icon.Download, label:"PDF + Word download", sub:"all templates", color:"#dc2626" },
          ].map(item => (
            <div key={item.label} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 0" }}>
              <div style={{ width:32, height:32, background:`${item.color}15`, borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", color:item.color, flexShrink:0 }}>
                <item.Icon />
              </div>
              <div>
                <div style={{ fontSize:13, fontWeight:700, color:"#0f172a" }}>{item.label}</div>
                <div style={{ fontSize:11, color:"#94a3b8" }}>{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ════════════════════════════════════
          HOW IT WORKS
      ════════════════════════════════════ */}
      <section id="how" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
        <div style={{ maxWidth:1000, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
            <span className="lp-tag" style={{ background:"#fef3c7", color:"#92400e", marginBottom:16 }}>Simple process</span>
            <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", lineHeight:1.2, marginBottom:14 }}>
              From upload to results in under a minute
            </h2>
            <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:480, margin:"0 auto" }}>
              No account tour, no setup. Just paste and go.
            </p>
          </div>

          <div className="lp-grid-3" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"clamp(24px,4vw,36px)" }}>
            {[
              { n:"1", Icon: Icon.CreditCard, title:"Pay once", body:`${fullPriceDisplay} one-time. No subscription. Includes ${analysisCount} full analyses, an improved resume, cover letter, and resume builder.` },
              { n:"2", Icon: Icon.Upload, title:"Upload resume + job description", body:"Paste or upload your resume. Paste the job description. That's all the input we need." },
              { n:"3", Icon: Icon.Zap, title:"Get your score and fixes", body:"See your ATS score, which keywords are missing, exactly where they should go, and a rewritten resume ready to download." },
            ].map(s => (
              <div key={s.n} className="lp-card" style={{ padding:"clamp(24px,4vw,32px)" }}>
                <div style={{ width:44, height:44, background:"#eff6ff", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center", color:"#2563eb", marginBottom:20 }}>
                  <s.Icon />
                </div>
                <div style={{ fontSize:11, fontWeight:700, color:"#2563eb", marginBottom:8, letterSpacing:"0.06em", textTransform:"uppercase" }}>Step {s.n}</div>
                <div style={{ fontSize:"clamp(15px,2.5vw,18px)", fontWeight:700, color:"#0f172a", marginBottom:10, lineHeight:1.3 }}>{s.title}</div>
                <p style={{ fontSize:"clamp(13px,2vw,14px)", color:"#64748b", lineHeight:1.65 }}>{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════
          FEATURES
      ════════════════════════════════════ */}
      <section id="features" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#fff" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
            <span className="lp-tag" style={{ background:"#eff6ff", color:"#1d4ed8", marginBottom:16 }}>What you get</span>
            <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
              Honest, specific feedback — not vague advice
            </h2>
            <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:500, margin:"0 auto" }}>
              We tell you exactly which keywords are missing, where to add them, and show you before/after rewrites.
            </p>
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(min(100%,300px),1fr))", gap:"clamp(16px,3vw,24px)" }}>
            {[
              {
                Icon: Icon.TrendingUp, color:"#2563eb", title:"Position-weighted ATS score",
                body:"We don't just count keywords. A keyword buried in your skills section scores less than one demonstrated in a bullet with a result. We show you exactly where each skill sits and how to move it up.",
                tag:null,
              },
              {
                Icon: Icon.Search,     color:"#7c3aed", title:"Hard skill gap analysis",
                body:"We extract the specific tools, technologies, and certifications from the job description and check your resume against them — with synonym matching (AWS = Amazon Web Services, etc.).",
                tag:null,
              },
              {
                Icon: Icon.Edit,   color:"#059669", title:"Before/after rewrite suggestions",
                body:"Not just \"add more keywords\" — we show you the exact weak bullet, and an improved version that adds a metric and the missing keyword naturally.",
                tag:null,
              },
              {
                Icon: Icon.RefreshCw, color:"#d97706", title:"AI-improved resume",
                body:"We take your real resume, promote skills-only keywords into experience bullets where they fit, add estimated metrics to weak bullets, and verify the score improved before delivering.",
                tag:null,
              },
              {
                Icon: Icon.Layout,    color:"#dc2626", title:"Resume from scratch",
                body:"No existing resume? We build a realistic sample based on your field, experience level, and job description. You'll need to personalise it with your real details.",
                tag:"Included free",
              },
              {
                Icon: Icon.Mail,      color:"#0891b2", title:"Cover letter",
                body:"A tailored cover letter that matches specific JD requirements to your real background. Three tone options: professional, confident, or enthusiastic.",
                tag:"Included free",
              },
            ].map(f => (
              <div key={f.title} className="lp-card" style={{ padding:"clamp(22px,3.5vw,28px)", position:"relative", overflow:"hidden" }}>
                <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg,#2563eb,#7c3aed)", opacity:0.6 }} />
                {f.tag && (
                  <span className="lp-tag" style={{ background:"#f0fdf4", color:"#059669", border:"1px solid #bbf7d0", fontSize:11, marginBottom:12, display:"inline-block" }}>{f.tag}</span>
                )}
                <div style={{ width:48, height:48, background:`${f.color}12`, borderRadius:14, display:"flex", alignItems:"center", justifyContent:"center", color:f.color, marginBottom:16 }}>
                  <f.Icon />
                </div>
                <div style={{ fontSize:"clamp(14px,2.5vw,16px)", fontWeight:700, color:"#0f172a", marginBottom:10, lineHeight:1.3 }}>{f.title}</div>
                <p style={{ fontSize:"clamp(12px,2vw,13px)", color:"#64748b", lineHeight:1.65 }}>{f.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════
          TEMPLATES
      ════════════════════════════════════ */}
      <section id="templates" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
            <span className="lp-tag" style={{ background:"#f3e8ff", color:"#6b21a8", marginBottom:16 }}>Resume templates</span>
            <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
              {allTemplates.length} templates, all ATS-compatible
            </h2>
            <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b", maxWidth:480, margin:"0 auto" }}>
              Clean layouts that parse correctly in modern ATS systems. Download as PDF, Word, or HTML.
            </p>
          </div>

          <div style={{ display:"flex", gap:"clamp(12px,2vw,20px)", overflowX:"auto", paddingBottom:16, scrollSnapType:"x mandatory", WebkitOverflowScrolling:"touch" }}>
            {allTemplates.map((t, i) => (
              <div key={t.id} onClick={() => setActiveTmpl(i)}
                style={{
                  flex:"0 0 min(260px,80vw)", scrollSnapAlign:"start", cursor:"pointer",
                  borderRadius:16, overflow:"hidden", transition:"all 0.2s",
                  border: activeTmpl===i ? `2px solid ${t.accent||"#2563eb"}` : "1.5px solid #e5e7eb",
                  background:"#fff", boxShadow: activeTmpl===i ? `0 12px 36px ${t.accent||"#2563eb"}20` : "0 2px 8px rgba(0,0,0,0.04)",
                }}>
                <div style={{ padding:"12px 14px", borderBottom:"1px solid #f3f4f6", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:13, color:"#0f172a" }}>{t.name}</div>
                    <div style={{ fontSize:10, color:"#94a3b8", marginTop:2 }}>{t.tags?.slice(0,2).join(" · ")}</div>
                  </div>
                  {activeTmpl===i && (
                    <div style={{ width:20, height:20, borderRadius:"50%", background:t.accent||"#2563eb", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <Icon.Check size={10} color="#fff" />
                    </div>
                  )}
                </div>
                <div style={{ padding:"16px", background:"#fafafa", display:"flex", alignItems:"center", justifyContent:"center", minHeight:220 }}>
                  <TemplateMini t={t} scale={0.22} width={500} />
                </div>
              </div>
            ))}
          </div>

          {/* Dots */}
          <div style={{ display:"flex", justifyContent:"center", gap:8, marginTop:20, marginBottom:32 }}>
            {allTemplates.map((t,i) => (
              <button key={i} onClick={() => setActiveTmpl(i)}
                style={{ width:i===activeTmpl?28:8, height:8, borderRadius:i===activeTmpl?12:4, background:i===activeTmpl?(allTemplates[activeTmpl]?.accent||"#2563eb"):"#d1d5db", border:"none", cursor:"pointer", transition:"all 0.2s" }} />
            ))}
          </div>

          <div style={{ textAlign:"center" }}>
            <p style={{ fontSize:13, color:"#94a3b8", marginBottom:20 }}>All templates included with every purchase — no upsells.</p>
            <button className="lp-btn-blue" style={{ padding:"12px 28px", fontSize:14 }} onClick={() => startPayment()}>
              Get started — {fullPriceDisplay}
            </button>
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════
          PRICING
      ════════════════════════════════════ */}
      <section id="pricing" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#fff" }}>
        <div style={{ maxWidth:640, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
            <span className="lp-tag" style={{ background:"#eff6ff", color:"#1d4ed8", marginBottom:16 }}>Pricing</span>
            <h2 style={{ fontSize:"clamp(28px,5vw,42px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em", marginBottom:14 }}>
              One price, no surprises
            </h2>
            <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#64748b" }}>
              Pay once. Use it. No recurring charges, no hidden fees.
            </p>
          </div>

          {enabledPlans.filter(p => p.active).map(plan => (
            <div key={plan.id} style={{
              background:"#0f172a", borderRadius:24, padding:"clamp(32px,5vw,48px) clamp(28px,4vw,40px)",
              boxShadow:"0 24px 64px rgba(0,0,0,0.15)", position:"relative", overflow:"hidden",
            }}>
              <div style={{ position:"absolute", top:-40, right:-40, width:200, height:200, borderRadius:"50%", background:"radial-gradient(circle,rgba(37,99,235,0.15),transparent)", pointerEvents:"none" }} />

              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:16, marginBottom:28, position:"relative", zIndex:2 }}>
                <div>
                  <div style={{ fontSize:20, fontWeight:800, color:"#fff", marginBottom:4 }}>{plan.name}</div>
                  <div style={{ fontSize:13, color:"#94a3b8" }}>Everything you need for a successful job application</div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ lineHeight:1 }}>
                  <div style={{ fontSize:"clamp(40px,6vw,52px)", fontWeight:800, color:"#fff" }}>{priceDisplay}</div>
                  {localPrice && <div style={{ fontSize:14, color:"rgba(255,255,255,0.5)", marginTop:4 }}>≈{localPrice}</div>}
                </div>
                  <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>one-time payment</div>
                </div>
              </div>

              <div className="lp-pricing-feats" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:10, marginBottom:32, position:"relative", zIndex:2 }}>
                {plan.features.filter(f => f.included).map(f => (
                  <div key={f.text} style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <div style={{ width:20, height:20, borderRadius:"50%", background:"rgba(37,99,235,0.25)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <Icon.Check size={10} color="#60a5fa" />
                    </div>
                    <span style={{ fontSize:"clamp(12px,2.5vw,13px)", color:"#e2e8f0" }}>{f.text}</span>
                  </div>
                ))}
              </div>

              <button onClick={() => startPayment(plan.id)} className="lp-btn-blue"
                style={{ width:"100%", padding:"15px", fontSize:"clamp(14px,3vw,16px)", borderRadius:12, fontWeight:700, position:"relative", zIndex:2 }}>
                Get started — {fullPriceDisplay}
              </button>

              {!user && (
                <p style={{ fontSize:12, color:"#64748b", textAlign:"center", marginTop:16, position:"relative", zIndex:2 }}>
                  Already have an account?{" "}
                  <Link to="/login" style={{ color:"#60a5fa", textDecoration:"none", fontWeight:600 }}>Sign in</Link>
                </p>
              )}
            </div>
          ))}

          {/* Honest notes */}
          <div style={{ marginTop:28, display:"flex", flexDirection:"column", gap:10 }}>
            {[
              { icon: <Icon.Lock />,  text: "Secure payment via Stripe — we never see your card details." },
              { icon: <Icon.Zap />,   text: "New product — we're actively improving based on your feedback." },
              { icon: <Icon.Mail />,  text: "Any issues? Email support and we'll respond personally." },
            ].map((note, i) => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:10, fontSize:13, color:"#6b7280", lineHeight:1.5 }}>
                <div style={{ color:"#94a3b8", flexShrink:0 }}>{note.icon}</div>
                <span>{note.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════
          FAQ
      ════════════════════════════════════ */}
      <section id="faq" style={{ padding:"clamp(64px,10vw,96px) 5%", background:"#f9fafb" }}>
        <div style={{ maxWidth:720, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:"clamp(40px,6vw,56px)" }}>
            <span className="lp-tag" style={{ background:"#fef3c7", color:"#92400e", marginBottom:16 }}>FAQ</span>
            <h2 style={{ fontSize:"clamp(28px,5vw,38px)", fontWeight:800, color:"#0f172a", letterSpacing:"-0.02em" }}>
              Common questions
            </h2>
          </div>

          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {/* Use servicesConfig FAQ if available, otherwise fallback */}
            {(servicesConfig.faq?.length > 0 ? servicesConfig.faq : [
              { q:"How does the ATS score work?",          a:`We extract hard skills (tools, technologies, certifications) from the job description and check where each one appears in your resume. A keyword in a bullet point with a result scores more than one buried in a skills list. Your final score is based on this position-weighted matching, plus bonuses for having metrics in every role and penalties for keyword stuffing.` },
              { q:"Is this an actual ATS or a simulation?", a:"It's a simulation — we replicate the keyword matching logic that most ATS software uses, but we're not the actual system your employer's using. Different employers use different ATS platforms and each one is slightly different. Our score gives you a strong indication of how your resume will perform, but it can't be 100% identical to any specific employer's system." },
              { q:"What does the AI-improved resume do?",   a:"We take your real resume, identify keywords that are only in your skills section and promote them into relevant experience bullets (where they score higher), add estimated metrics to weak bullets, and run the scorer on the output to verify the score improved before delivering it. We never invent skills you don't have." },
              { q:"What is the resume from scratch?",      a:"It generates a realistic sample resume based on your field, experience level, and the job description. It will have fictional company names and dates — you'll need to replace those with your real information before sending it to employers. Think of it as a well-structured starting point, not a finished product." },
              { q:"What do I get for the one-time payment?", a:`You get ${analysisCount} full ATS analyses, one AI-improved resume, one resume from scratch, one AI cover letter, and access to all ${allTemplates.length} resume templates with PDF, Word, and HTML download. No subscription, no expiry on what you've generated.` },
              { q:"I have a problem — how do I get support?", a:"Email us from the Support page. Since we're a new product, we read every message and respond personally. If something isn't working right, tell us and we'll fix it." },
            ]).map((item, i) => (
              <div key={i} style={{ background:"#fff", border:"1px solid #e5e7eb", borderRadius:14, overflow:"hidden" }}>
                <button onClick={() => setOpenFaq(openFaq===i ? null : i)}
                  style={{ width:"100%", textAlign:"left", padding:"clamp(14px,3vw,18px) clamp(18px,3vw,22px)", background:"#fff", border:"none", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", gap:16 }}>
                  <span style={{ fontSize:"clamp(13px,2.5vw,15px)", fontWeight:600, color:"#0f172a", flex:1, lineHeight:1.4 }}>{item.q}</span>
                  <span style={{ fontSize:18, color:"#94a3b8", flexShrink:0, fontWeight:300 }}>{openFaq===i ? "−" : "+"}</span>
                </button>
                {openFaq===i && (
                  <div style={{ padding:"0 clamp(18px,3vw,22px) clamp(16px,3vw,20px)", fontSize:"clamp(13px,2vw,14px)", color:"#4b5563", lineHeight:1.7, borderTop:"1px solid #f3f4f6", background:"#fafafa" }}>
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding:"clamp(40px,6vw,56px) 5%", background:"#f9fafb", borderTop:"1px solid #e5e7eb", borderBottom:"1px solid #e5e7eb" }}>
        <div style={{ maxWidth:760, margin:"0 auto" }}>

          {/* What we do — positive */}
          <div style={{ marginBottom:24 }}>
            <div style={{ fontSize:13, fontWeight:700, color:"#2563eb", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:14 }}>
              What ResumeScoreAI does for you
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:12, marginBottom:20 }}>
              {[
                { icon:"📊", title:"Scores your resume", body:"Analyses keyword match, section quality, and ATS compatibility against any job description." },
                { icon:"🔍", title:"Finds the gaps",     body:"Shows exactly which skills and keywords are missing and where to add them for maximum impact." },
                { icon:"✨", title:"Rewrites for you",   body:"Improves your existing resume or builds one from scratch — tailored to the role you want." },
                { icon:"📝", title:"Writes your cover letter", body:"Generates a tailored, professional cover letter matched to the job description in seconds." },
              ].map(item => (
                <div key={item.title} style={{ background:"#fff", borderRadius:12, padding:"14px 16px", border:"1px solid #e5e7eb", display:"flex", gap:10 }}>
                  <span style={{ fontSize:20, flexShrink:0 }}>{item.icon}</span>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700, color:"#0f172a", marginBottom:4 }}>{item.title}</div>
                    <div style={{ fontSize:12, color:"#64748b", lineHeight:1.6 }}>{item.body}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Honest disclaimer — positive framing */}
          <div style={{ background:"#fff", borderRadius:14, border:"1px solid #e2e8f0", padding:"18px 22px", display:"flex", alignItems:"flex-start", gap:12 }}>
            <div style={{ width:32, height:32, borderRadius:"50%", background:"#eff6ff", border:"1px solid #bfdbfe", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:15 }}>
              ℹ️
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:"#1e293b", marginBottom:6 }}>
                Honest about what we are
              </div>
              <p style={{ fontSize:13, color:"#64748b", lineHeight:1.75, margin:"0 0 6px" }}>
                ResumeScoreAI is an <strong style={{ color:"#374151" }}>AI-powered tool that helps you present your experience more effectively.</strong>{" "}
                We give you actionable feedback, keyword insights, and a stronger resume — but we don't control hiring decisions.
                Getting a job depends on many factors beyond your resume: the role, the competition, the interview, and the company.
              </p>
              <p style={{ fontSize:13, color:"#64748b", lineHeight:1.75, margin:0 }}>
                Our ATS score is a <strong style={{ color:"#374151" }}>directional simulation</strong> — not the exact score from any specific employer's system.
                Every AI-generated resume and suggestion is a <strong style={{ color:"#374151" }}>starting point</strong> that you should review and personalise before sending.
                We never guarantee interviews, job offers, or any specific career outcome.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* ════════════════════════════════════
          FINAL CTA
      ════════════════════════════════════ */}
      <section style={{ padding:"clamp(56px,8vw,80px) 5%", background:"#0f172a", textAlign:"center", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:-60, left:"50%", transform:"translateX(-50%)", width:400, height:400, borderRadius:"50%", background:"radial-gradient(circle,rgba(37,99,235,0.12),transparent)", pointerEvents:"none" }} />
        <div style={{ maxWidth:600, margin:"0 auto", position:"relative", zIndex:2 }}>
          <h2 style={{ fontSize:"clamp(28px,5vw,44px)", fontWeight:800, color:"#fff", letterSpacing:"-0.02em", marginBottom:16, lineHeight:1.2 }}>
            Stop guessing why you're not getting callbacks
          </h2>
          <p style={{ fontSize:"clamp(14px,2.5vw,17px)", color:"#94a3b8", marginBottom:32, lineHeight:1.65 }}>
            Find out exactly what your resume is missing for any job description — in under a minute.
          </p>
          <button className="lp-btn-blue lp-cta-btn" style={{ padding:"14px 36px", fontSize:"clamp(14px,3vw,16px)", fontWeight:700, borderRadius:12 }} onClick={() => startPayment()}>
            Analyse my resume — {fullPriceDisplay}
          </button>
          <p style={{ fontSize:12, color:"#475569", marginTop:18 }}>
            One-time payment · No subscription · Results in seconds
          </p>
        </div>
      </section>

      {/* ════════════════════════════════════
          FOOTER
      ════════════════════════════════════ */}
      <footer style={{ background:"#070d1a", padding:"clamp(40px,6vw,56px) 5% clamp(24px,4vw,32px)" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:"clamp(28px,4vw,40px)", marginBottom:"clamp(28px,4vw,40px)" }}>
            <div>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14 }}>
                <div style={{ width:32, height:32, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <span style={{ color:"#fff", fontWeight:800, fontSize:15 }}>R</span>
                </div>
                <span style={{ fontWeight:700, fontSize:16, color:"#fff" }}>ResumeScore<span style={{ color:"#60a5fa" }}>AI</span></span>
              </div>
              <p style={{ fontSize:12, color:"#64748b", lineHeight:1.6, maxWidth:220 }}>
                ATS analysis and resume optimisation tools for job seekers. New product — actively improving.
              </p>
            </div>

            <div>
              <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>PRODUCT</h4>
              {[["Features","#features"],["Templates","#templates"],["Pricing","#pricing"]].map(([l,h]) => (
                <a key={l} href={h} style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10, transition:"color 0.2s" }}
                   onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</a>
              ))}
            </div>

            <div>
              <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>SUPPORT</h4>
              <Link to="/support" style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>Contact us</Link>
              <a href="#faq"      style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>FAQ</a>
            </div>

            <div>
              <h4 style={{ color:"#fff", fontSize:12, fontWeight:700, marginBottom:14, letterSpacing:"0.06em" }}>LEGAL</h4>
              {[["Privacy Policy","/privacy"],["Terms of Service","/terms"],["Refund Policy","/refund"]].map(([l,h]) => (
                <Link key={l} to={h} style={{ display:"block", fontSize:13, color:"#64748b", textDecoration:"none", marginBottom:10 }}
                      onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</Link>
              ))}
            </div>
          </div>

          <div className="lp-footer-bottom" style={{ borderTop:"1px solid #1e293b", paddingTop:"clamp(20px,3vw,28px)", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
            <span style={{ fontSize:12, color:"#475569" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
            <span style={{ fontSize:12, color:"#334155" }}>Built with care for job seekers</span>
          </div>
        </div>
      </footer>

      <ChatWidget />
      {showModal && (
        <PaymentModal
          onSuccess={() => { setShowModal(false); navigate("/dashboard"); }}
          onClose={() => setShowModal(false)}
          userEmail={userData?.email || user?.email}
          userName={`${userData?.firstName||""} ${userData?.lastName||""}`.trim()}
          planId={planId}
          userId={user?.uid}
        />
      )}
    </div>
  );
}
